
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire043e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire043e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("acw62");


parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $f1950c559c93426d$var$CartContext = /*#__PURE__*/ (0, $acw62.createContext)();
function $f1950c559c93426d$export$9081b9c87ee4e12e({ children: children }) {
    const [cart, setCart] = (0, $acw62.useState)(()=>{
        const saved = localStorage.getItem("cart");
        return saved ? JSON.parse(saved) : [];
    });
    (0, $acw62.useEffect)(()=>{
        localStorage.setItem("cart", JSON.stringify(cart));
    }, [
        cart
    ]);
    const buildUploads = (count)=>{
        return Array.from({
            length: count
        }).map(()=>({
                file: null,
                uploadedId: null,
                note: "",
                hasPhrase: false,
                customPhrase: ""
            }));
    };
    const getUploadSlots = (product, quantity = 1)=>{
        if (product.skipUploads) return 0;
        if (product.selectedOption?.id === "doubleDifferent") return quantity * 2;
        if (product.requiredUploads) return product.requiredUploads * quantity;
        return quantity;
    };
    const addToCart = (product)=>{
        setCart((prev)=>{
            // Custom project products
            // ALWAYS create a new cart item
            if (product.isCustomProject) return [
                ...prev,
                {
                    ...product,
                    cartItemId: crypto.randomUUID(),
                    quantity: 1,
                    childName: product.childName || "",
                    uploads: buildUploads(getUploadSlots(product))
                }
            ];
            const existing = prev.find((item)=>{
                if (item.id !== product.id) return false;
                if (item.selectedOption?.label !== product.selectedOption?.label) return false;
                if ((item.personalizationText || "") !== (product.personalizationText || "")) return false;
                return true;
            });
            if (existing) return prev.map((item)=>{
                if (item.id !== product.id || item.selectedOption?.label !== product.selectedOption?.label || (item.personalizationText || "") !== (product.personalizationText || "")) return item;
                const qty = item.quantity + 1;
                const uploadSlots = getUploadSlots(item, qty);
                return {
                    ...item,
                    quantity: qty,
                    uploads: buildUploads(uploadSlots)
                };
            });
            return [
                ...prev,
                {
                    ...product,
                    cartItemId: crypto.randomUUID(),
                    quantity: 1,
                    childName: product.childName || "",
                    uploads: buildUploads(getUploadSlots(product))
                }
            ];
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1950c559c93426d$var$CartContext.Provider, {
        value: {
            cart: cart,
            setCart: setCart,
            addToCart: addToCart
        },
        children: children
    });
}
const $f1950c559c93426d$export$7e0ba394830a1349 = ()=>(0, $acw62.useContext)($f1950c559c93426d$var$CartContext);


var $9e632dda8832123b$exports = {};
$9e632dda8832123b$exports = import.meta.resolve("eE7To");


const $db9ed9a2274fc7a3$var$logo = new URL($9e632dda8832123b$exports).href;
function $db9ed9a2274fc7a3$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { cart: cart } = (0, $f1950c559c93426d$export$7e0ba394830a1349)();
    const cartCount = cart.reduce((total, item)=>total + item.quantity, 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: "navbar",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "navLeft",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/",
                    className: "logoLink",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "navBrand",
                        "aria-label": "Soulful Customs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: $db9ed9a2274fc7a3$var$logo,
                                alt: "",
                                className: "navBrandMark"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "navBrandText",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "SOULFUL"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "CUSTOMS"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: location.pathname === "/" ? "activeNav" : "",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/shop",
                        className: location.pathname === "/shop" ? "activeNav" : "",
                        children: "Shop"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/about",
                        className: location.pathname === "/about" ? "activeNav" : "",
                        children: "About"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/contact",
                        className: location.pathname === "/contact" ? "activeNav" : "",
                        children: "Contact"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "navRight",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/checkout",
                    className: "cartButton",
                    children: [
                        "\uD83D\uDED2",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `cartCount ${cartCount > 0 ? "cartCountActive" : "cartCountEmpty"}`,
                            children: cartCount
                        })
                    ]
                })
            })
        ]
    });
}



parcelRequire("acw62");
function $5686e64eaa3841eb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
        className: "footer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "\xa9 2026 Soulful Customs. All rights reserved."
        })
    });
}




var $acw62 = parcelRequire("acw62");


function $1e36c7b6755e73ca$export$2e2bcd8739ae039({ product: product, onClick: onClick }) {
    const options = product.options.sizes || product.options.styles || product.options.quantities || [];
    const optionCount = product.options.visualStyles ? product.options.visualStyles.length : options.length;
    const prices = options.map((option)=>option.price);
    const minPrice = Math.min(...prices, product.basePrice);
    const maxPrice = Math.max(...prices, product.basePrice);
    const priceLabel = minPrice === maxPrice ? `$${minPrice.toFixed(2)}` : `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        className: "productCard",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "productImageWrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: product.image,
                    alt: product.name,
                    className: "productImage"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "productInfo",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "productMeta",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: product.category
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            optionCount,
                                            " ",
                                            optionCount === 1 ? "option" : "options"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: product.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: product.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "productFooter",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "productPrice",
                                children: priceLabel
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "productAction",
                                children: "View"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

function $6ab32c4c6b17e175$export$2e2bcd8739ae039({ product: product, onClose: onClose }) {
    const { addToCart: addToCart } = (0, $f1950c559c93426d$export$7e0ba394830a1349)();
    const sizeOptionLabel = product.sizeOptionLabel || "Choose Size";
    const styleOptionLabel = product.optionLabel || (product.category === "Tags" ? "Choose Tag Style" : "Choose Style");
    const quantityOptionLabel = product.quantityLabel || "Choose Quantity";
    const personalization = product.personalization;
    const hasMultipleSizeOptions = (product.options.sizes?.length || 0) > 1;
    const hasMultipleStyleOptions = (product.options.styles?.length || 0) > 1;
    const shouldHideDetailSize = hasMultipleSizeOptions || hasMultipleStyleOptions;
    const visibleDetails = product.details?.filter((detail)=>{
        if (!shouldHideDetailSize) return true;
        return ![
            "size",
            "sizes"
        ].includes(detail.label.toLowerCase());
    }) || [];
    const hasVisualStyleOptions = Boolean(product.options.visualStyles?.length && product.options.quantities?.length);
    const defaultOption = product.options.sizes ? product.options.sizes[0] : product.options.styles?.[0];
    const [selectedOption, setSelectedOption] = (0, $acw62.useState)(defaultOption);
    const [selectedVisualStyles, setSelectedVisualStyles] = (0, $acw62.useState)(product.options.visualStyles ? [
        product.options.visualStyles[0]
    ] : []);
    const [activeVisualStyleIndex, setActiveVisualStyleIndex] = (0, $acw62.useState)(0);
    const [selectedQuantity, setSelectedQuantity] = (0, $acw62.useState)(product.options.quantities?.[0]);
    const [childName, setChildName] = (0, $acw62.useState)("");
    const [personalizationText, setPersonalizationText] = (0, $acw62.useState)("");
    const [addedToCart, setAddedToCart] = (0, $acw62.useState)(false);
    const selectedBadgeCount = selectedQuantity?.id === "three-pack" ? 3 : 1;
    const activeVisualStyles = hasVisualStyleOptions ? Array.from({
        length: selectedBadgeCount
    }, (_, index)=>selectedVisualStyles[index] || product.options.visualStyles[0]) : [];
    const selectedStyleLabels = activeVisualStyles.map((style)=>style.label);
    const selected = hasVisualStyleOptions ? {
        id: `${selectedStyleLabels.join("-")}-${selectedQuantity.id}`,
        label: selectedBadgeCount === 1 ? `${activeVisualStyles[0].label} - ${selectedQuantity.label}` : `${selectedStyleLabels.join(", ")} - ${selectedQuantity.label}`,
        description: selectedQuantity.description || activeVisualStyles[0].description,
        price: selectedQuantity.price,
        styleId: activeVisualStyles[0].id,
        styleLabel: activeVisualStyles[0].label,
        styleNumber: activeVisualStyles[0].styleNumber,
        styles: activeVisualStyles.map((style, index)=>({
                badgeNumber: index + 1,
                id: style.id,
                label: style.label,
                styleNumber: style.styleNumber,
                image: style.image
            })),
        quantityId: selectedQuantity.id,
        quantityLabel: selectedQuantity.label,
        image: activeVisualStyles[0].image
    } : selectedOption;
    function handleVisualStyleSelect(style) {
        setSelectedVisualStyles((currentStyles)=>{
            const nextStyles = [
                ...activeVisualStyles
            ];
            nextStyles[activeVisualStyleIndex] = style;
            return nextStyles;
        });
        if (activeVisualStyleIndex < selectedBadgeCount - 1) setActiveVisualStyleIndex(activeVisualStyleIndex + 1);
    }
    function handleQuantityChange(quantityId) {
        const nextQuantity = product.options.quantities.find((quantity)=>quantity.id === quantityId);
        const nextCount = nextQuantity.id === "three-pack" ? 3 : 1;
        setSelectedQuantity(nextQuantity);
        setSelectedVisualStyles((currentStyles)=>Array.from({
                length: nextCount
            }, (_, index)=>currentStyles[index] || product.options.visualStyles[0]));
        setActiveVisualStyleIndex((currentIndex)=>Math.min(currentIndex, nextCount - 1));
    }
    function handleAddToCart() {
        if (product.requiresChildName && !childName.trim()) {
            alert("Please enter the child's name.");
            return;
        }
        if (personalization?.required && !personalizationText.trim()) {
            alert(`Please enter ${personalization.label.toLowerCase()}.`);
            return;
        }
        addToCart({
            ...product,
            selectedOption: selected,
            price: selected.price,
            quantity: 1,
            childName: childName,
            personalizationText: personalizationText.trim(),
            personalizationEnabled: Boolean(personalization?.required || personalizationText.trim())
        });
        setAddedToCart(true);
        setTimeout(()=>{
            setAddedToCart(false);
        }, 2500);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modalOverlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "productModal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "closeModal",
                    onClick: onClose,
                    children: "\u2715"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: product.image,
                    alt: product.name,
                    className: "modalImage"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modalContent",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: product.name
                        }),
                        visibleDetails.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "productDetailList",
                            children: visibleDetails.map((detail)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: detail.label.toLowerCase() === "note" ? "isNote" : "",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: detail.label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: detail.value
                                        })
                                    ]
                                }, `${detail.label}-${detail.value}`))
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: product.description
                        }),
                        product.options.sizes?.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: product.options.sizes.length === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "optionGroup",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Size"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "singleOptionDisplay",
                                        children: product.options.sizes[0].dimensions || product.options.sizes[0].label
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "optionGroup",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: sizeOptionLabel
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: selected.label,
                                        onChange: (e)=>setSelectedOption(product.options.sizes.find((s)=>s.label === e.target.value)),
                                        children: product.options.sizes.map((size)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                value: size.label,
                                                children: [
                                                    size.label,
                                                    " \u2022 ",
                                                    size.dimensions,
                                                    " \u2022 $",
                                                    size.price.toFixed(2)
                                                ]
                                            }, size.label))
                                    })
                                ]
                            })
                        }),
                        product.options.styles && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "optionGroup",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: styleOptionLabel
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                    value: selected.id,
                                    onChange: (e)=>setSelectedOption(product.options.styles.find((s)=>s.id === e.target.value)),
                                    children: product.options.styles.map((style)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: style.id,
                                            children: style.label
                                        }, style.id))
                                })
                            ]
                        }),
                        hasVisualStyleOptions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "optionGroup visualOptionGroup",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: styleOptionLabel
                                        }),
                                        selectedBadgeCount > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "badgeSelectionSlots",
                                            children: activeVisualStyles.map((style, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: `badgeSelectionSlot${activeVisualStyleIndex === index ? " isActive" : ""}`,
                                                    onClick: ()=>setActiveVisualStyleIndex(index),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "Holder ",
                                                                index + 1
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: style.label
                                                        })
                                                    ]
                                                }, `badge-slot-${index}`))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "badgeStyleGrid",
                                            children: product.options.visualStyles.map((style)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: `badgeStyleOption${activeVisualStyles.some((selectedStyle)=>selectedStyle.id === style.id) ? " isSelected" : ""}`,
                                                    onClick: ()=>handleVisualStyleSelect(style),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            src: style.image,
                                                            alt: style.label
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: style.label
                                                        })
                                                    ]
                                                }, style.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "optionGroup",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: quantityOptionLabel
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                            value: selectedQuantity.id,
                                            onChange: (e)=>handleQuantityChange(e.target.value),
                                            children: product.options.quantities.map((quantity)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                    value: quantity.id,
                                                    children: [
                                                        quantity.label,
                                                        " - $",
                                                        quantity.price.toFixed(2)
                                                    ]
                                                }, quantity.id))
                                        })
                                    ]
                                })
                            ]
                        }),
                        product.requiresChildName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "optionGroup",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Child's Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    value: childName,
                                    onChange: (e)=>setChildName(e.target.value),
                                    placeholder: "Enter child's name",
                                    className: "modalInput"
                                })
                            ]
                        }),
                        personalization?.enabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "optionGroup",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: personalization.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    value: personalizationText,
                                    onChange: (e)=>setPersonalizationText(e.target.value),
                                    placeholder: personalization.placeholder,
                                    className: "modalInput"
                                }),
                                personalization.helperText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                    className: "optionHelpText",
                                    children: personalization.helperText
                                })
                            ]
                        }),
                        selected.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "optionDescription",
                            children: selected.description
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modalPriceBlock",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Price"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    className: "modalPrice",
                                    children: [
                                        "$",
                                        selected.price.toFixed(2)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "heroButtons",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primaryBtn",
                                onClick: handleAddToCart,
                                children: "Add To Cart"
                            })
                        })
                    ]
                }),
                addedToCart && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "cartToast",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "cartToastIcon",
                            children: "\u2713"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Added To Cart"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        product.name,
                                        " \u2022 ",
                                        selected.label
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


var $e7022975061ec7de$exports = {};
$e7022975061ec7de$exports = import.meta.resolve("f4di5");


const $a4c20a4101738e30$var$canvas12 = new URL($e7022975061ec7de$exports).href;
var $d0129a4331deb459$exports = {};
$d0129a4331deb459$exports = import.meta.resolve("a1qmT");


const $a4c20a4101738e30$var$canvas13 = new URL($d0129a4331deb459$exports).href;
var $fc672344e30508bb$exports = {};
$fc672344e30508bb$exports = import.meta.resolve("dhBAR");


const $a4c20a4101738e30$var$canvas14 = new URL($fc672344e30508bb$exports).href;
var $ca389edd34e5d5a7$exports = {};
$ca389edd34e5d5a7$exports = import.meta.resolve("51xmJ");


const $a4c20a4101738e30$var$canvas15 = new URL($ca389edd34e5d5a7$exports).href;
var $2d2f34ebac6dc6bc$exports = {};
$2d2f34ebac6dc6bc$exports = import.meta.resolve("ic4mu");


const $a4c20a4101738e30$var$backpackLifestyle = new URL($2d2f34ebac6dc6bc$exports).href;
var $36c6fea067f9b382$exports = {};
$36c6fea067f9b382$exports = import.meta.resolve("2Uvjh");


const $a4c20a4101738e30$var$pencilPouchLifestyle = new URL($36c6fea067f9b382$exports).href;
var $6164f164d3b24c56$exports = {};
$6164f164d3b24c56$exports = import.meta.resolve("i9FjL");


const $a4c20a4101738e30$var$lunchBagLifestyle = new URL($6164f164d3b24c56$exports).href;
var $503277dda641d1f6$exports = {};
$503277dda641d1f6$exports = import.meta.resolve("8TMLG");


const $a4c20a4101738e30$var$idBadgeHoldersLifestyle = new URL($503277dda641d1f6$exports).href;
var $8bffcaef404aa830$exports = {};
$8bffcaef404aa830$exports = import.meta.resolve("5zBPl");


const $a4c20a4101738e30$var$buttonPinsLifestyle = new URL($8bffcaef404aa830$exports).href;
var $d4cbbc04cd19f1f0$exports = {};
$d4cbbc04cd19f1f0$exports = import.meta.resolve("96tvY");


const $a4c20a4101738e30$var$potHoldersLifestyle = new URL($d4cbbc04cd19f1f0$exports).href;
var $f24d5441d1b57512$exports = {};
$f24d5441d1b57512$exports = import.meta.resolve("4Kl2o");


const $a4c20a4101738e30$var$rectangleGlassLifestyle = new URL($f24d5441d1b57512$exports).href;
var $6f56d7d0fb4c1ef8$exports = {};
$6f56d7d0fb4c1ef8$exports = import.meta.resolve("dQbdp");


const $a4c20a4101738e30$var$lightUpGlassLifestyle = new URL($6f56d7d0fb4c1ef8$exports).href;
var $7ce07ffb2ea8f5bc$exports = {};
$7ce07ffb2ea8f5bc$exports = import.meta.resolve("cNaSc");


const $a4c20a4101738e30$var$roundGlassLifestyle = new URL($7ce07ffb2ea8f5bc$exports).href;
var $0eab349977f24891$exports = {};
$0eab349977f24891$exports = import.meta.resolve("55cOD");


const $a4c20a4101738e30$var$rectangleSlateLifestyle = new URL($0eab349977f24891$exports).href;
var $7afabcc3fd51e455$exports = {};
$7afabcc3fd51e455$exports = import.meta.resolve("foPRK");


const $a4c20a4101738e30$var$heartSlateLifestyle = new URL($7afabcc3fd51e455$exports).href;
var $7471ad3d6988d0a4$exports = {};
$7471ad3d6988d0a4$exports = import.meta.resolve("8md8D");


const $a4c20a4101738e30$var$roundSlateLifestyle = new URL($7471ad3d6988d0a4$exports).href;
var $4fb1b1c9db2bd7cf$exports = {};
$4fb1b1c9db2bd7cf$exports = import.meta.resolve("hLKj1");


const $a4c20a4101738e30$var$sportsTagsLifestyle = new URL($4fb1b1c9db2bd7cf$exports).href;
var $f18009394aab818b$exports = {};
$f18009394aab818b$exports = import.meta.resolve("78yvP");


var $d7b7cfa50bdfa79b$exports = {};
$d7b7cfa50bdfa79b$exports = import.meta.resolve("j6PVx");


var $6bfe5a671a6be3f1$exports = {};
$6bfe5a671a6be3f1$exports = import.meta.resolve("8uYU4");


var $fdf65c3d800cf645$exports = {};
$fdf65c3d800cf645$exports = import.meta.resolve("cXYYN");


var $634584cc01d6966c$exports = {};
$634584cc01d6966c$exports = import.meta.resolve("5s0ZE");


var $d792949832a8d341$exports = {};
$d792949832a8d341$exports = import.meta.resolve("5vtbL");


var $005f6c93d47b96ab$exports = {};
$005f6c93d47b96ab$exports = import.meta.resolve("8jtd1");


var $96017e63324fac59$exports = {};
$96017e63324fac59$exports = import.meta.resolve("jdmug");


var $1a74f2f2206c9909$exports = {};
$1a74f2f2206c9909$exports = import.meta.resolve("fOdZz");


var $90fb9f43b4803c2f$exports = {};
$90fb9f43b4803c2f$exports = import.meta.resolve("HXrEg");


var $2f7bf282d89c07ad$exports = {};
$2f7bf282d89c07ad$exports = import.meta.resolve("dvW5n");


var $68f2cffaf10ce40a$exports = {};
$68f2cffaf10ce40a$exports = import.meta.resolve("31evr");


const $a4c20a4101738e30$var$idBadgeStyleImages = [
    new URL($f18009394aab818b$exports).href,
    new URL($d7b7cfa50bdfa79b$exports).href,
    new URL($6bfe5a671a6be3f1$exports).href,
    new URL($fdf65c3d800cf645$exports).href,
    new URL($634584cc01d6966c$exports).href,
    new URL($d792949832a8d341$exports).href,
    new URL($005f6c93d47b96ab$exports).href,
    new URL($96017e63324fac59$exports).href,
    new URL($1a74f2f2206c9909$exports).href,
    new URL($90fb9f43b4803c2f$exports).href,
    new URL($2f7bf282d89c07ad$exports).href,
    new URL($68f2cffaf10ce40a$exports).href
];
const $a4c20a4101738e30$var$idBadgeStyles = $a4c20a4101738e30$var$idBadgeStyleImages.map((image, index)=>{
    const styleNumber = index + 1;
    return {
        id: `style-${styleNumber}`,
        label: `Style ${styleNumber}`,
        styleNumber: styleNumber,
        image: image,
        description: '2.75" x 3.93" ID/badge holder.'
    };
});
const $a4c20a4101738e30$var$idBadgeQuantities = [
    {
        id: "single",
        label: "1 Badge",
        description: '2.75" x 3.93" ID/badge holder.',
        price: 12
    },
    {
        id: "three-pack",
        label: "3 Badges",
        description: '2.75" x 3.93" ID/badge holders. Bundle price for 3.',
        price: 30
    }
];
const $a4c20a4101738e30$var$backToSchoolPersonalization = {
    enabled: true,
    label: "Add Name",
    placeholder: "Enter name to print",
    helperText: "Optional. Add a name at no additional cost.",
    required: false
};
const $a4c20a4101738e30$var$badgeHolderPersonalization = {
    enabled: true,
    label: "Name / Title",
    placeholder: "Example: Ms. Smith",
    helperText: "Required. Enter the name or title to print on the holder.",
    required: true
};
const $a4c20a4101738e30$var$products = [
    // BACK TO SCHOOL
    {
        id: 12,
        name: "Backpack",
        description: 'Custom backpack, 16" tall.',
        details: [
            {
                label: "Product",
                value: "Custom Backpack"
            },
            {
                label: "Size",
                value: '16" tall'
            },
            {
                label: "Personalization",
                value: "Optional name included at no additional cost"
            }
        ],
        image: $a4c20a4101738e30$var$backpackLifestyle,
        basePrice: 45,
        category: "Back to School",
        personalization: $a4c20a4101738e30$var$backToSchoolPersonalization,
        options: {
            sizes: [
                {
                    label: "Standard",
                    dimensions: '16" tall',
                    price: 45
                }
            ]
        }
    },
    {
        id: 13,
        name: "Pencil Pouch",
        description: "Custom pencil pouch for school supplies and everyday carry.",
        details: [
            {
                label: "Product",
                value: "Custom Pencil Pouch"
            },
            {
                label: "Size",
                value: '4.72" x 8.27"'
            },
            {
                label: "Personalization",
                value: "Optional name included at no additional cost"
            }
        ],
        image: $a4c20a4101738e30$var$pencilPouchLifestyle,
        basePrice: 8,
        category: "Back to School",
        personalization: $a4c20a4101738e30$var$backToSchoolPersonalization,
        options: {
            sizes: [
                {
                    label: "Standard",
                    dimensions: '4.72" x 8.27"',
                    price: 8
                }
            ]
        }
    },
    {
        id: 14,
        name: "Lunch Bag",
        description: 'Custom lunch bag, 7.87" x 10.23" x 2.54".',
        details: [
            {
                label: "Product",
                value: "Custom Lunch Bag"
            },
            {
                label: "Size",
                value: '7.87" x 10.23" x 2.54"'
            },
            {
                label: "Personalization",
                value: "Optional name included at no additional cost"
            }
        ],
        image: $a4c20a4101738e30$var$lunchBagLifestyle,
        basePrice: 25,
        category: "Back to School",
        personalization: $a4c20a4101738e30$var$backToSchoolPersonalization,
        options: {
            sizes: [
                {
                    label: "Standard",
                    dimensions: '7.87" x 10.23" x 2.54"',
                    price: 25
                }
            ]
        }
    },
    // ID/BADGE HOLDERS, BUTTONS, AND HOME GOODS
    {
        id: 15,
        name: "ID/Badge Holder",
        description: 'Custom ID/badge holders, 2.75" x 3.93". Choose from 12 styles and order 1 or 3. NOTE: Holder only, lanyard not included.',
        details: [
            {
                label: "Product",
                value: "Custom ID / Badge Holder"
            },
            {
                label: "Size",
                value: '2.75" x 3.93"'
            },
            {
                label: "Styles",
                value: "Choose from 12 styles and order 1 or 3"
            },
            {
                label: "Note",
                value: "Holder only, lanyard not included."
            }
        ],
        image: $a4c20a4101738e30$var$idBadgeHoldersLifestyle,
        basePrice: 12,
        category: "ID/Badge Holders",
        skipUploads: true,
        personalization: $a4c20a4101738e30$var$badgeHolderPersonalization,
        optionLabel: "Choose Holder Style",
        quantityLabel: "Choose Quantity",
        options: {
            visualStyles: $a4c20a4101738e30$var$idBadgeStyles,
            quantities: $a4c20a4101738e30$var$idBadgeQuantities
        }
    },
    {
        id: 16,
        name: "Button Pins",
        description: 'Custom button pins available in 2.5" and 3" sizes with single and 5-pack pricing.',
        details: [
            {
                label: "Product",
                value: "Custom Button Pins"
            },
            {
                label: "Sizes",
                value: '2.5" and 3" buttons'
            },
            {
                label: "Pricing",
                value: "Single pins and 5-pack options available"
            }
        ],
        image: $a4c20a4101738e30$var$buttonPinsLifestyle,
        basePrice: 3,
        category: "Button Pins",
        optionLabel: "Choose Size / Quantity",
        options: {
            styles: [
                {
                    id: "2-5-single",
                    label: '2.5" button - 1 pin',
                    description: 'Single 2.5" custom button pin.',
                    price: 3
                },
                {
                    id: "2-5-five-pack",
                    label: '2.5" buttons - 5 pack',
                    description: 'Five 2.5" custom button pins.',
                    price: 10
                },
                {
                    id: "3-single",
                    label: '3" button - 1 pin',
                    description: 'Single 3" custom button pin.',
                    price: 3.5
                },
                {
                    id: "3-five-pack",
                    label: '3" buttons - 5 pack',
                    description: 'Five 3" custom button pins.',
                    price: 13
                }
            ]
        }
    },
    {
        id: 17,
        name: "Pot Holders",
        description: 'Custom pot holders, 8.25" x 10". Sold as a set of 2.',
        details: [
            {
                label: "Product",
                value: "Custom Pot Holders"
            },
            {
                label: "Size",
                value: '8.25" x 10"'
            },
            {
                label: "Quantity",
                value: "Set of 2"
            }
        ],
        image: $a4c20a4101738e30$var$potHoldersLifestyle,
        basePrice: 30,
        category: "Home Goods",
        options: {
            sizes: [
                {
                    label: "Set of 2",
                    dimensions: '8.25" x 10"',
                    price: 30
                }
            ]
        }
    },
    // GLASS FRAMES
    {
        id: 1,
        name: "Rectangle Glass Frame",
        description: "Custom Rectangle Glass Frame",
        details: [
            {
                label: "Product",
                value: "Custom Rectangle Glass Frame"
            },
            {
                label: "Sizes",
                value: 'Small 4.3" x 6.3", Medium 6" x 8", Large 7.87" x 11.2"'
            }
        ],
        image: $a4c20a4101738e30$var$rectangleGlassLifestyle,
        basePrice: 10,
        category: "Glass",
        options: {
            sizes: [
                {
                    label: "Small",
                    dimensions: '4.3" x 6.3"',
                    price: 10
                },
                {
                    label: "Medium",
                    dimensions: '6" x 8"',
                    price: 15
                },
                {
                    label: "Large",
                    dimensions: '7.87" x 11.2"',
                    price: 20
                }
            ]
        }
    },
    {
        id: 18,
        name: "Round Glass Frame",
        description: 'Custom Round Glass Frame, 9" x 9".',
        details: [
            {
                label: "Product",
                value: "Custom Round Glass Frame"
            },
            {
                label: "Size",
                value: '9" x 9"'
            },
            {
                label: "Personalization",
                value: "Optional custom phrase available for $1"
            }
        ],
        image: $a4c20a4101738e30$var$roundGlassLifestyle,
        basePrice: 35,
        category: "Glass",
        allowCustomPhrase: true,
        options: {
            sizes: [
                {
                    label: "Standard",
                    dimensions: '9" x 9"',
                    price: 35
                }
            ]
        }
    },
    {
        id: 2,
        name: "Light Up Glass Frame",
        description: "LED Light Up Glass Frame",
        details: [
            {
                label: "Product",
                value: "LED Light Up Glass Frame"
            },
            {
                label: "Size",
                value: '8" x 10"'
            }
        ],
        image: $a4c20a4101738e30$var$lightUpGlassLifestyle,
        basePrice: 45,
        category: "Glass",
        options: {
            sizes: [
                {
                    label: "Standard",
                    dimensions: '8" x 10"',
                    price: 45
                }
            ]
        }
    },
    // SLATE FRAMES
    {
        id: 3,
        name: "Rectangle Rock Slate",
        description: "Custom Rectangle Rock Slate Frame",
        details: [
            {
                label: "Product",
                value: "Custom Rectangle Rock Slate Frame"
            },
            {
                label: "Sizes",
                value: 'Medium 5.9" x 7.9", Large 8" x 10"'
            }
        ],
        image: $a4c20a4101738e30$var$rectangleSlateLifestyle,
        basePrice: 25,
        category: "Slate",
        options: {
            sizes: [
                {
                    label: "Medium",
                    dimensions: '5.9" x 7.9"',
                    price: 25
                },
                {
                    label: "Large",
                    dimensions: '8" x 10"',
                    price: 40
                }
            ]
        }
    },
    {
        id: 4,
        name: "Heart Rock Slate",
        description: "Custom Heart Rock Slate Frame",
        details: [
            {
                label: "Product",
                value: "Custom Heart Rock Slate Frame"
            },
            {
                label: "Sizes",
                value: 'Small 5.9" x 5.9", Medium 7.5" x 7.5"'
            }
        ],
        image: $a4c20a4101738e30$var$heartSlateLifestyle,
        basePrice: 18,
        category: "Slate",
        options: {
            sizes: [
                {
                    label: "Small",
                    dimensions: '5.9" x 5.9"',
                    price: 18
                },
                {
                    label: "Medium",
                    dimensions: '7.5" x 7.5"',
                    price: 25
                }
            ]
        }
    },
    {
        id: 5,
        name: "Round Rock Slate",
        description: "Custom Round Rock Slate Frame",
        details: [
            {
                label: "Product",
                value: "Custom Round Rock Slate Frame"
            },
            {
                label: "Size",
                value: '5.9" x 5.9"'
            }
        ],
        image: $a4c20a4101738e30$var$roundSlateLifestyle,
        basePrice: 18,
        category: "Slate",
        options: {
            sizes: [
                {
                    label: "Small",
                    dimensions: '5.9" x 5.9"',
                    price: 18
                }
            ]
        }
    },
    // TAGS
    {
        id: 6,
        name: "Sports / Luggage Tags",
        description: "Custom Sports Bag & Luggage Tags",
        details: [
            {
                label: "Product",
                value: "Custom Sports Bag & Luggage Tags"
            },
            {
                label: "Options",
                value: "Single-sided or double-sided printing"
            },
            {
                label: "Personalization",
                value: "Can include small text, name, sports number, and team mascot"
            }
        ],
        image: $a4c20a4101738e30$var$sportsTagsLifestyle,
        basePrice: 5,
        category: "Tags",
        options: {
            styles: [
                {
                    id: "single",
                    label: "Single Sided",
                    description: "Can include small text, name, sports number, and team mascot",
                    price: 5
                },
                {
                    id: "doubleSame",
                    label: "Double Sided (Same Photo)",
                    description: "Same photo on both sides. Can include text, name, sports number, and mascot",
                    price: 8
                },
                {
                    id: "doubleDifferent",
                    label: "Double Sided (Different Photos)",
                    description: "Different photos and/or text on each side. Can include text, name, sports number, and mascot",
                    price: 10
                }
            ]
        }
    },
    {
        id: 7,
        name: "Kindergarten Graduation T-Shirt & Stole",
        description: "Upload one photo and include the child's name and youth t-shirt size.",
        image: $a4c20a4101738e30$var$canvas12,
        basePrice: 30,
        category: "Graduation",
        requiredUploads: 1,
        requiresChildName: true,
        requiresYouthSize: true,
        isCustomProject: true,
        allowCustomPhrase: false,
        options: {
            sizes: [
                {
                    label: "Youth Small",
                    price: 30
                },
                {
                    label: "Youth Medium",
                    price: 30
                },
                {
                    label: "Youth Large",
                    price: 30
                },
                {
                    label: "Youth XL",
                    price: 30
                }
            ]
        }
    },
    {
        id: 8,
        name: "Custom Graduation Slate Frame",
        description: "Custom graduation slate frame. Upload 3 photos.",
        image: $a4c20a4101738e30$var$canvas15,
        basePrice: 35,
        category: "Graduation",
        requiredUploads: 3,
        isCustomProject: true,
        options: {
            sizes: [
                {
                    label: "Medium",
                    dimensions: '5.9" x 7.9"',
                    price: 35
                },
                {
                    label: "Large",
                    dimensions: '8" x 10"',
                    price: 55
                }
            ]
        }
    },
    {
        id: 9,
        name: "GradFlix Graduation Frame",
        description: "Upload 4 high quality photos. Paragraph text may be added at no additional cost.",
        image: $a4c20a4101738e30$var$canvas14,
        basePrice: 18,
        category: "Graduation",
        requiredUploads: 4,
        freeCustomPhrase: true,
        isCustomProject: true,
        options: {
            sizes: [
                {
                    label: "Standard",
                    dimensions: '6" x 8"',
                    price: 18
                }
            ]
        }
    },
    {
        id: 10,
        name: "DadFlix Father's Day Glass Frame",
        description: "5 photos. Paragraph text may be added at no additional cost.",
        image: $a4c20a4101738e30$var$canvas13,
        basePrice: 18,
        category: "Father's Day",
        requiredUploads: 5,
        freeCustomPhrase: true,
        isCustomProject: true,
        options: {
            sizes: [
                {
                    label: "Standard",
                    dimensions: '6" x 8"',
                    price: 18
                }
            ]
        }
    }
];
var $a4c20a4101738e30$export$2e2bcd8739ae039 = $a4c20a4101738e30$var$products;


var $f1a8b0ac7f8354ea$exports = {};
$f1a8b0ac7f8354ea$exports = import.meta.resolve("aIsRb");


const $8b294e964c12237c$var$glassLifestyle = new URL($f1a8b0ac7f8354ea$exports).href;
var $9d988c95e05236f5$exports = {};
$9d988c95e05236f5$exports = import.meta.resolve("bl6uv");


const $8b294e964c12237c$var$lightUpFrameBedtimeLifestyle = new URL($9d988c95e05236f5$exports).href;
var $32f5102b2b58df9c$exports = {};
$32f5102b2b58df9c$exports = import.meta.resolve("defLm");


const $8b294e964c12237c$var$slateLifestyle = new URL($32f5102b2b58df9c$exports).href;
var $b4e959502596cf70$exports = {};
$b4e959502596cf70$exports = import.meta.resolve("4zJTI");


const $8b294e964c12237c$var$tagLifestyle = new URL($b4e959502596cf70$exports).href;
var $612094dc7747e6bc$exports = {};
$612094dc7747e6bc$exports = import.meta.resolve("jDHac");


const $8b294e964c12237c$var$teacherBadgeLifestyle = new URL($612094dc7747e6bc$exports).href;
var $2460338889204697$exports = {};
$2460338889204697$exports = import.meta.resolve("leX6B");


const $8b294e964c12237c$var$denimPinsLifestyle = new URL($2460338889204697$exports).href;
var $55c3238abe05506b$exports = {};
$55c3238abe05506b$exports = import.meta.resolve("kLfn8");


const $8b294e964c12237c$var$kitchenPotHoldersLifestyle = new URL($55c3238abe05506b$exports).href;
const $8b294e964c12237c$var$heroTags = [
    "Backpacks",
    "Glass Frames",
    "Light-Up Frames",
    "Slate Frames",
    "Sports Tags",
    "ID Holders",
    "Button Pins",
    "Pot Holders"
];
const $8b294e964c12237c$var$hiddenSaleCategories = new Set([
    "Father's Day",
    "Graduation"
]);
const $8b294e964c12237c$var$categoryHighlights = [
    {
        title: "Back To School",
        category: "Back to School",
        copy: "Personalized backpacks, lunch bags, pencil pouches, and school essentials."
    },
    {
        title: "Glass Frames",
        category: "Glass",
        copy: "Glossy keepsakes with vivid photo color and clean display stands."
    },
    {
        title: "Slate Frames",
        category: "Slate",
        copy: "Natural stone pieces with organic edges and a substantial feel."
    },
    {
        title: "Sports & Luggage Tags",
        category: "Tags",
        copy: "Personalized tags for teams, travel bags, backpacks, and gifts."
    }
];
const $8b294e964c12237c$var$howItWorks = [
    {
        step: "01",
        title: "Choose your custom piece",
        copy: "Pick the frame, school essential, badge, pin, or tag style that fits the moment."
    },
    {
        step: "02",
        title: "Add your details",
        copy: "Send the photos, style choices, and notes needed to personalize the piece."
    },
    {
        step: "03",
        title: "Pickup locally",
        copy: "Soulful Customs confirms details and lets you know when it is ready."
    }
];
const $8b294e964c12237c$var$heroScenes = [
    {
        image: $8b294e964c12237c$var$glassLifestyle,
        title: "Rectangle Glass Frame",
        label: "Glass frames",
        headline: "Preserve Your Memories",
        copy: "Turn favorite photos into polished glass keepsakes made for shelves, desks, and everyday reminders."
    },
    {
        image: $8b294e964c12237c$var$lightUpFrameBedtimeLifestyle,
        title: "Light-Up Glass Frame",
        label: "Light-up frames",
        imagePosition: "68% center",
        headline: "Keep Memories Close At Night",
        copy: "Add a soft glow to favorite family photos with a light-up glass frame made for bedside moments."
    },
    {
        image: $8b294e964c12237c$var$slateLifestyle,
        title: "Heart Rock Slate",
        label: "Slate frames",
        headline: "Give Moments More Meaning",
        copy: "Create a heartfelt stone slate gift with natural texture, rich color, and a personal story behind it."
    },
    {
        image: $8b294e964c12237c$var$tagLifestyle,
        title: "Sports / Luggage Tags",
        label: "Custom tags",
        headline: "Make Everyday Gear Personal",
        copy: "Add custom photos, colors, and details to sports bags, backpacks, and luggage tags."
    },
    {
        image: $8b294e964c12237c$var$denimPinsLifestyle,
        title: "Jean Jacket Button Pins",
        label: "Wearable keepsakes",
        imagePosition: "center 18%",
        headline: "Pin Memories Where They Show",
        copy: "Add photo buttons to jackets, bags, and everyday outfits for a small custom detail with personality."
    },
    {
        image: $8b294e964c12237c$var$teacherBadgeLifestyle,
        title: "Teacher ID/Badge Holder",
        label: "Teacher styles",
        headline: "Carry Your Style To Work",
        copy: "Choose a teacher-inspired holder style and add the name or title that makes it yours."
    },
    {
        image: $8b294e964c12237c$var$kitchenPotHoldersLifestyle,
        title: "Custom Kitchen Pot Holders",
        label: "Kitchen gifts",
        headline: "Make The Kitchen Personal",
        copy: "Turn family photos and custom artwork into useful kitchen pieces made for everyday cooking."
    }
];
function $8b294e964c12237c$export$2e2bcd8739ae039({ isCompact: isCompact = false }) {
    const [selectedProduct, setSelectedProduct] = (0, $acw62.useState)(null);
    const visibleProducts = (0, $a4c20a4101738e30$export$2e2bcd8739ae039).filter((product)=>!$8b294e964c12237c$var$hiddenSaleCategories.has(product.category));
    const featuredProducts = [
        12,
        1,
        6
    ].map((id)=>visibleProducts.find((product)=>product.id === id)).filter(Boolean);
    const galleryProducts = [
        1,
        3,
        4,
        5,
        6,
        2
    ].map((id)=>visibleProducts.find((product)=>product.id === id)).filter(Boolean);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `luxHero${isCompact ? " luxHeroCompact" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "heroOverlay"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "heroContent",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "heroCopy",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "heroTextCarousel",
                                        "aria-live": "polite",
                                        children: $8b294e964c12237c$var$heroScenes.map((scene, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "heroTextSlide",
                                                style: {
                                                    "--scene-index": index
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                        children: scene.headline
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: scene.copy
                                                    })
                                                ]
                                            }, scene.headline))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "heroButtons",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: "/shop",
                                                className: "primaryBtn",
                                                children: "Order Prints"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: "/about",
                                                className: "secondaryBtn",
                                                children: "Our Story"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "heroTags",
                                        "aria-label": "Featured product types",
                                        children: $8b294e964c12237c$var$heroTags.map((tag)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: tag
                                            }, tag))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "heroShowcase",
                                "aria-label": "Product lifestyle scenes",
                                children: $8b294e964c12237c$var$heroScenes.map((scene, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("figure", {
                                        className: `heroScene${scene.imagePosition ? " heroScenePositioned" : ""}`,
                                        style: {
                                            "--scene-index": index,
                                            "--image-position": scene.imagePosition
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: scene.image,
                                                alt: `${scene.title} lifestyle scene`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("figcaption", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: scene.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: scene.title
                                                    })
                                                ]
                                            })
                                        ]
                                    }, scene.title))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "heroBottomFade"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: `homeStorefront${isCompact ? " homeStorefrontCompact" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "homeIntroBand",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "sectionEyebrow",
                                        children: "Start here"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: "Custom pieces for the photos worth keeping close."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Browse the core collection, add your details at checkout, and Soulful Customs will prepare your order for local pickup."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "homeCategoryGrid",
                        "aria-label": "Shop by category",
                        children: $8b294e964c12237c$var$categoryHighlights.map((category)=>{
                            const count = visibleProducts.filter((product)=>product.category === category.category).length;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/shop",
                                className: "homeCategoryCard",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            count,
                                            " options"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: category.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: category.copy
                                    })
                                ]
                            }, category.category);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "homeSplitSection",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "sectionEyebrow",
                                        children: "How it works"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: "A simple path from favorite photo to finished keepsake."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "processGrid",
                                children: $8b294e964c12237c$var$howItWorks.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "processStep",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: item.step
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: item.copy
                                            })
                                        ]
                                    }, item.step))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "homeProductSection",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "homeSectionHeader",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sectionEyebrow",
                                                children: "Featured"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "Popular ways to customize."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/shop",
                                        className: "textLink",
                                        children: "View all products"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "productGrid",
                                children: featuredProducts.map((product)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e36c7b6755e73ca$export$2e2bcd8739ae039), {
                                        product: product,
                                        onClick: ()=>setSelectedProduct(product)
                                    }, product.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "homeGallerySection",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "homeSectionHeader",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sectionEyebrow",
                                                children: "Previous work"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "A growing gallery of personalized pieces."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/contact",
                                        className: "textLink",
                                        children: "Ask a question"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "homeGalleryGrid",
                                children: galleryProducts.map((product)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: product.image,
                                        alt: product.name
                                    }, product.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "homeTrustBand",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Pickup only"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Local pickup arranged after your order is ready."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "4-5 business days"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Typical turnaround after purchase and order details."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Personalized orders"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Each piece is made from the photos and notes you provide."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            selectedProduct && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ab32c4c6b17e175$export$2e2bcd8739ae039), {
                product: selectedProduct,
                onClose: ()=>setSelectedProduct(null)
            })
        ]
    });
}



function $90a5d0e60c7a8ff3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "section aboutSection",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "aboutCard",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "About Soulful Customs"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Soulful Customs offers a wide variety of customized keepsakes and display pieces designed to preserve your most meaningful moments. Our collection includes custom glass frames, stone slate frames, and other personalized display items available in multiple styles and sizes. Each piece is thoughtfully crafted and includes a display stand."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "These one-of-a-kind personalized creations make meaningful gifts for Mother\u2019s Day, Father\u2019s Day, graduations, Valentine\u2019s Day, birthdays, anniversaries, and many other special occasions."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Customers may also add short custom phrases to their photos for an additional charge per frame."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "aboutList",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "Names"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "\u201CI Love You\u201D"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "\u201CHappy Mother\u2019s Day\u201D"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "\u201CCongrats Grad 2026\u201D"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "Due to the personalized nature of our products, full payment is required at the time of order and is ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "non-refundable"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "Orders are typically completed and ready for pickup within",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "4\u20135 Business Days"
                        }),
                        " of purchase."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Thank you for allowing Soulful Customs to create memorable gifts and keepsakes for you and your loved ones."
                })
            ]
        })
    });
}



parcelRequire("acw62");
function $612acbb6453dd4ca$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "section contactSection",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "contactContainer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Contact Soulful Customs"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "contactIntro",
                    children: "Questions about an order, custom requests, product options, or special occasions? We'd love to hear from you and help create the perfect personalized keepsake."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "contactGrid",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "contactCard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "mailto:support@soulfulcustoms.shop",
                                    className: "contactLink",
                                    children: "support@soulfulcustoms.shop"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "contactCard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Phone"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "tel:5103506360",
                                    className: "contactLink",
                                    children: "(510) 350-6360"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "contactCard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Social Media"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "contactSocialLinks",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "https://instagram.com/soulful_customs_",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "contactLink",
                                            children: "Instagram"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "https://www.facebook.com/profile.php?id=61591804949742&mibextid=wwXIfr",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "contactLink",
                                            children: "Facebook"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "contactCard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Turnaround Time"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "4\u20135 Business Days"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



const $72b2dfd9222704fd$var$hiddenSaleCategories = new Set([
    "Father's Day",
    "Graduation"
]);
const $72b2dfd9222704fd$var$categorySections = [
    {
        title: "Limited-Time Presale",
        category: "Back To School Presale",
        description: "Back to school bundle pricing available 7/11-7/18 while presale is open."
    },
    {
        title: "Back To School",
        category: "Back to School",
        description: "Personalized school essentials, including the limited-time presale bundle."
    },
    {
        title: "Glass Frames",
        category: "Glass",
        description: "Premium glass keepsakes with vibrant photo reproduction and elegant display stands."
    },
    {
        title: "Slate Frames",
        category: "Slate",
        description: "Natural stone photo displays crafted to preserve life's most meaningful moments."
    },
    {
        title: "Sports & Luggage Tags",
        category: "Tags",
        description: "Personalized tags perfect for athletes, teams, travel, and everyday identification."
    },
    {
        title: "ID/Badge Holders",
        category: "ID/Badge Holders",
        description: "Custom holders for IDs, work badges, and teacher badge inserts with single or 3-pack pricing."
    },
    {
        title: "Button Pins",
        category: "Button Pins",
        description: "Personalized button pins available in multiple sizes and bundle quantities."
    },
    {
        title: "Home Goods",
        category: "Home Goods",
        description: "Useful custom pieces for home gifting, kitchens, and everyday keepsakes."
    }
];
function $72b2dfd9222704fd$export$2e2bcd8739ae039() {
    const [selectedProduct, setSelectedProduct] = (0, $acw62.useState)(null);
    const visibleProducts = (0, $a4c20a4101738e30$export$2e2bcd8739ae039).filter((product)=>!$72b2dfd9222704fd$var$hiddenSaleCategories.has(product.category));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "shopPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "shopHeader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "shopEyebrow",
                                children: "Shop"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: "Custom Collection"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Choose a product, select a size or style, then add any required photos or notes at checkout."
                    })
                ]
            }),
            $72b2dfd9222704fd$var$categorySections.map((section)=>{
                const sectionProducts = visibleProducts.filter((product)=>product.category === section.category);
                if (sectionProducts.length === 0) return null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "shopCategory",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "shopCategoryHeader",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: section.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "categoryDescription",
                                            children: section.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "categoryCount",
                                    children: [
                                        sectionProducts.length,
                                        " ",
                                        sectionProducts.length === 1 ? "item" : "items"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "productGrid",
                            children: sectionProducts.map((product)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e36c7b6755e73ca$export$2e2bcd8739ae039), {
                                    product: product,
                                    onClick: ()=>setSelectedProduct(product)
                                }, product.id))
                        })
                    ]
                }, section.category);
            }),
            selectedProduct && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ab32c4c6b17e175$export$2e2bcd8739ae039), {
                product: selectedProduct,
                onClose: ()=>setSelectedProduct(null)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

async function $69dd0c0f45f96013$export$a5575dbeeffdad98(file) {
    const fd = new FormData();
    fd.append("file", file);
    const url = "https://soulful-upload.ceaser-r-hernandez.workers.dev";
    const response = await fetch(url, {
        method: "POST",
        body: fd
    });
    return await response.json();
}


const $a7f559d5d89c892f$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $029952e65115eee5$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $029952e65115eee5$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $029952e65115eee5$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $029952e65115eee5$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $029952e65115eee5$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $029952e65115eee5$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $029952e65115eee5$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($029952e65115eee5$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $029952e65115eee5$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $029952e65115eee5$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $029952e65115eee5$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $029952e65115eee5$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $029952e65115eee5$var$stringToByteArray$1(str);
    return $029952e65115eee5$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $029952e65115eee5$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $029952e65115eee5$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $029952e65115eee5$export$c62426fdd000a97e = function(str) {
    try {
        return $029952e65115eee5$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $029952e65115eee5$export$6c40052bed430212(value) {
    return $029952e65115eee5$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $029952e65115eee5$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$029952e65115eee5$var$isValidKey(prop)) continue;
        target[prop] = $029952e65115eee5$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $029952e65115eee5$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $029952e65115eee5$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$getDefaultsFromGlobal = ()=>$029952e65115eee5$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $029952e65115eee5$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $029952e65115eee5$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $029952e65115eee5$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $029952e65115eee5$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $a7f559d5d89c892f$export$6d3c090e66a883b1)() || $029952e65115eee5$var$getDefaultsFromGlobal() || $029952e65115eee5$var$getDefaultsFromEnvVariable() || $029952e65115eee5$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $029952e65115eee5$export$9c11895284c8adad = (productName)=>$029952e65115eee5$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $029952e65115eee5$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $029952e65115eee5$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $029952e65115eee5$export$3dfb6827a9f89756 = ()=>$029952e65115eee5$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $029952e65115eee5$export$5539a1a3afe87d6 = (name)=>$029952e65115eee5$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $029952e65115eee5$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(header)),
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $029952e65115eee5$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $029952e65115eee5$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($029952e65115eee5$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $029952e65115eee5$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $029952e65115eee5$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $029952e65115eee5$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $029952e65115eee5$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $029952e65115eee5$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $029952e65115eee5$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $029952e65115eee5$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $029952e65115eee5$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $029952e65115eee5$export$f2f6a8999f8ebd30() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $029952e65115eee5$export$7e7b1a9668aaed8() {
    const ua = $029952e65115eee5$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $029952e65115eee5$export$202944b2d2824246() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $029952e65115eee5$export$5d1d834fbbf8bab7() {
    return $029952e65115eee5$export$588c7fdda06fbb0a.NODE_CLIENT === true || $029952e65115eee5$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $029952e65115eee5$export$95df08bae54cb4df() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $029952e65115eee5$export$ef10bcfb06572016() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $029952e65115eee5$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $029952e65115eee5$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $029952e65115eee5$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $029952e65115eee5$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $029952e65115eee5$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $029952e65115eee5$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $029952e65115eee5$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $029952e65115eee5$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $029952e65115eee5$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $029952e65115eee5$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $029952e65115eee5$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $029952e65115eee5$var$replaceTemplate(template, data) {
    return template.replace($029952e65115eee5$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $029952e65115eee5$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $029952e65115eee5$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $029952e65115eee5$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[0]) || '');
        claims = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$5f870fcca7ae6a88 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$701c661ec91095f2 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $029952e65115eee5$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$fc970ed23da99565 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $029952e65115eee5$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $029952e65115eee5$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $029952e65115eee5$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $029952e65115eee5$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($029952e65115eee5$var$isObject(aProp) && $029952e65115eee5$var$isObject(bProp)) {
            if (!$029952e65115eee5$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $029952e65115eee5$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $029952e65115eee5$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $029952e65115eee5$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $029952e65115eee5$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $029952e65115eee5$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $029952e65115eee5$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $029952e65115eee5$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $029952e65115eee5$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $029952e65115eee5$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $029952e65115eee5$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($029952e65115eee5$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $029952e65115eee5$var$noop;
        if (observer.error === undefined) observer.error = $029952e65115eee5$var$noop;
        if (observer.complete === undefined) observer.complete = $029952e65115eee5$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $029952e65115eee5$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $029952e65115eee5$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $029952e65115eee5$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $029952e65115eee5$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $029952e65115eee5$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $029952e65115eee5$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $029952e65115eee5$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $029952e65115eee5$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $029952e65115eee5$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $029952e65115eee5$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $029952e65115eee5$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $029952e65115eee5$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $029952e65115eee5$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($029952e65115eee5$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $029952e65115eee5$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $029952e65115eee5$var$indicator(i);
}
function $029952e65115eee5$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $029952e65115eee5$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $029952e65115eee5$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ async function $029952e65115eee5$export$7220bf91e5c1b402(input) {
    const textEncoder = new TextEncoder();
    const data = textEncoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hexHash;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5782dd2556309534$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $5782dd2556309534$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $029952e65115eee5$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($5782dd2556309534$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $5782dd2556309534$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $5782dd2556309534$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $5782dd2556309534$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $5782dd2556309534$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $5782dd2556309534$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $5782dd2556309534$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $5782dd2556309534$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $59d1e3b150b2f36d$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $59d1e3b150b2f36d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($59d1e3b150b2f36d$export$243e62d78d3b544d || ($59d1e3b150b2f36d$export$243e62d78d3b544d = {}));
const $59d1e3b150b2f36d$var$levelStringToEnum = {
    'debug': $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG,
    'verbose': $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE,
    'info': $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO,
    'warn': $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN,
    'error': $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR,
    'silent': $59d1e3b150b2f36d$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $59d1e3b150b2f36d$var$defaultLogLevel = $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $59d1e3b150b2f36d$var$ConsoleMethod = {
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG]: 'log',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.INFO]: 'info',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.WARN]: 'warn',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $59d1e3b150b2f36d$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $59d1e3b150b2f36d$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $59d1e3b150b2f36d$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $59d1e3b150b2f36d$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $59d1e3b150b2f36d$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $59d1e3b150b2f36d$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $59d1e3b150b2f36d$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $59d1e3b150b2f36d$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $59d1e3b150b2f36d$export$c622e99c0ce7b1c9(level) {
    $59d1e3b150b2f36d$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $59d1e3b150b2f36d$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $59d1e3b150b2f36d$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $59d1e3b150b2f36d$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $59d1e3b150b2f36d$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($5e587d655f0a08bb$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $5e587d655f0a08bb$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $5e587d655f0a08bb$var$name$q = "@firebase/app";
const $5e587d655f0a08bb$var$version$1 = "0.14.12";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$logger = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)('@firebase/app');
const $5e587d655f0a08bb$var$name$p = "@firebase/app-compat";
const $5e587d655f0a08bb$var$name$o = "@firebase/analytics-compat";
const $5e587d655f0a08bb$var$name$n = "@firebase/analytics";
const $5e587d655f0a08bb$var$name$m = "@firebase/app-check-compat";
const $5e587d655f0a08bb$var$name$l = "@firebase/app-check";
const $5e587d655f0a08bb$var$name$k = "@firebase/auth";
const $5e587d655f0a08bb$var$name$j = "@firebase/auth-compat";
const $5e587d655f0a08bb$var$name$i = "@firebase/database";
const $5e587d655f0a08bb$var$name$h = "@firebase/data-connect";
const $5e587d655f0a08bb$var$name$g = "@firebase/database-compat";
const $5e587d655f0a08bb$var$name$f = "@firebase/functions";
const $5e587d655f0a08bb$var$name$e = "@firebase/functions-compat";
const $5e587d655f0a08bb$var$name$d = "@firebase/installations";
const $5e587d655f0a08bb$var$name$c = "@firebase/installations-compat";
const $5e587d655f0a08bb$var$name$b = "@firebase/messaging";
const $5e587d655f0a08bb$var$name$a = "@firebase/messaging-compat";
const $5e587d655f0a08bb$var$name$9 = "@firebase/performance";
const $5e587d655f0a08bb$var$name$8 = "@firebase/performance-compat";
const $5e587d655f0a08bb$var$name$7 = "@firebase/remote-config";
const $5e587d655f0a08bb$var$name$6 = "@firebase/remote-config-compat";
const $5e587d655f0a08bb$var$name$5 = "@firebase/storage";
const $5e587d655f0a08bb$var$name$4 = "@firebase/storage-compat";
const $5e587d655f0a08bb$var$name$3 = "@firebase/firestore";
const $5e587d655f0a08bb$var$name$2 = "@firebase/ai";
const $5e587d655f0a08bb$var$name$1 = "@firebase/firestore-compat";
const $5e587d655f0a08bb$var$name = "firebase";
const $5e587d655f0a08bb$var$version = "12.13.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $5e587d655f0a08bb$export$9f30fa0c10967f7f = '[DEFAULT]';
const $5e587d655f0a08bb$var$PLATFORM_LOG_STRING = {
    [$5e587d655f0a08bb$var$name$q]: 'fire-core',
    [$5e587d655f0a08bb$var$name$p]: 'fire-core-compat',
    [$5e587d655f0a08bb$var$name$n]: 'fire-analytics',
    [$5e587d655f0a08bb$var$name$o]: 'fire-analytics-compat',
    [$5e587d655f0a08bb$var$name$l]: 'fire-app-check',
    [$5e587d655f0a08bb$var$name$m]: 'fire-app-check-compat',
    [$5e587d655f0a08bb$var$name$k]: 'fire-auth',
    [$5e587d655f0a08bb$var$name$j]: 'fire-auth-compat',
    [$5e587d655f0a08bb$var$name$i]: 'fire-rtdb',
    [$5e587d655f0a08bb$var$name$h]: 'fire-data-connect',
    [$5e587d655f0a08bb$var$name$g]: 'fire-rtdb-compat',
    [$5e587d655f0a08bb$var$name$f]: 'fire-fn',
    [$5e587d655f0a08bb$var$name$e]: 'fire-fn-compat',
    [$5e587d655f0a08bb$var$name$d]: 'fire-iid',
    [$5e587d655f0a08bb$var$name$c]: 'fire-iid-compat',
    [$5e587d655f0a08bb$var$name$b]: 'fire-fcm',
    [$5e587d655f0a08bb$var$name$a]: 'fire-fcm-compat',
    [$5e587d655f0a08bb$var$name$9]: 'fire-perf',
    [$5e587d655f0a08bb$var$name$8]: 'fire-perf-compat',
    [$5e587d655f0a08bb$var$name$7]: 'fire-rc',
    [$5e587d655f0a08bb$var$name$6]: 'fire-rc-compat',
    [$5e587d655f0a08bb$var$name$5]: 'fire-gcs',
    [$5e587d655f0a08bb$var$name$4]: 'fire-gcs-compat',
    [$5e587d655f0a08bb$var$name$3]: 'fire-fst',
    [$5e587d655f0a08bb$var$name$1]: 'fire-fst-compat',
    [$5e587d655f0a08bb$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$5e587d655f0a08bb$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $5e587d655f0a08bb$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $5e587d655f0a08bb$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5e587d655f0a08bb$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $5e587d655f0a08bb$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $5e587d655f0a08bb$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $5e587d655f0a08bb$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($5e587d655f0a08bb$export$9566bce3835c0f28.has(componentName)) {
        $5e587d655f0a08bb$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $5e587d655f0a08bb$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $5e587d655f0a08bb$export$b4e3c36c855b14b5.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $5e587d655f0a08bb$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$38e311c93c671bec(obj) {
    if ($5e587d655f0a08bb$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $5e587d655f0a08bb$export$3685d89b9c3cdfaf() {
    $5e587d655f0a08bb$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $5e587d655f0a08bb$var$ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('app', 'Firebase', $5e587d655f0a08bb$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $5e587d655f0a08bb$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $029952e65115eee5$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $5e587d655f0a08bb$var$FirebaseServerAppImpl extends $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $5e587d655f0a08bb$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $5e587d655f0a08bb$export$31499a9cd224b78c = $5e587d655f0a08bb$var$version;
function $5e587d655f0a08bb$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $5e587d655f0a08bb$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!options) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(name);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseAppImpl(options, config, container);
    $5e587d655f0a08bb$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $5e587d655f0a08bb$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $029952e65115eee5$export$4e09c449d6c407f7)() && !(0, $029952e65115eee5$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($5e587d655f0a08bb$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($5e587d655f0a08bb$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(nameString);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $5e587d655f0a08bb$export$f9962582c9e66d99(name = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    const app = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $5e587d655f0a08bb$export$9f30fa0c10967f7f && (0, $029952e65115eee5$export$3dfb6827a9f89756)()) return $5e587d655f0a08bb$export$c55cfd413944906d();
    if (!app) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $5e587d655f0a08bb$export$68ddedf7d44b3bdf() {
    return Array.from($5e587d655f0a08bb$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $5e587d655f0a08bb$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($5e587d655f0a08bb$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $5e587d655f0a08bb$export$b4e3c36c855b14b5.delete(name);
    } else if ($5e587d655f0a08bb$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $5e587d655f0a08bb$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $5e587d655f0a08bb$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $5e587d655f0a08bb$var$logger.warn(warning.join(' '));
        return;
    }
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $5e587d655f0a08bb$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $59d1e3b150b2f36d$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $5e587d655f0a08bb$export$c622e99c0ce7b1c9(logLevel) {
    (0, $59d1e3b150b2f36d$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$DB_NAME = 'firebase-heartbeat-database';
const $5e587d655f0a08bb$var$DB_VERSION = 1;
const $5e587d655f0a08bb$var$STORE_NAME = 'firebase-heartbeat-store';
let $5e587d655f0a08bb$var$dbPromise = null;
function $5e587d655f0a08bb$var$getDbPromise() {
    if (!$5e587d655f0a08bb$var$dbPromise) $5e587d655f0a08bb$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($5e587d655f0a08bb$var$DB_NAME, $5e587d655f0a08bb$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($5e587d655f0a08bb$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $5e587d655f0a08bb$var$dbPromise;
}
async function $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME);
        const result = await tx.objectStore($5e587d655f0a08bb$var$STORE_NAME).get($5e587d655f0a08bb$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
async function $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($5e587d655f0a08bb$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $5e587d655f0a08bb$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
function $5e587d655f0a08bb$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$MAX_HEADER_BYTES = 1024;
const $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $5e587d655f0a08bb$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $5e587d655f0a08bb$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $5e587d655f0a08bb$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $029952e65115eee5$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
            return '';
        }
    }
}
function $5e587d655f0a08bb$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $5e587d655f0a08bb$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $5e587d655f0a08bb$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $5e587d655f0a08bb$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return false;
        else return (0, $029952e65115eee5$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $5e587d655f0a08bb$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $029952e65115eee5$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5e587d655f0a08bb$var$registerCoreComponents(variant) {
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('platform-logger', (container)=>new $5e587d655f0a08bb$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('heartbeat', (container)=>new $5e587d655f0a08bb$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $5e587d655f0a08bb$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $5e587d655f0a08bb$var$registerCoreComponents('');





var $906344b47e605252$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $906344b47e605252$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $906344b47e605252$export$70ffa26850098d01;
var $906344b47e605252$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(d, a) {
        function c() {}
        c.prototype = a.prototype;
        d.F = a.prototype;
        d.prototype = new c;
        d.prototype.constructor = d;
        d.D = function(f, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(f, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.C = Array(this.blockSize);
        this.o = this.h = 0;
        this.u();
    }
    k(m, l);
    m.prototype.u = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(d, a, c) {
        c || (c = 0);
        const f = Array(16);
        if (typeof a === "string") for(var e = 0; e < 16; ++e)f[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; e < 16; ++e)f[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = d.g[0];
        c = d.g[1];
        e = d.g[2];
        let g = d.g[3], b;
        b = a + (g ^ c & (e ^ g)) + f[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + f[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + f[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + f[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[9] + 3951481745 & 4294967295;
        d.g[0] = d.g[0] + a & 4294967295;
        d.g[1] = d.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        d.g[2] = d.g[2] + e & 4294967295;
        d.g[3] = d.g[3] + g & 4294967295;
    }
    m.prototype.v = function(d, a) {
        a === void 0 && (a = d.length);
        const c = a - this.blockSize, f = this.C;
        let e = this.h, g = 0;
        for(; g < a;){
            if (e == 0) for(; g <= c;)n(this, d, g), g += this.blockSize;
            if (typeof d === "string") {
                for(; g < a;)if (f[e++] = d.charCodeAt(g++), e == this.blockSize) {
                    n(this, f);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (f[e++] = d[g++], e == this.blockSize) {
                n(this, f);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.A = function() {
        var d = Array((this.h < 56 ? this.blockSize : this.blockSize * 2) - this.h);
        d[0] = 128;
        for(var a = 1; a < d.length - 8; ++a)d[a] = 0;
        a = this.o * 8;
        for(var c = d.length - 8; c < d.length; ++c)d[c] = a & 255, a /= 256;
        this.v(d);
        d = Array(16);
        a = 0;
        for(c = 0; c < 4; ++c)for(let f = 0; f < 32; f += 8)d[a++] = this.g[c] >>> f & 255;
        return d;
    };
    function p(d, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, d) ? c[d] : c[d] = a(d);
    }
    function t(d, a) {
        this.h = a;
        const c = [];
        let f = !0;
        for(let e = d.length - 1; e >= 0; e--){
            const g = d[e] | 0;
            f && g == a || (c[e] = g, f = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(d) {
        return -128 <= d && d < 128 ? p(d, function(a) {
            return new t([
                a | 0
            ], a < 0 ? -1 : 0);
        }) : new t([
            d | 0
        ], d < 0 ? -1 : 0);
    }
    function v(d) {
        if (isNaN(d) || !isFinite(d)) return w;
        if (d < 0) return x(v(-d));
        const a = [];
        let c = 1;
        for(let f = 0; d >= c; f++)a[f] = d / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(d, a) {
        if (d.length == 0) throw Error("number format error: empty string");
        a = a || 10;
        if (a < 2 || 36 < a) throw Error("radix out of range: " + a);
        if (d.charAt(0) == "-") return x(y(d.substring(1), a));
        if (d.indexOf("-") >= 0) throw Error('number format error: interior "-" character');
        const c = v(Math.pow(a, 8));
        let f = w;
        for(let g = 0; g < d.length; g += 8){
            var e = Math.min(8, d.length - g);
            const b = parseInt(d.substring(g, g + e), a);
            e < 8 ? (e = v(Math.pow(a, e)), f = f.j(e).add(v(b))) : (f = f.j(c), f = f.add(v(b)));
        }
        return f;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        let d = 0, a = 1;
        for(let c = 0; c < this.g.length; c++){
            const f = this.i(c);
            d += (f >= 0 ? f : 4294967296 + f) * a;
            a *= 4294967296;
        }
        return d;
    };
    h.toString = function(d) {
        d = d || 10;
        if (d < 2 || 36 < d) throw Error("radix out of range: " + d);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(d);
        const a = v(Math.pow(d, 6));
        var c = this;
        let f = "";
        for(;;){
            const e = D(c, a).g;
            c = F(c, e.j(a));
            let g = ((c.g.length > 0 ? c.g[0] : c.h) >>> 0).toString(d);
            c = e;
            if (C(c)) return g + f;
            for(; g.length < 6;)g = "0" + g;
            f = g + f;
        }
    };
    h.i = function(d) {
        return d < 0 ? 0 : d < this.g.length ? this.g[d] : this.h;
    };
    function C(d) {
        if (d.h != 0) return !1;
        for(let a = 0; a < d.g.length; a++)if (d.g[a] != 0) return !1;
        return !0;
    }
    function B(d) {
        return d.h == -1;
    }
    h.l = function(d) {
        d = F(this, d);
        return B(d) ? -1 : C(d) ? 0 : 1;
    };
    function x(d) {
        const a = d.g.length, c = [];
        for(let f = 0; f < a; f++)c[f] = ~d.g[f];
        return new t(c, ~d.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        let f = 0;
        for(let e = 0; e <= a; e++){
            let g = f + (this.i(e) & 65535) + (d.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (d.i(e) >>> 16);
            f = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(d, a) {
        return d.add(x(a));
    }
    h.j = function(d) {
        if (C(this) || C(d)) return w;
        if (B(this)) return B(d) ? x(this).j(x(d)) : x(x(this).j(d));
        if (B(d)) return x(this.j(x(d)));
        if (this.l(A) < 0 && d.l(A) < 0) return v(this.m() * d.m());
        const a = this.g.length + d.g.length, c = [];
        for(var f = 0; f < 2 * a; f++)c[f] = 0;
        for(f = 0; f < this.g.length; f++)for(let e = 0; e < d.g.length; e++){
            const g = this.i(f) >>> 16, b = this.i(f) & 65535, r = d.i(e) >>> 16, E = d.i(e) & 65535;
            c[2 * f + 2 * e] += b * E;
            G(c, 2 * f + 2 * e);
            c[2 * f + 2 * e + 1] += g * E;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 1] += b * r;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 2] += g * r;
            G(c, 2 * f + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(d, a) {
        for(; (d[a] & 65535) != d[a];)d[a + 1] += d[a] >>> 16, d[a] &= 65535, a++;
    }
    function H(d, a) {
        this.g = d;
        this.h = a;
    }
    function D(d, a) {
        if (C(a)) throw Error("division by zero");
        if (C(d)) return new H(w, w);
        if (B(d)) return a = D(x(d), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(d, x(a)), new H(x(a.g), a.h);
        if (d.g.length > 30) {
            if (B(d) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, f = a; f.l(d) <= 0;)c = I(c), f = I(f);
            var e = J(c, 1), g = J(f, 1);
            f = J(f, 2);
            for(c = J(c, 2); !C(f);){
                var b = g.add(f);
                b.l(d) <= 0 && (e = e.add(c), g = b);
                f = J(f, 1);
                c = J(c, 1);
            }
            a = F(d, e.j(a));
            return new H(e, a);
        }
        for(e = w; d.l(a) >= 0;){
            c = Math.max(1, Math.floor(d.m() / a.m()));
            f = Math.ceil(Math.log(c) / Math.LN2);
            f = f <= 48 ? 1 : Math.pow(2, f - 48);
            g = v(c);
            for(b = g.j(a); B(b) || b.l(d) > 0;)c -= f, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            d = F(d, b);
        }
        return new H(e, d);
    }
    h.B = function(d) {
        return D(this, d).h;
    };
    h.and = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) & d.i(f);
        return new t(c, this.h & d.h);
    };
    h.or = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) | d.i(f);
        return new t(c, this.h | d.h);
    };
    h.xor = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) ^ d.i(f);
        return new t(c, this.h ^ d.h);
    };
    function I(d) {
        const a = d.g.length + 1, c = [];
        for(let f = 0; f < a; f++)c[f] = d.i(f) << 1 | d.i(f - 1) >>> 31;
        return new t(c, d.h);
    }
    function J(d, a) {
        const c = a >> 5;
        a %= 32;
        const f = d.g.length - c, e = [];
        for(let g = 0; g < f; g++)e[g] = a > 0 ? d.i(g + c) >>> a | d.i(g + c + 1) << 32 - a : d.i(g + c);
        return new t(e, d.h);
    }
    m.prototype.digest = m.prototype.A;
    m.prototype.reset = m.prototype.u;
    m.prototype.update = m.prototype.v;
    $906344b47e605252$export$9f5a3dfc7a9f5dd = $906344b47e605252$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.B;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $906344b47e605252$export$70ffa26850098d01 = $906344b47e605252$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $906344b47e605252$var$commonjsGlobal !== 'undefined' ? $906344b47e605252$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});



var $33cb313d667e3306$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $33cb313d667e3306$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $33cb313d667e3306$export$26404658cda3ee02;
var $33cb313d667e3306$export$ddb1030448106742;
var $33cb313d667e3306$export$aa726fb96ad3e039;
var $33cb313d667e3306$export$3d7865934588d77e;
var $33cb313d667e3306$export$d4e71bc0b80dc0fb;
var $33cb313d667e3306$export$cbbc350c1dfc80cb;
var $33cb313d667e3306$export$d61e24a684f9e51;
var $33cb313d667e3306$export$888d0d9ab79d08fc;
var $33cb313d667e3306$export$66869136fc133c3a;
(function() {
    var h, aa = Object.defineProperty;
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $33cb313d667e3306$var$commonjsGlobal && $33cb313d667e3306$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    da("Symbol.dispose", function(a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return this[Symbol.iterator]();
        };
    });
    da("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)Object.prototype.hasOwnProperty.call(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var ea = ea || {}, l = this || self;
    function n(a) {
        var b = typeof a;
        return b == "object" && a != null || b == "function";
    }
    function fa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function p(a, b, c) {
        p = fa;
        return p.apply(null, arguments);
    }
    function ha(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Z = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Ob = function(d, e, f) {
            for(var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++)g[k - 2] = arguments[k];
            return b.prototype[e].apply(d, g);
        };
    }
    var ia = typeof AsyncContext !== "undefined" && typeof AsyncContext.Snapshot === "function" ? (a)=>a && AsyncContext.Snapshot.wrap(a) : (a)=>a;
    function ja(a) {
        const b = a.length;
        if (b > 0) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ka(a, b) {
        for(let d = 1; d < arguments.length; d++){
            const e = arguments[d];
            var c = typeof e;
            c = c != "object" ? c : e ? Array.isArray(e) ? "array" : c : "null";
            if (c == "array" || c == "object" && typeof e.length == "number") {
                c = a.length || 0;
                const f = e.length || 0;
                a.length = c + f;
                for(let g = 0; g < f; g++)a[c + g] = e[g];
            } else a.push(e);
        }
    }
    class la {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            this.h > 0 ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function ma(a) {
        l.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function na() {
        var a = oa;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class pa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = qa.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var qa = new la(()=>new ra, (a)=>a.reset());
    class ra {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let u, v = !1, oa = new pa, ta = ()=>{
        const a = Promise.resolve(void 0);
        u = ()=>{
            a.then(sa);
        };
    };
    function sa() {
        for(var a; a = na();){
            try {
                a.h.call(a.g);
            } catch (c) {
                ma(c);
            }
            var b = qa;
            b.j(a);
            b.h < 100 && (b.h++, a.next = b.g, b.g = a);
        }
        v = !1;
    }
    function w() {
        this.u = this.u;
        this.C = this.C;
    }
    w.prototype.u = !1;
    w.prototype.dispose = function() {
        this.u || (this.u = !0, this.N());
    };
    w.prototype[Symbol.dispose] = function() {
        this.dispose();
    };
    w.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function x(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    x.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var ua = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            l.addEventListener("test", c, b);
            l.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function y(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function z(a, b) {
        x.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        a && this.init(a, b);
    }
    t(z, x);
    z.prototype.init = function(a, b) {
        const c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? b = a.fromElement : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && z.Z.h.call(this);
    };
    z.prototype.h = function() {
        z.Z.h.call(this);
        const a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var B = "closure_listenable_" + (Math.random() * 1E6 | 0);
    var va = 0;
    function wa(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++va;
        this.da = this.fa = !1;
    }
    function xa(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function ya(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function Aa(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function Ba(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Da(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < Ca.length; f++)c = Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ea(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ea.prototype.add = function(a, b, c, d, e) {
        const f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        const g = Fa(a, b, d, e);
        g > -1 ? (b = a[g], c || (b.fa = !1)) : (b = new wa(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ga(a, b) {
        const c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = e >= 0) && Array.prototype.splice.call(d, e, 1);
            f && (xa(b), a.g[c].length == 0 && (delete a.g[c], a.h--));
        }
    }
    function Fa(a, b, c, d) {
        for(let e = 0; e < a.length; ++e){
            const f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Ha = "closure_lm_" + (Math.random() * 1E6 | 0), Ia = {};
    function Ka(a, b, c, d, e) {
        if (d && d.once) return La(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)Ka(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.J(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !1, d, e);
    }
    function Na(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        const g = n(e) ? !!e.capture : !!e;
        let k = Oa(a);
        k || (a[Ha] = k = new Ea(a));
        c = k.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Pa();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ua || (e = g), e === void 0 && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Qa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Pa() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Ra;
        return a;
    }
    function La(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)La(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !0, d, e);
    }
    function Sa(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Sa(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Ma(c), a && a[B]) ? (a = a.i, f = String(b).toString(), f in a.g && (b = a.g[f], c = Fa(b, c, d, e), c > -1 && (xa(b[c]), Array.prototype.splice.call(b, c, 1), b.length == 0 && (delete a.g[f], a.h--)))) : a && (a = Oa(a)) && (b = a.g[b.toString()], a = -1, b && (a = Fa(b, c, d, e)), (c = a > -1 ? b[a] : null) && Ta(c));
    }
    function Ta(a) {
        if (typeof a !== "number" && a && !a.da) {
            var b = a.src;
            if (b && b[B]) Ga(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Qa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Oa(b)) ? (Ga(c, a), c.h == 0 && (c.src = null, b[Ha] = null)) : xa(a);
            }
        }
    }
    function Qa(a) {
        return a in Ia ? Ia[a] : Ia[a] = "on" + a;
    }
    function Ra(a, b) {
        if (a.da) a = !0;
        else {
            b = new z(b, this);
            const c = a.listener, d = a.ha || a.src;
            a.fa && Ta(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Oa(a) {
        a = a[Ha];
        return a instanceof Ea ? a : null;
    }
    var Ua = "__closure_events_fn_" + (Math.random() * 1E9 >>> 0);
    function Ma(a) {
        if (typeof a === "function") return a;
        a[Ua] || (a[Ua] = function(b) {
            return a.handleEvent(b);
        });
        return a[Ua];
    }
    function C() {
        w.call(this);
        this.i = new Ea(this);
        this.M = this;
        this.G = null;
    }
    t(C, w);
    C.prototype[B] = !0;
    C.prototype.removeEventListener = function(a, b, c, d) {
        Sa(this, a, b, c, d);
    };
    function D(a, b) {
        var c, d = a.G;
        if (d) for(c = []; d; d = d.G)c.push(d);
        a = a.M;
        d = b.type || b;
        if (typeof b === "string") b = new x(b, a);
        else if (b instanceof x) b.target = b.target || a;
        else {
            var e = b;
            b = new x(d, a);
            Da(b, e);
        }
        e = !0;
        let f, g;
        if (c) for(g = c.length - 1; g >= 0; g--)f = b.g = c[g], e = Va(f, d, !0, b) && e;
        f = b.g = a;
        e = Va(f, d, !0, b) && e;
        e = Va(f, d, !1, b) && e;
        if (c) for(g = 0; g < c.length; g++)f = b.g = c[g], e = Va(f, d, !1, b) && e;
    }
    C.prototype.N = function() {
        C.Z.N.call(this);
        if (this.i) {
            var a = this.i;
            for(const c in a.g){
                const d = a.g[c];
                for(let e = 0; e < d.length; e++)xa(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.G = null;
    };
    C.prototype.J = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    C.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function Va(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        let e = !0;
        for(let f = 0; f < b.length; ++f){
            const g = b[f];
            if (g && !g.da && g.capture == c) {
                const k = g.listener, q = g.ha || g.src;
                g.fa && Ga(a.i, g);
                e = k.call(q, d) !== !1 && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Wa(a, b) {
        if (typeof a !== "function") {
            if (a && typeof a.handleEvent == "function") a = p(a.handleEvent, a);
            else throw Error("Invalid listener argument");
        }
        return Number(b) > 2147483647 ? -1 : l.setTimeout(a, b || 0);
    }
    function Xa(a) {
        a.g = Wa(()=>{
            a.g = null;
            a.i && (a.i = !1, Xa(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class Ya extends w {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : Xa(this);
        }
        N() {
            super.N();
            this.g && (l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function E(a) {
        w.call(this);
        this.h = a;
        this.g = {};
    }
    t(E, w);
    var Za = [];
    function $a(a) {
        ya(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Ta(b);
        }, a);
        a.g = {};
    }
    E.prototype.N = function() {
        E.Z.N.call(this);
        $a(this);
    };
    E.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var ab = l.JSON.stringify;
    var cb = l.JSON.parse;
    var db = class {
        stringify(a) {
            return l.JSON.stringify(a, void 0);
        }
        parse(a) {
            return l.JSON.parse(a, void 0);
        }
    };
    function eb() {}
    function fb() {}
    var H = {
        OPEN: "a",
        hb: "b",
        ERROR: "c",
        tb: "d"
    };
    function gb() {
        x.call(this, "d");
    }
    t(gb, x);
    function hb() {
        x.call(this, "c");
    }
    t(hb, x);
    var I = {}, ib = null;
    function jb() {
        return ib = ib || new C;
    }
    I.Ia = "serverreachability";
    function kb(a) {
        x.call(this, I.Ia, a);
    }
    t(kb, x);
    function lb(a) {
        const b = jb();
        D(b, new kb(b));
    }
    I.STAT_EVENT = "statevent";
    function mb(a, b) {
        x.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    t(mb, x);
    function J(a) {
        const b = jb();
        D(b, new mb(b, a));
    }
    I.Ja = "timingevent";
    function nb(a, b) {
        x.call(this, I.Ja, a);
        this.size = b;
    }
    t(nb, x);
    function ob(a, b) {
        if (typeof a !== "function") throw Error("Fn must not be null and must be a function");
        return l.setTimeout(function() {
            a();
        }, b);
    }
    function pb() {
        this.g = !0;
    }
    pb.prototype.ua = function() {
        this.g = !1;
    };
    function qb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    var k = f.split("&");
                    for(let m = 0; m < k.length; m++){
                        var q = k[m].split("=");
                        if (q.length > 1) {
                            const r = q[0];
                            q = q[1];
                            const A = r.split("_");
                            g = A.length >= 2 && A[1] == "type" ? g + (r + "=" + q + "&") : g + (r + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function rb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function K(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + sb(a, c) + (d ? " " + d : "");
        });
    }
    function tb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    pb.prototype.info = function() {};
    function sb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            const f = JSON.parse(b);
            if (f) {
                for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                    var c = f[a];
                    if (!(c.length < 2)) {
                        var d = c[1];
                        if (Array.isArray(d) && !(d.length < 1)) {
                            var e = d[0];
                            if (e != "noop" && e != "stop" && e != "close") for(let g = 1; g < d.length; g++)d[g] = "";
                        }
                    }
                }
            }
            return ab(f);
        } catch (f) {
            return b;
        }
    }
    var ub = {
        NO_ERROR: 0,
        cb: 1,
        qb: 2,
        pb: 3,
        kb: 4,
        ob: 5,
        rb: 6,
        Ga: 7,
        TIMEOUT: 8,
        ub: 9
    };
    var vb = {
        ib: "complete",
        Fb: "success",
        ERROR: "error",
        Ga: "abort",
        xb: "ready",
        yb: "readystatechange",
        TIMEOUT: "timeout",
        sb: "incrementaldata",
        wb: "progress",
        lb: "downloadprogress",
        Nb: "uploadprogress"
    };
    var wb;
    function xb() {}
    t(xb, eb);
    xb.prototype.g = function() {
        return new XMLHttpRequest;
    };
    wb = new xb;
    function L(a) {
        return encodeURIComponent(String(a));
    }
    function yb(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; b > 0 && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function N(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.S = d || 1;
        this.V = new E(this);
        this.H = 45E3;
        this.J = null;
        this.o = !1;
        this.u = this.B = this.A = this.M = this.F = this.T = this.D = null;
        this.G = [];
        this.g = null;
        this.C = 0;
        this.m = this.v = null;
        this.X = -1;
        this.K = !1;
        this.P = 0;
        this.O = null;
        this.W = this.L = this.U = this.R = !1;
        this.h = new zb;
    }
    function zb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Ab = {}, Bb = {};
    function Cb(a, b, c) {
        a.M = 1;
        a.A = Db(O(b));
        a.u = c;
        a.R = !0;
        Eb(a, null);
    }
    function Eb(a, b) {
        a.F = Date.now();
        Fb(a);
        a.B = O(a.A);
        var c = a.B, d = a.S;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Gb(c.i, "t", d);
        a.C = 0;
        c = a.j.L;
        a.h = new zb;
        a.g = Hb(a.j, c ? b : null, !a.u);
        a.P > 0 && (a.O = new Ya(p(a.Y, a, a.g), a.P));
        b = a.V;
        c = a.g;
        d = a.ba;
        var e = "readystatechange";
        Array.isArray(e) || (e && (Za[0] = e.toString()), e = Za);
        for(let f = 0; f < e.length; f++){
            const g = Ka(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.J ? Ba(a.J) : {};
        a.u ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.B, a.v, a.u, b)) : (a.v = "GET", a.g.ea(a.B, a.v, null, b));
        lb();
        qb(a.i, a.v, a.B, a.l, a.S, a.u);
    }
    N.prototype.ba = function(a) {
        a = a.target;
        const b = this.O;
        b && P(a) == 3 ? b.j() : this.Y(a);
    };
    N.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const k = P(this.g), q = this.g.ya(), m = this.g.ca();
                if (!(k < 3) && (k != 3 || this.g && (this.h.h || this.g.la() || Ib(this.g)))) {
                    this.K || k != 4 || q == 7 || (q == 8 || m <= 0 ? lb(3) : lb(2));
                    Jb(this);
                    var b = this.g.ca();
                    this.X = b;
                    var c = Kb(this);
                    this.o = b == 200;
                    rb(this.i, this.v, this.B, this.l, this.S, k, b);
                    if (this.o) {
                        if (this.U && !this.L) {
                            b: {
                                if (this.g) {
                                    var d, e = this.g;
                                    if ((d = e.g ? e.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(d)) {
                                        var f = d;
                                        break b;
                                    }
                                }
                                f = null;
                            }
                            if (a = f) K(this.i, this.l, a, "Initial handshake response via X-HTTP-Initial-Response"), this.L = !0, Lb(this, a);
                            else {
                                this.o = !1;
                                this.m = 3;
                                J(12);
                                Q(this);
                                Mb(this);
                                break a;
                            }
                        }
                        if (this.R) {
                            a = !0;
                            let r;
                            for(; !this.K && this.C < c.length;)if (r = Nb(this, c), r == Bb) {
                                k == 4 && (this.m = 4, J(14), a = !1);
                                K(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (r == Ab) {
                                this.m = 4;
                                J(15);
                                K(this.i, this.l, c, "[Invalid Chunk]");
                                a = !1;
                                break;
                            } else K(this.i, this.l, r, null), Lb(this, r);
                            Ob(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            k != 4 || c.length != 0 || this.h.h || (this.m = 1, J(16), a = !1);
                            this.o = this.o && a;
                            if (!a) K(this.i, this.l, c, "[Invalid Chunked Response]"), Q(this), Mb(this);
                            else if (c.length > 0 && !this.W) {
                                this.W = !0;
                                var g = this.j;
                                g.g == this && g.aa && !g.P && (g.j.info("Great, no buffering proxy detected. Bytes received: " + c.length), Pb(g), g.P = !0, J(11));
                            }
                        } else K(this.i, this.l, c, null), Lb(this, c);
                        k == 4 && Q(this);
                        this.o && !this.K && (k == 4 ? Qb(this.j, this) : (this.o = !1, Fb(this)));
                    } else Rb(this.g), b == 400 && c.indexOf("Unknown SID") > 0 ? (this.m = 3, J(12)) : (this.m = 0, J(13)), Q(this), Mb(this);
                }
            }
        } catch (k) {} finally{}
    };
    function Kb(a) {
        if (!Ob(a)) return a.g.la();
        const b = Ib(a.g);
        if (b === "") return "";
        let c = "";
        const d = b.length, e = P(a.g) == 4;
        if (!a.h.i) {
            if (typeof TextDecoder === "undefined") return Q(a), Mb(a), "";
            a.h.i = new l.TextDecoder;
        }
        for(let f = 0; f < d; f++)a.h.h = !0, c += a.h.i.decode(b[f], {
            stream: !(e && f == d - 1)
        });
        b.length = 0;
        a.h.g += c;
        a.C = 0;
        return a.h.g;
    }
    function Ob(a) {
        return a.g ? a.v == "GET" && a.M != 2 && a.j.Aa : !1;
    }
    function Nb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (d == -1) return Bb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Ab;
        d += 1;
        if (d + c > b.length) return Bb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    N.prototype.cancel = function() {
        this.K = !0;
        Q(this);
    };
    function Fb(a) {
        a.T = Date.now() + a.H;
        Sb(a, a.H);
    }
    function Sb(a, b) {
        if (a.D != null) throw Error("WatchDog timer not null");
        a.D = ob(p(a.aa, a), b);
    }
    function Jb(a) {
        a.D && (l.clearTimeout(a.D), a.D = null);
    }
    N.prototype.aa = function() {
        this.D = null;
        const a = Date.now();
        a - this.T >= 0 ? (tb(this.i, this.B), this.M != 2 && (lb(), J(17)), Q(this), this.m = 2, Mb(this)) : Sb(this, this.T - a);
    };
    function Mb(a) {
        a.j.I == 0 || a.K || Qb(a.j, a);
    }
    function Q(a) {
        Jb(a);
        var b = a.O;
        b && typeof b.dispose == "function" && b.dispose();
        a.O = null;
        $a(a.V);
        a.g && (b = a.g, a.g = null, b.abort(), b.dispose());
    }
    function Lb(a, b) {
        try {
            var c = a.j;
            if (c.I != 0 && (c.g == a || Tb(c.h, a))) {
                if (!a.L && Tb(c.h, a) && c.I == 3) {
                    try {
                        var d = c.Ba.g.parse(b);
                    } catch (m) {
                        d = null;
                    }
                    if (Array.isArray(d) && d.length == 3) {
                        var e = d;
                        if (e[0] == 0) {
                            a: if (!c.v) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Ub(c), Vb(c);
                                    else break a;
                                }
                                Wb(c);
                                J(18);
                            }
                        } else c.xa = e[1], 0 < c.xa - c.K && e[2] < 37500 && c.F && c.A == 0 && !c.C && (c.C = ob(p(c.Va, c), 6E3));
                        Xb(c.h) <= 1 && c.ta && (c.ta = void 0);
                    } else R(c, 11);
                } else if ((a.L || c.g == a) && Ub(c), !y(b)) for(e = c.Ba.g.parse(b), b = 0; b < e.length; b++){
                    let m = e[b];
                    const r = m[0];
                    if (!(r <= c.K)) {
                        if (c.K = r, m = m[1], c.I == 2) {
                            if (m[0] == "c") {
                                c.M = m[1];
                                c.ba = m[2];
                                const A = m[3];
                                A != null && (c.ka = A, c.j.info("VER=" + c.ka));
                                const M = m[4];
                                M != null && (c.za = M, c.j.info("SVER=" + c.za));
                                const F = m[5];
                                F != null && typeof F === "number" && F > 0 && (d = 1.5 * F, c.O = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                                d = c;
                                const G = a.g;
                                if (G) {
                                    const za = G.g ? G.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (za) {
                                        var f = d.h;
                                        f.g || za.indexOf("spdy") == -1 && za.indexOf("quic") == -1 && za.indexOf("h2") == -1 || (f.j = f.l, f.g = new Set, f.h && (Yb(f, f.h), f.h = null));
                                    }
                                    if (d.G) {
                                        const bb = G.g ? G.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        bb && (d.wa = bb, S(d.J, d.G, bb));
                                    }
                                }
                                c.I = 3;
                                c.l && c.l.ra();
                                c.aa && (c.T = Date.now() - a.F, c.j.info("Handshake RTT: " + c.T + "ms"));
                                d = c;
                                var g = a;
                                d.na = Zb(d, d.L ? d.ba : null, d.W);
                                if (g.L) {
                                    $b(d.h, g);
                                    var k = g, q = d.O;
                                    q && (k.H = q);
                                    k.D && (Jb(k), Fb(k));
                                    d.g = g;
                                } else ac(d);
                                c.i.length > 0 && bc(c);
                            } else m[0] != "stop" && m[0] != "close" || R(c, 7);
                        } else c.I == 3 && (m[0] == "stop" || m[0] == "close" ? m[0] == "stop" ? R(c, 7) : cc(c) : m[0] != "noop" && c.l && c.l.qa(m), c.A = 0);
                    }
                }
            }
            lb(4);
        } catch (m) {}
    }
    var dc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ec(a) {
        this.l = a || 10;
        l.PerformanceNavigationTiming ? (a = l.performance.getEntriesByType("navigation"), a = a.length > 0 && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(l.chrome && l.chrome.loadTimes && l.chrome.loadTimes() && l.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        this.j > 1 && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function fc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function Xb(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Tb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function Yb(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function $b(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ec.prototype.cancel = function() {
        this.i = hc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && this.g.size !== 0) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function hc(a) {
        if (a.h != null) return a.i.concat(a.h.G);
        if (a.g != null && a.g.size !== 0) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.G);
            return b;
        }
        return ja(a.i);
    }
    var ic = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function jc(a, b) {
        if (a) {
            a = a.split("&");
            for(let c = 0; c < a.length; c++){
                const d = a[c].indexOf("=");
                let e, f = null;
                d >= 0 ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];
                b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.u = null;
        this.m = this.h = "";
        this.l = !1;
        let b;
        a instanceof T ? (this.l = a.l, kc(this, a.j), this.o = a.o, this.g = a.g, lc(this, a.u), this.h = a.h, mc(this, nc(a.i)), this.m = a.m) : a && (b = String(a).match(ic)) ? (this.l = !1, kc(this, b[1] || "", !0), this.o = oc(b[2] || ""), this.g = oc(b[3] || "", !0), lc(this, b[4]), this.h = oc(b[5] || "", !0), mc(this, b[6] || "", !0), this.m = oc(b[7] || "")) : (this.l = !1, this.i = new pc(null, this.l));
    }
    T.prototype.toString = function() {
        const a = [];
        var b = this.j;
        b && a.push(qc(b, rc, !0), ":");
        var c = this.g;
        if (c || b == "file") a.push("//"), (b = this.o) && a.push(qc(b, rc, !0), "@"), a.push(L(c).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, c != null && a.push(":", String(c));
        if (c = this.h) this.g && c.charAt(0) != "/" && a.push("/"), a.push(qc(c, c.charAt(0) == "/" ? sc : tc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", qc(c, uc));
        return a.join("");
    };
    T.prototype.resolve = function(a) {
        const b = O(this);
        let c = !!a.j;
        c ? kc(b, a.j) : c = !!a.o;
        c ? b.o = a.o : c = !!a.g;
        c ? b.g = a.g : c = a.u != null;
        var d = a.h;
        if (c) lc(b, a.u);
        else if (c = !!a.h) {
            if (d.charAt(0) != "/") {
                if (this.g && !this.h) d = "/" + d;
                else {
                    var e = b.h.lastIndexOf("/");
                    e != -1 && (d = b.h.slice(0, e + 1) + d);
                }
            }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (e.indexOf("./") != -1 || e.indexOf("/.") != -1) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                const f = [];
                for(let g = 0; g < e.length;){
                    const k = e[g++];
                    k == "." ? d && g == e.length && f.push("") : k == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.h = d : c = a.i.toString() !== "";
        c ? mc(b, nc(a.i)) : c = !!a.m;
        c && (b.m = a.m);
        return b;
    };
    function O(a) {
        return new T(a);
    }
    function kc(a, b, c) {
        a.j = c ? oc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function lc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
            a.u = b;
        } else a.u = null;
    }
    function mc(a, b, c) {
        b instanceof pc ? (a.i = b, vc(a.i, a.l)) : (c || (b = qc(b, wc)), a.i = new pc(b, a.l));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Db(a) {
        S(a, "zx", Math.floor(Math.random() * 2147483648).toString(36) + Math.abs(Math.floor(Math.random() * 2147483648) ^ Date.now()).toString(36));
        return a;
    }
    function oc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function qc(a, b, c) {
        return typeof a === "string" ? (a = encodeURI(a).replace(b, xc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function xc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var rc = /[#\/\?@]/g, tc = /[#\?:]/g, sc = /[#\?]/g, wc = /[#\?@]/g, uc = /#/g;
    function pc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && jc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = pc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        let c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function yc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function zc(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    function Ac(a, b) {
        U(a);
        let c = [];
        if (typeof b === "string") zc(a, b) && (c = c.concat(a.g.get(V(a, b))));
        else for(a = Array.from(a.g.values()), b = 0; b < a.length; b++)c = c.concat(a[b]);
        return c;
    }
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        zc(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = Ac(this, a);
        return a.length > 0 ? String(a[0]) : b;
    };
    function Gb(a, b, c) {
        yc(a, b);
        c.length > 0 && (a.i = null, a.g.set(V(a, b), ja(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(let d = 0; d < b.length; d++){
            var c = b[d];
            const e = L(c);
            c = Ac(this, c);
            for(let f = 0; f < c.length; f++){
                let g = e;
                c[f] !== "" && (g += "=" + L(c[f]));
                a.push(g);
            }
        }
        return this.i = a.join("&");
    };
    function nc(a) {
        const b = new pc;
        b.i = a.i;
        a.g && (b.g = new Map(a.g), b.h = a.h);
        return b;
    }
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function vc(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            const e = d.toLowerCase();
            d != e && (yc(this, d), Gb(this, e, c));
        }, a));
        a.j = b;
    }
    function Bc(a, b) {
        const c = new pb;
        if (l.Image) {
            const d = new Image;
            d.onload = ha(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ha(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ha(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ha(W, c, "TestLoadImage: timeout", !1, b, d);
            l.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Cc(a, b) {
        const c = new pb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Dc() {
        this.g = new db;
    }
    function Ec(a) {
        this.i = a.Sb || null;
        this.h = a.ab || !1;
    }
    t(Ec, eb);
    Ec.prototype.g = function() {
        return new Fc(this.i, this.h);
    };
    function Fc(a, b) {
        C.call(this);
        this.H = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.A = new Headers;
        this.h = null;
        this.F = "GET";
        this.D = "";
        this.g = !1;
        this.B = this.j = this.l = null;
        this.v = new AbortController;
    }
    t(Fc, C);
    h = Fc.prototype;
    h.open = function(a, b) {
        if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
        this.F = a;
        this.D = b;
        this.readyState = 1;
        Gc(this);
    };
    h.send = function(a) {
        if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
        if (this.v.signal.aborted) throw this.abort(), Error("Request was aborted.");
        this.g = !0;
        const b = {
            headers: this.A,
            method: this.F,
            credentials: this.m,
            cache: void 0,
            signal: this.v.signal
        };
        a && (b.body = a);
        (this.H || l).fetch(new Request(this.D, b)).then(this.Pa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.A = new Headers;
        this.status = 0;
        this.v.abort();
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        this.readyState >= 1 && this.g && this.readyState != 4 && (this.g = !1, Hc(this));
        this.readyState = 0;
    };
    h.Pa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Gc(this)), this.g && (this.readyState = 3, Gc(this), this.g))) {
            if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Na.bind(this), this.ga.bind(this));
            else if (typeof l.ReadableStream !== "undefined" && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.B = new TextDecoder;
                Ic(this);
            } else a.text().then(this.Oa.bind(this), this.ga.bind(this));
        }
    };
    function Ic(a) {
        a.j.read().then(a.Ma.bind(a)).catch(a.ga.bind(a));
    }
    h.Ma = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.B.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Hc(this) : Gc(this);
            this.readyState == 3 && Ic(this);
        }
    };
    h.Oa = function(a) {
        this.g && (this.response = this.responseText = a, Hc(this));
    };
    h.Na = function(a) {
        this.g && (this.response = a, Hc(this));
    };
    h.ga = function() {
        this.g && Hc(this);
    };
    function Hc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.B = null;
        Gc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.A.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Gc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Fc.prototype, "withCredentials", {
        get: function() {
            return this.m === "include";
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Jc(a) {
        let b = "";
        ya(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Kc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Jc(c), typeof a === "string" ? c != null && L(c) : S(a, b, c));
    }
    function X(a) {
        C.call(this);
        this.headers = new Map;
        this.L = a || null;
        this.h = !1;
        this.g = null;
        this.D = "";
        this.o = 0;
        this.l = "";
        this.j = this.B = this.v = this.A = !1;
        this.m = null;
        this.F = "";
        this.H = !1;
    }
    t(X, C);
    var Lc = /^https?$/i, Mc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Fa = function(a) {
        this.H = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.o = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.L ? this.L.g() : wb.g();
        this.g.onreadystatechange = ia(p(this.Ca, this));
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Nc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if (typeof d.keys === "function" && typeof d.get === "function") for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = l.FormData && a instanceof l.FormData;
        !(Array.prototype.indexOf.call(Mc, b, void 0) >= 0) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.F && (this.g.responseType = this.F);
        "withCredentials" in this.g && this.g.withCredentials !== this.H && (this.g.withCredentials = this.H);
        try {
            this.m && (clearTimeout(this.m), this.m = null), this.v = !0, this.g.send(a), this.v = !1;
        } catch (f) {
            Nc(this, f);
        }
    };
    function Nc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.o = 5;
        Oc(a);
        Pc(a);
    }
    function Oc(a) {
        a.A || (a.A = !0, D(a, "complete"), D(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.o = a || 7, D(this, "complete"), D(this, "abort"), Pc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Pc(this, !0));
        X.Z.N.call(this);
    };
    h.Ca = function() {
        this.u || (this.B || this.v || this.j ? Qc(this) : this.Xa());
    };
    h.Xa = function() {
        Qc(this);
    };
    function Qc(a) {
        if (a.h && typeof ea != "undefined") {
            if (a.v && P(a) == 4) setTimeout(a.Ca.bind(a), 0);
            else if (D(a, "readystatechange"), P(a) == 4) {
                a.h = !1;
                try {
                    const f = a.ca();
                    a: switch(f){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = f === 0) {
                            let g = String(a.D).match(ic)[1] || null;
                            !g && l.self && l.self.location && (g = l.self.location.protocol.slice(0, -1));
                            d = !Lc.test(g ? g.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) D(a, "complete"), D(a, "success");
                    else {
                        a.o = 6;
                        try {
                            var e = P(a) > 2 ? a.g.statusText : "";
                        } catch (g) {
                            e = "";
                        }
                        a.l = e + " [" + a.ca() + "]";
                        Oc(a);
                    }
                } finally{
                    Pc(a);
                }
            }
        }
    }
    function Pc(a, b) {
        if (a.g) {
            a.m && (clearTimeout(a.m), a.m = null);
            const c = a.g;
            a.g = null;
            b || D(a, "ready");
            try {
                c.onreadystatechange = null;
            } catch (d) {}
        }
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.ca = function() {
        try {
            return P(this) > 2 ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.la = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.La = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && b.indexOf(a) == 0 && (b = b.substring(a.length));
            return cb(b);
        }
    };
    function Ib(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.F){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Rb(a) {
        const b = {};
        a = (a.g && P(a) >= 2 ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (y(a[d])) continue;
            var c = yb(a[d]);
            const e = c[0];
            c = c[1];
            if (typeof c !== "string") continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        Aa(b, function(d) {
            return d.join(", ");
        });
    }
    h.ya = function() {
        return this.o;
    };
    h.Ha = function() {
        return typeof this.l === "string" ? this.l : String(this.l);
    };
    function Rc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Sc(a) {
        this.za = 0;
        this.i = [];
        this.j = new pb;
        this.ba = this.na = this.J = this.W = this.g = this.wa = this.G = this.H = this.u = this.U = this.o = null;
        this.Ya = this.V = 0;
        this.Sa = Rc("failFast", !1, a);
        this.F = this.C = this.v = this.m = this.l = null;
        this.X = !0;
        this.xa = this.K = -1;
        this.Y = this.A = this.D = 0;
        this.Qa = Rc("baseRetryDelayMs", 5E3, a);
        this.Za = Rc("retryDelaySeedMs", 1E4, a);
        this.Ta = Rc("forwardChannelMaxRetries", 2, a);
        this.va = Rc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.ma = a && a.xmlHttpFactory || void 0;
        this.Ua = a && a.Rb || void 0;
        this.Aa = a && a.useFetchStreams || !1;
        this.O = void 0;
        this.L = a && a.supportsCrossDomainXhr || !1;
        this.M = "";
        this.h = new ec(a && a.concurrentRequestLimit);
        this.Ba = new Dc;
        this.S = a && a.fastHandshake || !1;
        this.R = a && a.encodeInitMessageHeaders || !1;
        this.S && this.R && (this.R = !1);
        this.Ra = a && a.Pb || !1;
        a && a.ua && this.j.ua();
        a && a.forceLongPolling && (this.X = !1);
        this.aa = !this.S && this.X && a && a.detectBufferingProxy || !1;
        this.ia = void 0;
        a && a.longPollingTimeout && a.longPollingTimeout > 0 && (this.ia = a.longPollingTimeout);
        this.ta = void 0;
        this.T = 0;
        this.P = !1;
        this.ja = this.B = null;
    }
    h = Sc.prototype;
    h.ka = 8;
    h.I = 1;
    h.connect = function(a, b, c, d) {
        J(0);
        this.W = a;
        this.H = b || {};
        c && d !== void 0 && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.J = Zb(this, null, this.W);
        bc(this);
    };
    function cc(a) {
        Tc(a);
        if (a.I == 3) {
            var b = a.V++, c = O(a.J);
            S(c, "SID", a.M);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            Uc(a, c);
            b = new N(a, a.j, b);
            b.M = 2;
            b.A = Db(O(c));
            c = !1;
            if (l.navigator && l.navigator.sendBeacon) try {
                c = l.navigator.sendBeacon(b.A.toString(), "");
            } catch (d) {}
            !c && l.Image && ((new Image).src = b.A, c = !0);
            c || (b.g = Hb(b.j, null), b.g.ea(b.A));
            b.F = Date.now();
            Fb(b);
        }
        Vc(a);
    }
    function Vb(a) {
        a.g && (Pb(a), a.g.cancel(), a.g = null);
    }
    function Tc(a) {
        Vb(a);
        a.v && (l.clearTimeout(a.v), a.v = null);
        Ub(a);
        a.h.cancel();
        a.m && (typeof a.m === "number" && l.clearTimeout(a.m), a.m = null);
    }
    function bc(a) {
        if (!fc(a.h) && !a.m) {
            a.m = !0;
            var b = a.Ea;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.D = 0;
        }
    }
    function Wc(a, b) {
        if (Xb(a.h) >= a.h.j - (a.m ? 1 : 0)) return !1;
        if (a.m) return a.i = b.G.concat(a.i), !0;
        if (a.I == 1 || a.I == 2 || a.D >= (a.Sa ? 0 : a.Ta)) return !1;
        a.m = ob(p(a.Ea, a, b), Xc(a, a.D));
        a.D++;
        return !0;
    }
    h.Ea = function(a) {
        if (this.m) {
            if (this.m = null, this.I == 1) {
                if (!a) {
                    this.V = Math.floor(Math.random() * 1E5);
                    a = this.V++;
                    const e = new N(this, this.j, a);
                    let f = this.o;
                    this.U && (f ? (f = Ba(f), Da(f, this.U)) : f = this.U);
                    this.u !== null || this.R || (e.J = f, f = null);
                    if (this.S) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, typeof d === "string")) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (d === void 0) break;
                            b += d;
                            if (b > 4096) {
                                b = c;
                                break a;
                            }
                            if (b === 4096 || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = Yc(this, e, b);
                    c = O(this.J);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.G && S(c, "X-HTTP-Session-Id", this.G);
                    Uc(this, c);
                    f && (this.R ? b = "headers=" + L(Jc(f)) + "&" + b : this.u && Kc(c, this.u, f));
                    Yb(this.h, e);
                    this.Ra && S(c, "TYPE", "init");
                    this.S ? (S(c, "$req", b), S(c, "SID", "null"), e.U = !0, Cb(e, c, null)) : Cb(e, c, b);
                    this.I = 2;
                }
            } else this.I == 3 && (a ? Zc(this, a) : this.i.length == 0 || fc(this.h) || Zc(this));
        }
    };
    function Zc(a, b) {
        var c;
        b ? c = b.l : c = a.V++;
        const d = O(a.J);
        S(d, "SID", a.M);
        S(d, "RID", c);
        S(d, "AID", a.K);
        Uc(a, d);
        a.u && a.o && Kc(d, a.u, a.o);
        c = new N(a, a.j, c, a.D + 1);
        a.u === null && (c.J = a.o);
        b && (a.i = b.G.concat(a.i));
        b = Yc(a, c, 1E3);
        c.H = Math.round(a.va * .5) + Math.round(a.va * .5 * Math.random());
        Yb(a.h, c);
        Cb(c, d, b);
    }
    function Uc(a, b) {
        a.H && ya(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && ya({}, function(c, d) {
            S(b, d, c);
        });
    }
    function Yc(a, b, c) {
        c = Math.min(a.i.length, c);
        const d = a.l ? p(a.l.Ka, a.l, a) : null;
        a: {
            var e = a.i;
            let k = -1;
            for(;;){
                const q = [
                    "count=" + c
                ];
                k == -1 ? c > 0 ? (k = e[0].g, q.push("ofs=" + k)) : k = 0 : q.push("ofs=" + k);
                let m = !0;
                for(let r = 0; r < c; r++){
                    var f = e[r].g;
                    const A = e[r].map;
                    f -= k;
                    if (f < 0) k = Math.max(0, e[r].g - 100), m = !1;
                    else try {
                        f = "req" + f + "_";
                        try {
                            var g = A instanceof Map ? A : Object.entries(A);
                            for (const [M, F] of g){
                                let G = F;
                                n(F) && (G = ab(F));
                                q.push(f + M + "=" + encodeURIComponent(G));
                            }
                        } catch (M) {
                            throw q.push(f + "type=" + encodeURIComponent("_badmap")), M;
                        }
                    } catch (M) {
                        d && d(A);
                    }
                }
                if (m) {
                    g = q.join("&");
                    break a;
                }
            }
            g = void 0;
        }
        a = a.i.splice(0, c);
        b.G = a;
        return g;
    }
    function ac(a) {
        if (!a.g && !a.v) {
            a.Y = 1;
            var b = a.Da;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.A = 0;
        }
    }
    function Wb(a) {
        if (a.g || a.v || a.A >= 3) return !1;
        a.Y++;
        a.v = ob(p(a.Da, a), Xc(a, a.A));
        a.A++;
        return !0;
    }
    h.Da = function() {
        this.v = null;
        $c(this);
        if (this.aa && !(this.P || this.g == null || this.T <= 0)) {
            var a = 4 * this.T;
            this.j.info("BP detection timer enabled: " + a);
            this.B = ob(p(this.Wa, this), a);
        }
    };
    h.Wa = function() {
        this.B && (this.B = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.P = !0, J(10), Vb(this), $c(this));
    };
    function Pb(a) {
        a.B != null && (l.clearTimeout(a.B), a.B = null);
    }
    function $c(a) {
        a.g = new N(a, a.j, "rpc", a.Y);
        a.u === null && (a.g.J = a.o);
        a.g.P = 0;
        var b = O(a.na);
        S(b, "RID", "rpc");
        S(b, "SID", a.M);
        S(b, "AID", a.K);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ia && S(b, "TO", a.ia);
        S(b, "TYPE", "xmlhttp");
        Uc(a, b);
        a.u && a.o && Kc(b, a.u, a.o);
        a.O && (a.g.H = a.O);
        var c = a.g;
        a = a.ba;
        c.M = 1;
        c.A = Db(O(b));
        c.u = null;
        c.R = !0;
        Eb(c, a);
    }
    h.Va = function() {
        this.C != null && (this.C = null, Vb(this), Wb(this), J(19));
    };
    function Ub(a) {
        a.C != null && (l.clearTimeout(a.C), a.C = null);
    }
    function Qb(a, b) {
        var c = null;
        if (a.g == b) {
            Ub(a);
            Pb(a);
            a.g = null;
            var d = 2;
        } else if (Tb(a.h, b)) c = b.G, $b(a.h, b), d = 1;
        else return;
        if (a.I != 0) {
            if (b.o) {
                if (d == 1) {
                    c = b.u ? b.u.length : 0;
                    b = Date.now() - b.F;
                    var e = a.D;
                    d = jb();
                    D(d, new nb(d, c));
                    bc(a);
                } else ac(a);
            } else if (e = b.m, e == 3 || e == 0 && b.X > 0 || !(d == 1 && Wc(a, b) || d == 2 && Wb(a))) switch(c && c.length > 0 && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function Xc(a, b) {
        let c = a.Qa + Math.floor(Math.random() * a.Za);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (b == 2) {
            var c = p(a.bb, a), d = a.Ua;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            l.location && l.location.protocol == "http" || kc(d, "https");
            Db(d);
            e ? Bc(d.toString(), c) : Cc(d.toString(), c);
        } else J(2);
        a.I = 0;
        a.l && a.l.pa(b);
        Vc(a);
        Tc(a);
    }
    h.bb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), J(2)) : (this.j.info("Failed to ping google.com"), J(1));
    };
    function Vc(a) {
        a.I = 0;
        a.ja = [];
        if (a.l) {
            const b = hc(a.h);
            if (b.length != 0 || a.i.length != 0) ka(a.ja, b), ka(a.ja, a.i), a.h.i.length = 0, ja(a.i), a.i.length = 0;
            a.l.oa();
        }
    }
    function Zb(a, b, c) {
        var d = c instanceof T ? O(c) : new T(c);
        if (d.g != "") b && (d.g = b + "." + d.g), lc(d, d.u);
        else {
            var e = l.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            const f = new T(null);
            d && kc(f, d);
            b && (f.g = b);
            e && lc(f, e);
            c && (f.h = c);
            d = f;
        }
        c = a.G;
        b = a.wa;
        c && b && S(d, c, b);
        S(d, "VER", a.ka);
        Uc(a, d);
        return d;
    }
    function Hb(a, b, c) {
        if (b && !a.L) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Aa && !a.ma ? new X(new Ec({
            ab: c
        })) : new X(a.ma);
        b.Fa(a.L);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function ad() {}
    h = ad.prototype;
    h.ra = function() {};
    h.qa = function() {};
    h.pa = function() {};
    h.oa = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Ka = function() {};
    function bd() {}
    bd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        C.call(this);
        this.g = new Sc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.sa && (a ? a["X-WebChannel-Client-Profile"] = b.sa : a = {
            "X-WebChannel-Client-Profile": b.sa
        });
        this.g.U = a;
        (a = b && b.Qb) && !y(a) && (this.g.u = a);
        this.A = b && b.supportsCrossDomainXhr || !1;
        this.v = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !y(b) && (this.g.G = b, a = this.h, a !== null && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    t(Y, C);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.A && (this.g.L = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        cc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if (typeof a === "string") {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.v && (c = {}, c.__data__ = ab(a), a = c);
        b.i.push(new dc(b.Ya++, a));
        b.I == 3 && bc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        cc(this.g);
        delete this.g;
        Y.Z.N.call(this);
    };
    function cd(a) {
        gb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = b !== null && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    t(cd, gb);
    function dd() {
        hb.call(this);
        this.status = 1;
    }
    t(dd, hb);
    function Z(a) {
        this.g = a;
    }
    t(Z, ad);
    Z.prototype.ra = function() {
        D(this.g, "a");
    };
    Z.prototype.qa = function(a) {
        D(this.g, new cd(a));
    };
    Z.prototype.pa = function(a) {
        D(this.g, new dd());
    };
    Z.prototype.oa = function() {
        D(this.g, "b");
    };
    bd.prototype.createWebChannel = bd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $33cb313d667e3306$export$66869136fc133c3a = $33cb313d667e3306$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new bd;
    };
    $33cb313d667e3306$export$888d0d9ab79d08fc = $33cb313d667e3306$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return jb();
    };
    $33cb313d667e3306$export$d61e24a684f9e51 = $33cb313d667e3306$export$2e2bcd8739ae039.Event = I;
    $33cb313d667e3306$export$cbbc350c1dfc80cb = $33cb313d667e3306$export$2e2bcd8739ae039.Stat = {
        jb: 0,
        mb: 1,
        nb: 2,
        Hb: 3,
        Mb: 4,
        Jb: 5,
        Kb: 6,
        Ib: 7,
        Gb: 8,
        Lb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Eb: 12,
        Ab: 13,
        Bb: 14,
        zb: 15,
        Cb: 16,
        Db: 17,
        fb: 18,
        eb: 19,
        gb: 20
    };
    ub.NO_ERROR = 0;
    ub.TIMEOUT = 8;
    ub.HTTP_ERROR = 6;
    $33cb313d667e3306$export$d4e71bc0b80dc0fb = $33cb313d667e3306$export$2e2bcd8739ae039.ErrorCode = ub;
    vb.COMPLETE = "complete";
    $33cb313d667e3306$export$3d7865934588d77e = $33cb313d667e3306$export$2e2bcd8739ae039.EventType = vb;
    fb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    C.prototype.listen = C.prototype.J;
    $33cb313d667e3306$export$aa726fb96ad3e039 = $33cb313d667e3306$export$2e2bcd8739ae039.WebChannel = fb;
    $33cb313d667e3306$export$ddb1030448106742 = $33cb313d667e3306$export$2e2bcd8739ae039.FetchXmlHttpFactory = Ec;
    X.prototype.listenOnce = X.prototype.K;
    X.prototype.getLastError = X.prototype.Ha;
    X.prototype.getLastErrorCode = X.prototype.ya;
    X.prototype.getStatus = X.prototype.ca;
    X.prototype.getResponseJson = X.prototype.La;
    X.prototype.getResponseText = X.prototype.la;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Fa;
    $33cb313d667e3306$export$26404658cda3ee02 = $33cb313d667e3306$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $33cb313d667e3306$var$commonjsGlobal !== 'undefined' ? $33cb313d667e3306$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $31a25a81deadb29c$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $31a25a81deadb29c$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $31a25a81deadb29c$var$User.UNAUTHENTICATED = new $31a25a81deadb29c$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$31a25a81deadb29c$var$User.GOOGLE_CREDENTIALS = new $31a25a81deadb29c$var$User("google-credentials-uid"), $31a25a81deadb29c$var$User.FIRST_PARTY = new $31a25a81deadb29c$var$User("first-party-uid"), $31a25a81deadb29c$var$User.MOCK_USER = new $31a25a81deadb29c$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $31a25a81deadb29c$var$b = "12.13.0";
function $31a25a81deadb29c$export$71511d61b312f219(e) {
    $31a25a81deadb29c$var$b = e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$S = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $31a25a81deadb29c$var$__PRIVATE_getLogLevel() {
    return $31a25a81deadb29c$var$S.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $31a25a81deadb29c$export$8c78c7c36408ea29(e) {
    $31a25a81deadb29c$var$S.setLogLevel(e);
}
function $31a25a81deadb29c$export$21579262ef46735b(e, ...t) {
    if ($31a25a81deadb29c$var$S.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($31a25a81deadb29c$var$__PRIVATE_argToString);
        $31a25a81deadb29c$var$S.debug(`Firestore (${$31a25a81deadb29c$var$b}): ${e}`, ...n);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_logError(e, ...t) {
    if ($31a25a81deadb29c$var$S.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) {
        const n = t.map($31a25a81deadb29c$var$__PRIVATE_argToString);
        $31a25a81deadb29c$var$S.error(`Firestore (${$31a25a81deadb29c$var$b}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $31a25a81deadb29c$export$4c3d22f3d993c33f(e, ...t) {
    if ($31a25a81deadb29c$var$S.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) {
        const n = t.map($31a25a81deadb29c$var$__PRIVATE_argToString);
        $31a25a81deadb29c$var$S.warn(`Firestore (${$31a25a81deadb29c$var$b}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $31a25a81deadb29c$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $31a25a81deadb29c$export$3a6d5c9ae78a2c08(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $31a25a81deadb29c$var$__PRIVATE__fail(e, r, n);
}
function $31a25a81deadb29c$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$31a25a81deadb29c$var$b}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $31a25a81deadb29c$var$__PRIVATE_logError(r), new Error(r);
}
function $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $31a25a81deadb29c$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $31a25a81deadb29c$export$53a70dd1ebbae346(e, t) {
    e || $31a25a81deadb29c$export$3a6d5c9ae78a2c08(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $31a25a81deadb29c$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$export$f1e1789686576879 = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $31a25a81deadb29c$export$4368d992c4eafac0 extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $31a25a81deadb29c$export$158acd800e1ef08b {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($31a25a81deadb29c$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $31a25a81deadb29c$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $31a25a81deadb29c$export$407448d2b89b1813 {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $31a25a81deadb29c$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $31a25a81deadb29c$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $31a25a81deadb29c$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($31a25a81deadb29c$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $31a25a81deadb29c$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($31a25a81deadb29c$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($31a25a81deadb29c$export$7a0bdf7d4a91ea88("string" == typeof t.accessToken, 31837, {
                l: t
            }), new $31a25a81deadb29c$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $31a25a81deadb29c$export$7a0bdf7d4a91ea88(null === e || "string" == typeof e, 2055, {
            h: e
        }), new $31a25a81deadb29c$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $31a25a81deadb29c$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n, this.type = "FirstParty", this.user = $31a25a81deadb29c$var$User.FIRST_PARTY, this.R = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ A() {
        return this.I ? this.I() : null;
    }
    get headers() {
        this.R.set("X-Goog-AuthUser", this.P);
        // Use array notation to prevent minification
        const e = this.A();
        return e && this.R.set("Authorization", e), this.T && this.R.set("X-Goog-Iam-Authorization-Token", this.T), this.R;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $31a25a81deadb29c$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n;
    }
    getToken() {
        return Promise.resolve(new $31a25a81deadb29c$var$__PRIVATE_FirstPartyToken(this.P, this.T, this.I));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($31a25a81deadb29c$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $31a25a81deadb29c$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $31a25a81deadb29c$export$8b22cf2602fb60ce {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $31a25a81deadb29c$export$21579262ef46735b("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, $31a25a81deadb29c$export$21579262ef46735b("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $31a25a81deadb29c$export$21579262ef46735b("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $31a25a81deadb29c$export$21579262ef46735b("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new $31a25a81deadb29c$var$AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($31a25a81deadb29c$export$7a0bdf7d4a91ea88("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new $31a25a81deadb29c$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $31a25a81deadb29c$export$24baa2b76016ce0e {
    getToken() {
        return Promise.resolve(new $31a25a81deadb29c$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $31a25a81deadb29c$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $31a25a81deadb29c$export$a07804094c3ecf2d {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $31a25a81deadb29c$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $31a25a81deadb29c$var$__PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    const n = Math.min(e.length, t.length);
    for(let r = 0; r < n; r++){
        const n = e.charAt(r), i = t.charAt(r);
        if (n !== i) return $31a25a81deadb29c$var$__PRIVATE_isSurrogate(n) === $31a25a81deadb29c$var$__PRIVATE_isSurrogate(i) ? $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n, i) : $31a25a81deadb29c$var$__PRIVATE_isSurrogate(n) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
const $31a25a81deadb29c$var$C = 55296, $31a25a81deadb29c$var$v = 57343;
function $31a25a81deadb29c$var$__PRIVATE_isSurrogate(e) {
    const t = e.charCodeAt(0);
    return t >= $31a25a81deadb29c$var$C && t <= $31a25a81deadb29c$var$v;
}
/** Helper to compare arrays using isEqual(). */ function $31a25a81deadb29c$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Verifies equality for an optional value.
 */ function $31a25a81deadb29c$export$c5d1328b37d47994(e, t, n) {
    return void 0 === e && void 0 === t || void 0 !== e && void 0 !== t && n(e, t);
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $31a25a81deadb29c$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$export$39c1cc7c062529d4 = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $31a25a81deadb29c$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $31a25a81deadb29c$export$3a6d5c9ae78a2c08(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $31a25a81deadb29c$export$3a6d5c9ae78a2c08(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $31a25a81deadb29c$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $31a25a81deadb29c$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $31a25a81deadb29c$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $31a25a81deadb29c$var$BasePath.isNumericId(e), r = $31a25a81deadb29c$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $31a25a81deadb29c$var$BasePath.extractNumericId(e).compare($31a25a81deadb29c$var$BasePath.extractNumericId(t)) : $31a25a81deadb29c$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $906344b47e605252$export$70ffa26850098d01).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $31a25a81deadb29c$export$db202ddc8be9136 extends $31a25a81deadb29c$var$BasePath {
    construct(e, t, n) {
        return new $31a25a81deadb29c$export$db202ddc8be9136(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $31a25a81deadb29c$export$db202ddc8be9136(t);
    }
    static emptyPath() {
        return new $31a25a81deadb29c$export$db202ddc8be9136([]);
    }
}
const $31a25a81deadb29c$var$M = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $31a25a81deadb29c$export$cf2f7c5792f80b46 extends $31a25a81deadb29c$var$BasePath {
    construct(e, t, n) {
        return new $31a25a81deadb29c$export$cf2f7c5792f80b46(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $31a25a81deadb29c$var$M.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $31a25a81deadb29c$export$cf2f7c5792f80b46.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $31a25a81deadb29c$export$39c1cc7c062529d4;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $31a25a81deadb29c$export$cf2f7c5792f80b46([
            $31a25a81deadb29c$export$39c1cc7c062529d4
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $31a25a81deadb29c$export$cf2f7c5792f80b46(t);
    }
    static emptyPath() {
        return new $31a25a81deadb29c$export$cf2f7c5792f80b46([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $31a25a81deadb29c$export$90a7f3efeed30595 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$export$db202ddc8be9136.fromString(e));
    }
    static fromName(e) {
        return new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$export$db202ddc8be9136.fromString(e).popFirst(5));
    }
    static empty() {
        return new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$export$db202ddc8be9136.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $31a25a81deadb29c$export$db202ddc8be9136.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $31a25a81deadb29c$export$db202ddc8be9136.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $31a25a81deadb29c$export$90a7f3efeed30595(new $31a25a81deadb29c$export$db202ddc8be9136(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $31a25a81deadb29c$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $31a25a81deadb29c$export$23ebac1979863676(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $31a25a81deadb29c$var$__PRIVATE_validateDocumentPath(e) {
    if (!$31a25a81deadb29c$export$90a7f3efeed30595.isDocumentKey(e)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $31a25a81deadb29c$var$__PRIVATE_validateCollectionPath(e) {
    if ($31a25a81deadb29c$export$90a7f3efeed30595.isDocumentKey(e)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $31a25a81deadb29c$export$7f557e5eb95176c2(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $31a25a81deadb29c$export$efccba1c4a2ef57b(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(12329, {
        type: typeof e
    });
}
function $31a25a81deadb29c$export$4a5767248b18ef41(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $31a25a81deadb29c$export$efccba1c4a2ef57b(e);
            throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $31a25a81deadb29c$export$953cecd6e717a553(e, t) {
    if (t <= 0) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $31a25a81deadb29c$export$ffb5f4729a158638(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json - A JSON object to validate.
 * @param scheme - a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $31a25a81deadb29c$export$9bb611d729802a56(e, t) {
    if (!$31a25a81deadb29c$export$7f557e5eb95176c2(e)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const o = e[r];
        if (i && typeof o !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && o !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $31a25a81deadb29c$var$x = -62135596800, $31a25a81deadb29c$var$O = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $31a25a81deadb29c$export$3d12bd131bb975d1 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $31a25a81deadb29c$export$3d12bd131bb975d1.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $31a25a81deadb29c$export$3d12bd131bb975d1.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $31a25a81deadb29c$var$O);
        return new $31a25a81deadb29c$export$3d12bd131bb975d1(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $31a25a81deadb29c$var$x) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $31a25a81deadb29c$var$O;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $31a25a81deadb29c$export$3d12bd131bb975d1._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($31a25a81deadb29c$export$9bb611d729802a56(e, $31a25a81deadb29c$export$3d12bd131bb975d1._jsonSchema)) return new $31a25a81deadb29c$export$3d12bd131bb975d1(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $31a25a81deadb29c$var$x;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$31a25a81deadb29c$export$3d12bd131bb975d1._jsonSchemaVersion = "firestore/timestamp/1.0", $31a25a81deadb29c$export$3d12bd131bb975d1._jsonSchema = {
    type: $31a25a81deadb29c$export$ffb5f4729a158638("string", $31a25a81deadb29c$export$3d12bd131bb975d1._jsonSchemaVersion),
    seconds: $31a25a81deadb29c$export$ffb5f4729a158638("number"),
    nanoseconds: $31a25a81deadb29c$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $31a25a81deadb29c$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $31a25a81deadb29c$var$SnapshotVersion(e);
    }
    static min() {
        return new $31a25a81deadb29c$var$SnapshotVersion(new $31a25a81deadb29c$export$3d12bd131bb975d1(0, 0));
    }
    static max() {
        return new $31a25a81deadb29c$var$SnapshotVersion(new $31a25a81deadb29c$export$3d12bd131bb975d1(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $31a25a81deadb29c$var$N = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $31a25a81deadb29c$export$ee7c8ad385a60b7b {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $31a25a81deadb29c$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $31a25a81deadb29c$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $31a25a81deadb29c$export$ee7c8ad385a60b7b.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $31a25a81deadb29c$export$c9170ad7d4cd7e57 {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $31a25a81deadb29c$export$cf2f7c5792f80b46.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $31a25a81deadb29c$export$995eb9fca571757 {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $31a25a81deadb29c$export$995eb9fca571757(0, $31a25a81deadb29c$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $31a25a81deadb29c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $31a25a81deadb29c$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $31a25a81deadb29c$export$3d12bd131bb975d1(n + 1, 0) : new $31a25a81deadb29c$export$3d12bd131bb975d1(n, r));
    return new $31a25a81deadb29c$var$IndexOffset(i, $31a25a81deadb29c$export$90a7f3efeed30595.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $31a25a81deadb29c$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $31a25a81deadb29c$var$IndexOffset(e.readTime, e.key, $31a25a81deadb29c$var$N);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $31a25a81deadb29c$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $31a25a81deadb29c$var$IndexOffset($31a25a81deadb29c$var$SnapshotVersion.min(), $31a25a81deadb29c$export$90a7f3efeed30595.empty(), $31a25a81deadb29c$var$N);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $31a25a81deadb29c$var$IndexOffset($31a25a81deadb29c$var$SnapshotVersion.max(), $31a25a81deadb29c$export$90a7f3efeed30595.empty(), $31a25a81deadb29c$var$N);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $31a25a81deadb29c$export$90a7f3efeed30595.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$B = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $31a25a81deadb29c$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION || e.message !== $31a25a81deadb29c$var$B) throw e;
    $31a25a81deadb29c$export$21579262ef46735b("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $31a25a81deadb29c$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $31a25a81deadb29c$export$3a6d5c9ae78a2c08(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $31a25a81deadb29c$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $31a25a81deadb29c$var$PersistencePromise ? t : $31a25a81deadb29c$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $31a25a81deadb29c$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $31a25a81deadb29c$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $31a25a81deadb29c$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $31a25a81deadb29c$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $31a25a81deadb29c$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $31a25a81deadb29c$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $31a25a81deadb29c$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $31a25a81deadb29c$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $31a25a81deadb29c$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $31a25a81deadb29c$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $31a25a81deadb29c$var$L = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $31a25a81deadb29c$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $31a25a81deadb29c$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.S = new $31a25a81deadb29c$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.S.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.S.reject(new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.S.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $31a25a81deadb29c$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.S.reject(new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get D() {
        return this.S.promise;
    }
    abort(e) {
        e && this.S.reject(e), this.aborted || ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    C() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $31a25a81deadb29c$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $31a25a81deadb29c$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "Removing database:", e);
        return $31a25a81deadb29c$var$__PRIVATE_wrapRequest((0, $029952e65115eee5$export$a4e55266d2135a7f)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static v() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return !1;
        if ($31a25a81deadb29c$var$__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $029952e65115eee5$export$c36915b22ce77c19)(), t = $31a25a81deadb29c$var$__PRIVATE_SimpleDb.M(e), n = 0 < t && t < 10, r = $31a25a81deadb29c$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static O(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static M(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.N = n, this.B = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $31a25a81deadb29c$var$__PRIVATE_SimpleDb.M((0, $029952e65115eee5$export$c36915b22ce77c19)()) && $31a25a81deadb29c$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async L(e) {
        return this.db || ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.N.k(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.K && (this.db.onversionchange = (e)=>this.K(e)), this.db;
    }
    q(e) {
        this.K = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.L(e);
                const t = $31a25a81deadb29c$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.C(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $31a25a81deadb29c$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.D, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $31a25a81deadb29c$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $31a25a81deadb29c$var$__PRIVATE_IterationController {
    constructor(e){
        this.U = e, this.$ = !1, this.W = null;
    }
    get isDone() {
        return this.$;
    }
    get G() {
        return this.W;
    }
    set cursor(e) {
        this.U = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.$ = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ j(e) {
        this.W = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $31a25a81deadb29c$var$__PRIVATE_wrapRequest(this.U.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransactionError extends $31a25a81deadb29c$export$4368d992c4eafac0 {
    constructor(e, t){
        super($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $31a25a81deadb29c$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $31a25a81deadb29c$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "ADD", this.store.name, e, e);
        return $31a25a81deadb29c$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $31a25a81deadb29c$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "DELETE", this.store.name, e);
        return $31a25a81deadb29c$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "COUNT", this.store.name);
        return $31a25a81deadb29c$var$__PRIVATE_wrapRequest(this.store.count());
    }
    J(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $31a25a81deadb29c$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.H(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ Z(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $31a25a81deadb29c$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    X(e, t) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$L, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.Y = !1;
        const r = this.cursor(n);
        return this.H(r, (e, t, n)=>n.delete());
    }
    ee(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.H(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ te(e) {
        const t = this.cursor({});
        return new $31a25a81deadb29c$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $31a25a81deadb29c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    H(e, t) {
        const n = [];
        return new $31a25a81deadb29c$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $31a25a81deadb29c$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $31a25a81deadb29c$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $31a25a81deadb29c$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.G ? i.continue() : i.continue(s.G);
            };
        }).next(()=>$31a25a81deadb29c$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.Y ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $31a25a81deadb29c$var$__PRIVATE_wrapRequest(e) {
    return new $31a25a81deadb29c$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $31a25a81deadb29c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $31a25a81deadb29c$var$k = !1;
function $31a25a81deadb29c$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_SimpleDb.M((0, $029952e65115eee5$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $31a25a81deadb29c$export$4368d992c4eafac0("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $31a25a81deadb29c$var$k || ($31a25a81deadb29c$var$k = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $31a25a81deadb29c$var$K = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $31a25a81deadb29c$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ne = t, this.task = null;
    }
    start() {
        this.re(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    re(e) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$K, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.ne.ie();
                $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$K, `Documents written: ${e}`);
            } catch (e) {
                $31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$K, "Ignoring IndexedDB error during index backfill: ", e) : await $31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.re(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $31a25a81deadb29c$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ie(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.se(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ se(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $31a25a81deadb29c$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$K, `Processing collection: ${t}`), this.oe(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ oe(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this._e(r, n)).next((n)=>($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$K, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ _e(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $31a25a81deadb29c$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $31a25a81deadb29c$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $31a25a81deadb29c$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $31a25a81deadb29c$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ae(e), this.ue = (e)=>t.writeSequenceNumber(e));
    }
    ae(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ue && this.ue(e), e;
    }
}
$31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $31a25a81deadb29c$var$q = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $31a25a81deadb29c$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $31a25a81deadb29c$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
function $31a25a81deadb29c$export$151db275011178c4(e) {
    return "number" == typeof e;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $31a25a81deadb29c$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$31a25a81deadb29c$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function $31a25a81deadb29c$export$ad4aebacdcaf47f8(e) {
    return "string" == typeof e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$U = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $31a25a81deadb29c$var$__PRIVATE_encodeSeparator(t)), t = $31a25a81deadb29c$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $31a25a81deadb29c$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $31a25a81deadb29c$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $31a25a81deadb29c$var$U:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $31a25a81deadb29c$var$__PRIVATE_encodeSeparator(e) {
    return e + $31a25a81deadb29c$var$U + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(t >= 2, 64408, {
        path: e
    }), 2 === t) return $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.charAt(0) === $31a25a81deadb29c$var$U && "" === e.charAt(1), 56145, {
        path: e
    }), $31a25a81deadb29c$export$db202ddc8be9136.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($31a25a81deadb29c$var$U, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $31a25a81deadb29c$export$3a6d5c9ae78a2c08(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $31a25a81deadb29c$export$3a6d5c9ae78a2c08(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $31a25a81deadb29c$export$db202ddc8be9136(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$$ = "remoteDocuments", $31a25a81deadb29c$var$W = "owner", $31a25a81deadb29c$var$Q = "owner", $31a25a81deadb29c$var$G = "mutationQueues", $31a25a81deadb29c$var$z = "userId", $31a25a81deadb29c$var$j = "mutations", $31a25a81deadb29c$var$H = "batchId", $31a25a81deadb29c$var$J = "userMutationsIndex", $31a25a81deadb29c$var$Z = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $31a25a81deadb29c$var$X = {}, $31a25a81deadb29c$var$Y = "documentMutations", $31a25a81deadb29c$var$ee = "remoteDocumentsV14", $31a25a81deadb29c$var$te = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $31a25a81deadb29c$var$ne = "documentKeyIndex", $31a25a81deadb29c$var$re = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $31a25a81deadb29c$var$ie = "collectionGroupIndex", $31a25a81deadb29c$var$se = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $31a25a81deadb29c$var$oe = "remoteDocumentGlobal", $31a25a81deadb29c$var$_e = "remoteDocumentGlobalKey", $31a25a81deadb29c$var$ae = "targets", $31a25a81deadb29c$var$ue = "queryTargetsIndex", $31a25a81deadb29c$var$ce = [
    "canonicalId",
    "targetId"
], $31a25a81deadb29c$var$le = "targetDocuments", $31a25a81deadb29c$var$he = [
    "targetId",
    "path"
], $31a25a81deadb29c$var$Pe = "documentTargetsIndex", $31a25a81deadb29c$var$Te = [
    "path",
    "targetId"
], $31a25a81deadb29c$var$Ie = "targetGlobalKey", $31a25a81deadb29c$var$Ee = "targetGlobal", $31a25a81deadb29c$var$Re = "collectionParents", $31a25a81deadb29c$var$Ae = [
    "collectionId",
    "parent"
], $31a25a81deadb29c$var$Ve = "clientMetadata", $31a25a81deadb29c$var$de = "clientId", $31a25a81deadb29c$var$me = "bundles", $31a25a81deadb29c$var$fe = "bundleId", $31a25a81deadb29c$var$ge = "namedQueries", $31a25a81deadb29c$var$pe = "name", $31a25a81deadb29c$var$ye = "indexConfiguration", $31a25a81deadb29c$var$we = "indexId", $31a25a81deadb29c$var$be = "collectionGroupIndex", $31a25a81deadb29c$var$Se = "collectionGroup", $31a25a81deadb29c$var$De = "indexState", $31a25a81deadb29c$var$Ce = [
    "indexId",
    "uid"
], $31a25a81deadb29c$var$ve = "sequenceNumberIndex", $31a25a81deadb29c$var$Fe = [
    "uid",
    "sequenceNumber"
], $31a25a81deadb29c$var$Me = "indexEntries", $31a25a81deadb29c$var$xe = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $31a25a81deadb29c$var$Oe = "documentKeyIndex", $31a25a81deadb29c$var$Ne = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $31a25a81deadb29c$var$Be = "documentOverlays", $31a25a81deadb29c$var$Le = [
    "userId",
    "collectionPath",
    "documentId"
], $31a25a81deadb29c$var$ke = "collectionPathOverlayIndex", $31a25a81deadb29c$var$Ke = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $31a25a81deadb29c$var$qe = "collectionGroupOverlayIndex", $31a25a81deadb29c$var$Ue = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $31a25a81deadb29c$var$$e = "globals", $31a25a81deadb29c$var$We = "name", $31a25a81deadb29c$var$Qe = [
    $31a25a81deadb29c$var$G,
    $31a25a81deadb29c$var$j,
    $31a25a81deadb29c$var$Y,
    $31a25a81deadb29c$var$$,
    $31a25a81deadb29c$var$ae,
    $31a25a81deadb29c$var$W,
    $31a25a81deadb29c$var$Ee,
    $31a25a81deadb29c$var$le,
    $31a25a81deadb29c$var$Ve,
    $31a25a81deadb29c$var$oe,
    $31a25a81deadb29c$var$Re,
    $31a25a81deadb29c$var$me,
    $31a25a81deadb29c$var$ge
], $31a25a81deadb29c$var$Ge = [
    ...$31a25a81deadb29c$var$Qe,
    $31a25a81deadb29c$var$Be
], $31a25a81deadb29c$var$ze = [
    $31a25a81deadb29c$var$G,
    $31a25a81deadb29c$var$j,
    $31a25a81deadb29c$var$Y,
    $31a25a81deadb29c$var$ee,
    $31a25a81deadb29c$var$ae,
    $31a25a81deadb29c$var$W,
    $31a25a81deadb29c$var$Ee,
    $31a25a81deadb29c$var$le,
    $31a25a81deadb29c$var$Ve,
    $31a25a81deadb29c$var$oe,
    $31a25a81deadb29c$var$Re,
    $31a25a81deadb29c$var$me,
    $31a25a81deadb29c$var$ge,
    $31a25a81deadb29c$var$Be
], $31a25a81deadb29c$var$je = $31a25a81deadb29c$var$ze, $31a25a81deadb29c$var$He = [
    ...$31a25a81deadb29c$var$je,
    $31a25a81deadb29c$var$ye,
    $31a25a81deadb29c$var$De,
    $31a25a81deadb29c$var$Me
], $31a25a81deadb29c$var$Je = $31a25a81deadb29c$var$He, $31a25a81deadb29c$var$Ze = [
    ...$31a25a81deadb29c$var$He,
    $31a25a81deadb29c$var$$e
], $31a25a81deadb29c$var$Xe = $31a25a81deadb29c$var$Ze;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransaction extends $31a25a81deadb29c$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.le = e, this.currentSequenceNumber = t;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_getStore(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return $31a25a81deadb29c$var$__PRIVATE_SimpleDb.O(n.le, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $31a25a81deadb29c$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $31a25a81deadb29c$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $31a25a81deadb29c$export$a9c23c6ac3fc3eca(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $31a25a81deadb29c$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $31a25a81deadb29c$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $31a25a81deadb29c$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $31a25a81deadb29c$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $31a25a81deadb29c$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $31a25a81deadb29c$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $31a25a81deadb29c$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $31a25a81deadb29c$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $31a25a81deadb29c$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $31a25a81deadb29c$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $31a25a81deadb29c$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $31a25a81deadb29c$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $31a25a81deadb29c$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $31a25a81deadb29c$var$LLRBNode.RED, this.left = null != r ? r : $31a25a81deadb29c$var$LLRBNode.EMPTY, this.right = null != i ? i : $31a25a81deadb29c$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $31a25a81deadb29c$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $31a25a81deadb29c$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $31a25a81deadb29c$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $31a25a81deadb29c$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $31a25a81deadb29c$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$31a25a81deadb29c$var$LLRBNode.EMPTY = null, $31a25a81deadb29c$var$LLRBNode.RED = !0, $31a25a81deadb29c$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$31a25a81deadb29c$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(57766);
    }
    get value() {
        throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(16141);
    }
    get color() {
        throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(16727);
    }
    get left() {
        throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(29726);
    }
    get right() {
        throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $31a25a81deadb29c$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $31a25a81deadb29c$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $31a25a81deadb29c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $31a25a81deadb29c$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $31a25a81deadb29c$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $31a25a81deadb29c$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $31a25a81deadb29c$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $31a25a81deadb29c$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $31a25a81deadb29c$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $31a25a81deadb29c$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($31a25a81deadb29c$export$cf2f7c5792f80b46.comparator);
    }
    static empty() {
        return new $31a25a81deadb29c$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$cf2f7c5792f80b46.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $31a25a81deadb29c$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $31a25a81deadb29c$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $31a25a81deadb29c$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $31a25a81deadb29c$export$a05254e7c3aeba6e() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $31a25a81deadb29c$export$9d398bebfec1c039 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $31a25a81deadb29c$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $31a25a81deadb29c$export$9d398bebfec1c039(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $31a25a81deadb29c$export$9d398bebfec1c039(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING = new $31a25a81deadb29c$export$9d398bebfec1c039("");
const $31a25a81deadb29c$var$Ye = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $31a25a81deadb29c$var$Ye.exec(e);
        if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $31a25a81deadb29c$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $31a25a81deadb29c$export$9d398bebfec1c039.fromBase64String(e) : $31a25a81deadb29c$export$9d398bebfec1c039.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $31a25a81deadb29c$var$et = "server_timestamp", $31a25a81deadb29c$var$tt = "__type__", $31a25a81deadb29c$var$nt = "__previous_value__", $31a25a81deadb29c$var$rt = "__local_write_time__";
function $31a25a81deadb29c$export$2408f22a0fab9ae5(e) {
    const t = (e?.mapValue?.fields || {})[$31a25a81deadb29c$var$tt]?.stringValue;
    return t === $31a25a81deadb29c$var$et;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $31a25a81deadb29c$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$31a25a81deadb29c$var$nt];
    return $31a25a81deadb29c$export$2408f22a0fab9ae5(t) ? $31a25a81deadb29c$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $31a25a81deadb29c$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$31a25a81deadb29c$var$rt].timestampValue);
    return new $31a25a81deadb29c$export$3d12bd131bb975d1(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions - Options that configure long-polling.
     * @param useFetchStreams - Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a, u, c){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a, this.isUsingEmulator = u, this.apiKey = c;
    }
}
/** The default database name for a project. */ const $31a25a81deadb29c$var$it = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $31a25a81deadb29c$export$890c4ad488842ce7 {
    constructor(e, t){
        this.projectId = e, this.database = t || $31a25a81deadb29c$var$it;
    }
    static empty() {
        return new $31a25a81deadb29c$export$890c4ad488842ce7("", "");
    }
    get isDefaultDatabase() {
        return this.database === $31a25a81deadb29c$var$it;
    }
    isEqual(e) {
        return e instanceof $31a25a81deadb29c$export$890c4ad488842ce7 && e.projectId === this.projectId && e.database === this.database;
    }
}
function $31a25a81deadb29c$export$db3b6bfb95261072(e, t) {
    if (!Object.prototype.hasOwnProperty.apply(e.options, [
        "projectId"
    ])) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
    return new $31a25a81deadb29c$export$890c4ad488842ce7(e.options.projectId, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$st = "__type__", $31a25a81deadb29c$var$ot = "__max__", $31a25a81deadb29c$var$_t = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $31a25a81deadb29c$var$ot
            }
        }
    }
}, $31a25a81deadb29c$var$at = "__vector__", $31a25a81deadb29c$var$ut = "value", $31a25a81deadb29c$var$ct = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $31a25a81deadb29c$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $31a25a81deadb29c$export$2408f22a0fab9ae5(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $31a25a81deadb29c$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $31a25a81deadb29c$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $31a25a81deadb29c$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $31a25a81deadb29c$var$__PRIVATE_typeOrder(e);
    if (n !== $31a25a81deadb29c$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_getLocalWriteTime(e).isEqual($31a25a81deadb29c$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $31a25a81deadb29c$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($31a25a81deadb29c$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.integerValue) === $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $31a25a81deadb29c$var$__PRIVATE_isNegativeZero(n) === $31a25a81deadb29c$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $31a25a81deadb29c$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($31a25a81deadb29c$var$__PRIVATE_objectSize(n) !== $31a25a81deadb29c$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$31a25a81deadb29c$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(52216, {
                left: e
            });
    }
}
function $31a25a81deadb29c$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$31a25a81deadb29c$var$__PRIVATE_valueEquals(e, t));
}
function $31a25a81deadb29c$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $31a25a81deadb29c$var$__PRIVATE_typeOrder(e), r = $31a25a81deadb29c$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_compareTimestamps($31a25a81deadb29c$var$__PRIVATE_getLocalWriteTime(e), $31a25a81deadb29c$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $31a25a81deadb29c$var$__PRIVATE_normalizeByteString(e), r = $31a25a81deadb29c$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator($31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.latitude), $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator($31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.longitude), $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                const n = e.fields || {}, r = t.fields || {}, i = n[$31a25a81deadb29c$var$ut]?.arrayValue, s = r[$31a25a81deadb29c$var$ut]?.arrayValue, o = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(i?.values?.length || 0, s?.values?.length || 0);
                if (0 !== o) return o;
                return $31a25a81deadb29c$var$__PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $31a25a81deadb29c$var$_t.mapValue && t === $31a25a81deadb29c$var$_t.mapValue) return 0;
                if (e === $31a25a81deadb29c$var$_t.mapValue) return 1;
                if (t === $31a25a81deadb29c$var$_t.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $31a25a81deadb29c$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $31a25a81deadb29c$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(23264, {
                he: n
            });
    }
}
function $31a25a81deadb29c$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e, t);
    const n = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(e), r = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(t), i = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $31a25a81deadb29c$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $31a25a81deadb29c$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $31a25a81deadb29c$var$canonicalId(e) {
    return $31a25a81deadb29c$var$__PRIVATE_canonifyValue(e);
}
function $31a25a81deadb29c$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $31a25a81deadb29c$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $31a25a81deadb29c$export$90a7f3efeed30595.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $31a25a81deadb29c$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$31a25a81deadb29c$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(61005, {
        value: e
    });
}
function $31a25a81deadb29c$var$__PRIVATE_estimateByteSize(e) {
    switch($31a25a81deadb29c$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $31a25a81deadb29c$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $31a25a81deadb29c$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $31a25a81deadb29c$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $31a25a81deadb29c$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $31a25a81deadb29c$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $31a25a81deadb29c$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(13486, {
                value: e
            });
    }
}
function $31a25a81deadb29c$export$43caf9889c228507(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $31a25a81deadb29c$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $31a25a81deadb29c$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $31a25a81deadb29c$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $31a25a81deadb29c$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $31a25a81deadb29c$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $31a25a81deadb29c$var$__PRIVATE_isVectorValue(e) {
    const t = (e?.mapValue?.fields || {})[$31a25a81deadb29c$var$st]?.stringValue;
    return t === $31a25a81deadb29c$var$at;
}
/** Creates a deep copy of `source`. */ function $31a25a81deadb29c$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: {
            ...e.geoPointValue
        }
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: {
            ...e.timestampValue
        }
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $31a25a81deadb29c$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $31a25a81deadb29c$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $31a25a81deadb29c$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return {
        ...e
    };
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $31a25a81deadb29c$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $31a25a81deadb29c$var$ot;
}
const $31a25a81deadb29c$var$lt = {
    mapValue: {
        fields: {
            [$31a25a81deadb29c$var$st]: {
                stringValue: $31a25a81deadb29c$var$at
            },
            [$31a25a81deadb29c$var$ut]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $31a25a81deadb29c$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $31a25a81deadb29c$var$ct : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $31a25a81deadb29c$export$43caf9889c228507($31a25a81deadb29c$export$890c4ad488842ce7.empty(), $31a25a81deadb29c$export$90a7f3efeed30595.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $31a25a81deadb29c$var$__PRIVATE_isVectorValue(e) ? $31a25a81deadb29c$var$lt : {
        mapValue: {}
    } : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $31a25a81deadb29c$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $31a25a81deadb29c$export$43caf9889c228507($31a25a81deadb29c$export$890c4ad488842ce7.empty(), $31a25a81deadb29c$export$90a7f3efeed30595.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $31a25a81deadb29c$var$lt : "mapValue" in e ? $31a25a81deadb29c$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $31a25a81deadb29c$var$_t : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(61959, {
        value: e
    });
}
function $31a25a81deadb29c$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $31a25a81deadb29c$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $31a25a81deadb29c$export$c4ce752e73470fba {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $31a25a81deadb29c$export$c4ce752e73470fba({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$31a25a81deadb29c$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $31a25a81deadb29c$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $31a25a81deadb29c$export$cf2f7c5792f80b46.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $31a25a81deadb29c$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $31a25a81deadb29c$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $31a25a81deadb29c$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $31a25a81deadb29c$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $31a25a81deadb29c$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $31a25a81deadb29c$export$c4ce752e73470fba($31a25a81deadb29c$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $31a25a81deadb29c$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $31a25a81deadb29c$var$forEach(e.fields, (e, n)=>{
        const r = new $31a25a81deadb29c$export$cf2f7c5792f80b46([
            e
        ]);
        if ($31a25a81deadb29c$var$__PRIVATE_isMapValue(n)) {
            const e = $31a25a81deadb29c$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $31a25a81deadb29c$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $31a25a81deadb29c$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $31a25a81deadb29c$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $31a25a81deadb29c$var$SnapshotVersion.min(), /* readTime */ $31a25a81deadb29c$var$SnapshotVersion.min(), /* createTime */ $31a25a81deadb29c$var$SnapshotVersion.min(), $31a25a81deadb29c$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $31a25a81deadb29c$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $31a25a81deadb29c$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $31a25a81deadb29c$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $31a25a81deadb29c$var$SnapshotVersion.min(), /* createTime */ $31a25a81deadb29c$var$SnapshotVersion.min(), $31a25a81deadb29c$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $31a25a81deadb29c$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $31a25a81deadb29c$var$SnapshotVersion.min(), /* createTime */ $31a25a81deadb29c$var$SnapshotVersion.min(), $31a25a81deadb29c$export$c4ce752e73470fba.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($31a25a81deadb29c$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $31a25a81deadb29c$export$c4ce752e73470fba.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $31a25a81deadb29c$export$c4ce752e73470fba.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $31a25a81deadb29c$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $31a25a81deadb29c$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $31a25a81deadb29c$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $31a25a81deadb29c$export$625550452a3fa3ec {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $31a25a81deadb29c$export$90a7f3efeed30595.comparator($31a25a81deadb29c$export$90a7f3efeed30595.fromName(o.referenceValue), n.key);
        else r = $31a25a81deadb29c$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $31a25a81deadb29c$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$31a25a81deadb29c$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $31a25a81deadb29c$export$306ddfe3a8403e2 {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$Filter {
}
class $31a25a81deadb29c$export$23f2a1d2818174ef extends $31a25a81deadb29c$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $31a25a81deadb29c$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $31a25a81deadb29c$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $31a25a81deadb29c$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $31a25a81deadb29c$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $31a25a81deadb29c$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $31a25a81deadb29c$export$23f2a1d2818174ef(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $31a25a81deadb29c$var$__PRIVATE_KeyFieldInFilter(e, n) : new $31a25a81deadb29c$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($31a25a81deadb29c$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $31a25a81deadb29c$var$__PRIVATE_typeOrder(this.value) === $31a25a81deadb29c$var$__PRIVATE_typeOrder(t) && this.matchesComparison($31a25a81deadb29c$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $31a25a81deadb29c$export$e7094788287c5e9b extends $31a25a81deadb29c$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.Pe = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $31a25a81deadb29c$export$e7094788287c5e9b(e, t);
    }
    matches(e) {
        return $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.Pe || (this.Pe = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.Pe;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsFlat(e) && $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $31a25a81deadb29c$export$e7094788287c5e9b) return !1;
    return !0;
}
function $31a25a81deadb29c$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $31a25a81deadb29c$var$canonicalId(e.value);
    if ($31a25a81deadb29c$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $31a25a81deadb29c$export$23f2a1d2818174ef && e.op === t.op && e.field.isEqual(t.field) && $31a25a81deadb29c$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $31a25a81deadb29c$export$e7094788287c5e9b ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $31a25a81deadb29c$export$e7094788287c5e9b && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $31a25a81deadb29c$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $31a25a81deadb29c$export$3a6d5c9ae78a2c08(19439);
}
function $31a25a81deadb29c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $31a25a81deadb29c$export$e7094788287c5e9b.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $31a25a81deadb29c$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$31a25a81deadb29c$var$canonicalId(e.value)}`;
    }(e) : e instanceof $31a25a81deadb29c$export$e7094788287c5e9b ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($31a25a81deadb29c$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $31a25a81deadb29c$var$__PRIVATE_KeyFieldFilter extends $31a25a81deadb29c$export$23f2a1d2818174ef {
    constructor(e, t, n){
        super(e, t, n), this.key = $31a25a81deadb29c$export$90a7f3efeed30595.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $31a25a81deadb29c$export$90a7f3efeed30595.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $31a25a81deadb29c$var$__PRIVATE_KeyFieldInFilter extends $31a25a81deadb29c$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $31a25a81deadb29c$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $31a25a81deadb29c$var$__PRIVATE_KeyFieldNotInFilter extends $31a25a81deadb29c$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $31a25a81deadb29c$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $31a25a81deadb29c$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    return (t.arrayValue?.values || []).map((e)=>$31a25a81deadb29c$export$90a7f3efeed30595.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $31a25a81deadb29c$var$__PRIVATE_ArrayContainsFilter extends $31a25a81deadb29c$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $31a25a81deadb29c$var$isArray(t) && $31a25a81deadb29c$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $31a25a81deadb29c$var$__PRIVATE_InFilter extends $31a25a81deadb29c$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $31a25a81deadb29c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $31a25a81deadb29c$var$__PRIVATE_NotInFilter extends $31a25a81deadb29c$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($31a25a81deadb29c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$31a25a81deadb29c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $31a25a81deadb29c$var$__PRIVATE_ArrayContainsAnyFilter extends $31a25a81deadb29c$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$31a25a81deadb29c$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$31a25a81deadb29c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $31a25a81deadb29c$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.Te = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $31a25a81deadb29c$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $31a25a81deadb29c$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $31a25a81deadb29c$var$__PRIVATE_canonifyTarget(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    if (null === t.Te) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $31a25a81deadb29c$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$31a25a81deadb29c$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$31a25a81deadb29c$var$canonicalId(e)).join(",")), t.Te = e;
    }
    return t.Te;
}
function $31a25a81deadb29c$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$31a25a81deadb29c$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$31a25a81deadb29c$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$31a25a81deadb29c$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $31a25a81deadb29c$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $31a25a81deadb29c$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $31a25a81deadb29c$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $31a25a81deadb29c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $31a25a81deadb29c$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $31a25a81deadb29c$var$ct, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $31a25a81deadb29c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $31a25a81deadb29c$var$ct, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $31a25a81deadb29c$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $31a25a81deadb29c$var$ct;
        }
        $31a25a81deadb29c$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $31a25a81deadb29c$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $31a25a81deadb29c$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $31a25a81deadb29c$var$_t, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $31a25a81deadb29c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $31a25a81deadb29c$var$_t, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $31a25a81deadb29c$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $31a25a81deadb29c$var$_t;
        }
        $31a25a81deadb29c$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $31a25a81deadb29c$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $31a25a81deadb29c$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.Ee = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.Re = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $31a25a81deadb29c$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $31a25a81deadb29c$export$a93c5207d687da10(e) {
    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $31a25a81deadb29c$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ function $31a25a81deadb29c$export$51b138e5a065c2bb(e) {
    return $31a25a81deadb29c$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $31a25a81deadb29c$export$3b14a55fb2447963(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $31a25a81deadb29c$export$9e5f44173e64f162(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    if (null === t.Ie) {
        t.Ie = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.Ie.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$cf2f7c5792f80b46.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.Ie.push(new $31a25a81deadb29c$export$306ddfe3a8403e2(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($31a25a81deadb29c$export$cf2f7c5792f80b46.keyField().canonicalString()) || t.Ie.push(new $31a25a81deadb29c$export$306ddfe3a8403e2($31a25a81deadb29c$export$cf2f7c5792f80b46.keyField(), n));
    }
    return t.Ie;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $31a25a81deadb29c$var$__PRIVATE_queryToTarget(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return t.Ee || (t.Ee = $31a25a81deadb29c$var$__PRIVATE__queryToTarget(t, $31a25a81deadb29c$export$9e5f44173e64f162(e))), t.Ee;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $31a25a81deadb29c$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return t.Re || // Do not include implicit order-bys for aggregate queries.
    (t.Re = $31a25a81deadb29c$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.Re;
}
function $31a25a81deadb29c$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $31a25a81deadb29c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $31a25a81deadb29c$export$306ddfe3a8403e2(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $31a25a81deadb29c$export$625550452a3fa3ec(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $31a25a81deadb29c$export$625550452a3fa3ec(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $31a25a81deadb29c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $31a25a81deadb29c$export$2d1720544b23b823(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $31a25a81deadb29c$export$342063e11d6c3cad(e, t) {
    // TODO(dimond): validate that orderBy does not list the same key twice.
    const n = e.explicitOrderBy.concat([
        t
    ]);
    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
}
function $31a25a81deadb29c$export$882b5998b3b9117c(e, t, n) {
    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $31a25a81deadb29c$export$7ccc53e8f1e7dfc5(e, t) {
    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
}
function $31a25a81deadb29c$export$ae1af26003f05816(e, t) {
    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
}
function $31a25a81deadb29c$var$__PRIVATE_queryEquals(e, t) {
    return $31a25a81deadb29c$var$__PRIVATE_targetEquals($31a25a81deadb29c$var$__PRIVATE_queryToTarget(e), $31a25a81deadb29c$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $31a25a81deadb29c$var$__PRIVATE_canonifyQuery(e) {
    return `${$31a25a81deadb29c$var$__PRIVATE_canonifyTarget($31a25a81deadb29c$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $31a25a81deadb29c$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $31a25a81deadb29c$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$31a25a81deadb29c$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$31a25a81deadb29c$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($31a25a81deadb29c$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $31a25a81deadb29c$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $31a25a81deadb29c$export$90a7f3efeed30595.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $31a25a81deadb29c$export$9e5f44173e64f162(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $31a25a81deadb29c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $31a25a81deadb29c$export$9e5f44173e64f162(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $31a25a81deadb29c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $31a25a81deadb29c$export$9e5f44173e64f162(e), t)) return !1;
        return !0;
    }(e, t);
}
function $31a25a81deadb29c$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $31a25a81deadb29c$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $31a25a81deadb29c$export$9e5f44173e64f162(e)){
            const e = $31a25a81deadb29c$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $31a25a81deadb29c$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $31a25a81deadb29c$export$90a7f3efeed30595.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $31a25a81deadb29c$var$__PRIVATE_valueCompare(r, i) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $31a25a81deadb29c$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $31a25a81deadb29c$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $31a25a81deadb29c$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$ht = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
function $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap() {
    return $31a25a81deadb29c$var$ht;
}
const $31a25a81deadb29c$var$Pt = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
function $31a25a81deadb29c$var$documentMap(...e) {
    let t = $31a25a81deadb29c$var$Pt;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $31a25a81deadb29c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $31a25a81deadb29c$var$Pt;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $31a25a81deadb29c$var$__PRIVATE_newOverlayMap() {
    return $31a25a81deadb29c$var$__PRIVATE_newDocumentKeyMap();
}
function $31a25a81deadb29c$var$__PRIVATE_newMutationMap() {
    return $31a25a81deadb29c$var$__PRIVATE_newDocumentKeyMap();
}
function $31a25a81deadb29c$var$__PRIVATE_newDocumentKeyMap() {
    return new $31a25a81deadb29c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $31a25a81deadb29c$var$Tt = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
const $31a25a81deadb29c$var$It = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
function $31a25a81deadb29c$export$971d5caa766a69d7(...e) {
    let t = $31a25a81deadb29c$var$It;
    for (const n of e)t = t.add(n);
    return t;
}
const $31a25a81deadb29c$var$Et = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_primitiveComparator);
function $31a25a81deadb29c$var$__PRIVATE_targetIdSet() {
    return $31a25a81deadb29c$var$Et;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $31a25a81deadb29c$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $31a25a81deadb29c$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $31a25a81deadb29c$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $31a25a81deadb29c$export$62d08d6fa708df47(e, t) {
    return $31a25a81deadb29c$var$isSafeInteger(t) ? $31a25a81deadb29c$var$__PRIVATE_toInteger(t) : $31a25a81deadb29c$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $31a25a81deadb29c$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $31a25a81deadb29c$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $31a25a81deadb29c$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$31a25a81deadb29c$var$tt]: {
                    stringValue: $31a25a81deadb29c$var$et
                },
                [$31a25a81deadb29c$var$rt]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $31a25a81deadb29c$export$2408f22a0fab9ae5(t) && (t = $31a25a81deadb29c$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$31a25a81deadb29c$var$nt] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation ? $31a25a81deadb29c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation ? $31a25a81deadb29c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $31a25a81deadb29c$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $31a25a81deadb29c$var$asNumber(n) + $31a25a81deadb29c$var$asNumber(e.Ae);
        return $31a25a81deadb29c$var$isInteger(n) && $31a25a81deadb29c$var$isInteger(e.Ae) ? $31a25a81deadb29c$var$__PRIVATE_toInteger(r) : $31a25a81deadb29c$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $31a25a81deadb29c$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation ? $31a25a81deadb29c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation ? $31a25a81deadb29c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $31a25a81deadb29c$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $31a25a81deadb29c$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $31a25a81deadb29c$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $31a25a81deadb29c$var$__PRIVATE_ServerTimestampTransform extends $31a25a81deadb29c$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation extends $31a25a81deadb29c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$31a25a81deadb29c$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation extends $31a25a81deadb29c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $31a25a81deadb29c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$31a25a81deadb29c$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $31a25a81deadb29c$var$__PRIVATE_NumericIncrementTransformOperation extends $31a25a81deadb29c$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Ae = t;
    }
}
function $31a25a81deadb29c$var$asNumber(e) {
    return $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $31a25a81deadb29c$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $31a25a81deadb29c$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $31a25a81deadb29c$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation ? $31a25a81deadb29c$var$__PRIVATE_arrayEquals(e.elements, t.elements, $31a25a81deadb29c$var$__PRIVATE_valueEquals) : e instanceof $31a25a81deadb29c$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $31a25a81deadb29c$var$__PRIVATE_NumericIncrementTransformOperation ? $31a25a81deadb29c$var$__PRIVATE_valueEquals(e.Ae, t.Ae) : e instanceof $31a25a81deadb29c$var$__PRIVATE_ServerTimestampTransform && t instanceof $31a25a81deadb29c$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $31a25a81deadb29c$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $31a25a81deadb29c$export$78acf4525d8a74c4 {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $31a25a81deadb29c$export$78acf4525d8a74c4;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $31a25a81deadb29c$export$78acf4525d8a74c4(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $31a25a81deadb29c$export$78acf4525d8a74c4(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $31a25a81deadb29c$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $31a25a81deadb29c$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $31a25a81deadb29c$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $31a25a81deadb29c$export$34aec0b863436764(e.key, $31a25a81deadb29c$export$78acf4525d8a74c4.none()) : new $31a25a81deadb29c$var$__PRIVATE_SetMutation(e.key, e.data, $31a25a81deadb29c$export$78acf4525d8a74c4.none());
    {
        const n = e.data, r = $31a25a81deadb29c$export$c4ce752e73470fba.empty();
        let i = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$cf2f7c5792f80b46.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $31a25a81deadb29c$var$__PRIVATE_PatchMutation(e.key, r, new $31a25a81deadb29c$var$FieldMask(i.toArray()), $31a25a81deadb29c$export$78acf4525d8a74c4.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $31a25a81deadb29c$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $31a25a81deadb29c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $31a25a81deadb29c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $31a25a81deadb29c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$31a25a81deadb29c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $31a25a81deadb29c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($31a25a81deadb29c$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $31a25a81deadb29c$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $31a25a81deadb29c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$31a25a81deadb29c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $31a25a81deadb29c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $31a25a81deadb29c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$31a25a81deadb29c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $31a25a81deadb29c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($31a25a81deadb29c$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($31a25a81deadb29c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $31a25a81deadb29c$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $31a25a81deadb29c$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $31a25a81deadb29c$export$c4ce752e73470fba.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $31a25a81deadb29c$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $31a25a81deadb29c$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$31a25a81deadb29c$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $31a25a81deadb29c$var$__PRIVATE_SetMutation extends $31a25a81deadb29c$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_PatchMutation extends $31a25a81deadb29c$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $31a25a81deadb29c$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.length === n.length, 32656, {
        Ve: n.length,
        de: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $31a25a81deadb29c$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $31a25a81deadb29c$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $31a25a81deadb29c$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $31a25a81deadb29c$export$34aec0b863436764 extends $31a25a81deadb29c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_VerifyMutation extends $31a25a81deadb29c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $31a25a81deadb29c$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $31a25a81deadb29c$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $31a25a81deadb29c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $31a25a81deadb29c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $31a25a81deadb29c$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $31a25a81deadb29c$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($31a25a81deadb29c$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $31a25a81deadb29c$export$971d5caa766a69d7());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $31a25a81deadb29c$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$31a25a81deadb29c$var$__PRIVATE_mutationEquals(e, t)) && $31a25a81deadb29c$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$31a25a81deadb29c$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $31a25a81deadb29c$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.mutations.length === n.length, 58842, {
            me: e.mutations.length,
            fe: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $31a25a81deadb29c$var$Tt;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $31a25a81deadb29c$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $31a25a81deadb29c$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $31a25a81deadb29c$export$7a38258bbe170828 {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $31a25a81deadb29c$var$Rt, $31a25a81deadb29c$var$At;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $31a25a81deadb29c$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $31a25a81deadb29c$export$f1e1789686576879.OK:
            return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(64938);
        case $31a25a81deadb29c$export$f1e1789686576879.CANCELLED:
        case $31a25a81deadb29c$export$f1e1789686576879.UNKNOWN:
        case $31a25a81deadb29c$export$f1e1789686576879.DEADLINE_EXCEEDED:
        case $31a25a81deadb29c$export$f1e1789686576879.RESOURCE_EXHAUSTED:
        case $31a25a81deadb29c$export$f1e1789686576879.INTERNAL:
        case $31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $31a25a81deadb29c$export$f1e1789686576879.UNAUTHENTICATED:
            return !1;
        case $31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT:
        case $31a25a81deadb29c$export$f1e1789686576879.NOT_FOUND:
        case $31a25a81deadb29c$export$f1e1789686576879.ALREADY_EXISTS:
        case $31a25a81deadb29c$export$f1e1789686576879.PERMISSION_DENIED:
        case $31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $31a25a81deadb29c$export$f1e1789686576879.ABORTED:
        case $31a25a81deadb29c$export$f1e1789686576879.OUT_OF_RANGE:
        case $31a25a81deadb29c$export$f1e1789686576879.UNIMPLEMENTED:
        case $31a25a81deadb29c$export$f1e1789686576879.DATA_LOSS:
            return !0;
        default:
            return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $31a25a81deadb29c$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $31a25a81deadb29c$var$__PRIVATE_logError("GRPC error has no .code"), $31a25a81deadb29c$export$f1e1789686576879.UNKNOWN;
    switch(e){
        case $31a25a81deadb29c$var$Rt.OK:
            return $31a25a81deadb29c$export$f1e1789686576879.OK;
        case $31a25a81deadb29c$var$Rt.CANCELLED:
            return $31a25a81deadb29c$export$f1e1789686576879.CANCELLED;
        case $31a25a81deadb29c$var$Rt.UNKNOWN:
            return $31a25a81deadb29c$export$f1e1789686576879.UNKNOWN;
        case $31a25a81deadb29c$var$Rt.DEADLINE_EXCEEDED:
            return $31a25a81deadb29c$export$f1e1789686576879.DEADLINE_EXCEEDED;
        case $31a25a81deadb29c$var$Rt.RESOURCE_EXHAUSTED:
            return $31a25a81deadb29c$export$f1e1789686576879.RESOURCE_EXHAUSTED;
        case $31a25a81deadb29c$var$Rt.INTERNAL:
            return $31a25a81deadb29c$export$f1e1789686576879.INTERNAL;
        case $31a25a81deadb29c$var$Rt.UNAVAILABLE:
            return $31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE;
        case $31a25a81deadb29c$var$Rt.UNAUTHENTICATED:
            return $31a25a81deadb29c$export$f1e1789686576879.UNAUTHENTICATED;
        case $31a25a81deadb29c$var$Rt.INVALID_ARGUMENT:
            return $31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT;
        case $31a25a81deadb29c$var$Rt.NOT_FOUND:
            return $31a25a81deadb29c$export$f1e1789686576879.NOT_FOUND;
        case $31a25a81deadb29c$var$Rt.ALREADY_EXISTS:
            return $31a25a81deadb29c$export$f1e1789686576879.ALREADY_EXISTS;
        case $31a25a81deadb29c$var$Rt.PERMISSION_DENIED:
            return $31a25a81deadb29c$export$f1e1789686576879.PERMISSION_DENIED;
        case $31a25a81deadb29c$var$Rt.FAILED_PRECONDITION:
            return $31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION;
        case $31a25a81deadb29c$var$Rt.ABORTED:
            return $31a25a81deadb29c$export$f1e1789686576879.ABORTED;
        case $31a25a81deadb29c$var$Rt.OUT_OF_RANGE:
            return $31a25a81deadb29c$export$f1e1789686576879.OUT_OF_RANGE;
        case $31a25a81deadb29c$var$Rt.UNIMPLEMENTED:
            return $31a25a81deadb29c$export$f1e1789686576879.UNIMPLEMENTED;
        case $31a25a81deadb29c$var$Rt.DATA_LOSS:
            return $31a25a81deadb29c$export$f1e1789686576879.DATA_LOSS;
        default:
            return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($31a25a81deadb29c$var$At = $31a25a81deadb29c$var$Rt || ($31a25a81deadb29c$var$Rt = {}))[$31a25a81deadb29c$var$At.OK = 0] = "OK", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.CANCELLED = 1] = "CANCELLED", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.UNKNOWN = 2] = "UNKNOWN", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.NOT_FOUND = 5] = "NOT_FOUND", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.ABORTED = 10] = "ABORTED", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.INTERNAL = 13] = "INTERNAL", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.UNAVAILABLE = 14] = "UNAVAILABLE", $31a25a81deadb29c$var$At[$31a25a81deadb29c$var$At.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $31a25a81deadb29c$var$Vt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance - the instance to set.
 */ function $31a25a81deadb29c$export$1a82df3d29112e01(e) {
    if ($31a25a81deadb29c$var$Vt) throw new Error("a TestingHooksSpi instance is already set");
    $31a25a81deadb29c$var$Vt = e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $31a25a81deadb29c$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$dt = new (0, $906344b47e605252$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $31a25a81deadb29c$var$__PRIVATE_getMd5HashValue(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $906344b47e605252$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $31a25a81deadb29c$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $31a25a81deadb29c$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $31a25a81deadb29c$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $31a25a81deadb29c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $31a25a81deadb29c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $31a25a81deadb29c$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.ge = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.pe = (0, $906344b47e605252$export$70ffa26850098d01).fromNumber(this.ge);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    ye(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $906344b47e605252$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($31a25a81deadb29c$var$dt) && (r = new (0, $906344b47e605252$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.pe).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    we(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.ge) return !1;
        const t = $31a25a81deadb29c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $31a25a81deadb29c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            if (!this.we(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $31a25a81deadb29c$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.ge) return;
        const t = $31a25a81deadb29c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $31a25a81deadb29c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            this.Se(t);
        }
    }
    Se(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $31a25a81deadb29c$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $31a25a81deadb29c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $31a25a81deadb29c$var$RemoteEvent($31a25a81deadb29c$var$SnapshotVersion.min(), r, new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator), $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap(), $31a25a81deadb29c$export$971d5caa766a69d7());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $31a25a81deadb29c$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $31a25a81deadb29c$var$TargetChange(n, t, $31a25a81deadb29c$export$971d5caa766a69d7(), $31a25a81deadb29c$export$971d5caa766a69d7(), $31a25a81deadb29c$export$971d5caa766a69d7());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $31a25a81deadb29c$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.be = e, this.removedTargetIds = t, this.key = n, this.De = r;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.Ce = t;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $31a25a81deadb29c$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ve = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Fe = $31a25a81deadb29c$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Me = $31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING, this.xe = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Oe = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.xe;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Me;
    }
    /** Whether this target has pending target adds or target removes. */ get Ne() {
        return 0 !== this.ve;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Be() {
        return this.Oe;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Le(e) {
        e.approximateByteSize() > 0 && (this.Oe = !0, this.Me = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ke() {
        let e = $31a25a81deadb29c$export$971d5caa766a69d7(), t = $31a25a81deadb29c$export$971d5caa766a69d7(), n = $31a25a81deadb29c$export$971d5caa766a69d7();
        return this.Fe.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $31a25a81deadb29c$export$3a6d5c9ae78a2c08(38017, {
                        changeType: i
                    });
            }
        }), new $31a25a81deadb29c$var$TargetChange(this.Me, this.xe, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Ke() {
        this.Oe = !1, this.Fe = $31a25a81deadb29c$var$__PRIVATE_snapshotChangesMap();
    }
    qe(e, t) {
        this.Oe = !0, this.Fe = this.Fe.insert(e, t);
    }
    Ue(e) {
        this.Oe = !0, this.Fe = this.Fe.remove(e);
    }
    $e() {
        this.ve += 1;
    }
    We() {
        this.ve -= 1, $31a25a81deadb29c$export$7a0bdf7d4a91ea88(this.ve >= 0, 3241, {
            ve: this.ve
        });
    }
    Qe() {
        this.Oe = !0, this.xe = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $31a25a81deadb29c$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Ge = e, /** The internal state of all tracked targets. */ this.ze = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.je = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap(), this.Je = $31a25a81deadb29c$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.He = $31a25a81deadb29c$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Ze = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Xe(e) {
        for (const t of e.be)e.De && e.De.isFoundDocument() ? this.Ye(t, e.De) : this.et(t, e.key, e.De);
        for (const t of e.removedTargetIds)this.et(t, e.key, e.De);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ tt(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.nt(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.rt(t) && n.Le(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.We(), n.Ne || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Ke(), n.Le(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.We(), n.Ne || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.rt(t) && (n.Qe(), n.Le(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.rt(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.it(t), n.Le(e.resumeToken));
                    break;
                default:
                    $31a25a81deadb29c$export$3a6d5c9ae78a2c08(56790, {
                        state: e.state
                    });
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.ze.forEach((e, n)=>{
            this.rt(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ st(e) {
        const t = e.targetId, n = e.Ce.count, r = this.ot(t);
        if (r) {
            const i = r.target;
            if ($31a25a81deadb29c$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $31a25a81deadb29c$export$90a7f3efeed30595(i.path);
                    this.et(t, e, $31a25a81deadb29c$var$MutableDocument.newNoDocument(e, $31a25a81deadb29c$var$SnapshotVersion.min()));
                } else $31a25a81deadb29c$export$7a0bdf7d4a91ea88(1 === n, 20013, {
                    expectedCount: n
                });
            } else {
                const r = this._t(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.ut(e), i = n ? this.ct(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.it(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Ze = this.Ze.insert(t, e);
                    }
                    $31a25a81deadb29c$var$Vt?.o(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        const s = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, o = t.unchangedNames;
                        o && (s.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: o?.hashCount ?? 0,
                            bitmapLength: o?.bits?.bitmap?.length ?? 0,
                            padding: o?.bits?.padding ?? 0,
                            mightContain: (e)=>r?.mightContain(e) ?? !1
                        });
                        return s;
                    }(r, e.Ce, this.Ge.ht(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ ut(e) {
        const t = e.Ce.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $31a25a81deadb29c$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $31a25a81deadb29c$var$__PRIVATE_Base64DecodeError) return $31a25a81deadb29c$export$4c3d22f3d993c33f("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $31a25a81deadb29c$var$BloomFilter(s, r, i);
        } catch (e) {
            return $31a25a81deadb29c$export$4c3d22f3d993c33f(e instanceof $31a25a81deadb29c$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.ge ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ ct(e, t, n) {
        return t.Ce.count === n - this.Pt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ Pt(e, t) {
        const n = this.Ge.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Ge.ht(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.et(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Tt(e) {
        const t = new Map;
        this.ze.forEach((n, r)=>{
            const i = this.ot(r);
            if (i) {
                if (n.current && $31a25a81deadb29c$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $31a25a81deadb29c$export$90a7f3efeed30595(i.target.path);
                    this.It(t).has(r) || this.Et(r, t) || this.et(r, t, $31a25a81deadb29c$var$MutableDocument.newNoDocument(t, e));
                }
                n.Be && (t.set(r, n.ke()), n.Ke());
            }
        });
        let n = $31a25a81deadb29c$export$971d5caa766a69d7();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.He.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.ot(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.je.forEach((t, n)=>n.setReadTime(e));
        const r = new $31a25a81deadb29c$var$RemoteEvent(e, t, this.Ze, this.je, n);
        return this.je = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap(), this.Je = $31a25a81deadb29c$var$__PRIVATE_documentTargetMap(), this.He = $31a25a81deadb29c$var$__PRIVATE_documentTargetMap(), this.Ze = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ye(e, t) {
        if (!this.rt(e)) return;
        const n = this.Et(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.nt(e).qe(t.key, n), this.je = this.je.insert(t.key, t), this.Je = this.Je.insert(t.key, this.It(t.key).add(e)), this.He = this.He.insert(t.key, this.Rt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    et(e, t, n) {
        if (!this.rt(e)) return;
        const r = this.nt(e);
        this.Et(e, t) ? r.qe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Ue(t), this.He = this.He.insert(t, this.Rt(t).delete(e)), this.He = this.He.insert(t, this.Rt(t).add(e)), n && (this.je = this.je.insert(t, n));
    }
    removeTarget(e) {
        this.ze.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ _t(e) {
        const t = this.nt(e).ke();
        return this.Ge.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ $e(e) {
        this.nt(e).$e();
    }
    nt(e) {
        let t = this.ze.get(e);
        return t || (t = new $31a25a81deadb29c$var$__PRIVATE_TargetState, this.ze.set(e, t)), t;
    }
    Rt(e) {
        let t = this.He.get(e);
        return t || (t = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_primitiveComparator), this.He = this.He.insert(e, t)), t;
    }
    It(e) {
        let t = this.Je.get(e);
        return t || (t = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ rt(e) {
        const t = null !== this.ot(e);
        return t || $31a25a81deadb29c$export$21579262ef46735b("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ ot(e) {
        const t = this.ze.get(e);
        return t && t.Ne ? null : this.Ge.At(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ it(e) {
        this.ze.set(e, new $31a25a81deadb29c$var$__PRIVATE_TargetState);
        this.Ge.getRemoteKeysForTarget(e).forEach((t)=>{
            this.et(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ Et(e, t) {
        return this.Ge.getRemoteKeysForTarget(e).has(t);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_documentTargetMap() {
    return new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
}
function $31a25a81deadb29c$var$__PRIVATE_snapshotChangesMap() {
    return new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
}
const $31a25a81deadb29c$var$mt = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $31a25a81deadb29c$var$ft = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $31a25a81deadb29c$var$gt = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $31a25a81deadb29c$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $31a25a81deadb29c$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $31a25a81deadb29c$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $31a25a81deadb29c$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ /**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $31a25a81deadb29c$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $31a25a81deadb29c$var$__PRIVATE_toVersion(e, t) {
    return $31a25a81deadb29c$var$toTimestamp(e, t.toTimestamp());
}
function $31a25a81deadb29c$var$__PRIVATE_fromVersion(e) {
    return $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!e, 49232), $31a25a81deadb29c$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(e);
        return new $31a25a81deadb29c$export$3d12bd131bb975d1(t.seconds, t.nanos);
    }(e));
}
function $31a25a81deadb29c$var$__PRIVATE_toResourceName(e, t) {
    return $31a25a81deadb29c$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $31a25a81deadb29c$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $31a25a81deadb29c$export$db202ddc8be9136([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $31a25a81deadb29c$var$__PRIVATE_fromResourceName(e) {
    const t = $31a25a81deadb29c$export$db202ddc8be9136.fromString(e);
    return $31a25a81deadb29c$export$7a0bdf7d4a91ea88($31a25a81deadb29c$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $31a25a81deadb29c$var$__PRIVATE_toName(e, t) {
    return $31a25a81deadb29c$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $31a25a81deadb29c$var$fromName(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $31a25a81deadb29c$var$__PRIVATE_toQueryPath(e, t) {
    return $31a25a81deadb29c$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $31a25a81deadb29c$var$__PRIVATE_fromQueryPath(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $31a25a81deadb29c$export$db202ddc8be9136.emptyPath() : $31a25a81deadb29c$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $31a25a81deadb29c$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $31a25a81deadb29c$export$db202ddc8be9136([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $31a25a81deadb29c$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $31a25a81deadb29c$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $31a25a81deadb29c$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $31a25a81deadb29c$var$__PRIVATE_fromPipelineResponse(e, t, n) {
    const r = {};
    t.transaction?.length && (r.transaction = t.transaction);
    const i = t.executionTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.executionTime) : void 0;
    return r.executionTime = i, n && (r.key = n.name ? $31a25a81deadb29c$var$fromName(e, n.name) : void 0, r.fields = new $31a25a81deadb29c$export$c4ce752e73470fba({
        mapValue: {
            fields: n.fields
        }
    }), r.createTime = n.createTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(n.createTime) : void 0, r.updateTime = n.updateTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(n.updateTime) : void 0), r;
}
function $31a25a81deadb29c$export$3a1a48c8f6ef640e(e, t, n) {
    const r = $31a25a81deadb29c$var$fromName(e, t.name), i = $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.createTime) : $31a25a81deadb29c$var$SnapshotVersion.min(), o = new $31a25a81deadb29c$export$c4ce752e73470fba({
        mapValue: {
            fields: t.fields
        }
    }), _ = $31a25a81deadb29c$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $31a25a81deadb29c$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $31a25a81deadb29c$var$fromName(e, t.found.name), r = $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.found.createTime) : $31a25a81deadb29c$var$SnapshotVersion.min(), s = new $31a25a81deadb29c$export$c4ce752e73470fba({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $31a25a81deadb29c$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!t.missing, 3894), $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!t.readTime, 22933);
        const n = $31a25a81deadb29c$var$fromName(e, t.missing), r = $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.readTime);
        return $31a25a81deadb29c$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(7234, {
        result: t
    });
}
function $31a25a81deadb29c$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(void 0 === t || "string" == typeof t, 58123), $31a25a81deadb29c$export$9d398bebfec1c039.fromBase64String(t || "")) : ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $31a25a81deadb29c$require$Buffer || t instanceof Uint8Array, 16193), $31a25a81deadb29c$export$9d398bebfec1c039.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $31a25a81deadb29c$export$f1e1789686576879.UNKNOWN : $31a25a81deadb29c$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $31a25a81deadb29c$export$4368d992c4eafac0(t, e.message || "");
        }(o);
        n = new $31a25a81deadb29c$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $31a25a81deadb29c$var$fromName(e, r.document.name), s = $31a25a81deadb29c$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(r.document.createTime) : $31a25a81deadb29c$var$SnapshotVersion.min(), _ = new $31a25a81deadb29c$export$c4ce752e73470fba({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $31a25a81deadb29c$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $31a25a81deadb29c$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $31a25a81deadb29c$var$fromName(e, r.document), s = r.readTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(r.readTime) : $31a25a81deadb29c$var$SnapshotVersion.min(), o = $31a25a81deadb29c$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $31a25a81deadb29c$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $31a25a81deadb29c$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $31a25a81deadb29c$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(11601, {
            Vt: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $31a25a81deadb29c$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $31a25a81deadb29c$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $31a25a81deadb29c$var$toMutation(e, t) {
    let n;
    if (t instanceof $31a25a81deadb29c$var$__PRIVATE_SetMutation) n = {
        update: $31a25a81deadb29c$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $31a25a81deadb29c$export$34aec0b863436764) n = {
        delete: $31a25a81deadb29c$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $31a25a81deadb29c$var$__PRIVATE_PatchMutation) n = {
        update: $31a25a81deadb29c$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $31a25a81deadb29c$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $31a25a81deadb29c$var$__PRIVATE_VerifyMutation)) return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(16599, {
            dt: t.type
        });
        n = {
            verify: $31a25a81deadb29c$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $31a25a81deadb29c$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $31a25a81deadb29c$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Ae
            };
            throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $31a25a81deadb29c$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(27497);
    }(e, t.precondition)), n;
}
function $31a25a81deadb29c$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $31a25a81deadb29c$export$78acf4525d8a74c4.updateTime($31a25a81deadb29c$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $31a25a81deadb29c$export$78acf4525d8a74c4.exists(e.exists) : $31a25a81deadb29c$export$78acf4525d8a74c4.none();
    }(t.currentDocument) : $31a25a81deadb29c$export$78acf4525d8a74c4.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $31a25a81deadb29c$export$7a0bdf7d4a91ea88("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $31a25a81deadb29c$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $31a25a81deadb29c$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(16584, {
                proto: t
            });
            const r = $31a25a81deadb29c$export$cf2f7c5792f80b46.fromServerFormat(t.fieldPath);
            return new $31a25a81deadb29c$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $31a25a81deadb29c$var$fromName(e, t.update.name), s = new $31a25a81deadb29c$export$c4ce752e73470fba({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $31a25a81deadb29c$var$FieldMask(t.map((e)=>$31a25a81deadb29c$export$cf2f7c5792f80b46.fromServerFormat(e)));
            }(t.updateMask);
            return new $31a25a81deadb29c$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $31a25a81deadb29c$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $31a25a81deadb29c$var$fromName(e, t.delete);
        return new $31a25a81deadb29c$export$34aec0b863436764(r, n);
    }
    if (t.verify) {
        const r = $31a25a81deadb29c$var$fromName(e, t.verify);
        return new $31a25a81deadb29c$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(1463, {
        proto: t
    });
}
function $31a25a81deadb29c$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(e.updateTime) : $31a25a81deadb29c$var$__PRIVATE_fromVersion(t);
            return n.isEqual($31a25a81deadb29c$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $31a25a81deadb29c$var$__PRIVATE_fromVersion(t)), new $31a25a81deadb29c$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $31a25a81deadb29c$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $31a25a81deadb29c$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $31a25a81deadb29c$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $31a25a81deadb29c$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $31a25a81deadb29c$var$__PRIVATE_toFilter($31a25a81deadb29c$export$e7094788287c5e9b.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $31a25a81deadb29c$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $31a25a81deadb29c$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        ft: n,
        parent: i
    };
}
function $31a25a81deadb29c$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { ft: i, parent: s } = $31a25a81deadb29c$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        gt: o,
        parent: s
    };
}
function $31a25a81deadb29c$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $31a25a81deadb29c$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_fromFilter(e);
        if (t instanceof $31a25a81deadb29c$export$e7094788287c5e9b && $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $31a25a81deadb29c$export$306ddfe3a8403e2($31a25a81deadb29c$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $31a25a81deadb29c$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $31a25a81deadb29c$export$625550452a3fa3ec(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $31a25a81deadb29c$export$625550452a3fa3ec(n, t);
    }(n.endAt)), $31a25a81deadb29c$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $31a25a81deadb29c$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $31a25a81deadb29c$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $31a25a81deadb29c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $31a25a81deadb29c$export$23f2a1d2818174ef.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $31a25a81deadb29c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $31a25a81deadb29c$export$23f2a1d2818174ef.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $31a25a81deadb29c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $31a25a81deadb29c$export$23f2a1d2818174ef.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $31a25a81deadb29c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $31a25a81deadb29c$export$23f2a1d2818174ef.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(61313);
            default:
                return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $31a25a81deadb29c$export$23f2a1d2818174ef.create($31a25a81deadb29c$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(58110);
                default:
                    return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $31a25a81deadb29c$export$e7094788287c5e9b.create(e.compositeFilter.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(30097, {
        filter: e
    });
}
function $31a25a81deadb29c$var$__PRIVATE_toDirection(e) {
    return $31a25a81deadb29c$var$mt[e];
}
function $31a25a81deadb29c$var$__PRIVATE_toOperatorName(e) {
    return $31a25a81deadb29c$var$ft[e];
}
function $31a25a81deadb29c$var$__PRIVATE_toCompositeOperatorName(e) {
    return $31a25a81deadb29c$var$gt[e];
}
function $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $31a25a81deadb29c$var$__PRIVATE_fromFieldPathReference(e) {
    return $31a25a81deadb29c$export$cf2f7c5792f80b46.fromServerFormat(e.fieldPath);
}
function $31a25a81deadb29c$var$__PRIVATE_toFilter(e) {
    return e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($31a25a81deadb29c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($31a25a81deadb29c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($31a25a81deadb29c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($31a25a81deadb29c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $31a25a81deadb29c$var$__PRIVATE_toFieldPathReference(e.field),
                op: $31a25a81deadb29c$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $31a25a81deadb29c$export$e7094788287c5e9b ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$31a25a81deadb29c$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $31a25a81deadb29c$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(54877, {
        filter: e
    });
}
function $31a25a81deadb29c$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $31a25a81deadb29c$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
function $31a25a81deadb29c$var$__PRIVATE_isProtoValueSerializable(// eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return !!e && "function" == typeof e._toProto && "ProtoValue" === e._protoValueType;
}
function $31a25a81deadb29c$export$31e67cf12fc9668(e, t) {
    const n = {
        fields: {}
    };
    return t.forEach((t, r)=>{
        if ("string" != typeof r) throw new Error(`Cannot encode map with non-string key: ${r}`);
        n.fields[r] = t._toProto(e);
    }), {
        mapValue: n
    };
}
function $31a25a81deadb29c$export$4ae495d48253603d(e) {
    return {
        stringValue: e
    };
}
function $31a25a81deadb29c$export$b4d5ecaefe2b27f3(e) {
    return {
        pipelineValue: e
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $31a25a81deadb29c$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $31a25a81deadb29c$var$SnapshotVersion.min(), s = $31a25a81deadb29c$var$SnapshotVersion.min(), o = $31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $31a25a81deadb29c$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $31a25a81deadb29c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $31a25a81deadb29c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $31a25a81deadb29c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $31a25a81deadb29c$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.yt = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $31a25a81deadb29c$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $31a25a81deadb29c$export$3a1a48c8f6ef640e(e.yt, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $31a25a81deadb29c$export$90a7f3efeed30595.fromSegments(t.noDocument.path), r = $31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $31a25a81deadb29c$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(56709);
        {
            const e = $31a25a81deadb29c$export$90a7f3efeed30595.fromSegments(t.unknownDocument.path), r = $31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $31a25a81deadb29c$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $31a25a81deadb29c$export$3d12bd131bb975d1(e[0], e[1]);
        return $31a25a81deadb29c$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $31a25a81deadb29c$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $31a25a81deadb29c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $31a25a81deadb29c$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $31a25a81deadb29c$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $31a25a81deadb29c$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.yt, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $31a25a81deadb29c$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $31a25a81deadb29c$export$3d12bd131bb975d1(e.seconds, e.nanoseconds);
    return $31a25a81deadb29c$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$31a25a81deadb29c$var$__PRIVATE_fromMutation(e.yt, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$31a25a81deadb29c$var$__PRIVATE_fromMutation(e.yt, t)), i = $31a25a81deadb29c$export$3d12bd131bb975d1.fromMillis(t.localWriteTimeMs);
    return new $31a25a81deadb29c$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $31a25a81deadb29c$var$__PRIVATE_fromDbTarget(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $31a25a81deadb29c$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $31a25a81deadb29c$export$7a0bdf7d4a91ea88(1 === t, 1966, {
            count: t
        }), $31a25a81deadb29c$var$__PRIVATE_queryToTarget($31a25a81deadb29c$export$a93c5207d687da10($31a25a81deadb29c$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $31a25a81deadb29c$var$__PRIVATE_queryToTarget($31a25a81deadb29c$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $31a25a81deadb29c$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $31a25a81deadb29c$export$9d398bebfec1c039.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $31a25a81deadb29c$var$__PRIVATE_toDbTarget(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $31a25a81deadb29c$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $31a25a81deadb29c$var$__PRIVATE_toDocumentsTarget(e.yt, t.target) : $31a25a81deadb29c$var$__PRIVATE_toQueryTarget(e.yt, t.target).ft;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $31a25a81deadb29c$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $31a25a81deadb29c$export$56c0d5a1e737357d(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $31a25a81deadb29c$export$882b5998b3b9117c(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $31a25a81deadb29c$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $31a25a81deadb29c$var$Overlay(t.largestBatchId, $31a25a81deadb29c$var$__PRIVATE_fromMutation(e.yt, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $31a25a81deadb29c$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $31a25a81deadb29c$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp($31a25a81deadb29c$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $31a25a81deadb29c$export$56c0d5a1e737357d(e.bundledQuery),
                    readTime: $31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $31a25a81deadb29c$var$__PRIVATE_toDbTimestamp($31a25a81deadb29c$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_bundlesStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$me);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_namedQueriesStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$ge);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static wt(e, t) {
        const n = t.uid || "";
        return new $31a25a81deadb29c$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_documentOverlayStore(e).get($31a25a81deadb29c$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $31a25a81deadb29c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap();
        return $31a25a81deadb29c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $31a25a81deadb29c$var$Overlay(t, i);
            r.push(this.St(e, s));
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($31a25a81deadb29c$var$__PRIVATE_documentOverlayStore(e).X($31a25a81deadb29c$var$ke, r));
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap(), i = $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $31a25a81deadb29c$var$__PRIVATE_documentOverlayStore(e).J($31a25a81deadb29c$var$ke, s).next((e)=>{
            for (const t of e){
                const e = $31a25a81deadb29c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $31a25a81deadb29c$var$__PRIVATE_documentOverlayStore(e).ee({
            index: $31a25a81deadb29c$var$qe,
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $31a25a81deadb29c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    St(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $31a25a81deadb29c$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $31a25a81deadb29c$var$toMutation(e.yt, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_documentOverlayStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$Be);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbGlobalsCache {
    bt(e) {
        return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$$e);
    }
    getSessionToken(e) {
        return this.bt(e).get("sessionToken").next((e)=>{
            const t = e?.value;
            return t ? $31a25a81deadb29c$export$9d398bebfec1c039.fromUint8Array(t) : $31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.bt(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Dt(e, t) {
        this.Ct(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.vt();
    }
    Ct(e, t) {
        if ("nullValue" in e) this.Ft(t, 5);
        else if ("booleanValue" in e) this.Ft(t, 10), t.Mt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Ft(t, 15), t.Mt($31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Ft(t, 13) : (this.Ft(t, 15), $31a25a81deadb29c$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.Mt(0) : t.Mt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Ft(t, 20), "string" == typeof n && (n = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(n)), t.xt(`${n.seconds || ""}`), t.Mt(n.nanos || 0);
        } else if ("stringValue" in e) this.Ot(e.stringValue, t), this.Nt(t);
        else if ("bytesValue" in e) this.Ft(t, 30), t.Bt($31a25a81deadb29c$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Nt(t);
        else if ("referenceValue" in e) this.Lt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Ft(t, 45), t.Mt(n.latitude || 0), t.Mt(n.longitude || 0);
        } else "mapValue" in e ? $31a25a81deadb29c$var$__PRIVATE_isMaxValue(e) ? this.Ft(t, Number.MAX_SAFE_INTEGER) : $31a25a81deadb29c$var$__PRIVATE_isVectorValue(e) ? this.kt(e.mapValue, t) : (this.Kt(e.mapValue, t), this.Nt(t)) : "arrayValue" in e ? (this.qt(e.arrayValue, t), this.Nt(t)) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(19022, {
            Ut: e
        });
    }
    Ot(e, t) {
        this.Ft(t, 25), this.$t(e, t);
    }
    $t(e, t) {
        t.xt(e);
    }
    Kt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 55);
        for (const e of Object.keys(n))this.Ot(e, t), this.Ct(n[e], t);
    }
    kt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 53);
        // Vectors sort first by length
        const r = $31a25a81deadb29c$var$ut, i = n[r].arrayValue?.values?.length || 0;
        this.Ft(t, 15), t.Mt($31a25a81deadb29c$var$__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
        this.Ot(r, t), this.Ct(n[r], t);
    }
    qt(e, t) {
        const n = e.values || [];
        this.Ft(t, 50);
        for (const e of n)this.Ct(e, t);
    }
    Lt(e, t) {
        this.Ft(t, 37);
        $31a25a81deadb29c$export$90a7f3efeed30595.fromName(e).path.forEach((e)=>{
            this.Ft(t, 60), this.$t(e, t);
        });
    }
    Ft(e, t) {
        e.Mt(t);
    }
    Nt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Mt(2);
    }
}
$31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter.Wt = new $31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $31a25a81deadb29c$var$pt = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $31a25a81deadb29c$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $31a25a81deadb29c$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $31a25a81deadb29c$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $31a25a81deadb29c$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Qt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Gt(n.value), n = t.next();
        this.zt();
    }
    jt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Jt(n.value), n = t.next();
        this.Ht();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Zt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Gt(e);
            else if (e < 2048) this.Gt(960 | e >>> 6), this.Gt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Gt(480 | e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Gt(240 | e >>> 18), this.Gt(128 | 63 & e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            }
        }
        this.zt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Xt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Jt(e);
            else if (e < 2048) this.Jt(960 | e >>> 6), this.Jt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Jt(480 | e >>> 12), this.Jt(128 | 63 & e >>> 6), this.Jt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Jt(240 | e >>> 18), this.Jt(128 | 63 & e >>> 12), this.Jt(128 | 63 & e >>> 6), this.Jt(128 | 63 & e);
            }
        }
        this.Ht();
    }
    Yt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $31a25a81deadb29c$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    nn(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $31a25a81deadb29c$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ rn() {
        this.sn($31a25a81deadb29c$var$pt), this.sn(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ _n() {
        this.an($31a25a81deadb29c$var$pt), this.an(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.tn(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ un() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ en(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Gt(e) {
        const t = 255 & e;
        0 === t ? (this.sn(0), this.sn(255)) : t === $31a25a81deadb29c$var$pt ? (this.sn($31a25a81deadb29c$var$pt), this.sn(0)) : this.sn(t);
    }
    /** Writes a single byte descending to the buffer.  */ Jt(e) {
        const t = 255 & e;
        0 === t ? (this.an(0), this.an(255)) : t === $31a25a81deadb29c$var$pt ? (this.an($31a25a81deadb29c$var$pt), this.an(0)) : this.an(e);
    }
    zt() {
        this.sn(0), this.sn(1);
    }
    Ht() {
        this.an(0), this.an(1);
    }
    sn(e) {
        this.tn(1), this.buffer[this.position++] = e;
    }
    an(e) {
        this.tn(1), this.buffer[this.position++] = ~e;
    }
    tn(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.Qt(e);
    }
    xt(e) {
        this.cn.Zt(e);
    }
    Mt(e) {
        this.cn.Yt(e);
    }
    vt() {
        this.cn.rn();
    }
}
class $31a25a81deadb29c$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.jt(e);
    }
    xt(e) {
        this.cn.Xt(e);
    }
    Mt(e) {
        this.cn.nn(e);
    }
    vt() {
        this.cn._n();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.cn = new $31a25a81deadb29c$var$__PRIVATE_OrderedCodeWriter, this.ascending = new $31a25a81deadb29c$var$__PRIVATE_AscendingIndexByteEncoder(this.cn), this.descending = new $31a25a81deadb29c$var$__PRIVATE_DescendingIndexByteEncoder(this.cn);
    }
    seed(e) {
        this.cn.seed(e);
    }
    ln(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.ascending : this.descending;
    }
    un() {
        return this.cn.un();
    }
    reset() {
        this.cn.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $31a25a81deadb29c$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.hn = e, this.Pn = t, this.Tn = n, this.In = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ En() {
        const e = this.In.length, t = 0 === e || 255 === this.In[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.In, 0), t !== e ? n.set([
            0
        ], this.In.length) : ++n[n.length - 1], new $31a25a81deadb29c$var$__PRIVATE_IndexEntry(this.hn, this.Pn, this.Tn, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    Rn(e, t, n) {
        return {
            indexId: this.hn,
            uid: e,
            arrayValue: $31a25a81deadb29c$var$__PRIVATE_encodeKeySafeBytes(this.Tn),
            directionalValue: $31a25a81deadb29c$var$__PRIVATE_encodeKeySafeBytes(this.In),
            orderedDocumentKey: $31a25a81deadb29c$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    An(e, t, n) {
        const r = this.Rn(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $31a25a81deadb29c$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.hn - t.hn;
    return 0 !== n ? n : (n = $31a25a81deadb29c$var$__PRIVATE_compareByteArrays(e.Tn, t.Tn), 0 !== n ? n : (n = $31a25a81deadb29c$var$__PRIVATE_compareByteArrays(e.In, t.In), 0 !== n ? n : $31a25a81deadb29c$export$90a7f3efeed30595.comparator(e.Pn, t.Pn)));
}
function $31a25a81deadb29c$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $31a25a81deadb29c$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $029952e65115eee5$export$ef10bcfb06572016)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $31a25a81deadb29c$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $31a25a81deadb29c$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Vn = new $31a25a81deadb29c$var$SortedSet((e, t)=>$31a25a81deadb29c$export$cf2f7c5792f80b46.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.dn = e.orderBy, this.mn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Vn = this.Vn.add(e) : this.mn.push(e);
        }
    }
    get fn() {
        return this.Vn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ gn(e) {
        if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.collectionGroup === this.collectionId, 49279), this.fn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.pn(t)) return !1;
        const n = $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.pn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.Vn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.Vn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.yn(e, t) || !this.wn(this.dn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.dn.length || !this.wn(this.dn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ Sn() {
        if (this.fn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$cf2f7c5792f80b46.comparator);
        const t = [];
        for (const n of this.mn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $31a25a81deadb29c$export$c9170ad7d4cd7e57(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $31a25a81deadb29c$export$c9170ad7d4cd7e57(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.dn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $31a25a81deadb29c$export$c9170ad7d4cd7e57(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $31a25a81deadb29c$export$ee7c8ad385a60b7b($31a25a81deadb29c$export$ee7c8ad385a60b7b.UNKNOWN_ID, this.collectionId, t, $31a25a81deadb29c$export$995eb9fca571757.empty());
    }
    pn(e) {
        for (const t of this.mn)if (this.yn(t, e)) return !0;
        return !1;
    }
    yn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    wn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $31a25a81deadb29c$var$__PRIVATE_computeInExpansion(e) {
    if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef || e instanceof $31a25a81deadb29c$export$e7094788287c5e9b, 20012), e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef) {
        if (e instanceof $31a25a81deadb29c$var$__PRIVATE_InFilter) {
            const t = e.value.arrayValue?.values?.map((t)=>$31a25a81deadb29c$export$23f2a1d2818174ef.create(e.field, "==" /* Operator.EQUAL */ , t)) || [];
            return $31a25a81deadb29c$export$e7094788287c5e9b.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const t = e.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_computeInExpansion(e));
    return $31a25a81deadb29c$export$e7094788287c5e9b.create(t, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter - the composite filter to calculate DNF transform for.
 * @returns the terms in the DNF transform.
 */ function $31a25a81deadb29c$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $31a25a81deadb29c$var$__PRIVATE_computeDistributedNormalForm($31a25a81deadb29c$var$__PRIVATE_computeInExpansion(e));
    return $31a25a81deadb29c$export$7a0bdf7d4a91ea88($31a25a81deadb29c$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $31a25a81deadb29c$var$__PRIVATE_isSingleFieldFilter(t) || $31a25a81deadb29c$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $31a25a81deadb29c$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $31a25a81deadb29c$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $31a25a81deadb29c$export$e7094788287c5e9b && $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $31a25a81deadb29c$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $31a25a81deadb29c$var$__PRIVATE_isSingleFieldFilter(e) || $31a25a81deadb29c$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $31a25a81deadb29c$export$e7094788287c5e9b && $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$31a25a81deadb29c$var$__PRIVATE_isSingleFieldFilter(t) && !$31a25a81deadb29c$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $31a25a81deadb29c$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef || e instanceof $31a25a81deadb29c$export$e7094788287c5e9b, 34018), e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef) return e;
    if (1 === e.filters.length) return $31a25a81deadb29c$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $31a25a81deadb29c$export$e7094788287c5e9b.create(t, e.op);
    return n = $31a25a81deadb29c$var$__PRIVATE_applyAssociation(n), $31a25a81deadb29c$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(n instanceof $31a25a81deadb29c$export$e7094788287c5e9b, 64498), $31a25a81deadb29c$export$7a0bdf7d4a91ea88($31a25a81deadb29c$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $31a25a81deadb29c$export$7a0bdf7d4a91ea88(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$31a25a81deadb29c$var$__PRIVATE_applyDistribution(e, t)));
}
function $31a25a81deadb29c$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef || e instanceof $31a25a81deadb29c$export$e7094788287c5e9b, 38388), $31a25a81deadb29c$export$7a0bdf7d4a91ea88(t instanceof $31a25a81deadb29c$export$23f2a1d2818174ef || t instanceof $31a25a81deadb29c$export$e7094788287c5e9b, 25473), // FieldFilter FieldFilter
    n = e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef ? t instanceof $31a25a81deadb29c$export$23f2a1d2818174ef ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $31a25a81deadb29c$export$e7094788287c5e9b.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $31a25a81deadb29c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $31a25a81deadb29c$export$23f2a1d2818174ef ? $31a25a81deadb29c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.filters.length > 0 && t.filters.length > 0, 48005), $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsConjunction(e) && $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsConjunction(t)) return $31a25a81deadb29c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $31a25a81deadb29c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$31a25a81deadb29c$var$__PRIVATE_applyDistribution(e, r));
        return $31a25a81deadb29c$export$e7094788287c5e9b.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $31a25a81deadb29c$var$__PRIVATE_applyAssociation(n);
}
function $31a25a81deadb29c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($31a25a81deadb29c$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $31a25a81deadb29c$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$31a25a81deadb29c$var$__PRIVATE_applyDistribution(e, t));
        return $31a25a81deadb29c$export$e7094788287c5e9b.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $31a25a81deadb29c$var$__PRIVATE_applyAssociation(e) {
    if ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef || e instanceof $31a25a81deadb29c$export$e7094788287c5e9b, 11850), e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $31a25a81deadb29c$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($31a25a81deadb29c$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$31a25a81deadb29c$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $31a25a81deadb29c$export$23f2a1d2818174ef ? r.push(t) : t instanceof $31a25a81deadb29c$export$e7094788287c5e9b && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $31a25a81deadb29c$export$e7094788287c5e9b.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.bn = new $31a25a81deadb29c$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.bn.add(t), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.bn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve($31a25a81deadb29c$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve($31a25a81deadb29c$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$db202ddc8be9136.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$db202ddc8be9136.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$yt = "IndexedDbIndexManager", $31a25a81deadb29c$var$wt = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.Dn = new $31a25a81deadb29c$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Cn = new $31a25a81deadb29c$var$ObjectMap((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyTarget(e), (e, t)=>$31a25a81deadb29c$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.Dn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.Dn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(r)
            };
            return $31a25a81deadb29c$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $31a25a81deadb29c$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $31a25a81deadb29c$var$__PRIVATE_collectionParentsStore(e).J(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $31a25a81deadb29c$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $31a25a81deadb29c$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($31a25a81deadb29c$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_indexConfigurationStore(e), r = $31a25a81deadb29c$var$__PRIVATE_indexStateStore(e), i = $31a25a81deadb29c$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_indexConfigurationStore(e), n = $31a25a81deadb29c$var$__PRIVATE_indexEntriesStore(e), r = $31a25a81deadb29c$var$__PRIVATE_indexStateStore(e);
        return t.X().next(()=>n.X()).next(()=>r.X());
    }
    createTargetIndexes(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.forEach(this.vn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $31a25a81deadb29c$var$__PRIVATE_TargetIndexMatcher(t).Sn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $31a25a81deadb29c$var$PersistencePromise.forEach(this.vn(t), (t)=>this.Fn(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $31a25a81deadb29c$export$971d5caa766a69d7();
                const r = [];
                return $31a25a81deadb29c$var$PersistencePromise.forEach(i, (i, s)=>{
                    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$yt, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$31a25a81deadb29c$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $31a25a81deadb29c$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $31a25a81deadb29c$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $31a25a81deadb29c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $31a25a81deadb29c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $31a25a81deadb29c$export$625550452a3fa3ec(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $31a25a81deadb29c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $31a25a81deadb29c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $31a25a81deadb29c$export$625550452a3fa3ec(n, r);
                    }(s, i), c = this.Mn(i, s, a), l = this.Mn(i, s, u), h = this.xn(i, s, _), P = this.On(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $31a25a81deadb29c$var$PersistencePromise.forEach(P, (i)=>n.Z(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $31a25a81deadb29c$export$90a7f3efeed30595.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $31a25a81deadb29c$var$PersistencePromise.resolve(null);
        });
    }
    vn(e) {
        let t = this.Cn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $31a25a81deadb29c$var$__PRIVATE_getDnfTerms($31a25a81deadb29c$export$e7094788287c5e9b.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$31a25a81deadb29c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Cn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ On(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Nn(t[c / a]) : $31a25a81deadb29c$var$wt, l = this.Bn(e, _, n[c % a], r), h = this.Ln(e, _, i[c % a], s), P = o.map((t)=>this.Bn(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ Bn(e, t, n, r) {
        const i = new $31a25a81deadb29c$var$__PRIVATE_IndexEntry(e, $31a25a81deadb29c$export$90a7f3efeed30595.empty(), t, n);
        return r ? i : i.En();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ Ln(e, t, n, r) {
        const i = new $31a25a81deadb29c$var$__PRIVATE_IndexEntry(e, $31a25a81deadb29c$export$90a7f3efeed30595.empty(), t, n);
        return r ? i.En() : i;
    }
    Fn(e, t) {
        const n = new $31a25a81deadb29c$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.gn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.vn(t);
        return $31a25a81deadb29c$var$PersistencePromise.forEach(r, (t)=>this.Fn(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$export$cf2f7c5792f80b46.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ kn(e, t) {
        const n = new $31a25a81deadb29c$var$__PRIVATE_IndexByteEncoder;
        for (const r of $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.ln(r.kind);
            $31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, i);
        }
        return n.un();
    }
    /** Encodes a single value to the ascending index format. */ Nn(e) {
        const t = new $31a25a81deadb29c$var$__PRIVATE_IndexByteEncoder;
        return $31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, t.ln(0 /* IndexKind.ASCENDING */ )), t.un();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ Kn(e, t) {
        const n = new $31a25a81deadb29c$var$__PRIVATE_IndexByteEncoder;
        return $31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt($31a25a81deadb29c$export$43caf9889c228507(this.databaseId, t), n.ln(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.un();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ xn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $31a25a81deadb29c$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.qn(t, s.fieldPath) && $31a25a81deadb29c$var$isArray(e)) r = this.Un(r, s, e);
            else {
                const t = n.ln(s.kind);
                $31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, t);
            }
        }
        return this.$n(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ Mn(e, t, n) {
        return this.xn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ $n(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].un();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Un(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $31a25a81deadb29c$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.un()), $31a25a81deadb29c$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, r.ln(t.kind)), i.push(r);
        }
        return i;
    }
    qn(e, t) {
        return !!e.filters.find((e)=>e instanceof $31a25a81deadb29c$export$23f2a1d2818174ef && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_indexConfigurationStore(e), r = $31a25a81deadb29c$var$__PRIVATE_indexStateStore(e);
        return (t ? n.J($31a25a81deadb29c$var$be, IDBKeyRange.bound(t, t)) : n.J()).next((e)=>{
            const t = [];
            return $31a25a81deadb29c$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $31a25a81deadb29c$export$995eb9fca571757(t.sequenceNumber, new $31a25a81deadb29c$var$IndexOffset($31a25a81deadb29c$var$__PRIVATE_fromDbTimestamp(t.readTime), new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $31a25a81deadb29c$export$995eb9fca571757.empty(), r = e.fields.map(([e, t])=>new $31a25a81deadb29c$export$c9170ad7d4cd7e57($31a25a81deadb29c$export$cf2f7c5792f80b46.fromServerFormat(e), t));
                        return new $31a25a81deadb29c$export$ee7c8ad385a60b7b(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $31a25a81deadb29c$var$__PRIVATE_indexConfigurationStore(e), i = $31a25a81deadb29c$var$__PRIVATE_indexStateStore(e);
        return this.Wn(e).next((e)=>r.J($31a25a81deadb29c$var$be, IDBKeyRange.bound(t, t)).next((t)=>$31a25a81deadb29c$var$PersistencePromise.forEach(t, (t)=>i.put($31a25a81deadb29c$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $31a25a81deadb29c$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $31a25a81deadb29c$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $31a25a81deadb29c$var$PersistencePromise.forEach(i, (n)=>this.Qn(e, t, n).next((t)=>{
                        const i = this.Gn(r, n);
                        return t.isEqual(i) ? $31a25a81deadb29c$var$PersistencePromise.resolve() : this.zn(e, r, n, t, i);
                    }))));
        });
    }
    jn(e, t, n, r) {
        return $31a25a81deadb29c$var$__PRIVATE_indexEntriesStore(e).put(r.Rn(this.uid, this.Kn(n, t.key), t.key));
    }
    Jn(e, t, n, r) {
        return $31a25a81deadb29c$var$__PRIVATE_indexEntriesStore(e).delete(r.An(this.uid, this.Kn(n, t.key), t.key));
    }
    Qn(e, t, n) {
        const r = $31a25a81deadb29c$var$__PRIVATE_indexEntriesStore(e);
        let i = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_indexEntryComparator);
        return r.ee({
            index: $31a25a81deadb29c$var$Oe,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $31a25a81deadb29c$var$__PRIVATE_encodeKeySafeBytes(this.Kn(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $31a25a81deadb29c$var$__PRIVATE_IndexEntry(n.indexId, t, $31a25a81deadb29c$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $31a25a81deadb29c$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Gn(e, t) {
        let n = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_indexEntryComparator);
        const r = this.kn(t, e);
        if (null == r) return n;
        const i = $31a25a81deadb29c$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($31a25a81deadb29c$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $31a25a81deadb29c$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Nn(i), r));
        } else n = n.add(new $31a25a81deadb29c$var$__PRIVATE_IndexEntry(t.indexId, e.key, $31a25a81deadb29c$var$wt, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ zn(e, t, n, r, i) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$yt, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $31a25a81deadb29c$var$__PRIVATE_advanceIterator(s), a = $31a25a81deadb29c$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $31a25a81deadb29c$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $31a25a81deadb29c$var$__PRIVATE_advanceIterator(s)) : (_ = $31a25a81deadb29c$var$__PRIVATE_advanceIterator(s), a = $31a25a81deadb29c$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $31a25a81deadb29c$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.jn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Jn(e, t, n, r));
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(s);
    }
    Wn(e) {
        let t = 1;
        return $31a25a81deadb29c$var$__PRIVATE_indexStateStore(e).ee({
            index: $31a25a81deadb29c$var$ve,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$31a25a81deadb29c$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $31a25a81deadb29c$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $31a25a81deadb29c$var$__PRIVATE_indexEntryComparator(i, e), s = $31a25a81deadb29c$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.En();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.En());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Hn(r[e], r[e + 1])) return [];
            const t = r[e].An(this.uid, $31a25a81deadb29c$var$wt, $31a25a81deadb29c$export$90a7f3efeed30595.empty()), n = r[e + 1].An(this.uid, $31a25a81deadb29c$var$wt, $31a25a81deadb29c$export$90a7f3efeed30595.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Hn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $31a25a81deadb29c$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($31a25a81deadb29c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.mapArray(this.vn(t), (t)=>this.Fn(e, t).next((e)=>e || $31a25a81deadb29c$export$3a6d5c9ae78a2c08(44426))).next($31a25a81deadb29c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $31a25a81deadb29c$var$__PRIVATE_collectionParentsStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$Re);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_indexEntriesStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$Me);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_indexConfigurationStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$ye);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_indexStateStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$De);
}
function $31a25a81deadb29c$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $31a25a81deadb29c$export$7a0bdf7d4a91ea88(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $31a25a81deadb29c$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $31a25a81deadb29c$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$bt = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $31a25a81deadb29c$var$St = 41943040;
class $31a25a81deadb29c$var$LruParams {
    static withCacheSize(e) {
        return new $31a25a81deadb29c$var$LruParams(e, $31a25a81deadb29c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $31a25a81deadb29c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $31a25a81deadb29c$var$removeMutationBatch(e, t, n) {
    const r = e.store($31a25a81deadb29c$var$j), i = e.store($31a25a81deadb29c$var$Y), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.ee({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(1 === _, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $31a25a81deadb29c$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $31a25a81deadb29c$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $31a25a81deadb29c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $31a25a81deadb29c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $31a25a81deadb29c$var$LruParams.DEFAULT = new $31a25a81deadb29c$var$LruParams($31a25a81deadb29c$var$St, $31a25a81deadb29c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $31a25a81deadb29c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $31a25a81deadb29c$var$LruParams.DISABLED = new $31a25a81deadb29c$var$LruParams(-1, 0, 0);
class $31a25a81deadb29c$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Zn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static wt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $31a25a81deadb29c$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e).ee({
            index: $31a25a81deadb29c$var$J,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $31a25a81deadb29c$var$__PRIVATE_documentMutationsStore(e), s = $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $31a25a81deadb29c$export$7a0bdf7d4a91ea88("number" == typeof o, 49019);
            const _ = new $31a25a81deadb29c$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$31a25a81deadb29c$var$toMutation(e.yt, t)), i = n.mutations.map((t)=>$31a25a81deadb29c$var$toMutation(e.yt, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $31a25a81deadb29c$var$SortedSet((e, t)=>$31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $31a25a81deadb29c$var$X));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Zn[o] = _.keys();
            }), $31a25a81deadb29c$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Xn(e, t) {
        return this.Zn[t] ? $31a25a81deadb29c$var$PersistencePromise.resolve(this.Zn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Zn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e).ee({
            index: $31a25a81deadb29c$var$J,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(t.batchId >= n, 47524, {
                Yn: n
            }), i = $31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $31a25a81deadb29c$var$q;
        return $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e).ee({
            index: $31a25a81deadb29c$var$J,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $31a25a81deadb29c$var$q
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e).J($31a25a81deadb29c$var$J, t).next((e)=>e.map((e)=>$31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $31a25a81deadb29c$var$__PRIVATE_documentMutationsStore(e).ee({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(61480, {
                    er: n,
                    batchId: a
                });
                $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $31a25a81deadb29c$var$__PRIVATE_documentMutationsStore(e).ee({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(r).next(()=>this.tr(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_primitiveComparator);
        return $31a25a81deadb29c$var$__PRIVATE_documentMutationsStore(e).ee({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.tr(e, o));
    }
    tr(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($31a25a81deadb29c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(35274, {
                    batchId: t
                });
                $31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $31a25a81deadb29c$var$removeMutationBatch(e.le, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.nr(t.batchId);
            }), $31a25a81deadb29c$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    nr(e) {
        delete this.Zn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $31a25a81deadb29c$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $31a25a81deadb29c$var$__PRIVATE_documentMutationsStore(e).ee({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $31a25a81deadb29c$export$7a0bdf7d4a91ea88(0 === r.length, 56720, {
                    rr: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ ir(e) {
        return $31a25a81deadb29c$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $31a25a81deadb29c$var$q,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $31a25a81deadb29c$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $31a25a81deadb29c$var$__PRIVATE_documentMutationsStore(e).ee({
        range: s,
        Y: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_mutationsStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$j);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_documentMutationsStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$Y);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_mutationQueuesStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$G);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.sr = e;
    }
    next() {
        return this.sr += 2, this.sr;
    }
    static _r() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator(0);
    }
    static ar() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.ur(e).next((t)=>{
            const n = new $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.cr(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.ur(e).next((e)=>$31a25a81deadb29c$var$SnapshotVersion.fromTimestamp(new $31a25a81deadb29c$export$3d12bd131bb975d1(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.ur(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.ur(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.cr(e, r)));
    }
    addTargetData(e, t) {
        return this.lr(e, t).next(()=>this.ur(e).next((n)=>(n.targetCount += 1, this.hr(t, n), this.cr(e, n))));
    }
    updateTargetData(e, t) {
        return this.lr(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$31a25a81deadb29c$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.ur(e)).next((t)=>($31a25a81deadb29c$export$7a0bdf7d4a91ea88(t.targetCount > 0, 8065), t.targetCount -= 1, this.cr(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $31a25a81deadb29c$var$__PRIVATE_targetsStore(e).ee((s, o)=>{
            const _ = $31a25a81deadb29c$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$31a25a81deadb29c$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_targetsStore(e).ee((e, n)=>{
            const r = $31a25a81deadb29c$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    ur(e) {
        return $31a25a81deadb29c$var$__PRIVATE_globalTargetStore(e).get($31a25a81deadb29c$var$Ie).next((e)=>($31a25a81deadb29c$export$7a0bdf7d4a91ea88(null !== e, 2888), e));
    }
    cr(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_globalTargetStore(e).put($31a25a81deadb29c$var$Ie, t);
    }
    lr(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_targetsStore(e).put($31a25a81deadb29c$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ hr(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.ur(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $31a25a81deadb29c$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $31a25a81deadb29c$var$__PRIVATE_targetsStore(e).ee({
            range: r,
            index: $31a25a81deadb29c$var$ue
        }, (e, n, r)=>{
            const s = $31a25a81deadb29c$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $31a25a81deadb29c$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e);
        return $31a25a81deadb29c$var$PersistencePromise.forEach(t, (t)=>{
            const i = $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(t.path);
            return $31a25a81deadb29c$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e);
        let i = $31a25a81deadb29c$export$971d5caa766a69d7();
        return r.ee({
            range: n,
            Y: !0
        }, (e, t, n)=>{
            const r = $31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(e[1]), s = new $31a25a81deadb29c$export$90a7f3efeed30595(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $31a25a81deadb29c$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e).ee({
            index: $31a25a81deadb29c$var$Pe,
            Y: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    At(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $31a25a81deadb29c$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_targetsStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$ae);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_globalTargetStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$Ee);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$le);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$Dt = "LruGarbageCollector", $31a25a81deadb29c$var$Ct = 1048576;
function $31a25a81deadb29c$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $31a25a81deadb29c$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Pr = e, this.buffer = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_bufferEntryComparator), this.Tr = 0;
    }
    Ir() {
        return ++this.Tr;
    }
    Er(e) {
        const t = [
            e,
            this.Ir()
        ];
        if (this.buffer.size < this.Pr) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $31a25a81deadb29c$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $31a25a81deadb29c$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Rr = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Ar(6e4);
    }
    stop() {
        this.Rr && (this.Rr.cancel(), this.Rr = null);
    }
    get started() {
        return null !== this.Rr;
    }
    Ar(e) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Dt, `Garbage collection scheduled in ${e}ms`), this.Rr = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Rr = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Dt, "Ignoring IndexedDB error during garbage collection: ", e) : await $31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Ar(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $31a25a81deadb29c$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Vr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Vr.dr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $31a25a81deadb29c$var$PersistencePromise.resolve($31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce);
        const n = new $31a25a81deadb29c$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Vr.forEachTarget(e, (e)=>n.Er(e.sequenceNumber)).next(()=>this.Vr.mr(e, (e)=>n.Er(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Vr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Vr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($31a25a81deadb29c$export$21579262ef46735b("LruGarbageCollector", "Garbage collection skipped; disabled"), $31a25a81deadb29c$var$PersistencePromise.resolve($31a25a81deadb29c$var$bt)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($31a25a81deadb29c$export$21579262ef46735b("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $31a25a81deadb29c$var$bt) : this.gr(e, t));
    }
    getCacheSize(e) {
        return this.Vr.getCacheSize(e);
    }
    gr(e, t) {
        let n, r, i, s, o, _, a;
        const u = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($31a25a81deadb29c$export$21579262ef46735b("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, _ = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (a = Date.now(), $31a25a81deadb29c$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) $31a25a81deadb29c$export$21579262ef46735b("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - u}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (_ - o) + "ms\n" + `\tRemoved ${e} documents in ` + (a - _) + "ms\n" + `Total Duration: ${a - u}ms`);
            return $31a25a81deadb29c$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $31a25a81deadb29c$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $31a25a81deadb29c$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $31a25a81deadb29c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    dr(e) {
        const t = this.pr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    pr(e) {
        let t = 0;
        return this.mr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    mr(e, t) {
        return this.yr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $31a25a81deadb29c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $31a25a81deadb29c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ wr(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $31a25a81deadb29c$var$__PRIVATE_mutationQueuesStore(e).te((r)=>$31a25a81deadb29c$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $31a25a81deadb29c$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.yr(e, (s, o)=>{
            if (o <= t) {
                const t = this.wr(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $31a25a81deadb29c$var$SnapshotVersion.min()), $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$31a25a81deadb29c$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ yr(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e);
        let r, i = $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce;
        return n.ee({
            index: $31a25a81deadb29c$var$Pe
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce && t(new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce && t(new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_writeSentinelKey(e, t) {
    return $31a25a81deadb29c$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $31a25a81deadb29c$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $31a25a81deadb29c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $31a25a81deadb29c$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $31a25a81deadb29c$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $31a25a81deadb29c$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.Sr(e, n)));
    }
    getEntry(e, t) {
        let n = $31a25a81deadb29c$var$MutableDocument.newInvalidDocument(t);
        return $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $31a25a81deadb29c$var$ne,
            range: IDBKeyRange.only($31a25a81deadb29c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.br(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Dr(e, t) {
        let n = {
            size: 0,
            document: $31a25a81deadb29c$var$MutableDocument.newInvalidDocument(t)
        };
        return $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $31a25a81deadb29c$var$ne,
            range: IDBKeyRange.only($31a25a81deadb29c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.br(t, r),
                size: $31a25a81deadb29c$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
        return this.Cr(e, t, (e, t)=>{
            const r = this.br(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ vr(e, t) {
        let n = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap(), r = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
        return this.Cr(e, t, (e, t)=>{
            const i = this.br(e, t);
            n = n.insert(e, i), r = r.insert(e, $31a25a81deadb29c$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Fr: r
            }));
    }
    Cr(e, t, n) {
        if (t.isEmpty()) return $31a25a81deadb29c$var$PersistencePromise.resolve();
        let r = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($31a25a81deadb29c$var$__PRIVATE_dbKey(r.first()), $31a25a81deadb29c$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $31a25a81deadb29c$var$ne,
            range: i
        }, (e, t, r)=>{
            const i = $31a25a81deadb29c$export$90a7f3efeed30595.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $31a25a81deadb29c$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.j($31a25a81deadb29c$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $31a25a81deadb29c$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e).J(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            i?.incrementDocumentReadCount(e.length);
            let n = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.br($31a25a81deadb29c$export$90a7f3efeed30595.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($31a25a81deadb29c$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
        const s = $31a25a81deadb29c$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $31a25a81deadb29c$var$__PRIVATE_dbCollectionGroupKey(t, $31a25a81deadb29c$var$IndexOffset.max());
        return $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $31a25a81deadb29c$var$ie,
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.br($31a25a81deadb29c$export$90a7f3efeed30595.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $31a25a81deadb29c$var$__PRIVATE_documentGlobalStore(e).get($31a25a81deadb29c$var$_e).next((e)=>($31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!e, 20021), e));
    }
    Sr(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_documentGlobalStore(e).put($31a25a81deadb29c$var$_e, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ br(e, t) {
        if (t) {
            const e = $31a25a81deadb29c$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($31a25a81deadb29c$var$SnapshotVersion.min()))) return e;
        }
        return $31a25a81deadb29c$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $31a25a81deadb29c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $31a25a81deadb29c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $31a25a81deadb29c$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.Mr = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Or = new $31a25a81deadb29c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $31a25a81deadb29c$var$SortedSet((e, t)=>$31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Or.get(i);
            if (t.push(this.Mr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $31a25a81deadb29c$var$__PRIVATE_toDbRemoteDocument(this.Mr.serializer, s);
                r = r.add(i.path.popLast());
                const a = $31a25a81deadb29c$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.Mr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $31a25a81deadb29c$var$__PRIVATE_toDbRemoteDocument(this.Mr.serializer, s.convertToNoDocument($31a25a81deadb29c$var$SnapshotVersion.min()));
                t.push(this.Mr.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.Mr.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.Mr.updateMetadata(e, n)), $31a25a81deadb29c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Mr.Dr(e, t).next((e)=>(this.Or.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Mr.vr(e, t).next(({ documents: e, Fr: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Or.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $31a25a81deadb29c$var$__PRIVATE_documentGlobalStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$oe);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_remoteDocumentsStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$ee);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $31a25a81deadb29c$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $31a25a81deadb29c$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $31a25a81deadb29c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $31a25a81deadb29c$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $31a25a81deadb29c$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $31a25a81deadb29c$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $31a25a81deadb29c$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $31a25a81deadb29c$var$FieldMask.empty(), $31a25a81deadb29c$export$3d12bd131bb975d1.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $31a25a81deadb29c$export$971d5caa766a69d7()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $31a25a81deadb29c$export$971d5caa766a69d7()) {
        const r = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $31a25a81deadb29c$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $31a25a81deadb29c$export$971d5caa766a69d7()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @returns A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
        const s = $31a25a81deadb29c$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $31a25a81deadb29c$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $31a25a81deadb29c$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $31a25a81deadb29c$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $31a25a81deadb29c$export$3d12bd131bb975d1.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $31a25a81deadb29c$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>o.set(e, new $31a25a81deadb29c$var$OverlayedDocument(t, s.get(e) ?? null))), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $31a25a81deadb29c$var$SortedMap((e, t)=>e - t), i = $31a25a81deadb29c$export$971d5caa766a69d7();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $31a25a81deadb29c$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $31a25a81deadb29c$export$971d5caa766a69d7()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $31a25a81deadb29c$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $31a25a81deadb29c$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $31a25a81deadb29c$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        return $31a25a81deadb29c$export$51b138e5a065c2bb(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $31a25a81deadb29c$export$3b14a55fb2447963(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup - The collection group for the documents.
     * @param offset - The offset to index into.
     * @param count - The number of documents to return
     * @returns A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $31a25a81deadb29c$var$PersistencePromise.resolve($31a25a81deadb29c$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = $31a25a81deadb29c$var$N, _ = i;
            return s.next((t)=>$31a25a81deadb29c$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $31a25a81deadb29c$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $31a25a81deadb29c$export$971d5caa766a69d7())).next((e)=>({
                        batchId: o,
                        changes: $31a25a81deadb29c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $31a25a81deadb29c$export$90a7f3efeed30595(t)).next((e)=>{
            let t = $31a25a81deadb29c$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $31a25a81deadb29c$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$31a25a81deadb29c$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $31a25a81deadb29c$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $31a25a81deadb29c$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $31a25a81deadb29c$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $31a25a81deadb29c$var$FieldMask.empty(), $31a25a81deadb29c$export$3d12bd131bb975d1.now()), // Finally, insert the documents that still match the query
                $31a25a81deadb29c$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Nr = new Map, this.Br = new Map;
    }
    getBundleMetadata(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.Nr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Nr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $31a25a81deadb29c$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.Br.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Br.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $31a25a81deadb29c$export$56c0d5a1e737357d(e.bundledQuery),
                readTime: $31a25a81deadb29c$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator), this.Lr = new Map;
    }
    getOverlay(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap();
        return $31a25a81deadb29c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.St(e, t, r);
        }), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Lr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Lr.delete(n)), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $31a25a81deadb29c$export$90a7f3efeed30595(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $31a25a81deadb29c$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $31a25a81deadb29c$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $31a25a81deadb29c$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $31a25a81deadb29c$var$PersistencePromise.resolve(o);
    }
    St(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Lr.get(r.largestBatchId).delete(n.key);
            this.Lr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $31a25a81deadb29c$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Lr.get(t);
        void 0 === i && (i = $31a25a81deadb29c$export$971d5caa766a69d7(), this.Lr.set(t, i)), this.Lr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $31a25a81deadb29c$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.kr = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_DocReference.Kr), // A set of outstanding references to a document sorted by target id.
        this.qr = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_DocReference.Ur);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.kr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $31a25a81deadb29c$var$__PRIVATE_DocReference(e, t);
        this.kr = this.kr.add(n), this.qr = this.qr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ $r(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Wr(new $31a25a81deadb29c$var$__PRIVATE_DocReference(e, t));
    }
    Qr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Gr(e) {
        const t = new $31a25a81deadb29c$export$90a7f3efeed30595(new $31a25a81deadb29c$export$db202ddc8be9136([])), n = new $31a25a81deadb29c$var$__PRIVATE_DocReference(t, e), r = new $31a25a81deadb29c$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.qr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Wr(e), i.push(e.key);
        }), i;
    }
    zr() {
        this.kr.forEach((e)=>this.Wr(e));
    }
    Wr(e) {
        this.kr = this.kr.delete(e), this.qr = this.qr.delete(e);
    }
    jr(e) {
        const t = new $31a25a81deadb29c$export$90a7f3efeed30595(new $31a25a81deadb29c$export$db202ddc8be9136([])), n = new $31a25a81deadb29c$var$__PRIVATE_DocReference(t, e), r = new $31a25a81deadb29c$var$__PRIVATE_DocReference(t, e + 1);
        let i = $31a25a81deadb29c$export$971d5caa766a69d7();
        return this.qr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $31a25a81deadb29c$var$__PRIVATE_DocReference(e, 0), n = this.kr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $31a25a81deadb29c$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.Jr = t;
    }
    /** Compare by key then by ID */ static Kr(e, t) {
        return $31a25a81deadb29c$export$90a7f3efeed30595.comparator(e.key, t.key) || $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.Jr, t.Jr);
    }
    /** Compare by ID then by key */ static Ur(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(e.Jr, t.Jr) || $31a25a81deadb29c$export$90a7f3efeed30595.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Yn = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Hr = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_DocReference.Kr);
    }
    checkEmpty(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Yn;
        this.Yn++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $31a25a81deadb29c$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.Hr = this.Hr.add(new $31a25a81deadb29c$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $31a25a81deadb29c$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.Zr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Xr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $31a25a81deadb29c$var$q : this.Yn - 1);
    }
    getAllMutationBatches(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $31a25a81deadb29c$var$__PRIVATE_DocReference(t, 0), r = new $31a25a81deadb29c$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.Hr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Zr(e.Jr);
            i.push(t);
        }), $31a25a81deadb29c$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $31a25a81deadb29c$var$__PRIVATE_DocReference(e, 0), r = new $31a25a81deadb29c$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.Hr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.Jr);
            });
        }), $31a25a81deadb29c$var$PersistencePromise.resolve(this.Yr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $31a25a81deadb29c$export$90a7f3efeed30595.isDocumentKey(i) || (i = i.child(""));
        const s = new $31a25a81deadb29c$var$__PRIVATE_DocReference(new $31a25a81deadb29c$export$90a7f3efeed30595(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_primitiveComparator);
        return this.Hr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.Jr)), !0);
        }, s), $31a25a81deadb29c$var$PersistencePromise.resolve(this.Yr(o));
    }
    Yr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Zr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(0 === this.ei(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.Hr;
        return $31a25a81deadb29c$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $31a25a81deadb29c$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.Hr = n;
        });
    }
    nr(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $31a25a81deadb29c$var$__PRIVATE_DocReference(t, 0), r = this.Hr.firstAfterOrEqual(n);
        return $31a25a81deadb29c$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ei(e, t) {
        return this.Xr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ Xr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Zr(e) {
        const t = this.Xr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.ti = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.ti(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $31a25a81deadb29c$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $31a25a81deadb29c$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $31a25a81deadb29c$var$MutableDocument.newInvalidDocument(e));
        }), $31a25a81deadb29c$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $31a25a81deadb29c$export$90a7f3efeed30595(s.child("__id-9223372036854775808__")), _ = this.docs.getIteratorFrom(o);
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $31a25a81deadb29c$var$__PRIVATE_indexOffsetComparator($31a25a81deadb29c$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $31a25a81deadb29c$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $31a25a81deadb29c$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $31a25a81deadb29c$export$3a6d5c9ae78a2c08(9500);
    }
    ni(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $31a25a81deadb29c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $31a25a81deadb29c$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.Mr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.Mr.addEntry(e, r)) : this.Mr.removeEntry(n);
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.Mr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.Mr.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.ri = new $31a25a81deadb29c$var$ObjectMap((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyTarget(e), $31a25a81deadb29c$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $31a25a81deadb29c$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.ii = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.si = new $31a25a81deadb29c$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.oi = $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator._r();
    }
    forEachTarget(e, t) {
        return this.ri.forEach((e, n)=>t(n)), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.ii);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.oi.next(), $31a25a81deadb29c$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.ii && (this.ii = t), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    lr(e) {
        this.ri.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.oi = new $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.ii && (this.ii = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.lr(t), this.targetCount += 1, $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.lr(t), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.ri.delete(t.target), this.si.Gr(t.targetId), this.targetCount -= 1, $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.ri.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.ri.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.ri.get(t) || null;
        return $31a25a81deadb29c$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.si.$r(t, n), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.si.Qr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $31a25a81deadb29c$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.si.Gr(t), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.si.jr(t);
        return $31a25a81deadb29c$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve(this.si.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this._i = {}, this.overlays = {}, this.ai = new $31a25a81deadb29c$var$__PRIVATE_ListenSequence(0), this.ui = !1, this.ui = !0, this.ci = new $31a25a81deadb29c$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.li = new $31a25a81deadb29c$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $31a25a81deadb29c$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $31a25a81deadb29c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.hi(e)), this.serializer = new $31a25a81deadb29c$var$__PRIVATE_LocalSerializer(t), this.Pi = new $31a25a81deadb29c$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.ui = !1, Promise.resolve();
    }
    get started() {
        return this.ui;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $31a25a81deadb29c$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this._i[e.toKey()];
        return n || (n = new $31a25a81deadb29c$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this._i[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.ci;
    }
    getTargetCache() {
        return this.li;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Pi;
    }
    runTransaction(e, t, n) {
        $31a25a81deadb29c$export$21579262ef46735b("MemoryPersistence", "Starting transaction:", e);
        const r = new $31a25a81deadb29c$var$__PRIVATE_MemoryTransaction(this.ai.next());
        return this.referenceDelegate.Ti(), n(r).next((e)=>this.referenceDelegate.Ii(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Ei(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.or(Object.values(this._i).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $31a25a81deadb29c$var$__PRIVATE_MemoryTransaction extends $31a25a81deadb29c$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Ri = new $31a25a81deadb29c$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Ai = null;
    }
    static Vi(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get di() {
        if (this.Ai) return this.Ai;
        throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(60996);
    }
    addReference(e, t, n) {
        return this.Ri.addReference(n, t), this.di.delete(n.toString()), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Ri.removeReference(n, t), this.di.add(n.toString()), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.di.add(t.toString()), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Ri.Gr(t.targetId).forEach((e)=>this.di.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.di.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Ti() {
        this.Ai = new Set;
    }
    Ii(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $31a25a81deadb29c$var$PersistencePromise.forEach(this.di, (n)=>{
            const r = $31a25a81deadb29c$export$90a7f3efeed30595.fromPath(n);
            return this.mi(e, r).next((e)=>{
                e || t.removeEntry(r, $31a25a81deadb29c$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Ai = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.mi(e, t).next((e)=>{
            e ? this.di.delete(t.toString()) : this.di.add(t.toString());
        });
    }
    hi(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    mi(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.or([
            ()=>$31a25a81deadb29c$var$PersistencePromise.resolve(this.Ri.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Ei(e, t)
        ]);
    }
}
class $31a25a81deadb29c$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.fi = new $31a25a81deadb29c$var$ObjectMap((e)=>$31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $31a25a81deadb29c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static Vi(e, t) {
        return new $31a25a81deadb29c$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Ti() {}
    Ii(e) {
        return $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    dr(e) {
        const t = this.pr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    pr(e) {
        let t = 0;
        return this.mr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    mr(e, t) {
        return $31a25a81deadb29c$var$PersistencePromise.forEach(this.fi, (n, r)=>this.wr(e, n, r).next((e)=>e ? $31a25a81deadb29c$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.ni(e, (r)=>this.wr(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $31a25a81deadb29c$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.fi.set(t, e.currentSequenceNumber), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.fi.set(n, e.currentSequenceNumber), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.fi.set(n, e.currentSequenceNumber), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.fi.set(t, e.currentSequenceNumber), $31a25a81deadb29c$var$PersistencePromise.resolve();
    }
    hi(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $31a25a81deadb29c$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    wr(e, t, n) {
        return $31a25a81deadb29c$var$PersistencePromise.or([
            ()=>this.persistence.Ei(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.fi.get(t);
                return $31a25a81deadb29c$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $31a25a81deadb29c$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ k(e, t, n, r) {
        const i = new $31a25a81deadb29c$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($31a25a81deadb29c$var$W);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($31a25a81deadb29c$var$G, {
                keyPath: $31a25a81deadb29c$var$z
            });
            const t = e.createObjectStore($31a25a81deadb29c$var$j, {
                keyPath: $31a25a81deadb29c$var$H,
                autoIncrement: !0
            });
            t.createIndex($31a25a81deadb29c$var$J, $31a25a81deadb29c$var$Z, {
                unique: !0
            }), e.createObjectStore($31a25a81deadb29c$var$Y);
        }(e), $31a25a81deadb29c$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($31a25a81deadb29c$var$$);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $31a25a81deadb29c$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($31a25a81deadb29c$var$le), e.deleteObjectStore($31a25a81deadb29c$var$ae), e.deleteObjectStore($31a25a81deadb29c$var$Ee);
        }(e), $31a25a81deadb29c$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($31a25a81deadb29c$var$Ee), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $31a25a81deadb29c$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($31a25a81deadb29c$var$Ie, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($31a25a81deadb29c$var$j);
                return n.J().next((n)=>{
                    e.deleteObjectStore($31a25a81deadb29c$var$j);
                    e.createObjectStore($31a25a81deadb29c$var$j, {
                        keyPath: $31a25a81deadb29c$var$H,
                        autoIncrement: !0
                    }).createIndex($31a25a81deadb29c$var$J, $31a25a81deadb29c$var$Z, {
                        unique: !0
                    });
                    const r = t.store($31a25a81deadb29c$var$j), i = n.map((e)=>r.put(e));
                    return $31a25a81deadb29c$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($31a25a81deadb29c$var$Ve, {
                    keyPath: $31a25a81deadb29c$var$de
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.gi(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($31a25a81deadb29c$var$oe);
            })(e), this.pi(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.yi(i))), n < 8 && r >= 8 && (s = s.next(()=>this.wi(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.Si(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($31a25a81deadb29c$var$me, {
                    keyPath: $31a25a81deadb29c$var$fe
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($31a25a81deadb29c$var$ge, {
                    keyPath: $31a25a81deadb29c$var$pe
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($31a25a81deadb29c$var$Be, {
                    keyPath: $31a25a81deadb29c$var$Le
                });
                t.createIndex($31a25a81deadb29c$var$ke, $31a25a81deadb29c$var$Ke, {
                    unique: !1
                }), t.createIndex($31a25a81deadb29c$var$qe, $31a25a81deadb29c$var$Ue, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($31a25a81deadb29c$var$ee, {
                    keyPath: $31a25a81deadb29c$var$te
                });
                t.createIndex($31a25a81deadb29c$var$ne, $31a25a81deadb29c$var$re), t.createIndex($31a25a81deadb29c$var$ie, $31a25a81deadb29c$var$se);
            })(e)).next(()=>this.bi(e, i)).next(()=>e.deleteObjectStore($31a25a81deadb29c$var$$))), n < 14 && r >= 14 && (s = s.next(()=>this.Di(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($31a25a81deadb29c$var$ye, {
                    keyPath: $31a25a81deadb29c$var$we,
                    autoIncrement: !0
                });
                t.createIndex($31a25a81deadb29c$var$be, $31a25a81deadb29c$var$Se, {
                    unique: !1
                });
                const n = e.createObjectStore($31a25a81deadb29c$var$De, {
                    keyPath: $31a25a81deadb29c$var$Ce
                });
                n.createIndex($31a25a81deadb29c$var$ve, $31a25a81deadb29c$var$Fe, {
                    unique: !1
                });
                const r = e.createObjectStore($31a25a81deadb29c$var$Me, {
                    keyPath: $31a25a81deadb29c$var$xe
                });
                r.createIndex($31a25a81deadb29c$var$Oe, $31a25a81deadb29c$var$Ne, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($31a25a81deadb29c$var$De).clear();
        }).next(()=>{
            t.objectStore($31a25a81deadb29c$var$Me).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($31a25a81deadb29c$var$$e, {
                    keyPath: $31a25a81deadb29c$var$We
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $029952e65115eee5$export$ef10bcfb06572016)() && (s = s.next(()=>{
            t.objectStore($31a25a81deadb29c$var$De).clear();
        }).next(()=>{
            t.objectStore($31a25a81deadb29c$var$Me).clear();
        })), s;
    }
    pi(e) {
        let t = 0;
        return e.store($31a25a81deadb29c$var$$).ee((e, n)=>{
            t += $31a25a81deadb29c$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($31a25a81deadb29c$var$oe).put($31a25a81deadb29c$var$_e, n);
        });
    }
    gi(e) {
        const t = e.store($31a25a81deadb29c$var$G), n = e.store($31a25a81deadb29c$var$j);
        return t.J().next((t)=>$31a25a81deadb29c$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $31a25a81deadb29c$var$q
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.J($31a25a81deadb29c$var$J, r).next((n)=>$31a25a81deadb29c$var$PersistencePromise.forEach(n, (n)=>{
                        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $31a25a81deadb29c$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ yi(e) {
        const t = e.store($31a25a81deadb29c$var$le), n = e.store($31a25a81deadb29c$var$$);
        return e.store($31a25a81deadb29c$var$Ee).get($31a25a81deadb29c$var$Ie).next((e)=>{
            const r = [];
            return n.ee((n, i)=>{
                const s = new $31a25a81deadb29c$export$db202ddc8be9136(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $31a25a81deadb29c$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$31a25a81deadb29c$var$PersistencePromise.waitFor(r));
        });
    }
    wi(e, t) {
        // Create the index.
        e.createObjectStore($31a25a81deadb29c$var$Re, {
            keyPath: $31a25a81deadb29c$var$Ae
        });
        const n = t.store($31a25a81deadb29c$var$Re), r = new $31a25a81deadb29c$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $31a25a81deadb29c$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($31a25a81deadb29c$var$$).ee({
            Y: !0
        }, (e, t)=>{
            const n = new $31a25a81deadb29c$export$db202ddc8be9136(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($31a25a81deadb29c$var$Y).ee({
                Y: !0
            }, ([e, t, n], r)=>{
                const i = $31a25a81deadb29c$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    Si(e) {
        const t = e.store($31a25a81deadb29c$var$ae);
        return t.ee((e, n)=>{
            const r = $31a25a81deadb29c$var$__PRIVATE_fromDbTarget(n), i = $31a25a81deadb29c$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    bi(e, t) {
        const n = t.store($31a25a81deadb29c$var$$), r = [];
        return n.ee((e, n)=>{
            const i = t.store($31a25a81deadb29c$var$ee), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$export$db202ddc8be9136.fromString(e.document.name).popFirst(5)) : e.noDocument ? $31a25a81deadb29c$export$90a7f3efeed30595.fromSegments(e.noDocument.path) : e.unknownDocument ? $31a25a81deadb29c$export$90a7f3efeed30595.fromSegments(e.unknownDocument.path) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(36783);
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$31a25a81deadb29c$var$PersistencePromise.waitFor(r));
    }
    Di(e, t) {
        const n = t.store($31a25a81deadb29c$var$j), r = $31a25a81deadb29c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $31a25a81deadb29c$var$__PRIVATE_MemoryPersistence($31a25a81deadb29c$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer.yt);
        return n.J().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                let t = n.get(e.userId) ?? $31a25a81deadb29c$export$971d5caa766a69d7();
                $31a25a81deadb29c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>t = t.add(e)), n.set(e.userId, t);
            }), $31a25a81deadb29c$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $31a25a81deadb29c$var$User(n), o = $31a25a81deadb29c$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, s), _ = i.getIndexManager(s), a = $31a25a81deadb29c$var$__PRIVATE_IndexedDbMutationQueue.wt(s, this.serializer, _, i.referenceDelegate);
                return new $31a25a81deadb29c$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransaction(t, $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce), e).next();
            });
        });
    }
}
function $31a25a81deadb29c$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($31a25a81deadb29c$var$le, {
        keyPath: $31a25a81deadb29c$var$he
    }).createIndex($31a25a81deadb29c$var$Pe, $31a25a81deadb29c$var$Te, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($31a25a81deadb29c$var$ae, {
        keyPath: "targetId"
    }).createIndex($31a25a81deadb29c$var$ue, $31a25a81deadb29c$var$ce, {
        unique: !0
    }), e.createObjectStore($31a25a81deadb29c$var$Ee);
}
const $31a25a81deadb29c$var$vt = "IndexedDbPersistence", $31a25a81deadb29c$var$Ft = 18e5, $31a25a81deadb29c$var$Mt = 5e3, $31a25a81deadb29c$var$xt = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $31a25a81deadb29c$var$Ot = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $31a25a81deadb29c$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Ci = i, this.window = s, this.document = o, this.Fi = a, this.Mi = u, this.xi = c, this.ai = null, this.ui = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Oi = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ni = null, /** The client metadata refresh task. */ this.Bi = null, /** The last time we garbage collected the client metadata object store. */ this.Li = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.ki = (e)=>Promise.resolve(), !$31a25a81deadb29c$var$__PRIVATE_IndexedDbPersistence.v()) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $31a25a81deadb29c$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Ki = t + $31a25a81deadb29c$var$Ot, this.serializer = new $31a25a81deadb29c$var$__PRIVATE_LocalSerializer(_), this.qi = new $31a25a81deadb29c$var$__PRIVATE_SimpleDb(this.Ki, this.xi, new $31a25a81deadb29c$var$__PRIVATE_SchemaConverter(this.serializer)), this.ci = new $31a25a81deadb29c$var$__PRIVATE_IndexedDbGlobalsCache, this.li = new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $31a25a81deadb29c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Pi = new $31a25a81deadb29c$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ui = this.window.localStorage : (this.Ui = null, !1 === u && $31a25a81deadb29c$var$__PRIVATE_logError($31a25a81deadb29c$var$vt, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.$i().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, $31a25a81deadb29c$var$xt);
            return this.Wi(), this.Qi(), this.Gi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.li.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.ai = new $31a25a81deadb29c$var$__PRIVATE_ListenSequence(e, this.Fi);
        }).then(()=>{
            this.ui = !0;
        }).catch((e)=>(this.qi && this.qi.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ zi(e) {
        return this.ki = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.qi.q(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Ci.enqueueAndForget(async ()=>{
            this.started && await this.$i();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ $i() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$31a25a81deadb29c$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.ji(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Ci.enqueueRetryable(()=>this.ki(!1)));
                });
            }).next(()=>this.Ji(e)).next((t)=>this.isPrimary && !t ? this.Hi(e).next(()=>!1) : !!t && this.Zi(e).next(()=>!0))).catch((e)=>{
            if ($31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$vt, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$vt, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Ci.enqueueRetryable(()=>this.ki(e)), this.isPrimary = e;
        });
    }
    ji(e) {
        return $31a25a81deadb29c$var$__PRIVATE_primaryClientStore(e).get($31a25a81deadb29c$var$Q).next((e)=>$31a25a81deadb29c$var$PersistencePromise.resolve(this.Xi(e)));
    }
    Yi(e) {
        return $31a25a81deadb29c$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async es() {
        if (this.isPrimary && !this.ts(this.Li, $31a25a81deadb29c$var$Ft)) {
            this.Li = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$Ve);
                return t.J().next((e)=>{
                    const n = this.ns(e, $31a25a81deadb29c$var$Ft), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $31a25a81deadb29c$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Ui) for (const t of e)this.Ui.removeItem(this.rs(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ Gi() {
        this.Bi = this.Ci.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.$i().then(()=>this.es()).then(()=>this.Gi()));
    }
    /** Checks whether `client` is the local client. */ Xi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Ji(e) {
        if (this.Mi) return $31a25a81deadb29c$var$PersistencePromise.resolve(!0);
        return $31a25a81deadb29c$var$__PRIVATE_primaryClientStore(e).get($31a25a81deadb29c$var$Q).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.ts(t.leaseTimestampMs, $31a25a81deadb29c$var$Mt) && !this.ss(t.ownerId)) {
                if (this.Xi(t) && this.networkEnabled) return !0;
                if (!this.Xi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, $31a25a81deadb29c$var$xt);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $31a25a81deadb29c$var$__PRIVATE_clientMetadataStore(e).J().next((e)=>void 0 === this.ns(e, $31a25a81deadb29c$var$Mt).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$vt, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.ui = !1, this._s(), this.Bi && (this.Bi.cancel(), this.Bi = null), this.us(), this.cs(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.qi.runTransaction("shutdown", "readwrite", [
            $31a25a81deadb29c$var$W,
            $31a25a81deadb29c$var$Ve
        ], (e)=>{
            const t = new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransaction(e, $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce);
            return this.Hi(t).next(()=>this.Yi(t));
        }), this.qi.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.ls();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ ns(e, t) {
        return e.filter((e)=>this.ts(e.updateTimeMs, t) && !this.ss(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ hs() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$31a25a81deadb29c$var$__PRIVATE_clientMetadataStore(e).J().next((e)=>this.ns(e, $31a25a81deadb29c$var$Ft).map((e)=>e.clientId)));
    }
    get started() {
        return this.ui;
    }
    getGlobalsCache() {
        return this.ci;
    }
    getMutationQueue(e, t) {
        return $31a25a81deadb29c$var$__PRIVATE_IndexedDbMutationQueue.wt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.li;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.yt.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $31a25a81deadb29c$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, e);
    }
    getBundleCache() {
        return this.Pi;
    }
    runTransaction(e, t, n) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$vt, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $31a25a81deadb29c$var$Xe : 17 === e ? $31a25a81deadb29c$var$Ze : 16 === e ? $31a25a81deadb29c$var$Je : 15 === e ? $31a25a81deadb29c$var$He : 14 === e ? $31a25a81deadb29c$var$je : 13 === e ? $31a25a81deadb29c$var$ze : 12 === e ? $31a25a81deadb29c$var$Ge : 11 === e ? $31a25a81deadb29c$var$Qe : void $31a25a81deadb29c$export$3a6d5c9ae78a2c08(60245);
        }(this.xi);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.qi.runTransaction(e, r, i, (r)=>(s = new $31a25a81deadb29c$var$__PRIVATE_IndexedDbTransaction(r, this.ai ? this.ai.next() : $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce), "readwrite-primary" === t ? this.ji(s).next((e)=>!!e || this.Ji(s)).next((t)=>{
                if (!t) throw $31a25a81deadb29c$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Ci.enqueueRetryable(()=>this.ki(!1)), new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, $31a25a81deadb29c$var$B);
                return n(s);
            }).next((e)=>this.Zi(s).next(()=>e)) : this.Ps(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ps(e) {
        return $31a25a81deadb29c$var$__PRIVATE_primaryClientStore(e).get($31a25a81deadb29c$var$Q).next((e)=>{
            if (null !== e && this.ts(e.leaseTimestampMs, $31a25a81deadb29c$var$Mt) && !this.ss(e.ownerId) && !this.Xi(e) && !(this.Mi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, $31a25a81deadb29c$var$xt);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Zi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $31a25a81deadb29c$var$__PRIVATE_primaryClientStore(e).put($31a25a81deadb29c$var$Q, t);
    }
    static v() {
        return $31a25a81deadb29c$var$__PRIVATE_SimpleDb.v();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Hi(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_primaryClientStore(e);
        return t.get($31a25a81deadb29c$var$Q).next((e)=>this.Xi(e) ? ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$vt, "Releasing primary lease."), t.delete($31a25a81deadb29c$var$Q)) : $31a25a81deadb29c$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ ts(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($31a25a81deadb29c$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Wi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ni = ()=>{
            this.Ci.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.$i()));
        }, this.document.addEventListener("visibilitychange", this.Ni), this.inForeground = "visible" === this.document.visibilityState);
    }
    us() {
        this.Ni && (this.document.removeEventListener("visibilitychange", this.Ni), this.Ni = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Qi() {
        "function" == typeof this.window?.addEventListener && (this.Oi = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this._s();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $029952e65115eee5$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Ci.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Ci.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Oi));
    }
    cs() {
        this.Oi && (this.window.removeEventListener("pagehide", this.Oi), this.Oi = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ ss(e) {
        try {
            const t = null !== this.Ui?.getItem(this.rs(e));
            return $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$vt, `Client '${e}' ${t ? "is" : "is not"} zombied in LocalStorage`), t;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $31a25a81deadb29c$var$__PRIVATE_logError($31a25a81deadb29c$var$vt, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ _s() {
        if (this.Ui) try {
            this.Ui.setItem(this.rs(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $31a25a81deadb29c$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ ls() {
        if (this.Ui) try {
            this.Ui.removeItem(this.rs(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    rs(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_primaryClientStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$W);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $31a25a81deadb29c$var$__PRIVATE_clientMetadataStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_getStore(e, $31a25a81deadb29c$var$Ve);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $31a25a81deadb29c$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $31a25a81deadb29c$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Ts = n, this.Is = r;
    }
    static Es(e, t) {
        let n = $31a25a81deadb29c$export$971d5caa766a69d7(), r = $31a25a81deadb29c$export$971d5caa766a69d7();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $31a25a81deadb29c$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $31a25a81deadb29c$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $31a25a81deadb29c$var$__PRIVATE_QueryEngine {
    constructor(){
        this.Rs = !1, this.As = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Vs = 100, this.ds = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $029952e65115eee5$export$95df08bae54cb4df)() ? 8 : $31a25a81deadb29c$var$__PRIVATE_getAndroidVersion((0, $029952e65115eee5$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.fs = e, this.indexManager = t, this.Rs = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.gs(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.ps(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $31a25a81deadb29c$var$QueryContext;
            return this.ys(e, t, n).next((r)=>{
                if (i.result = r, this.As) return this.ws(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    ws(e, t, n, r) {
        return n.documentReadCount < this.Vs ? ($31a25a81deadb29c$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $31a25a81deadb29c$export$21579262ef46735b("QueryEngine", "SDK will not create cache indexes for query:", $31a25a81deadb29c$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Vs, "documents"), $31a25a81deadb29c$var$PersistencePromise.resolve()) : ($31a25a81deadb29c$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $31a25a81deadb29c$export$21579262ef46735b("QueryEngine", "Query:", $31a25a81deadb29c$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.ds * r ? ($31a25a81deadb29c$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $31a25a81deadb29c$export$21579262ef46735b("QueryEngine", "The SDK decides to create cache indexes for query:", $31a25a81deadb29c$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $31a25a81deadb29c$var$__PRIVATE_queryToTarget(t))) : $31a25a81deadb29c$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ gs(e, t) {
        if ($31a25a81deadb29c$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $31a25a81deadb29c$var$PersistencePromise.resolve(null);
        let n = $31a25a81deadb29c$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $31a25a81deadb29c$export$882b5998b3b9117c(t, null, "F" /* LimitType.First */ ), n = $31a25a81deadb29c$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $31a25a81deadb29c$export$971d5caa766a69d7(...r);
                return this.fs.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.Ss(t, r);
                        return this.bs(t, s, i, n.readTime) ? this.gs(e, $31a25a81deadb29c$export$882b5998b3b9117c(t, null, "F" /* LimitType.First */ )) : this.Ds(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ ps(e, t, n, r) {
        return $31a25a81deadb29c$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($31a25a81deadb29c$var$SnapshotVersion.min()) ? $31a25a81deadb29c$var$PersistencePromise.resolve(null) : this.fs.getDocuments(e, n).next((i)=>{
            const s = this.Ss(t, i);
            return this.bs(t, s, n, r) ? $31a25a81deadb29c$var$PersistencePromise.resolve(null) : ($31a25a81deadb29c$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $31a25a81deadb29c$export$21579262ef46735b("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $31a25a81deadb29c$var$__PRIVATE_stringifyQuery(t)), this.Ds(e, s, t, $31a25a81deadb29c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $31a25a81deadb29c$var$N)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ Ss(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $31a25a81deadb29c$var$SortedSet($31a25a81deadb29c$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $31a25a81deadb29c$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ bs(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    ys(e, t, n) {
        return $31a25a81deadb29c$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $31a25a81deadb29c$export$21579262ef46735b("QueryEngine", "Using full collection scan to execute query:", $31a25a81deadb29c$var$__PRIVATE_stringifyQuery(t)), this.fs.getDocumentsMatchingQuery(e, t, $31a25a81deadb29c$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Ds(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.fs.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$Nt = "LocalStore", $31a25a81deadb29c$var$Bt = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $31a25a81deadb29c$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Cs = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.vs = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Fs = new $31a25a81deadb29c$var$ObjectMap((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyTarget(e), $31a25a81deadb29c$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Ms = new Map, this.xs = e.getRemoteDocumentCache(), this.li = e.getTargetCache(), this.Pi = e.getBundleCache(), this.Os(n);
    }
    Os(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $31a25a81deadb29c$var$LocalDocumentsView(this.xs, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.xs.setIndexManager(this.indexManager), this.Cs.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.vs));
    }
}
function $31a25a81deadb29c$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $31a25a81deadb29c$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $31a25a81deadb29c$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Os(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $31a25a81deadb29c$export$971d5caa766a69d7();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Ns: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $31a25a81deadb29c$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.xs.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $31a25a81deadb29c$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $31a25a81deadb29c$export$7a0bdf7d4a91ea88(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $31a25a81deadb29c$export$971d5caa766a69d7();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $31a25a81deadb29c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.li.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $31a25a81deadb29c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.vs;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.xs.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.vs;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.li.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.li.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING, $31a25a81deadb29c$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($31a25a81deadb29c$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $31a25a81deadb29c$var$Bt) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && o.push(n.li.updateTargetData(e, u));
        });
        let _ = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap(), a = $31a25a81deadb29c$export$971d5caa766a69d7();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($31a25a81deadb29c$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Bs, a = e.Ls;
        })), !r.isEqual($31a25a81deadb29c$var$SnapshotVersion.min())) {
            const t = n.li.getLastRemoteSnapshotVersion(e).next((t)=>n.li.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $31a25a81deadb29c$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.vs = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $31a25a81deadb29c$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $31a25a81deadb29c$export$971d5caa766a69d7(), i = $31a25a81deadb29c$export$971d5caa766a69d7();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($31a25a81deadb29c$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Nt, "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Bs: r,
            Ls: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $31a25a81deadb29c$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $31a25a81deadb29c$var$q), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $31a25a81deadb29c$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.li.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $31a25a81deadb29c$var$PersistencePromise.resolve(r)) : n.li.allocateTargetId(e).next((i)=>(r = new $31a25a81deadb29c$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.li.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.vs.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.vs = n.vs.insert(e.targetId, e), n.Fs.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $31a25a81deadb29c$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), i = r.vs.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Nt, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.vs = r.vs.remove(t), r.Fs.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $31a25a81deadb29c$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    let i = $31a25a81deadb29c$var$SnapshotVersion.min(), s = $31a25a81deadb29c$export$971d5caa766a69d7();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), i = r.Fs.get(n);
            return void 0 !== i ? $31a25a81deadb29c$var$PersistencePromise.resolve(r.vs.get(i)) : r.li.getTargetData(t, n);
        })(r, e, $31a25a81deadb29c$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.li.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Cs.getDocumentsMatchingQuery(e, t, n ? i : $31a25a81deadb29c$var$SnapshotVersion.min(), n ? s : $31a25a81deadb29c$export$971d5caa766a69d7())).next((e)=>($31a25a81deadb29c$var$__PRIVATE_setMaxReadTime(r, $31a25a81deadb29c$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                ks: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $31a25a81deadb29c$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = $31a25a81deadb29c$var$__PRIVATE_debugCast(n.li), i = n.vs.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.At(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $31a25a81deadb29c$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = n.Ms.get(t) || $31a25a81deadb29c$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.xs.getAllFromCollectionGroup(e, t, $31a25a81deadb29c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $31a25a81deadb29c$var$N), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($31a25a81deadb29c$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $31a25a81deadb29c$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.Ms.get(t) || $31a25a81deadb29c$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.Ms.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $31a25a81deadb29c$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    let s = $31a25a81deadb29c$export$971d5caa766a69d7(), o = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Ks(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.qs(e);
        r.setReadTime(t.Us(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.xs.newChangeBuffer({
        trackRemovals: !0
    }), a = await $31a25a81deadb29c$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $31a25a81deadb29c$var$__PRIVATE_queryToTarget($31a25a81deadb29c$export$a93c5207d687da10($31a25a81deadb29c$export$db202ddc8be9136.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$31a25a81deadb29c$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.li.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.li.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Bs, t.Ls)).next(()=>t.Bs)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $31a25a81deadb29c$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $31a25a81deadb29c$export$971d5caa766a69d7()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $31a25a81deadb29c$var$__PRIVATE_localStoreAllocateTarget(e, $31a25a81deadb29c$var$__PRIVATE_queryToTarget($31a25a81deadb29c$export$56c0d5a1e737357d(t.bundledQuery))), i = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Pi.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING, s);
        return i.vs = i.vs.insert(o.targetId, o), i.li.updateTargetData(e, o).next(()=>i.li.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.li.addMatchingKeys(e, n, r.targetId)).next(()=>i.Pi.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $31a25a81deadb29c$var$Lt = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $31a25a81deadb29c$var$createWebStorageClientStateKey(e, t) {
    return `${$31a25a81deadb29c$var$Lt}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $31a25a81deadb29c$var$kt = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $31a25a81deadb29c$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$31a25a81deadb29c$var$kt}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $31a25a81deadb29c$var$Kt = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $31a25a81deadb29c$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$31a25a81deadb29c$var$Kt}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$qt = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $31a25a81deadb29c$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $31a25a81deadb29c$export$4368d992c4eafac0(r.error.code, r.error.message))), s ? new $31a25a81deadb29c$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($31a25a81deadb29c$var$__PRIVATE_logError($31a25a81deadb29c$var$qt, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $31a25a81deadb29c$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $31a25a81deadb29c$export$4368d992c4eafac0(n.error.code, n.error.message))), i ? new $31a25a81deadb29c$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($31a25a81deadb29c$var$__PRIVATE_logError($31a25a81deadb29c$var$qt, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $31a25a81deadb29c$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $31a25a81deadb29c$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $31a25a81deadb29c$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $31a25a81deadb29c$var$__PRIVATE_RemoteClientState(e, i) : ($31a25a81deadb29c$var$__PRIVATE_logError($31a25a81deadb29c$var$qt, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $31a25a81deadb29c$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $31a25a81deadb29c$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($31a25a81deadb29c$var$__PRIVATE_logError($31a25a81deadb29c$var$qt, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $31a25a81deadb29c$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $31a25a81deadb29c$var$__PRIVATE_targetIdSet();
    }
    Qs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    Gs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Ws() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $31a25a81deadb29c$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Ci = t, this.persistenceKey = n, this.zs = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.js = this.Js.bind(this), this.Hs = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Zs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Xs = $31a25a81deadb29c$var$createWebStorageClientStateKey(this.persistenceKey, this.zs), this.Ys = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Hs = this.Hs.insert(this.zs, new $31a25a81deadb29c$var$__PRIVATE_LocalClientState), this.eo = new RegExp(`^${$31a25a81deadb29c$var$Lt}_${s}_([^_]*)$`), this.no = new RegExp(`^${$31a25a81deadb29c$var$kt}_${s}_(\\d+)(?:_(.*))?$`), this.ro = new RegExp(`^${$31a25a81deadb29c$var$Kt}_${s}_(\\d+)$`), this.io = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.so = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.js);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static v(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.hs();
        for (const t of e){
            if (t === this.zs) continue;
            const e = this.getItem($31a25a81deadb29c$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $31a25a81deadb29c$var$__PRIVATE_RemoteClientState.$s(t, e);
                n && (this.Hs = this.Hs.insert(n.clientId, n));
            }
        }
        this.oo();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.io);
        if (t) {
            const e = this._o(t);
            e && this.ao(e);
        }
        for (const e of this.Zs)this.Js(e);
        this.Zs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Ys, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.uo(this.Hs);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Hs.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.co(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.co(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.lo(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($31a25a81deadb29c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $31a25a81deadb29c$var$__PRIVATE_QueryTargetMetadata.$s(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.ho.Qs(e), this.oo(), n;
    }
    removeLocalQueryTarget(e) {
        this.ho.Gs(e), this.oo();
    }
    isLocalQueryTarget(e) {
        return this.ho.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($31a25a81deadb29c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.Po(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.lo(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.To(e);
    }
    notifyBundleLoaded(e) {
        this.Io(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.js), this.removeItem(this.Xs), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$qt, "READ", e, t), t;
    }
    setItem(e, t) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$qt, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$qt, "REMOVE", e), this.storage.removeItem(e);
    }
    Js(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$qt, "EVENT", t.key, t.newValue), t.key === this.Xs) return void $31a25a81deadb29c$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Ci.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.eo.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Eo(t.key);
                                return this.Ro(e, null);
                            }
                            {
                                const e = this.Ao(t.key, t.newValue);
                                if (e) return this.Ro(e.clientId, e);
                            }
                        } else if (this.no.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Vo(t.key, t.newValue);
                                if (e) return this.mo(e);
                            }
                        } else if (this.ro.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.fo(t.key, t.newValue);
                                if (e) return this.po(e);
                            }
                        } else if (t.key === this.io) {
                            if (null !== t.newValue) {
                                const e = this._o(t.newValue);
                                if (e) return this.ao(e);
                            }
                        } else if (t.key === this.Ys) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $31a25a81deadb29c$export$7a0bdf7d4a91ea88("number" == typeof n, 30636, {
                                        yo: e
                                    }), t = n;
                                } catch (e) {
                                    $31a25a81deadb29c$var$__PRIVATE_logError($31a25a81deadb29c$var$qt, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce && this.sequenceNumberHandler(e);
                        } else if (t.key === this.so) {
                            const e = this.wo(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.So(e)));
                        }
                    }
                } else this.Zs.push(t);
            });
        }
    }
    get ho() {
        return this.Hs.get(this.zs);
    }
    oo() {
        this.setItem(this.Xs, this.ho.Ws());
    }
    co(e, t, n) {
        const r = new $31a25a81deadb29c$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $31a25a81deadb29c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Ws());
    }
    lo(e) {
        const t = $31a25a81deadb29c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    To(e) {
        const t = {
            clientId: this.zs,
            onlineState: e
        };
        this.storage.setItem(this.io, JSON.stringify(t));
    }
    Po(e, t, n) {
        const r = $31a25a81deadb29c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $31a25a81deadb29c$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Ws());
    }
    Io(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.so, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Eo(e) {
        const t = this.eo.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Ao(e, t) {
        const n = this.Eo(e);
        return $31a25a81deadb29c$var$__PRIVATE_RemoteClientState.$s(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Vo(e, t) {
        const n = this.no.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $31a25a81deadb29c$var$__PRIVATE_MutationMetadata.$s(new $31a25a81deadb29c$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ fo(e, t) {
        const n = this.ro.exec(e), r = Number(n[1]);
        return $31a25a81deadb29c$var$__PRIVATE_QueryTargetMetadata.$s(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ _o(e) {
        return $31a25a81deadb29c$var$__PRIVATE_SharedOnlineState.$s(e);
    }
    wo(e) {
        return JSON.parse(e);
    }
    async mo(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.bo(e.batchId, e.state, e.error);
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$qt, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    po(e) {
        return this.syncEngine.Do(e.targetId, e.state, e.error);
    }
    Ro(e, t) {
        const n = t ? this.Hs.insert(e, t) : this.Hs.remove(e), r = this.uo(this.Hs), i = this.uo(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.Co(s, o).then(()=>{
            this.Hs = n;
        });
    }
    ao(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Hs.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    uo(e) {
        let t = $31a25a81deadb29c$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.vo = new $31a25a81deadb29c$var$__PRIVATE_LocalClientState, this.Fo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.vo.Qs(e), this.Fo[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.Fo[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.vo.Gs(e);
    }
    isLocalQueryTarget(e) {
        return this.vo.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.Fo[e];
    }
    getAllActiveQueryTargets() {
        return this.vo.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.vo.activeTargetIds.has(e);
    }
    start() {
        return this.vo = new $31a25a81deadb29c$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_NoopConnectivityMonitor {
    Mo(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $31a25a81deadb29c$var$Ut = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $31a25a81deadb29c$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.xo = ()=>this.Oo(), this.No = ()=>this.Bo(), this.Lo = [], this.ko();
    }
    Mo(e) {
        this.Lo.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.xo), window.removeEventListener("offline", this.No);
    }
    ko() {
        window.addEventListener("online", this.xo), window.addEventListener("offline", this.No);
    }
    Oo() {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Ut, "Network connectivity changed: AVAILABLE");
        for (const e of this.Lo)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    Bo() {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Ut, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.Lo)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static v() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $31a25a81deadb29c$var$$t = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @returns the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $31a25a81deadb29c$var$__PRIVATE_generateUniqueDebugId() {
    return null === $31a25a81deadb29c$var$$t ? $31a25a81deadb29c$var$$t = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $31a25a81deadb29c$var$$t++, "0x" + $31a25a81deadb29c$var$$t.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$Wt = "RestConnection", $31a25a81deadb29c$var$Qt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery",
    ExecutePipeline: "executePipeline"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $31a25a81deadb29c$var$__PRIVATE_RestConnection {
    get Ko() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.qo = t + "://" + e.host, this.Uo = `projects/${n}/databases/${r}`, this.$o = this.databaseId.database === $31a25a81deadb29c$var$it ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Wo(e, t, n, r, i) {
        const s = $31a25a81deadb29c$var$__PRIVATE_generateUniqueDebugId(), o = this.Qo(e, t.toUriEncodedString());
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Wt, `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Uo,
            "x-goog-request-params": this.$o
        };
        this.Go(_, r, i);
        const { host: a } = new URL(o), c = (0, $029952e65115eee5$export$5b4d24b45140ad90)(a);
        return this.zo(e, o, _, n, c).then((t)=>($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Wt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $31a25a81deadb29c$export$4c3d22f3d993c33f($31a25a81deadb29c$var$Wt, `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    jo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Wo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Go(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $31a25a81deadb29c$var$b;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    Qo(e, t) {
        const n = $31a25a81deadb29c$var$Qt[e];
        let r = `${this.qo}/v1/${t}:${n}`;
        return this.databaseInfo.apiKey && (r = `${r}?key=${encodeURIComponent(this.databaseInfo.apiKey)}`), r;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $31a25a81deadb29c$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Jo = e.Jo, this.Ho = e.Ho;
    }
    Zo(e) {
        this.Xo = e;
    }
    Yo(e) {
        this.e_ = e;
    }
    t_(e) {
        this.n_ = e;
    }
    onMessage(e) {
        this.r_ = e;
    }
    close() {
        this.Ho();
    }
    send(e) {
        this.Jo(e);
    }
    i_() {
        this.Xo();
    }
    s_() {
        this.e_();
    }
    o_(e) {
        this.n_(e);
    }
    __(e) {
        this.r_(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$Gt = "WebChannelConnection", $31a25a81deadb29c$var$__PRIVATE_unguardedEventListen = (e, t, n)=>{
    // TODO(dimond): closure typing seems broken because WebChannel does
    // not implement goog.events.Listenable
    e.listen(t, (e)=>{
        try {
            n(e);
        } catch (e) {
            setTimeout(()=>{
                throw e;
            }, 0);
        }
    });
};
class $31a25a81deadb29c$var$__PRIVATE_WebChannelConnection extends $31a25a81deadb29c$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.a_ = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    /**
     * Initialize STAT_EVENT listener once. Subsequent calls are a no-op.
     * getStatEventTarget() returns the same target every time.
     */ static u_() {
        if (!$31a25a81deadb29c$var$__PRIVATE_WebChannelConnection.c_) {
            const e = (0, $33cb313d667e3306$export$888d0d9ab79d08fc)();
            $31a25a81deadb29c$var$__PRIVATE_unguardedEventListen(e, (0, $33cb313d667e3306$export$d61e24a684f9e51).STAT_EVENT, (e)=>{
                e.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).PROXY ? $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, "STAT_EVENT: detected buffering proxy") : e.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).NOPROXY && $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, "STAT_EVENT: detected no buffering proxy");
            }), $31a25a81deadb29c$var$__PRIVATE_WebChannelConnection.c_ = !0;
        }
    }
    zo(e, t, n, r, i) {
        const s = $31a25a81deadb29c$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, o)=>{
            const _ = new (0, $33cb313d667e3306$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $33cb313d667e3306$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' ${s} timed out`), o(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' ${s} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = e?.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($31a25a81deadb29c$export$f1e1789686576879).indexOf(t) >= 0 ? t : $31a25a81deadb29c$export$f1e1789686576879.UNKNOWN;
                                    }(t.status);
                                    o(new $31a25a81deadb29c$export$4368d992c4eafac0(e, t.message));
                                } else o(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $31a25a81deadb29c$export$3a6d5c9ae78a2c08(9055, {
                                l_: e,
                                streamId: s,
                                h_: _.getLastErrorCode(),
                                P_: _.getLastError()
                            });
                    }
                } finally{
                    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' ${s} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    T_(e, t, n) {
        const r = $31a25a81deadb29c$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.qo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = this.createWebChannelTransport(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, _ = this.longPollingOptions.timeoutSeconds;
        void 0 !== _ && (o.longPollingTimeout = Math.round(1e3 * _)), this.useFetchStreams && (o.useFetchStreams = !0), this.Go(o.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        o.encodeInitMessageHeaders = !0;
        const a = i.join("");
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `Creating RPC '${e}' stream ${r}: ${a}`, o);
        const u = s.createWebChannel(a, o);
        this.I_(u);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let c = !1, l = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const h = new $31a25a81deadb29c$var$__PRIVATE_StreamBridge({
            Jo: (t)=>{
                l ? $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (c || ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `Opening RPC '${e}' stream ${r} transport.`), u.open(), c = !0), $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' stream ${r} sending:`, t), u.send(t));
            },
            Ho: ()=>u.close()
        });
        return $31a25a81deadb29c$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            l || ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' stream ${r} transport opened.`), h.i_());
        }), $31a25a81deadb29c$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            l || (l = !0, $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' stream ${r} transport closed`), h.o_(), this.E_(u));
        }), $31a25a81deadb29c$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            l || (l = !0, $31a25a81deadb29c$export$4c3d22f3d993c33f($31a25a81deadb29c$var$Gt, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), h.o_(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, "The operation could not be completed")));
        }), $31a25a81deadb29c$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            if (!l) {
                const n = t.data[0];
                $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!n, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const i = n, s = i?.error || i[0]?.error;
                if (s) {
                    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' stream ${r} received error:`, s);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = s.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $31a25a81deadb29c$var$Rt[e];
                        if (void 0 !== t) return $31a25a81deadb29c$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = s.message;
                    "NOT_FOUND" === t && i.includes("database") && i.includes("does not exist") && i.includes(this.databaseId.database) && $31a25a81deadb29c$export$4c3d22f3d993c33f(`Database '${this.databaseId.database}' not found. Please check your project configuration.`), void 0 === n && (n = $31a25a81deadb29c$export$f1e1789686576879.INTERNAL, i = "Unknown error status: " + t + " with message " + s.message), // Mark closed so no further events are propagated
                    l = !0, h.o_(new $31a25a81deadb29c$export$4368d992c4eafac0(n, i)), u.close();
                } else $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Gt, `RPC '${e}' stream ${r} received:`, n), h.__(n);
            }
        }), // Ensure that event listeners are configured for STAT_EVENTs.
        $31a25a81deadb29c$var$__PRIVATE_WebChannelConnection.u_(), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            h.s_();
        }, 0), h;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.a_.forEach((e)=>e.close()), this.a_ = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ I_(e) {
        this.a_.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ E_(e) {
        this.a_ = this.a_.filter((t)=>t === e);
    }
    /**
     * Modifies the headers for a request, adding the api key if present,
     * and then calling super.modifyHeadersForRequest
     */ Go(e, t, n) {
        super.Go(e, t, n), // For web channel streams, we want to send the api key in the headers.
        this.databaseInfo.apiKey && (e["x-goog-api-key"] = this.databaseInfo.apiKey);
    }
    /**
     * Wrapped for mocking.
     * @protected
     */ createWebChannelTransport() {
        return (0, $33cb313d667e3306$export$66869136fc133c3a)();
    }
}
/**
 * Track if the STAT_EVENT listener has been initialized.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ function $31a25a81deadb29c$var$__PRIVATE_newConnection(e) {
    return new $31a25a81deadb29c$var$__PRIVATE_WebChannelConnection(e);
}
/** Return the Platform-specific connectivity monitor. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $31a25a81deadb29c$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $31a25a81deadb29c$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $31a25a81deadb29c$export$b4171a6734a65d42(e) {
    return new $31a25a81deadb29c$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $31a25a81deadb29c$var$__PRIVATE_WebChannelConnection.c_ = !1;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $31a25a81deadb29c$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Ci = e, this.timerId = t, this.R_ = n, this.A_ = r, this.V_ = i, this.d_ = 0, this.m_ = null, /** The last backoff attempt, as epoch milliseconds. */ this.f_ = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.d_ = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ g_() {
        this.d_ = this.V_;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ p_(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.d_ + this.y_()), n = Math.max(0, Date.now() - this.f_), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $31a25a81deadb29c$export$21579262ef46735b("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.d_} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.m_ = this.Ci.enqueueAfterDelay(this.timerId, r, ()=>(this.f_ = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.d_ *= this.A_, this.d_ < this.R_ && (this.d_ = this.R_), this.d_ > this.V_ && (this.d_ = this.V_);
    }
    w_() {
        null !== this.m_ && (this.m_.skipDelay(), this.m_ = null);
    }
    cancel() {
        null !== this.m_ && (this.m_.cancel(), this.m_ = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ y_() {
        return (Math.random() - .5) * this.d_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$zt = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $31a25a81deadb29c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.Ci = e, this.S_ = n, this.b_ = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.D_ = 0, this.C_ = null, this.v_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.F_ = 0, this.M_ = new $31a25a81deadb29c$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ x_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.O_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ O_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.F_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.N_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.x_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ B_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.M_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ L_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.O_() && null === this.C_ && (this.C_ = this.Ci.enqueueAfterDelay(this.S_, 6e4, ()=>this.k_()));
    }
    /** Sends a message to the underlying stream. */ K_(e) {
        this.q_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async k_() {
        if (this.O_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ q_() {
        this.C_ && (this.C_.cancel(), this.C_ = null);
    }
    /** Cancels the health check delayed operation. */ U_() {
        this.v_ && (this.v_.cancel(), this.v_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.q_(), this.U_(), this.M_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.D_++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.M_.reset() : t && t.code === $31a25a81deadb29c$export$f1e1789686576879.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($31a25a81deadb29c$var$__PRIVATE_logError(t.toString()), $31a25a81deadb29c$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.M_.g_()) : t && t.code === $31a25a81deadb29c$export$f1e1789686576879.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.W_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.t_(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ W_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.Q_(this.D_), t = this.D_;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.D_ === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.G_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.z_(e);
            });
        });
    }
    G_(e, t) {
        const n = this.Q_(this.D_);
        this.stream = this.j_(e, t), this.stream.Zo(()=>{
            n(()=>this.listener.Zo());
        }), this.stream.Yo(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.v_ = this.Ci.enqueueAfterDelay(this.b_, 1e4, ()=>(this.O_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.Yo()));
        }), this.stream.t_((e)=>{
            n(()=>this.z_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.F_ ? this.J_(e) : this.onNext(e));
        });
    }
    N_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.M_.p_(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    z_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$zt, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Q_(e) {
        return (t)=>{
            this.Ci.enqueueAndForget(()=>this.D_ === e ? t() : ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$zt, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $31a25a81deadb29c$var$__PRIVATE_PersistentListenStream extends $31a25a81deadb29c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    j_(e, t) {
        return this.connection.T_("Listen", e, t);
    }
    J_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.M_.reset();
        const t = $31a25a81deadb29c$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $31a25a81deadb29c$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $31a25a81deadb29c$var$SnapshotVersion.min() : t.readTime ? $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.readTime) : $31a25a81deadb29c$var$SnapshotVersion.min();
        }(e);
        return this.listener.H_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ Z_(e) {
        const t = {};
        t.database = $31a25a81deadb29c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $31a25a81deadb29c$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $31a25a81deadb29c$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $31a25a81deadb29c$var$__PRIVATE_toQueryTarget(e, r).ft
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $31a25a81deadb29c$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $31a25a81deadb29c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($31a25a81deadb29c$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $31a25a81deadb29c$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $31a25a81deadb29c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $31a25a81deadb29c$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.K_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ X_(e) {
        const t = {};
        t.database = $31a25a81deadb29c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.K_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $31a25a81deadb29c$var$__PRIVATE_PersistentWriteStream extends $31a25a81deadb29c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Y_() {
        return this.F_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    W_() {
        this.Y_ && this.ea([]);
    }
    j_(e, t) {
        return this.connection.T_("Write", e, t);
    }
    J_(e) {
        // Always capture the last stream token.
        return $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.ta();
    }
    onNext(e) {
        // Always capture the last stream token.
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.M_.reset();
        const t = $31a25a81deadb29c$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $31a25a81deadb29c$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.na(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ ra() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $31a25a81deadb29c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.K_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ ea(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$31a25a81deadb29c$var$toMutation(this.serializer, e))
        };
        this.K_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $31a25a81deadb29c$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $31a25a81deadb29c$var$__PRIVATE_DatastoreImpl extends $31a25a81deadb29c$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.ia = !1;
    }
    sa() {
        if (this.ia) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Wo(e, t, n, r) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Wo(e, $31a25a81deadb29c$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $31a25a81deadb29c$export$f1e1789686576879.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ jo(e, t, n, r, i) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.jo(e, $31a25a81deadb29c$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $31a25a81deadb29c$export$f1e1789686576879.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.ia = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
function $31a25a81deadb29c$var$__PRIVATE_newDatastore(e, t, n, r) {
    return new $31a25a81deadb29c$var$__PRIVATE_DatastoreImpl(e, t, n, r);
}
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $31a25a81deadb29c$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.oa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this._a = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.aa = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ ua() {
        0 === this.oa && (this.ca("Unknown" /* OnlineState.Unknown */ ), this._a = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this._a = null, this.la("Backend didn't respond within 10 seconds."), this.ca("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ ha(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.ca("Unknown" /* OnlineState.Unknown */ ) : (this.oa++, this.oa >= 1 && (this.Pa(), this.la(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.ca("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.Pa(), this.oa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.aa = !1), this.ca(e);
    }
    ca(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    la(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.aa ? ($31a25a81deadb29c$var$__PRIVATE_logError(t), this.aa = !1) : $31a25a81deadb29c$export$21579262ef46735b("OnlineStateTracker", t);
    }
    Pa() {
        null !== this._a && (this._a.cancel(), this._a = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$jt = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $31a25a81deadb29c$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Ta = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ia = new Map, this.Ea = new Map, this.Ra = new Map, this.Aa = new $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator(1e3), this.Va = new $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator(1001), /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.da = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.ma = [], this.fa = i, this.fa.Mo((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(this) && ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
                    t.da.add(4 /* OfflineCause.ConnectivityChange */ ), await $31a25a81deadb29c$var$__PRIVATE_disableNetworkInternal(t), t.ga.set("Unknown" /* OnlineState.Unknown */ ), t.da.delete(4 /* OfflineCause.ConnectivityChange */ ), await $31a25a81deadb29c$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.ga = new $31a25a81deadb29c$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $31a25a81deadb29c$var$__PRIVATE_enableNetworkInternal(e) {
    if ($31a25a81deadb29c$var$__PRIVATE_canUseNetwork(e)) for (const t of e.ma)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $31a25a81deadb29c$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.ma)await t(/* enabled= */ !1);
}
/**
 * Returns the remote target ID currently mapped to this
 * sdkTargetId. Or returns `0` if the SDK target ID
 * is not currently mapped.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ function $31a25a81deadb29c$var$__PRIVATE_getRemoteTargetId(e, t) {
    return e.Ea.get(t) || void 0;
}
/**
 * Generates a new remote target ID that is acceptable
 * to map to the given SDK target ID.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ /**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $31a25a81deadb29c$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = $31a25a81deadb29c$var$__PRIVATE_getRemoteTargetId(n, t.targetId);
    // Get any remote target ID currently mapped to the targetData
    // If remote store is still listening for this remote target ID, this is a no-op.
    if (void 0 !== r && n.Ia.has(r)) return;
    // Generate and map a new remote ID to the SDK target ID
    const i = /**
 * Generate a new remote target ID for the given SDK target ID.
 * Re-map the given SDK to the new remote ID.
 * Delete any mapping of the old remote ID, if given.
 * @param remoteStoreImpl
 * @param sdkTargetId
 * @return The new remote ID.
 */ function __PRIVATE_allocateRemoteTargetId(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_getRemoteTargetId(e, t);
        void 0 !== n && // If there was an existing remote target ID mapped to that SDK target ID, forget about the old remote ID.
        e.Ra.delete(n);
        // Generate a new unique remote target ID
        const r = function __PRIVATE_generateRemoteTargetId(e, t) {
            // If the given sdkTargetId is odd, map it to an odd (sync engine) target ID
            return t % 2 != 0 ? e.Va.next() : e.Aa.next();
        }(e, t);
        return e.Ea.set(t, r), e.Ra.set(r, t), r;
    }(n, t.targetId);
    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "remoteStoreListen mapping SDK target ID to remote", t.targetId, i);
    // Create a new TargetData for remote use, which uses
    // the remote TargetID.
    const s = new $31a25a81deadb29c$var$TargetData(t.target, i, t.purpose, t.sequenceNumber, t.snapshotVersion, t.lastLimboFreeSnapshotVersion, t.resumeToken);
    // Mark this as something the client is currently listening for.
    n.Ia.set(i, s), $31a25a81deadb29c$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $31a25a81deadb29c$var$__PRIVATE_startWatchStream(n) : $31a25a81deadb29c$var$__PRIVATE_ensureWatchStream(n).O_() && $31a25a81deadb29c$var$__PRIVATE_sendWatchRequest(n, s);
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $31a25a81deadb29c$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = $31a25a81deadb29c$var$__PRIVATE_ensureWatchStream(n), i = $31a25a81deadb29c$var$__PRIVATE_getRemoteTargetId(n, t);
    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "remoteStoreUnlisten removing mapping of SDK target ID to remote", t, i), n.Ia.delete(i), n.Ea.delete(t), n.Ra.delete(i), r.O_() && $31a25a81deadb29c$var$__PRIVATE_sendUnwatchRequest(n, i), 0 === n.Ia.size && (r.O_() ? r.L_() : $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.ga.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $31a25a81deadb29c$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.pa.$e(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($31a25a81deadb29c$var$SnapshotVersion.min()) > 0) {
        const n = e.Ra.get(t.targetId);
        if (void 0 === n) // There's already a new remoteStoreListen request for the original
        // target, so ignore this.
        return void $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "SDK target ID not found for remote ID: " + t.targetId);
        const r = e.remoteSyncer.getRemoteKeysForTarget(n).size;
        t = t.withExpectedCount(r);
    }
    $31a25a81deadb29c$var$__PRIVATE_ensureWatchStream(e).Z_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $31a25a81deadb29c$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.pa.$e(t), $31a25a81deadb29c$var$__PRIVATE_ensureWatchStream(e).X_(t);
}
function $31a25a81deadb29c$var$__PRIVATE_startWatchStream(e) {
    e.pa = new $31a25a81deadb29c$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>{
            // Remote syncer uses SDK target IDs, so we need to map the remote
            // id to external id
            const n = e.Ra.get(t);
            // If no sdkTargetId is mapped, return an empty key set
            return void 0 !== n ? e.remoteSyncer.getRemoteKeysForTarget(n) : $31a25a81deadb29c$export$971d5caa766a69d7();
        },
        At: (t)=>e.Ia.get(t) || null,
        ht: ()=>e.datastore.serializer.databaseId
    }), $31a25a81deadb29c$var$__PRIVATE_ensureWatchStream(e).start(), e.ga.ua();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $31a25a81deadb29c$var$__PRIVATE_shouldStartWatchStream(e) {
    return $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(e) && !$31a25a81deadb29c$var$__PRIVATE_ensureWatchStream(e).x_() && e.Ia.size > 0;
}
function $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $31a25a81deadb29c$var$__PRIVATE_debugCast(e).da.size;
}
function $31a25a81deadb29c$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.pa = void 0;
}
async function $31a25a81deadb29c$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.ga.set("Online" /* OnlineState.Online */ );
}
async function $31a25a81deadb29c$var$__PRIVATE_onWatchStreamOpen(e) {
    e.Ia.forEach((t, n)=>{
        $31a25a81deadb29c$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $31a25a81deadb29c$var$__PRIVATE_onWatchStreamClose(e, t) {
    $31a25a81deadb29c$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $31a25a81deadb29c$var$__PRIVATE_shouldStartWatchStream(e) ? (e.ga.ha(t), $31a25a81deadb29c$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.ga.set("Unknown" /* OnlineState.Unknown */ );
}
async function $31a25a81deadb29c$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.ga.set("Online" /* OnlineState.Online */ ), t instanceof $31a25a81deadb29c$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds){
                // A watched target might have been removed already.
                if (e.Ia.has(r)) {
                    const t = e.Ra.get(r);
                    // If we still track the remote target ID, then notify the remoteSyncer
                    // of the error and then free up the remote ID.
                    void 0 !== t && (await e.remoteSyncer.rejectListen(t, n), e.Ea.delete(t), e.Ra.delete(r)), e.Ia.delete(r);
                }
                e.pa.removeTarget(r);
            }
        }(e, t);
    } catch (n) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $31a25a81deadb29c$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $31a25a81deadb29c$var$__PRIVATE_DocumentWatchChange ? e.pa.Xe(t) : t instanceof $31a25a81deadb29c$var$__PRIVATE_ExistenceFilterChange ? e.pa.st(t) : e.pa.tt(t), !n.isEqual($31a25a81deadb29c$var$SnapshotVersion.min())) try {
        const t = await $31a25a81deadb29c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.pa.Tt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ia.get(r);
                    // A watched target might have been removed already.
                    i && e.Ia.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ia.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ia.set(t, r.withResumeToken($31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $31a25a81deadb29c$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $31a25a81deadb29c$var$TargetData(r.target, t, n, r.sequenceNumber);
                $31a25a81deadb29c$var$__PRIVATE_sendWatchRequest(e, i);
            });
            const r = /**
 * Convert a RemoteEvent with remote IDs to a RemoteEvent with
 * SDK IDs and dropped updates
 * for any targets we no longer track.
 *
 * @param remoteStoreImpl
 * @param remoteEvent
 * @return a new RemoteEvent with SDK IDs and dropped updates
 * for any targets we no longer track.
 */ function __PRIVATE_toSdkRemoteEvent(e, t) {
                // Map TargetChanges to TargetChanges with SDK ID
                const n = new Map;
                t.targetChanges.forEach((t, r)=>{
                    // If we no longer track the remote ID, then drop the TargetChange
                    // otherwise propagate the TargetChange
                    const i = e.Ra.get(r);
                    void 0 !== i && n.set(i, t);
                });
                // Map target mismatches to target mismatches with SDK ID
                let r = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator);
                return t.targetMismatches.forEach((t, n)=>{
                    // If we no longer track the remote ID, then drop the target mismatch
                    // otherwise propagate the target mismatch
                    const i = e.Ra.get(t);
                    void 0 !== i && (r = r.insert(i, n));
                }), new $31a25a81deadb29c$var$RemoteEvent(t.snapshotVersion, n, r, t.documentUpdates, t.resolvedLimboDocuments);
            }(e, n);
            return e.remoteSyncer.applyRemoteEvent(r);
        }(e, n);
    } catch (t) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "Failed to raise snapshot:", t), await $31a25a81deadb29c$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $31a25a81deadb29c$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.da.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $31a25a81deadb29c$var$__PRIVATE_disableNetworkInternal(e), e.ga.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$31a25a81deadb29c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "Retrying IndexedDB access"), await n(), e.da.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $31a25a81deadb29c$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $31a25a81deadb29c$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$31a25a81deadb29c$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $31a25a81deadb29c$var$__PRIVATE_fillWritePipeline(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), n = $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(t);
    let r = t.Ta.length > 0 ? t.Ta[t.Ta.length - 1].batchId : $31a25a81deadb29c$var$q;
    for(; $31a25a81deadb29c$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $31a25a81deadb29c$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Ta.length && n.L_();
            break;
        }
        r = e.batchId, $31a25a81deadb29c$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $31a25a81deadb29c$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $31a25a81deadb29c$var$__PRIVATE_shouldStartWriteStream(t) && $31a25a81deadb29c$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $31a25a81deadb29c$var$__PRIVATE_canAddToWritePipeline(e) {
    return $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(e) && e.Ta.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $31a25a81deadb29c$var$__PRIVATE_addToWritePipeline(e, t) {
    e.Ta.push(t);
    const n = $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e);
    n.O_() && n.Y_ && n.ea(t.mutations);
}
function $31a25a81deadb29c$var$__PRIVATE_shouldStartWriteStream(e) {
    return $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(e) && !$31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e).x_() && e.Ta.length > 0;
}
function $31a25a81deadb29c$var$__PRIVATE_startWriteStream(e) {
    $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $31a25a81deadb29c$var$__PRIVATE_onWriteStreamOpen(e) {
    $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e).ra();
}
async function $31a25a81deadb29c$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Ta)t.ea(n.mutations);
}
async function $31a25a81deadb29c$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.Ta.shift(), i = $31a25a81deadb29c$var$MutationBatchResult.from(r, t, n);
    await $31a25a81deadb29c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $31a25a81deadb29c$var$__PRIVATE_fillWritePipeline(e);
}
async function $31a25a81deadb29c$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e).Y_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $31a25a81deadb29c$var$__PRIVATE_isPermanentError(e) && e !== $31a25a81deadb29c$export$f1e1789686576879.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Ta.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e).B_(), await $31a25a81deadb29c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $31a25a81deadb29c$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $31a25a81deadb29c$var$__PRIVATE_shouldStartWriteStream(e) && $31a25a81deadb29c$var$__PRIVATE_startWriteStream(e);
}
async function $31a25a81deadb29c$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "RemoteStore received new credentials");
    const r = $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.da.add(3 /* OfflineCause.CredentialChange */ ), await $31a25a81deadb29c$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.ga.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.da.delete(3 /* OfflineCause.CredentialChange */ ), await $31a25a81deadb29c$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $31a25a81deadb29c$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    t ? (n.da.delete(2 /* OfflineCause.IsSecondary */ ), await $31a25a81deadb29c$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.da.add(2 /* OfflineCause.IsSecondary */ ), await $31a25a81deadb29c$var$__PRIVATE_disableNetworkInternal(n), n.ga.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $31a25a81deadb29c$var$__PRIVATE_ensureWatchStream(e) {
    return e.ya || // Create stream (but note that it is not started yet).
    (e.ya = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
        return r.sa(), new $31a25a81deadb29c$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: $31a25a81deadb29c$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        Yo: $31a25a81deadb29c$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        t_: $31a25a81deadb29c$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        H_: $31a25a81deadb29c$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.ma.push(async (t)=>{
        t ? (e.ya.B_(), $31a25a81deadb29c$var$__PRIVATE_shouldStartWatchStream(e) ? $31a25a81deadb29c$var$__PRIVATE_startWatchStream(e) : e.ga.set("Unknown" /* OnlineState.Unknown */ )) : (await e.ya.stop(), $31a25a81deadb29c$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.ya;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $31a25a81deadb29c$var$__PRIVATE_ensureWriteStream(e) {
    return e.wa || // Create stream (but note that it is not started yet).
    (e.wa = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
        return r.sa(), new $31a25a81deadb29c$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: ()=>Promise.resolve(),
        Yo: $31a25a81deadb29c$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        t_: $31a25a81deadb29c$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        ta: $31a25a81deadb29c$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        na: $31a25a81deadb29c$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.ma.push(async (t)=>{
        t ? (e.wa.B_(), // This will start the write stream if necessary.
        await $31a25a81deadb29c$var$__PRIVATE_fillWritePipeline(e)) : (await e.wa.stop(), e.Ta.length > 0 && ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, `Stopping write stream with ${e.Ta.length} pending writes`), e.Ta = []));
    })), e.wa;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $31a25a81deadb29c$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $31a25a81deadb29c$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $31a25a81deadb29c$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $31a25a81deadb29c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($31a25a81deadb29c$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $31a25a81deadb29c$export$25ce5a424b770e84 {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $31a25a81deadb29c$export$25ce5a424b770e84(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $31a25a81deadb29c$export$90a7f3efeed30595.comparator(t.key, n.key) : (e, t)=>$31a25a81deadb29c$export$90a7f3efeed30595.comparator(e.key, t.key), this.keyedMap = $31a25a81deadb29c$var$documentMap(), this.sortedSet = new $31a25a81deadb29c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $31a25a81deadb29c$export$25ce5a424b770e84)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $31a25a81deadb29c$export$25ce5a424b770e84;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $31a25a81deadb29c$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.Sa = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.Sa.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.Sa = this.Sa.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.Sa = this.Sa.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.Sa = this.Sa.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.Sa = this.Sa.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.Sa = this.Sa.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.Sa = this.Sa.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.Sa = this.Sa.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $31a25a81deadb29c$export$3a6d5c9ae78a2c08(63341, {
            Vt: e,
            ba: n
        }) : this.Sa = this.Sa.insert(t, e);
    }
    Da() {
        const e = [];
        return this.Sa.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $31a25a81deadb29c$export$e7c866399fa523f5 {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $31a25a81deadb29c$export$e7c866399fa523f5(e, t, $31a25a81deadb29c$export$25ce5a424b770e84.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $31a25a81deadb29c$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $31a25a81deadb29c$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.Ca = void 0, this.va = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    Fa() {
        return this.va.some((e)=>e.Ma());
    }
}
class $31a25a81deadb29c$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $31a25a81deadb29c$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.xa = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $31a25a81deadb29c$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.va)e.onError(t);
            });
        }(this, new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.ABORTED, "Firestore shutting down"));
    }
}
function $31a25a81deadb29c$var$__PRIVATE_newQueriesObjectMap() {
    return new $31a25a81deadb29c$var$ObjectMap((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyQuery(e), $31a25a81deadb29c$var$__PRIVATE_queryEquals);
}
async function $31a25a81deadb29c$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.Fa() && t.Ma() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $31a25a81deadb29c$var$__PRIVATE_QueryListenersInfo, r = t.Ma() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.Ca = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.Ca = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $31a25a81deadb29c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$31a25a81deadb29c$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.va.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.Oa(n.onlineState), s.Ca) t.Na(s.Ca) && $31a25a81deadb29c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $31a25a81deadb29c$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.va.indexOf(t);
        e >= 0 && (s.va.splice(e, 1), 0 === s.va.length ? i = t.Ma() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.Fa() && t.Ma() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.va)t.Na(e) && (r = !0);
            i.Ca = e;
        }
    }
    r && $31a25a81deadb29c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $31a25a81deadb29c$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.va)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $31a25a81deadb29c$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.xa.forEach((e)=>{
        e.next();
    });
}
var $31a25a81deadb29c$var$Ht, $31a25a81deadb29c$var$Jt;
/** Listen to both cache and server changes */ ($31a25a81deadb29c$var$Jt = $31a25a81deadb29c$var$Ht || ($31a25a81deadb29c$var$Ht = {})).Ba = "default", /** Listen to changes in cache only */ $31a25a81deadb29c$var$Jt.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $31a25a81deadb29c$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.La = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.ka = !1, this.Ka = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Na(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $31a25a81deadb29c$export$e7c866399fa523f5(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.ka ? this.qa(e) && (this.La.next(e), t = !0) : this.Ua(e, this.onlineState) && (this.$a(e), t = !0), this.Ka = e, t;
    }
    onError(e) {
        this.La.error(e);
    }
    /** Returns whether a snapshot was raised. */ Oa(e) {
        this.onlineState = e;
        let t = !1;
        return this.Ka && !this.ka && this.Ua(this.Ka, e) && (this.$a(this.Ka), t = !0), t;
    }
    Ua(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.Ma()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Wa || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    qa(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.Ka && this.Ka.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    $a(e) {
        e = $31a25a81deadb29c$export$e7c866399fa523f5.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.ka = !0, this.La.next(e);
    }
    Ma() {
        return this.options.source !== $31a25a81deadb29c$var$Ht.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $31a25a81deadb29c$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.Qa = e, this.byteLength = t;
    }
    Ga() {
        return "metadata" in this.Qa;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $31a25a81deadb29c$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Ks(e) {
        return $31a25a81deadb29c$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ qs(e) {
        return e.metadata.exists ? $31a25a81deadb29c$export$3a1a48c8f6ef640e(this.serializer, e.document, !1) : $31a25a81deadb29c$var$MutableDocument.newNoDocument(this.Ks(e.metadata.name), this.Us(e.metadata.readTime));
    }
    Us(e) {
        return $31a25a81deadb29c$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $31a25a81deadb29c$export$61196ced6d74a310 {
    constructor(e, t){
        this.za = e, this.serializer = t, /** Batched queries to be saved into storage */ this.ja = [], /** Batched documents to be saved into storage */ this.Ja = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $31a25a81deadb29c$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.ja;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.Ja;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Ha(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.Qa.namedQuery) this.ja.push(e.Qa.namedQuery);
        else if (e.Qa.documentMetadata) {
            this.Ja.push({
                metadata: e.Qa.documentMetadata
            }), e.Qa.documentMetadata.exists || ++t;
            const n = $31a25a81deadb29c$export$db202ddc8be9136.fromString(e.Qa.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.Qa.document && (this.Ja[this.Ja.length - 1].document = e.Qa.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, {
            ...this.progress
        }) : null;
    }
    Za(e) {
        const t = new Map, n = new $31a25a81deadb29c$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Ks(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $31a25a81deadb29c$export$971d5caa766a69d7()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async Xa(e) {
        const t = await $31a25a81deadb29c$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $31a25a81deadb29c$var$__PRIVATE_BundleConverterImpl(this.serializer), this.Ja, this.za.id), n = this.Za(this.documents);
        for (const t of this.ja)await $31a25a81deadb29c$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ya: this.collectionGroups,
            eu: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $31a25a81deadb29c$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $31a25a81deadb29c$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.tu = t, this.nu = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.ru = $31a25a81deadb29c$export$971d5caa766a69d7(), /** Document Keys that have local changes */ this.mutatedKeys = $31a25a81deadb29c$export$971d5caa766a69d7(), this.iu = $31a25a81deadb29c$var$__PRIVATE_newQueryComparator(e), this.su = new $31a25a81deadb29c$export$25ce5a424b770e84(this.iu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get ou() {
        return this.tu;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ _u(e, t) {
        const n = t ? t.au : new $31a25a81deadb29c$var$__PRIVATE_DocumentChangeSet, r = t ? t.su : this.su;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $31a25a81deadb29c$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.uu(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.iu(c, _) > 0 || a && this.iu(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            su: s,
            au: n,
            bs: o,
            mutatedKeys: i
        };
    }
    uu(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.su;
        this.su = e.su, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.au.Da();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $31a25a81deadb29c$export$3a6d5c9ae78a2c08(20277, {
                                Vt: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.iu(e.doc, t.doc)), this.cu(n), r = r ?? !1;
        const o = t && !r ? this.lu() : [], _ = 0 === this.ru.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.nu;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.nu = _, 0 !== s.length || a) return {
            snapshot: new $31a25a81deadb29c$export$e7c866399fa523f5(this.query, e.su, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            hu: o
        };
        // no changes
        return {
            hu: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Oa(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            su: this.su,
            au: new $31a25a81deadb29c$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            bs: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            hu: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ Pu(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.tu.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.su.has(e) && !this.su.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ cu(e) {
        e && (e.addedDocuments.forEach((e)=>this.tu = this.tu.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.tu = this.tu.delete(e)), this.current = e.current);
    }
    lu() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.ru;
        this.ru = $31a25a81deadb29c$export$971d5caa766a69d7(), this.su.forEach((e)=>{
            this.Pu(e.key) && (this.ru = this.ru.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.ru.has(e) || t.push(new $31a25a81deadb29c$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.ru.forEach((n)=>{
            e.has(n) || t.push(new $31a25a81deadb29c$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    Tu(e) {
        this.tu = e.ks, this.ru = $31a25a81deadb29c$export$971d5caa766a69d7();
        const t = this._u(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Iu() {
        return $31a25a81deadb29c$export$e7c866399fa523f5.fromInitialDocuments(this.query, this.su, this.mutatedKeys, 0 /* SyncState.Local */  === this.nu, this.hasCachedResults);
    }
}
const $31a25a81deadb29c$var$Zt = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $31a25a81deadb29c$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $31a25a81deadb29c$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Eu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $31a25a81deadb29c$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Ru = {}, this.Au = new $31a25a81deadb29c$var$ObjectMap((e)=>$31a25a81deadb29c$var$__PRIVATE_canonifyQuery(e), $31a25a81deadb29c$var$__PRIVATE_queryEquals), this.Vu = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.du = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.mu = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.fu = new Map, this.gu = new $31a25a81deadb29c$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.pu = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.yu = new Map, this.wu = $31a25a81deadb29c$var$__PRIVATE_TargetIdGenerator.ar(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.Su = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.Su;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $31a25a81deadb29c$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $31a25a81deadb29c$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.Au.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.Iu()) : i = await $31a25a81deadb29c$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $31a25a81deadb29c$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_ensureWatchCallbacks(e);
    await $31a25a81deadb29c$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $31a25a81deadb29c$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $31a25a81deadb29c$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $31a25a81deadb29c$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $31a25a81deadb29c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $31a25a81deadb29c$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $31a25a81deadb29c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.bu = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view._u(n);
            i.bs && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $31a25a81deadb29c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view._u(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $31a25a81deadb29c$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.hu), _.snapshot;
        })(e, t, n, r);
    const s = await $31a25a81deadb29c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $31a25a81deadb29c$var$__PRIVATE_View(t, s.ks), _ = o._u(s.documents), a = $31a25a81deadb29c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $31a25a81deadb29c$var$__PRIVATE_updateTrackedLimbos(e, n, u.hu);
    const c = new $31a25a81deadb29c$var$__PRIVATE_QueryView(t, n, o);
    return e.Au.set(t, c), e.Vu.has(n) ? e.Vu.get(n).push(t) : e.Vu.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $31a25a81deadb29c$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), i = r.Au.get(t), s = r.Vu.get(i.targetId);
    if (s.length > 1) return r.Vu.set(i.targetId, s.filter((e)=>!$31a25a81deadb29c$var$__PRIVATE_queryEquals(e, t))), void r.Au.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $31a25a81deadb29c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $31a25a81deadb29c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $31a25a81deadb29c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $31a25a81deadb29c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $31a25a81deadb29c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $31a25a81deadb29c$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = n.Au.get(t), i = n.Vu.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $31a25a81deadb29c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $31a25a81deadb29c$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = $31a25a81deadb29c$export$3d12bd131bb975d1.now(), i = t.reduce((e, t)=>e.add(t.key), $31a25a81deadb29c$export$971d5caa766a69d7());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $31a25a81deadb29c$var$__PRIVATE_mutableDocumentMap(), a = $31a25a81deadb29c$export$971d5caa766a69d7();
                return n.xs.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $31a25a81deadb29c$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $31a25a81deadb29c$var$__PRIVATE_PatchMutation(e.key, t, $31a25a81deadb29c$var$__PRIVATE_extractFieldMask(t.value.mapValue), $31a25a81deadb29c$export$78acf4525d8a74c4.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $31a25a81deadb29c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.pu[e.currentUser.toKey()];
            r || (r = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.pu[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $31a25a81deadb29c$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $31a25a81deadb29c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    try {
        const e = await $31a25a81deadb29c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.fu.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.Eu = !0 : e.modifiedDocuments.size > 0 ? $31a25a81deadb29c$export$7a0bdf7d4a91ea88(r.Eu, 14607) : e.removedDocuments.size > 0 && ($31a25a81deadb29c$export$7a0bdf7d4a91ea88(r.Eu, 42227), r.Eu = !1));
        }), await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Au.forEach((n, r)=>{
            const i = r.view.Oa(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.va)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.Oa(t) && (r = !0);
            }), r && $31a25a81deadb29c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Ru.H_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $31a25a81deadb29c$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.fu.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $31a25a81deadb29c$var$MutableDocument.newNoDocument(s, $31a25a81deadb29c$var$SnapshotVersion.min()));
        const n = $31a25a81deadb29c$export$971d5caa766a69d7().add(s), i = new $31a25a81deadb29c$var$RemoteEvent($31a25a81deadb29c$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$var$__PRIVATE_primitiveComparator), e, n);
        await $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.mu = r.mu.remove(s), r.fu.delete(t), $31a25a81deadb29c$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $31a25a81deadb29c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$31a25a81deadb29c$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $31a25a81deadb29c$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $31a25a81deadb29c$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $31a25a81deadb29c$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($31a25a81deadb29c$export$7a0bdf7d4a91ea88(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $31a25a81deadb29c$var$__PRIVATE_processUserCallback(r, t, n), $31a25a81deadb29c$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $31a25a81deadb29c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    $31a25a81deadb29c$var$__PRIVATE_canUseNetwork(n.remoteStore) || $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Zt, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $31a25a81deadb29c$var$q) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.yu.get(e) || [];
        r.push(t), n.yu.set(e, r);
    } catch (e) {
        const n = $31a25a81deadb29c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $31a25a81deadb29c$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.yu.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.yu.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $31a25a81deadb29c$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    let i = r.pu[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.pu[r.currentUser.toKey()] = i;
    }
}
function $31a25a81deadb29c$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Vu.get(t))e.Au.delete(r), n && e.Ru.Du(r, n);
    if (e.Vu.delete(t), e.isPrimaryClient) e.gu.Gr(t).forEach((t)=>{
        e.gu.containsKey(t) || // We removed the last reference for this key
        $31a25a81deadb29c$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $31a25a81deadb29c$var$__PRIVATE_removeLimboTarget(e, t) {
    e.du.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.mu.get(t);
    null !== n && ($31a25a81deadb29c$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.mu = e.mu.remove(t), e.fu.delete(n), $31a25a81deadb29c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $31a25a81deadb29c$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $31a25a81deadb29c$var$__PRIVATE_AddedLimboDocument) e.gu.addReference(r.key, t), $31a25a81deadb29c$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $31a25a81deadb29c$var$__PRIVATE_RemovedLimboDocument) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Zt, "Document no longer in limbo: " + r.key), e.gu.removeReference(r.key, t);
        e.gu.containsKey(r.key) || // We removed the last reference for this key
        $31a25a81deadb29c$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $31a25a81deadb29c$export$3a6d5c9ae78a2c08(19791, {
        Cu: r
    });
}
function $31a25a81deadb29c$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.mu.get(n) || e.du.has(r) || ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Zt, "New document in limbo: " + n), e.du.add(r), $31a25a81deadb29c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $31a25a81deadb29c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.du.size > 0 && e.mu.size < e.maxConcurrentLimboResolutions;){
        const t = e.du.values().next().value;
        e.du.delete(t);
        const n = new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$export$db202ddc8be9136.fromString(t)), r = e.wu.next();
        e.fu.set(r, new $31a25a81deadb29c$var$LimboResolution(n)), e.mu = e.mu.insert(n, r), $31a25a81deadb29c$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $31a25a81deadb29c$var$TargetData($31a25a81deadb29c$var$__PRIVATE_queryToTarget($31a25a81deadb29c$export$a93c5207d687da10(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $31a25a81deadb29c$var$__PRIVATE_ListenSequence.ce));
    }
}
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Au.isEmpty() || (r.Au.forEach((e, _)=>{
        o.push(r.bu(_, t, n).then((e)=>{
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const t = e ? !e.fromCache : n?.targetChanges.get(_.targetId)?.current;
                r.sharedClientState.updateQueryState(_.targetId, t ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $31a25a81deadb29c$var$__PRIVATE_LocalViewChanges.Es(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Ru.H_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$31a25a81deadb29c$var$PersistencePromise.forEach(t, (t)=>$31a25a81deadb29c$var$PersistencePromise.forEach(t.Ts, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$31a25a81deadb29c$var$PersistencePromise.forEach(t.Is, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Nt, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.vs.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.vs = n.vs.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Zt, "User change. New user:", t.toKey());
        const e = await $31a25a81deadb29c$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.yu.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.CANCELLED, t));
                });
            }), e.yu.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Ns);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = n.fu.get(t);
    if (r && r.Eu) return $31a25a81deadb29c$export$971d5caa766a69d7().add(r.key);
    {
        let e = $31a25a81deadb29c$export$971d5caa766a69d7();
        const r = n.Vu.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Au.get(t);
            e = e.unionWith(r.view.ou);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $31a25a81deadb29c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = await $31a25a81deadb29c$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.Tu(r);
    return n.isPrimaryClient && $31a25a81deadb29c$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.hu), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return $31a25a81deadb29c$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = $31a25a81deadb29c$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Xn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $31a25a81deadb29c$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $31a25a81deadb29c$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($31a25a81deadb29c$var$__PRIVATE_processUserCallback(i, t, r || null), $31a25a81deadb29c$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $31a25a81deadb29c$var$__PRIVATE_debugCast($31a25a81deadb29c$var$__PRIVATE_debugCast(e).mutationQueue).nr(t);
    }(i.localStore, t)) : $31a25a81deadb29c$export$3a6d5c9ae78a2c08(6720, "Unknown batchState", {
        vu: n
    }), await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Zt, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    if ($31a25a81deadb29c$var$__PRIVATE_ensureWatchCallbacks(n), $31a25a81deadb29c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.Su) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $31a25a81deadb29c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.Su = !0, await $31a25a81deadb29c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$31a25a81deadb29c$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.Su) {
        const e = [];
        let t = Promise.resolve();
        n.Vu.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($31a25a81deadb29c$var$__PRIVATE_removeAndCleanupTarget(n, i), $31a25a81deadb29c$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $31a25a81deadb29c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $31a25a81deadb29c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            t.fu.forEach((e, n)=>{
                $31a25a81deadb29c$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.gu.zr(), t.fu = new Map, t.mu = new $31a25a81deadb29c$var$SortedMap($31a25a81deadb29c$export$90a7f3efeed30595.comparator);
        }(n), n.Su = !1, await $31a25a81deadb29c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $31a25a81deadb29c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Vu.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $31a25a81deadb29c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $31a25a81deadb29c$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Au.get(e), n = await $31a25a81deadb29c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $31a25a81deadb29c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $31a25a81deadb29c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $31a25a81deadb29c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $31a25a81deadb29c$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Ru.H_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $31a25a81deadb29c$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $31a25a81deadb29c$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $31a25a81deadb29c$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $31a25a81deadb29c$var$__PRIVATE_debugCast($31a25a81deadb29c$var$__PRIVATE_debugCast(e).persistence).hs();
    }($31a25a81deadb29c$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    if (i.Su) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Zt, "Ignoring unexpected query state notification.");
    const s = i.Vu.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $31a25a81deadb29c$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $31a25a81deadb29c$var$__PRIVATE_queryCollectionGroup(s[0])), r = $31a25a81deadb29c$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $31a25a81deadb29c$export$9d398bebfec1c039.EMPTY_BYTE_STRING);
                await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $31a25a81deadb29c$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $31a25a81deadb29c$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $31a25a81deadb29c$export$3a6d5c9ae78a2c08(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.Su) {
        for (const e of t){
            if (r.Vu.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Zt, "Adding an already active target " + e);
                continue;
            }
            const t = await $31a25a81deadb29c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $31a25a81deadb29c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $31a25a81deadb29c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $31a25a81deadb29c$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $31a25a81deadb29c$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Vu.has(e) && // Release queries that are still active.
        await $31a25a81deadb29c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $31a25a81deadb29c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $31a25a81deadb29c$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($31a25a81deadb29c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $31a25a81deadb29c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $31a25a81deadb29c$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Ru.H_ = $31a25a81deadb29c$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Ru.Du = $31a25a81deadb29c$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $31a25a81deadb29c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $31a25a81deadb29c$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $31a25a81deadb29c$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $31a25a81deadb29c$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = $31a25a81deadb29c$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Pi.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($31a25a81deadb29c$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $31a25a81deadb29c$export$61196ced6d74a310(r, t.serializer);
            let s = await t.Fu();
            for(; s;){
                const e = await i.Ha(s);
                e && n._updateProgress(e), s = await t.Fu();
            }
            const o = await i.Xa(e.localStore);
            return await $31a25a81deadb29c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.eu, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Pi.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Ya);
        } catch (e) {
            return $31a25a81deadb29c$export$4c3d22f3d993c33f($31a25a81deadb29c$var$Zt, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $31a25a81deadb29c$export$d24c54395ce0c509 {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $31a25a81deadb29c$export$b4171a6734a65d42(e.databaseInfo.databaseId), this.sharedClientState = this.Mu(e), this.persistence = this.xu(e), await this.persistence.start(), this.localStore = this.Ou(e), this.gcScheduler = this.Nu(e, this.localStore), this.indexBackfillerScheduler = this.Bu(e, this.localStore);
    }
    Nu(e, t) {
        return null;
    }
    Bu(e, t) {
        return null;
    }
    Ou(e) {
        return $31a25a81deadb29c$var$__PRIVATE_newLocalStore(this.persistence, new $31a25a81deadb29c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    xu(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_MemoryPersistence($31a25a81deadb29c$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer);
    }
    Mu(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler?.stop(), this.indexBackfillerScheduler?.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$31a25a81deadb29c$export$d24c54395ce0c509.provider = {
    build: ()=>new $31a25a81deadb29c$export$d24c54395ce0c509
};
class $31a25a81deadb29c$export$8a5498727ef6be21 extends $31a25a81deadb29c$export$d24c54395ce0c509 {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Nu(e, t) {
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88(this.persistence.referenceDelegate instanceof $31a25a81deadb29c$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $31a25a81deadb29c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    xu(e) {
        const t = void 0 !== this.cacheSizeBytes ? $31a25a81deadb29c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $31a25a81deadb29c$var$LruParams.DEFAULT;
        return new $31a25a81deadb29c$var$__PRIVATE_MemoryPersistence((e)=>$31a25a81deadb29c$var$__PRIVATE_MemoryLruDelegate.Vi(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $31a25a81deadb29c$export$6554612db691658e extends $31a25a81deadb29c$export$d24c54395ce0c509 {
    constructor(e, t, n){
        super(), this.Lu = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Lu.initialize(this, e), // Enqueue writes from a previous session
        await $31a25a81deadb29c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Lu.syncEngine), await $31a25a81deadb29c$var$__PRIVATE_fillWritePipeline(this.Lu.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.zi(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    Ou(e) {
        return $31a25a81deadb29c$var$__PRIVATE_newLocalStore(this.persistence, new $31a25a81deadb29c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Nu(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $31a25a81deadb29c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Bu(e, t) {
        const n = new $31a25a81deadb29c$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $31a25a81deadb29c$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    xu(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $31a25a81deadb29c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $31a25a81deadb29c$var$LruParams.DEFAULT;
        return new $31a25a81deadb29c$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $31a25a81deadb29c$var$__PRIVATE_getWindow(), $31a25a81deadb29c$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Mu(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $31a25a81deadb29c$export$493d36ec626b6698 extends $31a25a81deadb29c$export$6554612db691658e {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.Lu = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Lu.syncEngine;
        this.sharedClientState instanceof $31a25a81deadb29c$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            bo: $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            Do: $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Co: $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            hs: $31a25a81deadb29c$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            So: $31a25a81deadb29c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.zi(async (e)=>{
            await $31a25a81deadb29c$var$__PRIVATE_syncEngineApplyPrimaryState(this.Lu.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Mu(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_getWindow();
        if (!$31a25a81deadb29c$var$__PRIVATE_WebStorageSharedClientState.v(t)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $31a25a81deadb29c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $31a25a81deadb29c$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $31a25a81deadb29c$export$2f6ca3d3b1f80bf5 {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$31a25a81deadb29c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $31a25a81deadb29c$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $31a25a81deadb29c$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $31a25a81deadb29c$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $31a25a81deadb29c$export$b4171a6734a65d42(e.databaseInfo.databaseId), n = $31a25a81deadb29c$var$__PRIVATE_newConnection(e.databaseInfo);
        return $31a25a81deadb29c$var$__PRIVATE_newDatastore(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $31a25a81deadb29c$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$31a25a81deadb29c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $31a25a81deadb29c$var$__PRIVATE_BrowserConnectivityMonitor.v() ? new $31a25a81deadb29c$var$__PRIVATE_BrowserConnectivityMonitor : new $31a25a81deadb29c$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $31a25a81deadb29c$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.Su = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$jt, "RemoteStore shutting down."), t.da.add(5 /* OfflineCause.Shutdown */ ), await $31a25a81deadb29c$var$__PRIVATE_disableNetworkInternal(t), t.fa.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.ga.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), this.datastore?.terminate(), this.eventManager?.terminate();
    }
}
$31a25a81deadb29c$export$2f6ca3d3b1f80bf5.provider = {
    build: ()=>new $31a25a81deadb29c$export$2f6ca3d3b1f80bf5
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $31a25a81deadb29c$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $31a25a81deadb29c$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.ku(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.ku(this.observer.error, e) : $31a25a81deadb29c$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Ku() {
        this.muted = !0;
    }
    ku(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $31a25a81deadb29c$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.qu = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $31a25a81deadb29c$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Uu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.$u().then((e)=>{
            e && e.Ga() ? this.metadata.resolve(e.Qa.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(e?.Qa)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.qu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Fu() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.$u();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async $u() {
        const e = await this.Wu();
        if (null === e) return null;
        const t = this.Uu.decode(e), n = Number(t);
        isNaN(n) && this.Qu(`length string (${t}) is not valid number`);
        const r = await this.Gu(n);
        return new $31a25a81deadb29c$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ zu() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async Wu() {
        for(; this.zu() < 0;){
            if (await this.ju()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.zu();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.Qu("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Gu(e) {
        for(; this.buffer.length < e;)await this.ju() && this.Qu("Reached the end of bundle when more is expected.");
        const t = this.Uu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    Qu(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.qu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async ju() {
        const e = await this.qu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $31a25a81deadb29c$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.Fu();
        if (!n || !n.Ga()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(n?.Qa)}`);
        this.metadata = n;
        do n = this.Fu(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ Ju() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ Fu() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.Wu(), t = this.Gu(e);
        return new $31a25a81deadb29c$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length - how many characters to read.
     * @returns a string parsed from the bundle.
     */ Gu(e) {
        if (this.cursor + e > this.bundleData.length) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ Wu() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $31a25a81deadb29c$var$Transaction {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$31a25a81deadb29c$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.jo("BatchGetDocuments", n.serializer.databaseId, $31a25a81deadb29c$export$db202ddc8be9136.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $31a25a81deadb29c$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $31a25a81deadb29c$export$7a0bdf7d4a91ea88(!!t, 55234, {
                    key: e
                }), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $31a25a81deadb29c$export$34aec0b863436764(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $31a25a81deadb29c$export$90a7f3efeed30595.fromPath(t);
            this.mutations.push(new $31a25a81deadb29c$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$31a25a81deadb29c$var$toMutation(n.serializer, e))
            };
            await n.Wo("Commit", n.serializer.databaseId, $31a25a81deadb29c$export$db202ddc8be9136.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(50498, {
                Hu: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $31a25a81deadb29c$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($31a25a81deadb29c$var$SnapshotVersion.min()) ? $31a25a81deadb29c$export$78acf4525d8a74c4.exists(!1) : $31a25a81deadb29c$export$78acf4525d8a74c4.updateTime(t) : $31a25a81deadb29c$export$78acf4525d8a74c4.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($31a25a81deadb29c$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $31a25a81deadb29c$export$78acf4525d8a74c4.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $31a25a81deadb29c$export$78acf4525d8a74c4.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $31a25a81deadb29c$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Zu = n.maxAttempts, this.M_ = new $31a25a81deadb29c$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ Xu() {
        this.Zu -= 1, this.Yu();
    }
    Yu() {
        this.M_.p_(async ()=>{
            const e = new $31a25a81deadb29c$var$Transaction(this.datastore), t = this.ec(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.tc(e);
                    }));
            }).catch((e)=>{
                this.tc(e);
            });
        });
    }
    ec(e) {
        try {
            const t = this.updateFunction(e);
            return !$31a25a81deadb29c$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    tc(e) {
        this.Zu > 0 && this.nc(e) ? (this.Zu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Yu(), Promise.resolve()))) : this.deferred.reject(e);
    }
    nc(e) {
        if ("FirebaseError" === e?.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$31a25a81deadb29c$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$Xt = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $31a25a81deadb29c$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, /**
     * Exposed for testing
     */ r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this._databaseInfo = r, this.user = $31a25a81deadb29c$var$User.UNAUTHENTICATED, this.clientId = $31a25a81deadb29c$export$a07804094c3ecf2d.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this._databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $31a25a81deadb29c$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $31a25a81deadb29c$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $31a25a81deadb29c$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $31a25a81deadb29c$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $31a25a81deadb29c$var$__PRIVATE_ensureOfflineComponents(e);
    $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$31a25a81deadb29c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$31a25a81deadb29c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $31a25a81deadb29c$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Using user provided OfflineComponentProvider");
            try {
                await $31a25a81deadb29c$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION || e.code === $31a25a81deadb29c$export$f1e1789686576879.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $31a25a81deadb29c$export$4c3d22f3d993c33f("Error using user provided cache. Falling back to memory cache: " + n), await $31a25a81deadb29c$var$__PRIVATE_setOfflineComponentProvider(e, new $31a25a81deadb29c$export$d24c54395ce0c509);
            }
        } else $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Using default OfflineComponentProvider"), await $31a25a81deadb29c$var$__PRIVATE_setOfflineComponentProvider(e, new $31a25a81deadb29c$export$8a5498727ef6be21(void 0));
    }
    return e._offlineComponents;
}
async function $31a25a81deadb29c$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Using user provided OnlineComponentProvider"), await $31a25a81deadb29c$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Xt, "Using default OnlineComponentProvider"), await $31a25a81deadb29c$var$__PRIVATE_setOnlineComponentProvider(e, new $31a25a81deadb29c$export$2f6ca3d3b1f80bf5))), e._onlineComponents;
}
function $31a25a81deadb29c$var$__PRIVATE_getPersistence(e) {
    return $31a25a81deadb29c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $31a25a81deadb29c$var$__PRIVATE_getLocalStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $31a25a81deadb29c$var$__PRIVATE_getRemoteStore(e) {
    return $31a25a81deadb29c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $31a25a81deadb29c$var$__PRIVATE_getSyncEngine(e) {
    return $31a25a81deadb29c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $31a25a81deadb29c$var$__PRIVATE_getDatastore$1(e) {
    return $31a25a81deadb29c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $31a25a81deadb29c$var$__PRIVATE_getEventManager(e) {
    const t = await $31a25a81deadb29c$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $31a25a81deadb29c$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $31a25a81deadb29c$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $31a25a81deadb29c$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $31a25a81deadb29c$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $31a25a81deadb29c$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $31a25a81deadb29c$var$__PRIVATE_getPersistence(e), n = await $31a25a81deadb29c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            return t.da.delete(0 /* OfflineCause.UserDisabled */ ), $31a25a81deadb29c$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $31a25a81deadb29c$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $31a25a81deadb29c$var$__PRIVATE_getPersistence(e), n = await $31a25a81deadb29c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            t.da.add(0 /* OfflineCause.UserDisabled */ ), await $31a25a81deadb29c$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.ga.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $31a25a81deadb29c$export$c3950d9923825c02(e, t, n, r) {
    const i = new $31a25a81deadb29c$var$__PRIVATE_AsyncObserver(r), s = new $31a25a81deadb29c$var$__PRIVATE_QueryListener(t, i, n);
    return e.asyncQueue.enqueueAndForget(async ()=>$31a25a81deadb29c$var$__PRIVATE_eventManagerListen(await $31a25a81deadb29c$var$__PRIVATE_getEventManager(e), s)), ()=>{
        i.Ku(), e.asyncQueue.enqueueAndForget(async ()=>$31a25a81deadb29c$var$__PRIVATE_eventManagerUnlisten(await $31a25a81deadb29c$var$__PRIVATE_getEventManager(e), s));
    };
}
function $31a25a81deadb29c$export$6559d589eb85fbb6(e, t) {
    const n = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $31a25a81deadb29c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $31a25a81deadb29c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $31a25a81deadb29c$export$ce26c07117d59d6a(e, t, n = {}) {
    const r = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $31a25a81deadb29c$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Ku(), t.enqueueAndForget(()=>$31a25a81deadb29c$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $31a25a81deadb29c$var$__PRIVATE_QueryListener($31a25a81deadb29c$export$a93c5207d687da10(n.path), s, {
                includeMetadataChanges: !0,
                Wa: !0
            });
            return $31a25a81deadb29c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $31a25a81deadb29c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $31a25a81deadb29c$export$a8550f7dbe79f93a(e, t) {
    const n = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $31a25a81deadb29c$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $31a25a81deadb29c$var$__PRIVATE_View(t, r.ks), s = i._u(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $31a25a81deadb29c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $31a25a81deadb29c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $31a25a81deadb29c$export$efca4cbe5dd06740(e, t, n = {}) {
    const r = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $31a25a81deadb29c$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Ku(), t.enqueueAndForget(()=>$31a25a81deadb29c$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $31a25a81deadb29c$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                Wa: !0
            });
            return $31a25a81deadb29c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $31a25a81deadb29c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $31a25a81deadb29c$export$2329c99376c9d0a4(e, t, n) {
    const r = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $31a25a81deadb29c$var$__PRIVATE_getDatastore$1(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                const r = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), { request: i, gt: s, parent: o } = $31a25a81deadb29c$var$__PRIVATE_toRunAggregationQueryRequest(r.serializer, $31a25a81deadb29c$var$__PRIVATE_queryToAggregateTarget(t), n);
                r.connection.Ko || delete i.parent;
                const _ = (await r.jo("RunAggregationQuery", r.serializer.databaseId, o, i, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $31a25a81deadb29c$export$7a0bdf7d4a91ea88(1 === _.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const a = _[0].result?.aggregateFields;
                return Object.keys(a).reduce((e, t)=>(e[s[t]] = a[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $31a25a81deadb29c$export$d22783b3c2400a3a(e, t) {
    const n = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        try {
            const r = await $31a25a81deadb29c$var$__PRIVATE_getDatastore$1(e);
            n.resolve(async function __PRIVATE_invokeExecutePipeline(e, t) {
                const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = {
                    database: $31a25a81deadb29c$var$__PRIVATE_getEncodedDatabaseId(n.serializer),
                    structuredPipeline: t._toProto(n.serializer)
                }, i = await n.jo("ExecutePipeline", n.serializer.databaseId, $31a25a81deadb29c$export$db202ddc8be9136.emptyPath(), r), s = [];
                return i.forEach((e)=>{
                    if (e.results && 0 !== e.results.length) return e.results.forEach((t)=>s.push($31a25a81deadb29c$var$__PRIVATE_fromPipelineResponse(n.serializer, e, t)));
                    s.push($31a25a81deadb29c$var$__PRIVATE_fromPipelineResponse(n.serializer, e));
                }), s;
            }(r, t));
        } catch (e) {
            n.reject(e);
        }
    }), n.promise;
}
function $31a25a81deadb29c$export$2219238a014317b0(e, t) {
    const n = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>$31a25a81deadb29c$var$__PRIVATE_syncEngineWrite(await $31a25a81deadb29c$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
}
function $31a25a81deadb29c$export$555508cbc6add439(e, t) {
    const n = new $31a25a81deadb29c$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $31a25a81deadb29c$var$__PRIVATE_debugCast(e).xa.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $31a25a81deadb29c$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Ku(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $31a25a81deadb29c$var$__PRIVATE_debugCast(e).xa.delete(t);
            })(await $31a25a81deadb29c$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $31a25a81deadb29c$export$3c2fa207a37baaea(e, t, n) {
    const r = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        const i = await $31a25a81deadb29c$var$__PRIVATE_getDatastore$1(e);
        new $31a25a81deadb29c$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Xu();
    }), r.promise;
}
function $31a25a81deadb29c$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $31a25a81deadb29c$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $31a25a81deadb29c$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $31a25a81deadb29c$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $31a25a81deadb29c$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $31a25a81deadb29c$export$b4171a6734a65d42(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $31a25a81deadb29c$var$__PRIVATE_syncEngineLoadBundle(await $31a25a81deadb29c$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $31a25a81deadb29c$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Pi.getNamedQuery(e, t));
        })(await $31a25a81deadb29c$var$__PRIVATE_getLocalStore(e), t));
}
function $31a25a81deadb29c$export$3466f893ebf79586(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $31a25a81deadb29c$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $31a25a81deadb29c$export$f38c853ae54ed474(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $31a25a81deadb29c$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$31a25a81deadb29c$var$PersistencePromise.waitFor(i)));
        })(await $31a25a81deadb29c$var$__PRIVATE_getLocalStore(e), t));
}
function $31a25a81deadb29c$export$ab83b03e4111b1d0(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $31a25a81deadb29c$var$__PRIVATE_debugCast(e).Cs.As = t;
        })(await $31a25a81deadb29c$var$__PRIVATE_getLocalStore(e), t));
}
function $31a25a81deadb29c$export$3b513254972cfc9c(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $31a25a81deadb29c$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $31a25a81deadb29c$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $31a25a81deadb29c$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$Yt = "ComponentProvider", $31a25a81deadb29c$var$en = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ function $31a25a81deadb29c$var$__PRIVATE_makeDatabaseInfo(e, t, n, r, i) {
    return new $31a25a81deadb29c$var$DatabaseInfo(e, t, n, i.host, i.ssl, i.experimentalForceLongPolling, i.experimentalAutoDetectLongPolling, $31a25a81deadb29c$var$__PRIVATE_cloneLongPollingOptions(i.experimentalLongPollingOptions), i.useFetchStreams, i.isUsingEmulator, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $31a25a81deadb29c$var$tn = "firestore.googleapis.com", $31a25a81deadb29c$var$nn = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $31a25a81deadb29c$var$FirestoreSettingsImpl {
    constructor(e){
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $31a25a81deadb29c$var$tn, this.ssl = $31a25a81deadb29c$var$nn;
        } else this.host = e.host, this.ssl = e.ssl ?? $31a25a81deadb29c$var$nn;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $31a25a81deadb29c$var$St;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $31a25a81deadb29c$var$Ct) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $31a25a81deadb29c$export$23ebac1979863676("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $31a25a81deadb29c$var$__PRIVATE_cloneLongPollingOptions(e.experimentalLongPollingOptions ?? {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $31a25a81deadb29c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $31a25a81deadb29c$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $31a25a81deadb29c$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $31a25a81deadb29c$export$158acd800e1ef08b;
            switch(e.type){
                case "firstParty":
                    return new $31a25a81deadb29c$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $31a25a81deadb29c$var$en.get(e);
            t && ($31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Yt, "Removing Datastore"), $31a25a81deadb29c$var$en.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $31a25a81deadb29c$export$f96d196f7728bb5(e, t, n, r = {}) {
    e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$var$Firestore$1);
    const i = (0, $029952e65115eee5$export$5b4d24b45140ad90)(t), s = e._getSettings(), o = {
        ...s,
        emulatorOptions: e._getEmulatorOptions()
    }, _ = `${t}:${n}`;
    i && (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`https://${_}`), s.host !== $31a25a81deadb29c$var$tn && s.host !== _ && $31a25a81deadb29c$export$4c3d22f3d993c33f("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const a = {
        ...s,
        host: _,
        ssl: i,
        emulatorOptions: r
    };
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $029952e65115eee5$export$9cb4719e2e525b7a)(a, o) && (e._setSettings(a), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $31a25a81deadb29c$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $029952e65115eee5$export$367bf224123348f1)(r.mockUserToken, e._app?.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $31a25a81deadb29c$var$User(i);
        }
        e._authCredentials = new $31a25a81deadb29c$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $31a25a81deadb29c$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $31a25a81deadb29c$export$3722cfe417b6ed86 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $31a25a81deadb29c$export$3722cfe417b6ed86(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $31a25a81deadb29c$export$96f57966bedc81b4 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $31a25a81deadb29c$export$d66dc83d8cfc8dd(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $31a25a81deadb29c$export$96f57966bedc81b4(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $31a25a81deadb29c$export$96f57966bedc81b4._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($31a25a81deadb29c$export$9bb611d729802a56(t, $31a25a81deadb29c$export$96f57966bedc81b4._jsonSchema)) return new $31a25a81deadb29c$export$96f57966bedc81b4(e, n || null, new $31a25a81deadb29c$export$90a7f3efeed30595($31a25a81deadb29c$export$db202ddc8be9136.fromString(t.referencePath)));
    }
}
$31a25a81deadb29c$export$96f57966bedc81b4._jsonSchemaVersion = "firestore/documentReference/1.0", $31a25a81deadb29c$export$96f57966bedc81b4._jsonSchema = {
    type: $31a25a81deadb29c$export$ffb5f4729a158638("string", $31a25a81deadb29c$export$96f57966bedc81b4._jsonSchemaVersion),
    referencePath: $31a25a81deadb29c$export$ffb5f4729a158638("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $31a25a81deadb29c$export$d66dc83d8cfc8dd extends $31a25a81deadb29c$export$3722cfe417b6ed86 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $31a25a81deadb29c$export$a93c5207d687da10(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $31a25a81deadb29c$export$96f57966bedc81b4(this.firestore, /* converter= */ null, new $31a25a81deadb29c$export$90a7f3efeed30595(e));
    }
    withConverter(e) {
        return new $31a25a81deadb29c$export$d66dc83d8cfc8dd(this.firestore, e, this._path);
    }
}
function $31a25a81deadb29c$export$7060da4b5db56fb9(e) {
    return e instanceof $31a25a81deadb29c$export$d66dc83d8cfc8dd;
}
function $31a25a81deadb29c$export$c03999cb2f36933f(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), $31a25a81deadb29c$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $31a25a81deadb29c$var$Firestore$1) {
        const r = $31a25a81deadb29c$export$db202ddc8be9136.fromString(t, ...n);
        return $31a25a81deadb29c$var$__PRIVATE_validateCollectionPath(r), new $31a25a81deadb29c$export$d66dc83d8cfc8dd(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $31a25a81deadb29c$export$96f57966bedc81b4 || e instanceof $31a25a81deadb29c$export$d66dc83d8cfc8dd)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($31a25a81deadb29c$export$db202ddc8be9136.fromString(t, ...n));
        return $31a25a81deadb29c$var$__PRIVATE_validateCollectionPath(r), new $31a25a81deadb29c$export$d66dc83d8cfc8dd(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $31a25a81deadb29c$export$2ed0fc6709e59212(e, t) {
    if (e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$var$Firestore$1), $31a25a81deadb29c$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $31a25a81deadb29c$export$3722cfe417b6ed86(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_QueryImpl($31a25a81deadb29c$export$db202ddc8be9136.emptyPath(), e);
    }(t));
}
function $31a25a81deadb29c$export$2e2af4578d910ddf(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $31a25a81deadb29c$export$a07804094c3ecf2d.newId()), $31a25a81deadb29c$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $31a25a81deadb29c$var$Firestore$1) {
        const r = $31a25a81deadb29c$export$db202ddc8be9136.fromString(t, ...n);
        return $31a25a81deadb29c$var$__PRIVATE_validateDocumentPath(r), new $31a25a81deadb29c$export$96f57966bedc81b4(e, /* converter= */ null, new $31a25a81deadb29c$export$90a7f3efeed30595(r));
    }
    {
        if (!(e instanceof $31a25a81deadb29c$export$96f57966bedc81b4 || e instanceof $31a25a81deadb29c$export$d66dc83d8cfc8dd)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Expected first argument to doc() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($31a25a81deadb29c$export$db202ddc8be9136.fromString(t, ...n));
        return $31a25a81deadb29c$var$__PRIVATE_validateDocumentPath(r), new $31a25a81deadb29c$export$96f57966bedc81b4(e.firestore, e instanceof $31a25a81deadb29c$export$d66dc83d8cfc8dd ? e.converter : null, new $31a25a81deadb29c$export$90a7f3efeed30595(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $31a25a81deadb29c$export$a17c37559e1db147(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), (e instanceof $31a25a81deadb29c$export$96f57966bedc81b4 || e instanceof $31a25a81deadb29c$export$d66dc83d8cfc8dd) && (t instanceof $31a25a81deadb29c$export$96f57966bedc81b4 || t instanceof $31a25a81deadb29c$export$d66dc83d8cfc8dd) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $31a25a81deadb29c$export$d141bba7fdc215a3(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), e instanceof $31a25a81deadb29c$export$3722cfe417b6ed86 && t instanceof $31a25a81deadb29c$export$3722cfe417b6ed86 && e.firestore === t.firestore && $31a25a81deadb29c$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$rn = "AsyncQueue";
class $31a25a81deadb29c$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.rc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.sc = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.oc = [], // visible for testing
        this._c = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.ac = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.uc = !1, // List of TimerIds to fast-forward delays for.
        this.cc = [], // Backoff timer used to schedule retries for retryable operations
        this.M_ = new $31a25a81deadb29c$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.lc = ()=>{
            const e = $31a25a81deadb29c$var$getDocument();
            e && $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$rn, "Visibility state changed to " + e.visibilityState), this.M_.w_();
        }, this.hc = e;
        const t = $31a25a81deadb29c$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.lc);
    }
    get isShuttingDown() {
        return this.sc;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.Pc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Tc(e);
    }
    enterRestrictedMode(e) {
        if (!this.sc) {
            this.sc = !0, this.uc = e || !1;
            const t = $31a25a81deadb29c$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.lc);
        }
    }
    enqueue(e) {
        if (this.Pc(), this.sc) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
        return this.Tc(()=>this.sc && this.uc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.rc.push(e), this.Ic()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async Ic() {
        if (0 !== this.rc.length) {
            try {
                await this.rc[0](), this.rc.shift(), this.M_.reset();
            } catch (e) {
                if (!$31a25a81deadb29c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$rn, "Operation failed with retryable error: " + e);
            }
            this.rc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.M_.p_(()=>this.Ic());
        }
    }
    Tc(e) {
        const t = this.hc.then(()=>(this.ac = !0, e().catch((e)=>{
                this._c = e, this.ac = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $31a25a81deadb29c$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $31a25a81deadb29c$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.ac = !1, e))));
        return this.hc = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.Pc(), // Fast-forward delays for timerIds that have been overridden.
        this.cc.indexOf(e) > -1 && (t = 0);
        const r = $31a25a81deadb29c$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.Ec(e));
        return this.oc.push(r), r;
    }
    Pc() {
        this._c && $31a25a81deadb29c$export$3a6d5c9ae78a2c08(47125, {
            Rc: $31a25a81deadb29c$var$__PRIVATE_getMessageOrStack(this._c)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async Ac() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.hc, await e;
        while (e !== this.hc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Vc(e) {
        for (const t of this.oc)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ dc(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Ac().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.oc.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.oc)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.Ac();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ mc(e) {
        this.cc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ Ec(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.oc.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.oc.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $31a25a81deadb29c$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ class $31a25a81deadb29c$export$28f7fcd39efa255 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $31a25a81deadb29c$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $31a25a81deadb29c$export$1fbe638ecf81657e = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $31a25a81deadb29c$export$d66501df72047452 extends $31a25a81deadb29c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $31a25a81deadb29c$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = r?.name || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $31a25a81deadb29c$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $31a25a81deadb29c$export$527e9aa3390079e9(e, t, n) {
    n || (n = $31a25a81deadb29c$var$it);
    const r = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $31a25a81deadb29c$var$Ct) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $029952e65115eee5$export$5b4d24b45140ad90)(t.host) && (0, $029952e65115eee5$export$c0f0d0ce4283a937)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $31a25a81deadb29c$export$1a8f5705751d8277(e, n) {
    const r = "object" == typeof e ? e : (0, $5e587d655f0a08bb$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : n || $31a25a81deadb29c$var$it, s = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $029952e65115eee5$export$a3febcf1f14a3a0c)("firestore");
        e && $31a25a81deadb29c$export$f96d196f7728bb5(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $31a25a81deadb29c$export$df995fae86a55f06(e) {
    if (e._terminated) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $31a25a81deadb29c$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $31a25a81deadb29c$var$__PRIVATE_configureFirestore(e) {
    const t = e._freezeSettings(), n = $31a25a81deadb29c$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e._app?.options.appId || "", e._persistenceKey, e._app?.options.apiKey, t);
    e._componentsProvider || t.localCache?._offlineComponentProvider && t.localCache?._onlineComponentProvider && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new $31a25a81deadb29c$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = e?._online.build();
        return {
            _offline: e?._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $31a25a81deadb29c$export$317a3d46287192d8(e, t) {
    $31a25a81deadb29c$export$4c3d22f3d993c33f("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $31a25a81deadb29c$var$__PRIVATE_setPersistenceProviders(e, $31a25a81deadb29c$export$2f6ca3d3b1f80bf5.provider, {
        build: (e)=>new $31a25a81deadb29c$export$6554612db691658e(e, n.cacheSizeBytes, t?.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $31a25a81deadb29c$export$1ee57be6f6687d2c(e) {
    $31a25a81deadb29c$export$4c3d22f3d993c33f("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $31a25a81deadb29c$var$__PRIVATE_setPersistenceProviders(e, $31a25a81deadb29c$export$2f6ca3d3b1f80bf5.provider, {
        build: (e)=>new $31a25a81deadb29c$export$493d36ec626b6698(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $31a25a81deadb29c$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$export$d66501df72047452))._firestoreClient || e._terminated) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $31a25a81deadb29c$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $31a25a81deadb29c$export$faec65b429be379(e) {
    if (e._initialized && !e._terminated) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$31a25a81deadb29c$var$__PRIVATE_SimpleDb.v()) return Promise.resolve();
                const t = e + $31a25a81deadb29c$var$Ot;
                await $31a25a81deadb29c$var$__PRIVATE_SimpleDb.delete(t);
            }($31a25a81deadb29c$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $31a25a81deadb29c$export$53c86fa97d611818(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $31a25a81deadb29c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$31a25a81deadb29c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $31a25a81deadb29c$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($31a25a81deadb29c$export$df995fae86a55f06(e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$export$d66501df72047452)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $31a25a81deadb29c$export$9d0e2d13d04f7070(e) {
    return $31a25a81deadb29c$var$__PRIVATE_firestoreClientEnableNetwork($31a25a81deadb29c$export$df995fae86a55f06(e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$export$d66501df72047452)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $31a25a81deadb29c$export$d377dcb2b61d6c4e(e) {
    return $31a25a81deadb29c$var$__PRIVATE_firestoreClientDisableNetwork($31a25a81deadb29c$export$df995fae86a55f06(e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$export$d66501df72047452)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $31a25a81deadb29c$export$d29e374196577086(e) {
    return (0, $5e587d655f0a08bb$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $31a25a81deadb29c$export$a9c996f45e5784d0(e, t) {
    const n = $31a25a81deadb29c$export$df995fae86a55f06(e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$export$d66501df72047452)), r = new $31a25a81deadb29c$export$28f7fcd39efa255;
    return $31a25a81deadb29c$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $31a25a81deadb29c$export$7910e0436ed8d1de(e, t) {
    return $31a25a81deadb29c$var$__PRIVATE_firestoreClientGetNamedQuery($31a25a81deadb29c$export$df995fae86a55f06(e = $31a25a81deadb29c$export$4a5767248b18ef41(e, $31a25a81deadb29c$export$d66501df72047452)), t).then((t)=>t ? new $31a25a81deadb29c$export$3722cfe417b6ed86(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $31a25a81deadb29c$export$ef35774e6d314e91 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $31a25a81deadb29c$export$ef35774e6d314e91($31a25a81deadb29c$export$9d398bebfec1c039.fromBase64String(e));
        } catch (e) {
            throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $31a25a81deadb29c$export$ef35774e6d314e91($31a25a81deadb29c$export$9d398bebfec1c039.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $31a25a81deadb29c$export$ef35774e6d314e91._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json - a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($31a25a81deadb29c$export$9bb611d729802a56(e, $31a25a81deadb29c$export$ef35774e6d314e91._jsonSchema)) return $31a25a81deadb29c$export$ef35774e6d314e91.fromBase64String(e.bytes);
    }
}
$31a25a81deadb29c$export$ef35774e6d314e91._jsonSchemaVersion = "firestore/bytes/1.0", $31a25a81deadb29c$export$ef35774e6d314e91._jsonSchema = {
    type: $31a25a81deadb29c$export$ffb5f4729a158638("string", $31a25a81deadb29c$export$ef35774e6d314e91._jsonSchemaVersion),
    bytes: $31a25a81deadb29c$export$ffb5f4729a158638("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $31a25a81deadb29c$export$8743009a87fcb00f {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $31a25a81deadb29c$export$cf2f7c5792f80b46(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $31a25a81deadb29c$export$667d3bf0c5f83305() {
    return new $31a25a81deadb29c$export$8743009a87fcb00f($31a25a81deadb29c$export$39c1cc7c062529d4);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $31a25a81deadb29c$export$92108d983e8ee699 {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $31a25a81deadb29c$export$9fa96a7d116ea3ce {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $31a25a81deadb29c$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $31a25a81deadb29c$export$9fa96a7d116ea3ce._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json - a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($31a25a81deadb29c$export$9bb611d729802a56(e, $31a25a81deadb29c$export$9fa96a7d116ea3ce._jsonSchema)) return new $31a25a81deadb29c$export$9fa96a7d116ea3ce(e.latitude, e.longitude);
    }
}
$31a25a81deadb29c$export$9fa96a7d116ea3ce._jsonSchemaVersion = "firestore/geoPoint/1.0", $31a25a81deadb29c$export$9fa96a7d116ea3ce._jsonSchema = {
    type: $31a25a81deadb29c$export$ffb5f4729a158638("string", $31a25a81deadb29c$export$9fa96a7d116ea3ce._jsonSchemaVersion),
    latitude: $31a25a81deadb29c$export$ffb5f4729a158638("number"),
    longitude: $31a25a81deadb29c$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 */ class $31a25a81deadb29c$export$91c6e00c14e7e6fd {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $31a25a81deadb29c$export$91c6e00c14e7e6fd._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json - a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($31a25a81deadb29c$export$9bb611d729802a56(e, $31a25a81deadb29c$export$91c6e00c14e7e6fd._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $31a25a81deadb29c$export$91c6e00c14e7e6fd(e.vectorValues);
            throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$31a25a81deadb29c$export$91c6e00c14e7e6fd._jsonSchemaVersion = "firestore/vectorValue/1.0", $31a25a81deadb29c$export$91c6e00c14e7e6fd._jsonSchema = {
    type: $31a25a81deadb29c$export$ffb5f4729a158638("string", $31a25a81deadb29c$export$91c6e00c14e7e6fd._jsonSchemaVersion),
    vectorValues: $31a25a81deadb29c$export$ffb5f4729a158638("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31a25a81deadb29c$var$on = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $31a25a81deadb29c$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $31a25a81deadb29c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $31a25a81deadb29c$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $31a25a81deadb29c$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $31a25a81deadb29c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(40011, {
                dataSource: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $31a25a81deadb29c$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.fc(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get dataSource() {
        return this.settings.dataSource;
    }
    /** Returns a new context with the specified settings overwritten. */ i(e) {
        return new $31a25a81deadb29c$var$__PRIVATE_ParseContextImpl({
            ...this.settings,
            ...e
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    yc(e) {
        const t = this.path?.child(e), n = this.i({
            path: t,
            arrayElement: !1
        });
        return n.wc(e), n;
    }
    Sc(e) {
        const t = this.path?.child(e), n = this.i({
            path: t,
            arrayElement: !1
        });
        return n.fc(), n;
    }
    bc(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.i({
            path: void 0,
            arrayElement: !0
        });
    }
    Dc(e) {
        return $31a25a81deadb29c$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.hasConverter || !1, this.path, this.settings.targetDoc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    fc() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.wc(this.path.get(e));
    }
    wc(e) {
        if (0 === e.length) throw this.Dc("Document fields must not be empty");
        if ($31a25a81deadb29c$var$__PRIVATE_isWrite(this.dataSource) && $31a25a81deadb29c$var$on.test(e)) throw this.Dc('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $31a25a81deadb29c$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $31a25a81deadb29c$export$b4171a6734a65d42(e);
    }
    /** Creates a new top-level parse context. */ V(e, t, n, r = !1) {
        return new $31a25a81deadb29c$var$__PRIVATE_ParseContextImpl({
            dataSource: e,
            methodName: t,
            targetDoc: n,
            path: $31a25a81deadb29c$export$cf2f7c5792f80b46.emptyPath(),
            arrayElement: !1,
            hasConverter: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $31a25a81deadb29c$export$39b482c5e57630a8(e) {
    const t = e._freezeSettings(), n = $31a25a81deadb29c$export$b4171a6734a65d42(e._databaseId);
    return new $31a25a81deadb29c$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $31a25a81deadb29c$export$71cec2538cb2c617(e, t, n, r, i, s = {}) {
    const o = e.V(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $31a25a81deadb29c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $31a25a81deadb29c$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $31a25a81deadb29c$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $31a25a81deadb29c$export$35e795649ee09318(t, r, n);
            if (!o.contains(i)) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $31a25a81deadb29c$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $31a25a81deadb29c$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $31a25a81deadb29c$var$ParsedSetData(new $31a25a81deadb29c$export$c4ce752e73470fba(_), a, u);
}
class $31a25a81deadb29c$var$__PRIVATE_DeleteFieldValueImpl extends $31a25a81deadb29c$export$92108d983e8ee699 {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.dataSource) throw 1 /* UserDataSource.Update */  === e.dataSource ? e.Dc(`${this._methodName}() can only appear at the top level of your update data`) : e.Dc(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $31a25a81deadb29c$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $31a25a81deadb29c$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $31a25a81deadb29c$var$__PRIVATE_ParseContextImpl({
        dataSource: 3 /* UserDataSource.Argument */ ,
        targetDoc: t.settings.targetDoc,
        methodName: e._methodName,
        arrayElement: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $31a25a81deadb29c$var$__PRIVATE_ServerTimestampFieldValueImpl extends $31a25a81deadb29c$export$92108d983e8ee699 {
    _toFieldTransform(e) {
        return new $31a25a81deadb29c$var$FieldTransform(e.path, new $31a25a81deadb29c$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $31a25a81deadb29c$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $31a25a81deadb29c$var$__PRIVATE_ArrayUnionFieldValueImpl extends $31a25a81deadb29c$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$31a25a81deadb29c$export$c18d01048907ea92(e, t)), r = new $31a25a81deadb29c$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $31a25a81deadb29c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this.vc, e.vc);
    }
}
class $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $31a25a81deadb29c$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$31a25a81deadb29c$export$c18d01048907ea92(e, t)), r = new $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $31a25a81deadb29c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this.vc, e.vc);
    }
}
class $31a25a81deadb29c$var$__PRIVATE_NumericIncrementFieldValueImpl extends $31a25a81deadb29c$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.Fc = t;
    }
    _toFieldTransform(e) {
        const t = new $31a25a81deadb29c$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $31a25a81deadb29c$export$62d08d6fa708df47(e.serializer, this.Fc));
        return new $31a25a81deadb29c$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $31a25a81deadb29c$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Fc === e.Fc;
    }
}
/** Parse update data from an update() call. */ function $31a25a81deadb29c$export$3d8c2f653ac9d0b9(e, t, n, r) {
    const i = e.V(1 /* UserDataSource.Update */ , t, n);
    $31a25a81deadb29c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $31a25a81deadb29c$export$c4ce752e73470fba.empty();
    $31a25a81deadb29c$var$forEach(r, (e, r)=>{
        const _ = $31a25a81deadb29c$export$f787f51d84a910ad(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(r);
        const a = i.Sc(_);
        if (r instanceof $31a25a81deadb29c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $31a25a81deadb29c$export$c18d01048907ea92(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $31a25a81deadb29c$var$FieldMask(s);
    return new $31a25a81deadb29c$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $31a25a81deadb29c$export$dc98b0b04f4c7758(e, t, n, r, i, s) {
    const o = e.V(1 /* UserDataSource.Update */ , t, n), _ = [
        $31a25a81deadb29c$export$35e795649ee09318(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($31a25a81deadb29c$export$35e795649ee09318(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $31a25a81deadb29c$export$c4ce752e73470fba.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$31a25a81deadb29c$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n);
        const r = o.Sc(t);
        if (n instanceof $31a25a81deadb29c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $31a25a81deadb29c$export$c18d01048907ea92(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $31a25a81deadb29c$var$FieldMask(u);
    return new $31a25a81deadb29c$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $31a25a81deadb29c$export$dda1d9f60106f0e9(e, t, n, r = !1) {
    return $31a25a81deadb29c$export$c18d01048907ea92(n, e.V(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $31a25a81deadb29c$export$c18d01048907ea92(e, t) {
    if ($31a25a81deadb29c$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return $31a25a81deadb29c$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $31a25a81deadb29c$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $31a25a81deadb29c$export$92108d983e8ee699) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$31a25a81deadb29c$var$__PRIVATE_isWrite(t.dataSource)) throw t.Dc(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.Dc(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.arrayElement && 4 /* UserDataSource.ArrayArgument */  !== t.dataSource) throw t.Dc("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $31a25a81deadb29c$export$c18d01048907ea92(i, t.bc(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $31a25a81deadb29c$export$62d08d6fa708df47(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $31a25a81deadb29c$export$3d12bd131bb975d1.fromDate(e);
            return {
                timestampValue: $31a25a81deadb29c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $31a25a81deadb29c$export$3d12bd131bb975d1) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $31a25a81deadb29c$export$3d12bd131bb975d1(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $31a25a81deadb29c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $31a25a81deadb29c$export$9fa96a7d116ea3ce) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $31a25a81deadb29c$export$ef35774e6d314e91) return {
            bytesValue: $31a25a81deadb29c$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $31a25a81deadb29c$export$96f57966bedc81b4) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.Dc(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $31a25a81deadb29c$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $31a25a81deadb29c$export$91c6e00c14e7e6fd) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = e instanceof $31a25a81deadb29c$export$91c6e00c14e7e6fd ? e.toArray() : e, r = {
                fields: {
                    [$31a25a81deadb29c$var$st]: {
                        stringValue: $31a25a81deadb29c$var$at
                    },
                    [$31a25a81deadb29c$var$ut]: {
                        arrayValue: {
                            values: n.map((e)=>{
                                if ("number" != typeof e) throw t.Dc("VectorValues must only contain numeric values.");
                                return $31a25a81deadb29c$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: r
            };
        }(e, t);
        if ($31a25a81deadb29c$var$__PRIVATE_isProtoValueSerializable(e)) return e._toProto(t.serializer);
        throw t.Dc(`Unsupported field value: ${$31a25a81deadb29c$export$efccba1c4a2ef57b(e)}`);
    }(e, t);
}
function $31a25a81deadb29c$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $31a25a81deadb29c$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $31a25a81deadb29c$var$forEach(e, (e, r)=>{
        const i = $31a25a81deadb29c$export$c18d01048907ea92(r, t.yc(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $31a25a81deadb29c$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $31a25a81deadb29c$export$3d12bd131bb975d1 || e instanceof $31a25a81deadb29c$export$9fa96a7d116ea3ce || e instanceof $31a25a81deadb29c$export$ef35774e6d314e91 || e instanceof $31a25a81deadb29c$export$96f57966bedc81b4 || e instanceof $31a25a81deadb29c$export$92108d983e8ee699 || e instanceof $31a25a81deadb29c$export$91c6e00c14e7e6fd || $31a25a81deadb29c$var$__PRIVATE_isProtoValueSerializable(e));
}
function $31a25a81deadb29c$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$31a25a81deadb29c$var$__PRIVATE_looksLikeJsonObject(n) || !$31a25a81deadb29c$export$7f557e5eb95176c2(n)) {
        const r = $31a25a81deadb29c$export$efccba1c4a2ef57b(n);
        throw "an object" === r ? t.Dc(e + " a custom object") : t.Dc(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $31a25a81deadb29c$export$35e795649ee09318(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)) instanceof $31a25a81deadb29c$export$8743009a87fcb00f) return t._internalPath;
    if ("string" == typeof t) return $31a25a81deadb29c$export$f787f51d84a910ad(e, t);
    throw $31a25a81deadb29c$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $31a25a81deadb29c$var$_n = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $31a25a81deadb29c$export$f787f51d84a910ad(e, t, n) {
    if (t.search($31a25a81deadb29c$var$_n) >= 0) throw $31a25a81deadb29c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $31a25a81deadb29c$export$8743009a87fcb00f(...t.split("."))._internalPath;
    } catch (r) {
        throw $31a25a81deadb29c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $31a25a81deadb29c$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $31a25a81deadb29c$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
function $31a25a81deadb29c$export$5521614468b862fb(e) {
    return "function" == typeof e._readUserData;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class $31a25a81deadb29c$export$ebd11618f299a286 {
    convertValue(e, t = "none") {
        switch($31a25a81deadb29c$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($31a25a81deadb29c$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $31a25a81deadb29c$export$3a6d5c9ae78a2c08(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $31a25a81deadb29c$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        const t = e.fields?.[$31a25a81deadb29c$var$ut].arrayValue?.values?.map((e)=>$31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $31a25a81deadb29c$export$91c6e00c14e7e6fd(t);
    }
    convertGeoPoint(e) {
        return new $31a25a81deadb29c$export$9fa96a7d116ea3ce($31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.latitude), $31a25a81deadb29c$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $31a25a81deadb29c$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($31a25a81deadb29c$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $31a25a81deadb29c$var$__PRIVATE_normalizeTimestamp(e);
        return new $31a25a81deadb29c$export$3d12bd131bb975d1(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $31a25a81deadb29c$export$db202ddc8be9136.fromString(e);
        $31a25a81deadb29c$export$7a0bdf7d4a91ea88($31a25a81deadb29c$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $31a25a81deadb29c$export$890c4ad488842ce7(n.get(1), n.get(3)), i = new $31a25a81deadb29c$export$90a7f3efeed30595(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $31a25a81deadb29c$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$export$7f8ddf7c7c20b3cd extends $31a25a81deadb29c$export$ebd11618f299a286 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $31a25a81deadb29c$export$ef35774e6d314e91(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $31a25a81deadb29c$export$96f57966bedc81b4(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $31a25a81deadb29c$export$738ab4df8bf92ae9() {
    return new $31a25a81deadb29c$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $31a25a81deadb29c$export$fef3dfd9bad05307() {
    return new $31a25a81deadb29c$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $31a25a81deadb29c$export$9f4f30ee63539e24(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $31a25a81deadb29c$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $31a25a81deadb29c$export$91477dc880baac21(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $31a25a81deadb29c$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $31a25a81deadb29c$export$e171bab687b50e0(e) {
    return new $31a25a81deadb29c$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $31a25a81deadb29c$export$2ec5befb9e6c97d4(e) {
    return new $31a25a81deadb29c$export$91c6e00c14e7e6fd(e);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$export$f074adc9fbd50943 {
    constructor(e){
        this.optionDefinitions = e;
    }
    _getKnownOptions(e, t) {
        const n = $31a25a81deadb29c$export$c4ce752e73470fba.empty();
        // SERIALIZE KNOWN OPTIONS
        for(const r in this.optionDefinitions)if (this.optionDefinitions.hasOwnProperty(r)) {
            const i = this.optionDefinitions[r];
            if (r in e) {
                const s = e[r];
                let o;
                if (i.nestedOptions && $31a25a81deadb29c$export$7f557e5eb95176c2(s)) o = {
                    mapValue: {
                        fields: new $31a25a81deadb29c$export$f074adc9fbd50943(i.nestedOptions).getOptionsProto(t, s)
                    }
                };
                else s && (o = $31a25a81deadb29c$export$c18d01048907ea92(s, t) ?? void 0);
                o && n.set($31a25a81deadb29c$export$cf2f7c5792f80b46.fromServerFormat(i.serverName), o);
            }
        }
        return n;
    }
    getOptionsProto(e, t, n) {
        const r = this._getKnownOptions(t, e);
        // APPLY OPTIONS OVERRIDES
        if (n) {
            const t = new Map($31a25a81deadb29c$export$a9c23c6ac3fc3eca(n, (t, n)=>[
                    $31a25a81deadb29c$export$cf2f7c5792f80b46.fromServerFormat(n),
                    void 0 !== t ? $31a25a81deadb29c$export$c18d01048907ea92(t, e) : null
                ]));
            r.setAll(t);
        }
        // Return MapValue from `result` or empty map value
        return r.value.mapValue.fields ?? {};
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $31a25a81deadb29c$export$136fd86de524d3c2 {
    constructor(e = {}, t = {}){
        this.Mc = e, this.xc = t, this.Oc = new $31a25a81deadb29c$export$f074adc9fbd50943({
            indexMode: {
                serverName: "index_mode"
            }
        });
    }
    _readUserData(e) {
        this.proto = this.Oc.getOptionsProto(e, this.Mc, this.xc);
    }
}
class $31a25a81deadb29c$export$a36fb7d24305ed9d {
    constructor(e, t){
        this.pipeline = e, this.options = t;
    }
    _toProto(e) {
        return {
            pipeline: this.pipeline._toProto(e),
            options: this.options.proto
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $31a25a81deadb29c$export$b9a6b53f9be3734(e) {
    const t = $31a25a81deadb29c$export$df995fae86a55f06($31a25a81deadb29c$export$4a5767248b18ef41(e.firestore, $31a25a81deadb29c$export$d66501df72047452)), n = t._onlineComponents?.datastore.serializer;
    return void 0 === n ? null : $31a25a81deadb29c$var$__PRIVATE_toQueryTarget(n, $31a25a81deadb29c$var$__PRIVATE_queryToTarget(e._query)).ft;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $31a25a81deadb29c$export$a33b77bbdbb8366c(e, t) {
    const n = $31a25a81deadb29c$export$a9c23c6ac3fc3eca(t, (e, t)=>new $31a25a81deadb29c$export$7a38258bbe170828(t, e.aggregateType, e._internalFieldPath)), r = $31a25a81deadb29c$export$df995fae86a55f06($31a25a81deadb29c$export$4a5767248b18ef41(e.firestore, $31a25a81deadb29c$export$d66501df72047452)), i = r._onlineComponents?.datastore.serializer;
    return void 0 === i ? null : $31a25a81deadb29c$var$__PRIVATE_toRunAggregationQueryRequest(i, $31a25a81deadb29c$var$__PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ !0).request;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `ExecutePipelineRequest` representation of the given query.
 * Returns `null` if the Firestore client associated with the given query has
 * not been initialized or has been terminated.
 *
 * @param pipeline - The Pipeline to convert to proto representation.
 */ function $31a25a81deadb29c$export$55ff3cc1821e8445(e) {
    if (!e._db) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "This pipeline was created without a database and cannot be serialized for execution.");
    const t = $31a25a81deadb29c$export$4a5767248b18ef41(e._db, $31a25a81deadb29c$export$d66501df72047452), n = $31a25a81deadb29c$export$39b482c5e57630a8(t).V(3 /* UserDataSource.Argument */ , "_internalPipelineToExecutePipelineRequestProto");
    e._readUserData(n);
    const r = /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function __PRIVATE_getDatastore(e) {
        if (e._terminated) throw new $31a25a81deadb29c$export$4368d992c4eafac0($31a25a81deadb29c$export$f1e1789686576879.FAILED_PRECONDITION, "The client has already been terminated.");
        if (!$31a25a81deadb29c$var$en.has(e)) {
            $31a25a81deadb29c$export$21579262ef46735b($31a25a81deadb29c$var$Yt, "Initializing Datastore");
            const t = $31a25a81deadb29c$var$__PRIVATE_newConnection($31a25a81deadb29c$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e.app.options.appId || "", e._persistenceKey, e.app.options.apiKey, e._freezeSettings())), n = $31a25a81deadb29c$export$b4171a6734a65d42(e._databaseId), r = $31a25a81deadb29c$var$__PRIVATE_newDatastore(e._authCredentials, e._appCheckCredentials, t, n);
            $31a25a81deadb29c$var$en.set(e, r);
        }
        return $31a25a81deadb29c$var$en.get(e);
    }(t), i = r.serializer;
    if (void 0 === i) return null;
    const s = new $31a25a81deadb29c$export$a36fb7d24305ed9d(e, new $31a25a81deadb29c$export$136fd86de524d3c2);
    return {
        database: $31a25a81deadb29c$var$__PRIVATE_getEncodedDatabaseId(i),
        structuredPipeline: s._toProto(i)
    };
}






const $a33cbddcd7bfa0a9$var$Ut = "@firebase/firestore", $a33cbddcd7bfa0a9$var$Ht = "4.14.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $a33cbddcd7bfa0a9$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType - Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath - Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(t = "count", e){
        this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = t;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $a33cbddcd7bfa0a9$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the snapshot as a proto value.
     *
     * @returns An `Object` containing all fields in the snapshot.
     */ _fieldsProto() {
        // Return the cloned value to prevent manipulation of the Snapshot's data
        return new (0, $31a25a81deadb29c$export$c4ce752e73470fba)({
            mapValue: {
                fields: this._data
            }
        }).clone().value.mapValue.fields;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, r, s){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = r, this._converter = s;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new (0, $31a25a81deadb29c$export$96f57966bedc81b4)(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $a33cbddcd7bfa0a9$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the document as a proto Value. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ _fieldsProto() {
        // Return a cloned value to prevent manipulation of the Snapshot's data
        return this._document?.data.clone().value.mapValue.fields ?? void 0;
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field((0, $31a25a81deadb29c$export$35e795649ee09318)("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $a33cbddcd7bfa0a9$var$QueryDocumentSnapshot$1 extends $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
function $a33cbddcd7bfa0a9$export$2fa187e846a241c4(t, e, ...n) {
    let r = [];
    e instanceof $a33cbddcd7bfa0a9$var$AppliableConstraint && r.push(e), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(t) {
        const e = t.filter((t)=>t instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2).length, n = t.filter((t)=>t instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && n > 0) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const e of r)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$f765fc5789dfd439 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$f765fc5789dfd439(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(t._query, e), new (0, $31a25a81deadb29c$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $31a25a81deadb29c$export$2d1720544b23b823)(t._query, e));
    }
    _parse(t) {
        const e = (0, $31a25a81deadb29c$export$39b482c5e57630a8)(t.firestore), n = function __PRIVATE_newQueryFilter(t, e, n, r, s, a, o) {
            let i;
            if (s.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === a || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === a) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid Query. You can't perform '${a}' queries on documentId().`);
                if ("in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a) {
                    $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(o, a);
                    const e = [];
                    for (const n of o)e.push($a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, t, n));
                    i = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else i = $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, t, o);
            } else "in" /* Operator.IN */  !== a && "not-in" /* Operator.NOT_IN */  !== a && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== a || $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(o, a), i = (0, $31a25a81deadb29c$export$dda1d9f60106f0e9)(n, e, o, /* allowArrays= */ "in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a);
            const c = (0, $31a25a81deadb29c$export$23f2a1d2818174ef).create(s, a, i);
            return c;
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$9c59b80dda569a6e(t, e, n) {
    const r = e, s = (0, $31a25a81deadb29c$export$35e795649ee09318)("where", t);
    return $a33cbddcd7bfa0a9$export$f765fc5789dfd439._create(s, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2 extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : (0, $31a25a81deadb29c$export$e7094788287c5e9b).create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function __PRIVATE_validateNewFilter(t, e) {
            let n = t;
            const r = e.getFlattenedFilters();
            for (const t of r)$a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(n, t), n = (0, $31a25a81deadb29c$export$2d1720544b23b823)(n, t);
        }(t._query, e), new (0, $31a25a81deadb29c$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $31a25a81deadb29c$export$2d1720544b23b823)(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("or", t)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("and", t)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function __PRIVATE_newQueryOrderBy(t, e, n) {
            if (null !== t.startAt) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new (0, $31a25a81deadb29c$export$306ddfe3a8403e2)(e, n);
            return r;
        }(t._query, this._field, this._direction);
        return new (0, $31a25a81deadb29c$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $31a25a81deadb29c$export$342063e11d6c3cad)(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, r = (0, $31a25a81deadb29c$export$35e795649ee09318)("orderBy", t);
    return $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $a33cbddcd7bfa0a9$export$49bb5356ca788047 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$49bb5356ca788047(t, e, n);
    }
    _apply(t) {
        return new (0, $31a25a81deadb29c$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $31a25a81deadb29c$export$882b5998b3b9117c)(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$ee37e834aaad6f7e(t) {
    return (0, $31a25a81deadb29c$export$953cecd6e717a553)("limit", t), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f823b3589f69d3b8(t) {
    return (0, $31a25a81deadb29c$export$953cecd6e717a553)("limitToLast", t), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$d92e2830aca1d816 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$d92e2830aca1d816(t, e, n);
    }
    _apply(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $31a25a81deadb29c$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $31a25a81deadb29c$export$7ccc53e8f1e7dfc5)(t._query, e));
    }
}
function $a33cbddcd7bfa0a9$export$859941c5fc8eba6b(...t) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ !0);
}
function $a33cbddcd7bfa0a9$export$dd8dee5f7b804673(...t) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$fd1782fd870d1e06 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$fd1782fd870d1e06(t, e, n);
    }
    _apply(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $31a25a81deadb29c$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $31a25a81deadb29c$export$ae1af26003f05816)(t._query, e));
    }
}
function $a33cbddcd7bfa0a9$export$57203950645b8b11(...t) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ !1);
}
function $a33cbddcd7bfa0a9$export$28ec54a8428bdb3f(...t) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, e, n, r) {
    if (n[0] = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $a33cbddcd7bfa0a9$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(t, e, n, r, s) {
        if (!r) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const a = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of (0, $31a25a81deadb29c$export$9e5f44173e64f162)(t))if (n.field.isKeyField()) a.push((0, $31a25a81deadb29c$export$43caf9889c228507)(e, r.key));
        else {
            const t = r.data.field(n.field);
            if ((0, $31a25a81deadb29c$export$2408f22a0fab9ae5)(t)) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            a.push(t);
        }
        return new (0, $31a25a81deadb29c$export$625550452a3fa3ec)(a, s);
    }(t._query, t.firestore._databaseId, e, n[0]._document, r);
    {
        const s = (0, $31a25a81deadb29c$export$39b482c5e57630a8)(t.firestore);
        return function __PRIVATE_newQueryBoundFromFields(t, e, n, r, s, a) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (s.length > o.length) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const i = [];
            for(let a = 0; a < s.length; a++){
                const c = s[a];
                if (o[a].field.isKeyField()) {
                    if ("string" != typeof c) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof c}`);
                    if (!(0, $31a25a81deadb29c$export$3b14a55fb2447963)(t) && -1 !== c.indexOf("/")) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${c}' contains a slash.`);
                    const n = t.path.child((0, $31a25a81deadb29c$export$db202ddc8be9136).fromString(c));
                    if (!(0, $31a25a81deadb29c$export$90a7f3efeed30595).isDocumentKey(n)) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const s = new (0, $31a25a81deadb29c$export$90a7f3efeed30595)(n);
                    i.push((0, $31a25a81deadb29c$export$43caf9889c228507)(e, s));
                } else {
                    const t = (0, $31a25a81deadb29c$export$dda1d9f60106f0e9)(n, r, c);
                    i.push(t);
                }
            }
            return new (0, $31a25a81deadb29c$export$625550452a3fa3ec)(i, a);
        }(t._query, t.firestore._databaseId, s, e, n, r);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(t, e, n) {
    if ("string" == typeof (n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!(0, $31a25a81deadb29c$export$3b14a55fb2447963)(e) && -1 !== n.indexOf("/")) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = e.path.child((0, $31a25a81deadb29c$export$db202ddc8be9136).fromString(n));
        if (!(0, $31a25a81deadb29c$export$90a7f3efeed30595).isDocumentKey(r)) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return (0, $31a25a81deadb29c$export$43caf9889c228507)(t, new (0, $31a25a81deadb29c$export$90a7f3efeed30595)(r));
    }
    if (n instanceof (0, $31a25a81deadb29c$export$96f57966bedc81b4)) return (0, $31a25a81deadb29c$export$43caf9889c228507)(t, n._key);
    throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${(0, $31a25a81deadb29c$export$efccba1c4a2ef57b)(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(t, e) {
    const n = function __PRIVATE_findOpInsideFilters(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function __PRIVATE_conflictingOps(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint(t, e) {
    if (!(e instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439 || e instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2)) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t, e, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, r;
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter extends (0, $31a25a81deadb29c$export$ebd11618f299a286) {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new (0, $31a25a81deadb29c$export$ef35774e6d314e91)(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new (0, $31a25a81deadb29c$export$96f57966bedc81b4)(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to sum across the result set.
 */ function $a33cbddcd7bfa0a9$export$8a63f25cc62965f1(t) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("sum", (0, $31a25a81deadb29c$export$35e795649ee09318)("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to average across the result set.
 */ function $a33cbddcd7bfa0a9$export$cc6710ee5f037d57(t) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("avg", (0, $31a25a81deadb29c$export$35e795649ee09318)("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $a33cbddcd7bfa0a9$export$85b9a36db797e02b() {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left - Compare this AggregateField to the `right`.
 * @param right - Compare this AggregateField to the `left`.
 */ function $a33cbddcd7bfa0a9$export$31fa8ec66e0239ad(t, e) {
    return t instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && e instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && t.aggregateType === e.aggregateType && t._internalFieldPath?.canonicalString() === e._internalFieldPath?.canonicalString();
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $a33cbddcd7bfa0a9$export$104f59389a332076(t, e) {
    return (0, $31a25a81deadb29c$export$d141bba7fdc215a3)(t.query, e.query) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $a33cbddcd7bfa0a9$export$b1de1b12889d0afb(t) {
    return $a33cbddcd7bfa0a9$export$a51511de2fae49b3(t, {
        count: $a33cbddcd7bfa0a9$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set is aggregated over.
 * @param aggregateSpec - An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $a33cbddcd7bfa0a9$export$a51511de2fae49b3(t, e) {
    const n = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), r = (0, $31a25a81deadb29c$export$df995fae86a55f06)(n), s = (0, $31a25a81deadb29c$export$a9c23c6ac3fc3eca)(e, (t, e)=>new (0, $31a25a81deadb29c$export$7a38258bbe170828)(e, t.aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (0, $31a25a81deadb29c$export$2329c99376c9d0a4)(r, t._query, s).then((e)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult - Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(t, e, n) {
            const r = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(t), s = new $a33cbddcd7bfa0a9$export$40257fef64be808b(e, r, n);
            return s;
        })(n, t, e));
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = (0, $31a25a81deadb29c$export$2f6ca3d3b1f80bf5).provider, this._offlineComponentProvider = t?.garbageCollector ? t.garbageCollector._offlineComponentProvider : {
            build: ()=>new (0, $31a25a81deadb29c$export$8a5498727ef6be21)(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(t){
        let e;
        this.kind = "persistent", t?.tabManager ? (t.tabManager._initialize(t), e = t.tabManager) : (e = $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = (0, $31a25a81deadb29c$export$d24c54395ce0c509).provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new (0, $31a25a81deadb29c$export$8a5498727ef6be21)(t)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $a33cbddcd7bfa0a9$export$574728f3be606189() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $a33cbddcd7bfa0a9$export$2340f88905cc0c23(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl(t?.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $a33cbddcd7bfa0a9$export$72ef71adb739a32c(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $a33cbddcd7bfa0a9$export$51b321e43d5331d5(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl(t);
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $31a25a81deadb29c$export$2f6ca3d3b1f80bf5).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $31a25a81deadb29c$export$6554612db691658e)(e, t?.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $31a25a81deadb29c$export$2f6ca3d3b1f80bf5).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $31a25a81deadb29c$export$493d36ec626b6698)(e, t?.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings - Configures the created tab manager.
 */ function $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl(t?.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $a33cbddcd7bfa0a9$export$57e9d290b0b4dc04() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$zt = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $a33cbddcd7bfa0a9$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 extends $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(t, e, n, r, s, a){
        super(t, e, n, r, a), this._firestore = t, this._firestoreImpl = t, this.metadata = s;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field((0, $31a25a81deadb29c$export$35e795649ee09318)("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const t = this._document, e = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (e.type = $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion, e.bundle = "", e.bundleSource = "DocumentSnapshot", e.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument()) return e;
        this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous");
        return e.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), e;
    }
}
function $a33cbddcd7bfa0a9$export$bbac1bdeb8972634(t, e, n) {
    if ((0, $31a25a81deadb29c$export$9bb611d729802a56)(e, $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema)) {
        if (e.bundle === $a33cbddcd7bfa0a9$var$zt) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $31a25a81deadb29c$export$b4171a6734a65d42)(t._databaseId), s = (0, $31a25a81deadb29c$export$3466f893ebf79586)(e.bundle, r), a = s.Ju(), o = new (0, $31a25a81deadb29c$export$61196ced6d74a310)(s.getMetadata(), r);
        for (const t of a)o.Ha(t);
        // Ensure that we have the correct number of documents in the bundle.
        const i = o.documents;
        if (1 !== i.length) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${i.length} documents.`);
        // Build out the internal document data.
        const c = (0, $31a25a81deadb29c$export$3a1a48c8f6ef640e)(r, i[0].document), h = new (0, $31a25a81deadb29c$export$90a7f3efeed30595)((0, $31a25a81deadb29c$export$db202ddc8be9136).fromString(e.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(t, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(t), h, c, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema = {
    type: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string", "DocumentSnapshot"),
    bundleName: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string"),
    bundle: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string")
};
class $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c extends $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $a33cbddcd7bfa0a9$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, r){
        this._firestore = t, this._userDataWriter = e, this._snapshot = r, this.metadata = new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let s = -1, a = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (s = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), a = n.indexOf(e.doc.key)), {
                        type: $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(e.type),
                        doc: r,
                        oldIndex: s,
                        newIndex: a
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = {};
        t.type = $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = (0, $31a25a81deadb29c$export$a07804094c3ecf2d).newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const e = [], n = [], r = [];
        return this.docs.forEach((t)=>{
            null !== t._document && (e.push(t._document), n.push(this._userDataWriter.convertObjectMap(t._document.data.value.mapValue.fields, "previous")), r.push(t.ref.path));
        }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
    }
}
function $a33cbddcd7bfa0a9$export$5bed7af38da9d026(t, e, n) {
    if ((0, $31a25a81deadb29c$export$9bb611d729802a56)(e, $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema)) {
        if (e.bundle === $a33cbddcd7bfa0a9$var$zt) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $31a25a81deadb29c$export$b4171a6734a65d42)(t._databaseId), s = (0, $31a25a81deadb29c$export$3466f893ebf79586)(e.bundle, r), a = s.Ju(), o = new (0, $31a25a81deadb29c$export$61196ced6d74a310)(s.getMetadata(), r);
        for (const t of a)o.Ha(t);
        if (1 !== o.queries.length) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const i = (0, $31a25a81deadb29c$export$56c0d5a1e737357d)(o.queries[0].bundledQuery), c = o.documents;
        // Construct the arrays of document data for the query.
        let h = new (0, $31a25a81deadb29c$export$25ce5a424b770e84);
        c.map((t)=>{
            const e = (0, $31a25a81deadb29c$export$3a1a48c8f6ef640e)(r, t.document);
            h = h.add(e);
        });
        // Create a view snapshot of the query and documents.
        const d = (0, $31a25a81deadb29c$export$e7c866399fa523f5).fromInitialDocuments(i, h, (0, $31a25a81deadb29c$export$971d5caa766a69d7)(), /* fromCache= */ !1, /* hasCachedResults= */ !1), p = new (0, $31a25a81deadb29c$export$3722cfe417b6ed86)(t, n || null, i);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $a33cbddcd7bfa0a9$export$8f21149d8133945c(t, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(t), p, d);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return (0, $31a25a81deadb29c$export$3a6d5c9ae78a2c08)(61501, {
                type: t
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $a33cbddcd7bfa0a9$export$f243a5d948512846(t, e) {
    return t instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 && e instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && e instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && t._firestore === e._firestore && (0, $31a25a81deadb29c$export$d141bba7fdc215a3)(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema = {
    type: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string", "QuerySnapshot"),
    bundleName: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string"),
    bundle: (0, $31a25a81deadb29c$export$ffb5f4729a158638)("string")
};
const $a33cbddcd7bfa0a9$var$Yt = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $a33cbddcd7bfa0a9$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = (0, $31a25a81deadb29c$export$39b482c5e57630a8)(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $31a25a81deadb29c$export$71cec2538cb2c617)(this._dataReader, "WriteBatch.set", r._key, s, null !== r.converter, n);
        return this._mutations.push(a.toMutation(r._key, (0, $31a25a81deadb29c$export$78acf4525d8a74c4).none())), this;
    }
    update(t, e, n, ...r) {
        this._verifyNotCommitted();
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $31a25a81deadb29c$export$8743009a87fcb00f) ? (0, $31a25a81deadb29c$export$dc98b0b04f4c7758)(this._dataReader, "WriteBatch.update", s._key, e, n, r) : (0, $31a25a81deadb29c$export$3d8c2f653ac9d0b9)(this._dataReader, "WriteBatch.update", s._key, e), this._mutations.push(a.toMutation(s._key, (0, $31a25a81deadb29c$export$78acf4525d8a74c4).exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        return this._mutations = this._mutations.concat(new (0, $31a25a81deadb29c$export$34aec0b863436764)(e._key, (0, $31a25a81deadb29c$export$78acf4525d8a74c4).none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, e) {
    if ((t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)).firestore !== e) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $a33cbddcd7bfa0a9$var$Transaction$1 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = (0, $31a25a81deadb29c$export$39b482c5e57630a8)(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return (0, $31a25a81deadb29c$export$3a6d5c9ae78a2c08)(24041);
            const r = t[0];
            if (r.isFoundDocument()) return new $a33cbddcd7bfa0a9$var$DocumentSnapshot$1(this._firestore, n, r.key, r, e.converter);
            if (r.isNoDocument()) return new $a33cbddcd7bfa0a9$var$DocumentSnapshot$1(this._firestore, n, e._key, null, e.converter);
            throw (0, $31a25a81deadb29c$export$3a6d5c9ae78a2c08)(18433, {
                doc: r
            });
        });
    }
    set(t, e, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $31a25a81deadb29c$export$71cec2538cb2c617)(this._dataReader, "Transaction.set", r._key, s, null !== r.converter, n);
        return this._transaction.set(r._key, a), this;
    }
    update(t, e, n, ...r) {
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $31a25a81deadb29c$export$8743009a87fcb00f) ? (0, $31a25a81deadb29c$export$dc98b0b04f4c7758)(this._dataReader, "Transaction.update", s._key, e, n, r) : (0, $31a25a81deadb29c$export$3d8c2f653ac9d0b9)(this._dataReader, "Transaction.update", s._key, e), this._transaction.update(s._key, a), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $a33cbddcd7bfa0a9$export$febc5573c75cefb0 extends $a33cbddcd7bfa0a9$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), n = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(this._firestore);
        return super.get(t).then((t)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $a33cbddcd7bfa0a9$export$3c54e006bf9c93b7(t, e, n) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$d66501df72047452));
    const r = {
        ...$a33cbddcd7bfa0a9$var$Yt,
        ...n
    };
    !function __PRIVATE_validateTransactionOptions(t) {
        if (t.maxAttempts < 1) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    const s = (0, $31a25a81deadb29c$export$df995fae86a55f06)(t);
    return (0, $31a25a81deadb29c$export$3c2fa207a37baaea)(s, (n)=>e(new $a33cbddcd7bfa0a9$export$febc5573c75cefb0(t, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$11eb3b5ef9574821(t) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$96f57966bedc81b4));
    const e = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(e);
    return (0, $31a25a81deadb29c$export$ce26c07117d59d6a)(n, t._key).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$a58bd92642f7fb58(t) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$96f57966bedc81b4));
    const e = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(e), r = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(e);
    return (0, $31a25a81deadb29c$export$6559d589eb85fbb6)(n, t._key).then((n)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(e, r, t._key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$35dd759aed9686b4(t) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$96f57966bedc81b4));
    const e = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(e);
    return (0, $31a25a81deadb29c$export$ce26c07117d59d6a)(n, t._key, {
        source: "server"
    }).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$81d3477bd73c86ef(t) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$3722cfe417b6ed86));
    const e = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(e), r = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(e);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query), (0, $31a25a81deadb29c$export$efca4cbe5dd06740)(n, t._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$3fd010f18eac1dd(t) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$3722cfe417b6ed86));
    const e = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(e), r = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(e);
    return (0, $31a25a81deadb29c$export$a8550f7dbe79f93a)(n, t._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$ec7d9e44f349c77b(t) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$3722cfe417b6ed86));
    const e = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(e), r = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(e);
    return (0, $31a25a81deadb29c$export$efca4cbe5dd06740)(n, t._query, {
        source: "server"
    }).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
function $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12(t, e, n) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$96f57966bedc81b4));
    const r = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e, n), o = (0, $31a25a81deadb29c$export$39b482c5e57630a8)(r);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(r, [
        (0, $31a25a81deadb29c$export$71cec2538cb2c617)(o, "setDoc", t._key, s, null !== t.converter, n).toMutation(t._key, (0, $31a25a81deadb29c$export$78acf4525d8a74c4).none())
    ]);
}
function $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2(t, e, n, ...r) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$96f57966bedc81b4));
    const s = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), o = (0, $31a25a81deadb29c$export$39b482c5e57630a8)(s);
    let i;
    i = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $31a25a81deadb29c$export$8743009a87fcb00f) ? (0, $31a25a81deadb29c$export$dc98b0b04f4c7758)(o, "updateDoc", t._key, e, n, r) : (0, $31a25a81deadb29c$export$3d8c2f653ac9d0b9)(o, "updateDoc", t._key, e);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(s, [
        i.toMutation(t._key, (0, $31a25a81deadb29c$export$78acf4525d8a74c4).exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully deleted from the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error deleting the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given data _will_ be immediately deleted from the local cache and will be
 * reflected in future "get" operations as if it had been successfully
 * deleted from the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be deleted from the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the document to delete.
 * @returns A `Promise` that resolves once the document has been successfully
 * deleted from the backend or rejects once the backend reports an error
 * deleting the document.
 */ function $a33cbddcd7bfa0a9$export$a4f20481fae8f78b(t) {
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613((0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), [
        new (0, $31a25a81deadb29c$export$34aec0b863436764)(t._key, (0, $31a25a81deadb29c$export$78acf4525d8a74c4).none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully created to the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error creating the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given document _will_ be immediately created in the local cache and will be
 * incorporated into future "get" operations as if it had been successfully
 * created in the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be created in the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` that resolves once the docoument has been successfully
 * created in the backend or rejects once the backend reports an error creating
 * the document.
 */ function $a33cbddcd7bfa0a9$export$a13890143fb1c2dd(t, e) {
    const n = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), r = (0, $31a25a81deadb29c$export$2e2af4578d910ddf)(t), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e), o = (0, $31a25a81deadb29c$export$39b482c5e57630a8)(t.firestore);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(n, [
        (0, $31a25a81deadb29c$export$71cec2538cb2c617)(o, "addDoc", r._key, s, null !== t.converter, {}).toMutation(r._key, (0, $31a25a81deadb29c$export$78acf4525d8a74c4).exists(!1))
    ]).then(()=>r);
}
function $a33cbddcd7bfa0a9$export$d36370812fb26935(t, ...e) {
    // onSnapshot for Query or Document.
    t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t);
    let n = {
        includeMetadataChanges: !1,
        source: "default"
    }, r = 0;
    "object" != typeof e[r] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e[r]) || (n = e[r++]);
    const s = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e[r])) {
        const t = e[r];
        e[r] = t.next?.bind(t), e[r + 1] = t.error?.bind(t), e[r + 2] = t.complete?.bind(t);
    }
    let o, i, c;
    if (t instanceof (0, $31a25a81deadb29c$export$96f57966bedc81b4)) i = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), c = (0, $31a25a81deadb29c$export$a93c5207d687da10)(t._key.path), o = {
        next: (n)=>{
            e[r] && e[r]($a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(i, t, n));
        },
        error: e[r + 1],
        complete: e[r + 2]
    };
    else {
        const n = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$3722cfe417b6ed86));
        i = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(n.firestore, (0, $31a25a81deadb29c$export$d66501df72047452)), c = n._query;
        const s = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(i);
        o = {
            next: (t)=>{
                e[r] && e[r](new $a33cbddcd7bfa0a9$export$8f21149d8133945c(i, s, n, t));
            },
            error: e[r + 1],
            complete: e[r + 2]
        }, $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query);
    }
    const h = (0, $31a25a81deadb29c$export$df995fae86a55f06)(i);
    return (0, $31a25a81deadb29c$export$c3950d9923825c02)(h, c, s, o);
}
function $a33cbddcd7bfa0a9$export$a1ef90ed3b4a87fa(t, e, ...n) {
    const r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), s = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(t) {
        const e = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in t)) {
                e.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = t[r];
            if ("string" != typeof n) {
                e.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                e.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? e.bundle = n : "bundleName" === r ? e.bundleName = n : "bundleSource" === r && (e.bundleSource = n);
        }
        return e;
    }(e);
    if (s.error) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, s.error);
    let a, o = 0;
    if ("object" != typeof n[o] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o]) || (a = n[o++]), "QuerySnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $31a25a81deadb29c$export$a9c996f45e5784d0)(t, e.bundle);
            return i.then(()=>(0, $31a25a81deadb29c$export$7910e0436ed8d1de)(t, e.bundleName)).then((t)=>{
                if (t && !o) s && t.withConverter(s), a = $a33cbddcd7bfa0a9$export$d36370812fb26935(t, n || {}, r);
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    if ("DocumentSnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $31a25a81deadb29c$export$a9c996f45e5784d0)(t, e.bundle);
            return i.then(()=>{
                if (!o) {
                    const o = new (0, $31a25a81deadb29c$export$96f57966bedc81b4)(t, s || null, (0, $31a25a81deadb29c$export$90a7f3efeed30595).fromPath(e.bundleName));
                    a = $a33cbddcd7bfa0a9$export$d36370812fb26935(o, n || {}, r);
                }
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, `unsupported bundle source: ${s.bundleSource}`);
}
function $a33cbddcd7bfa0a9$export$9dff4f5aba83e348(t, e) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$d66501df72047452));
    const n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(t), r = $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e) ? e : {
        next: e
    };
    return (0, $31a25a81deadb29c$export$555508cbc6add439)(n, r);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $a33cbddcd7bfa0a9$export$1945f8fec9dda613(t, e) {
    const n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(t);
    return (0, $31a25a81deadb29c$export$2219238a014317b0)(n, e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(t, e, n) {
    const r = n.docs.get(e._key), s = new (0, $31a25a81deadb29c$export$7f8ddf7c7c20b3cd)(t);
    return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(t, s, e._key, r, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
function $a33cbddcd7bfa0a9$export$44cd1c9d57edd9b1(t) {
    return t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$d66501df72047452)), (0, $31a25a81deadb29c$export$df995fae86a55f06)(t), new $a33cbddcd7bfa0a9$export$d94ed661b1cfd435(t, (e)=>$a33cbddcd7bfa0a9$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$export$ff1663c0c1304f1a(t, e) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$d66501df72047452));
    const n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(t);
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return (0, $31a25a81deadb29c$export$4c3d22f3d993c33f)("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(t) {
        const e = "string" == typeof t ? function __PRIVATE_tryParseJson(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "Failed to parse JSON: " + t?.message);
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(t, "collectionGroup"), r = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(e, "fieldPath"), n = (0, $31a25a81deadb29c$export$f787f51d84a910ad)("setIndexConfiguration", t);
                "CONTAINS" === e.arrayConfig ? r.push(new (0, $31a25a81deadb29c$export$c9170ad7d4cd7e57)(n, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? r.push(new (0, $31a25a81deadb29c$export$c9170ad7d4cd7e57)(n, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && r.push(new (0, $31a25a81deadb29c$export$c9170ad7d4cd7e57)(n, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new (0, $31a25a81deadb29c$export$ee7c8ad385a60b7b)((0, $31a25a81deadb29c$export$ee7c8ad385a60b7b).UNKNOWN_ID, e, r, (0, $31a25a81deadb29c$export$995eb9fca571757).empty()));
        }
        return n;
    }(e);
    return (0, $31a25a81deadb29c$export$f38c853ae54ed474)(n, r);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(t, e) {
    if ("string" != typeof t[e]) throw new (0, $31a25a81deadb29c$export$4368d992c4eafac0)((0, $31a25a81deadb29c$export$f1e1789686576879).INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(t){
        this._firestore = t, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @returns The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $a33cbddcd7bfa0a9$export$61c6347b57bdfa06(t) {
    t = (0, $31a25a81deadb29c$export$4a5767248b18ef41)(t, (0, $31a25a81deadb29c$export$d66501df72047452));
    const e = $a33cbddcd7bfa0a9$var$Kt.get(t);
    if (e) return e;
    const n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(t);
    if ("persistent" !== n._uninitializedComponentsProvider?._offline.kind) return null;
    const r = new $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8(t);
    return $a33cbddcd7bfa0a9$var$Kt.set(t, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $a33cbddcd7bfa0a9$export$9b2c0a7aacbcd151(t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $a33cbddcd7bfa0a9$export$5b460d5f48076743(t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $a33cbddcd7bfa0a9$export$72809fc2fc5083d5(t) {
    const e = (0, $31a25a81deadb29c$export$df995fae86a55f06)(t._firestore);
    (0, $31a25a81deadb29c$export$3b513254972cfc9c)(e).then((t)=>(0, $31a25a81deadb29c$export$21579262ef46735b)("deleting all persistent cache indexes succeeded")).catch((t)=>(0, $31a25a81deadb29c$export$4c3d22f3d993c33f)("deleting all persistent cache indexes failed", t));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, e) {
    const n = (0, $31a25a81deadb29c$export$df995fae86a55f06)(t._firestore);
    (0, $31a25a81deadb29c$export$ab83b03e4111b1d0)(n, e).then((t)=>(0, $31a25a81deadb29c$export$21579262ef46735b)(`setting persistent cache index auto creation isEnabled=${e} succeeded`)).catch((t)=>(0, $31a25a81deadb29c$export$4c3d22f3d993c33f)(`setting persistent cache index auto creation isEnabled=${e} failed`, t));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $a33cbddcd7bfa0a9$var$Kt = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $a33cbddcd7bfa0a9$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback - the callback to invoke upon existence filter mismatch.
     *
     * @returns a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(t);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.t = new Map;
    }
    static get instance() {
        return $a33cbddcd7bfa0a9$var$Xt || ($a33cbddcd7bfa0a9$var$Xt = new $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl, (0, $31a25a81deadb29c$export$1a82df3d29112e01)($a33cbddcd7bfa0a9$var$Xt)), $a33cbddcd7bfa0a9$var$Xt;
    }
    o(t) {
        this.t.forEach((e)=>e(t));
    }
    onExistenceFilterMismatch(t) {
        const e = Symbol(), n = this.t;
        return n.set(e, t), ()=>n.delete(e);
    }
}
let $a33cbddcd7bfa0a9$var$Xt = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(h, d = !0) {
    (0, $31a25a81deadb29c$export$71511d61b312f219)((0, $5e587d655f0a08bb$export$31499a9cd224b78c)), (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("firestore", (t, { instanceIdentifier: e, options: n })=>{
        const r = t.getProvider("app").getImmediate(), s = new (0, $31a25a81deadb29c$export$d66501df72047452)(new (0, $31a25a81deadb29c$export$407448d2b89b1813)(t.getProvider("auth-internal")), new (0, $31a25a81deadb29c$export$8b22cf2602fb60ce)(r, t.getProvider("app-check-internal")), (0, $31a25a81deadb29c$export$db3b6bfb95261072)(r, e), r);
        return n = {
            useFetchStreams: d,
            ...n
        }, s._setSettings(n), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$Ut, $a33cbddcd7bfa0a9$var$Ht, h), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$Ut, $a33cbddcd7bfa0a9$var$Ht, "esm2020");
}();





var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "12.13.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');







/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$9e5f44173e64f162 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $5ecbc04d9be5cf27$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$7f8ddf7c7c20b3cd = $5ecbc04d9be5cf27$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$9bb611d729802a56 = $5ecbc04d9be5cf27$var$_prodErrorMap;
const $5ecbc04d9be5cf27$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $5ecbc04d9be5cf27$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$b4171a6734a65d42 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_PASSWORD: 'auth/missing-password',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$logClient = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)('@firebase/auth');
function $5ecbc04d9be5cf27$var$_logWarn(msg, ...args) {
    if ($5ecbc04d9be5cf27$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) $5ecbc04d9be5cf27$var$logClient.warn(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $5ecbc04d9be5cf27$var$_logError(msg, ...args) {
    if ($5ecbc04d9be5cf27$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) $5ecbc04d9be5cf27$var$logClient.error(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$export$28f7fcd39efa255(authOrCode, ...rest) {
    throw $5ecbc04d9be5cf27$var$createErrorInternal(authOrCode, ...rest);
}
function $5ecbc04d9be5cf27$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $5ecbc04d9be5cf27$var$createErrorInternal(authOrCode, ...rest);
}
function $5ecbc04d9be5cf27$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...$5ecbc04d9be5cf27$export$9bb611d729802a56(),
        [code]: message
    };
    const factory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $5ecbc04d9be5cf27$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $5ecbc04d9be5cf27$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $5ecbc04d9be5cf27$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $5ecbc04d9be5cf27$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $5ecbc04d9be5cf27$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $5ecbc04d9be5cf27$export$24baa2b76016ce0e(assertion, authOrCode, ...rest) {
    if (!assertion) throw $5ecbc04d9be5cf27$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $5ecbc04d9be5cf27$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $5ecbc04d9be5cf27$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(assertion, message) {
    if (!assertion) $5ecbc04d9be5cf27$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$_getCurrentUrl() {
    return typeof self !== 'undefined' && self.location?.href || '';
}
function $5ecbc04d9be5cf27$var$_isHttpOrHttps() {
    return $5ecbc04d9be5cf27$var$_getCurrentScheme() === 'http:' || $5ecbc04d9be5cf27$var$_getCurrentScheme() === 'https:';
}
function $5ecbc04d9be5cf27$var$_getCurrentScheme() {
    return typeof self !== 'undefined' && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $5ecbc04d9be5cf27$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($5ecbc04d9be5cf27$var$_isHttpOrHttps() || (0, $029952e65115eee5$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $5ecbc04d9be5cf27$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $5ecbc04d9be5cf27$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $029952e65115eee5$export$872f8323f01d7ae0)() || (0, $029952e65115eee5$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$5ecbc04d9be5cf27$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$_emulatorUrl(config, path) {
    $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$export$f96d196f7728bb5 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $5ecbc04d9be5cf27$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $5ecbc04d9be5cf27$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $5ecbc04d9be5cf27$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $5ecbc04d9be5cf27$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $5ecbc04d9be5cf27$var$DEFAULT_API_TIMEOUT_MS = new $5ecbc04d9be5cf27$var$Delay(30000, 60000);
function $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function $5ecbc04d9be5cf27$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $5ecbc04d9be5cf27$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $029952e65115eee5$export$ac4103b836844853)({
            key: auth.config.apiKey,
            ...params
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method: method,
            headers: headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $029952e65115eee5$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'no-referrer';
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return $5ecbc04d9be5cf27$export$f96d196f7728bb5.fetch()(await $5ecbc04d9be5cf27$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $5ecbc04d9be5cf27$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...$5ecbc04d9be5cf27$var$SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new $5ecbc04d9be5cf27$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $5ecbc04d9be5cf27$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $5ecbc04d9be5cf27$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $5ecbc04d9be5cf27$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $5ecbc04d9be5cf27$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $5ecbc04d9be5cf27$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $5ecbc04d9be5cf27$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $5ecbc04d9be5cf27$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $5ecbc04d9be5cf27$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $5ecbc04d9be5cf27$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($5ecbc04d9be5cf27$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $5ecbc04d9be5cf27$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $5ecbc04d9be5cf27$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $5ecbc04d9be5cf27$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $5ecbc04d9be5cf27$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $5ecbc04d9be5cf27$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $5ecbc04d9be5cf27$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $5ecbc04d9be5cf27$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$getRecaptchaParams(auth) {
    return (await $5ecbc04d9be5cf27$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $5ecbc04d9be5cf27$var$getRecaptchaConfig(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$deleteAccount(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $5ecbc04d9be5cf27$var$deleteLinkedAccounts(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $5ecbc04d9be5cf27$var$getAccountInfo(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$7a38258bbe170828(user, forceRefresh = false) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$2f6ca3d3b1f80bf5(user, forceRefresh = false) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $5ecbc04d9be5cf27$var$_parseToken(token);
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase?.['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $5ecbc04d9be5cf27$var$utcTimestampToDateString($5ecbc04d9be5cf27$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $5ecbc04d9be5cf27$var$utcTimestampToDateString($5ecbc04d9be5cf27$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $5ecbc04d9be5cf27$var$utcTimestampToDateString($5ecbc04d9be5cf27$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.['sign_in_second_factor'] || null
    };
}
function $5ecbc04d9be5cf27$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $5ecbc04d9be5cf27$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $5ecbc04d9be5cf27$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $029952e65115eee5$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $5ecbc04d9be5cf27$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $5ecbc04d9be5cf27$var$_logError('Caught error parsing JWT payload as JSON', e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $5ecbc04d9be5cf27$var$_tokenExpiresIn(token) {
    const parsedToken = $5ecbc04d9be5cf27$var$_parseToken(token);
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56) && $5ecbc04d9be5cf27$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $5ecbc04d9be5cf27$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $5ecbc04d9be5cf27$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $5ecbc04d9be5cf27$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$_reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(user, $5ecbc04d9be5cf27$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? $5ecbc04d9be5cf27$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $5ecbc04d9be5cf27$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $5ecbc04d9be5cf27$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$6554612db691658e(user) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $5ecbc04d9be5cf27$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $5ecbc04d9be5cf27$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $5ecbc04d9be5cf27$var$extractProviderData(providers) {
    return providers.map(({ providerId: providerId, ...provider })=>{
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$requestStsToken(auth, refreshToken) {
    const response = await $5ecbc04d9be5cf27$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $029952e65115eee5$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $5ecbc04d9be5cf27$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) options.credentials = 'include';
        return $5ecbc04d9be5cf27$export$f96d196f7728bb5.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $5ecbc04d9be5cf27$var$revokeToken(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $5ecbc04d9be5cf27$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $5ecbc04d9be5cf27$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $5ecbc04d9be5cf27$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $5ecbc04d9be5cf27$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $5ecbc04d9be5cf27$var$StsTokenManager();
        if (refreshToken) {
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $5ecbc04d9be5cf27$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $5ecbc04d9be5cf27$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$assertStringOrUndefined(assertion, appName) {
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $5ecbc04d9be5cf27$export$91477dc880baac21 {
    constructor({ uid: uid, auth: auth, stsTokenManager: stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $5ecbc04d9be5cf27$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $5ecbc04d9be5cf27$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $5ecbc04d9be5cf27$export$2f6ca3d3b1f80bf5(this, forceRefresh);
    }
    reload() {
        return $5ecbc04d9be5cf27$export$6554612db691658e(this);
    }
    _assign(user) {
        if (this === user) return;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $5ecbc04d9be5cf27$export$91477dc880baac21({
            ...this,
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $5ecbc04d9be5cf27$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(this, $5ecbc04d9be5cf27$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $5ecbc04d9be5cf27$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(displayName, auth.name);
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(email, auth.name);
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(phoneNumber, auth.name);
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(photoURL, auth.name);
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(tenantId, auth.name);
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(createdAt, auth.name);
        $5ecbc04d9be5cf27$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $5ecbc04d9be5cf27$export$91477dc880baac21({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $5ecbc04d9be5cf27$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $5ecbc04d9be5cf27$export$91477dc880baac21({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $5ecbc04d9be5cf27$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $5ecbc04d9be5cf27$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new $5ecbc04d9be5cf27$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $5ecbc04d9be5cf27$export$91477dc880baac21({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $5ecbc04d9be5cf27$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$instanceCache = new Map();
function $5ecbc04d9be5cf27$export$cf2f7c5792f80b46(cls) {
    $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(cls instanceof Function, 'Expected a class definition');
    let instance = $5ecbc04d9be5cf27$var$instanceCache.get(cls);
    if (instance) {
        $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $5ecbc04d9be5cf27$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$5ecbc04d9be5cf27$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$e7c866399fa523f5 = $5ecbc04d9be5cf27$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $5ecbc04d9be5cf27$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $5ecbc04d9be5cf27$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $5ecbc04d9be5cf27$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await $5ecbc04d9be5cf27$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $5ecbc04d9be5cf27$export$91477dc880baac21._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $5ecbc04d9be5cf27$export$91477dc880baac21._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $5ecbc04d9be5cf27$var$PersistenceUserManager($5ecbc04d9be5cf27$export$cf2f7c5792f80b46($5ecbc04d9be5cf27$export$e7c866399fa523f5), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $5ecbc04d9be5cf27$export$cf2f7c5792f80b46($5ecbc04d9be5cf27$export$e7c866399fa523f5);
        const key = $5ecbc04d9be5cf27$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await $5ecbc04d9be5cf27$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $5ecbc04d9be5cf27$export$91477dc880baac21._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $5ecbc04d9be5cf27$export$91477dc880baac21._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $5ecbc04d9be5cf27$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new $5ecbc04d9be5cf27$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $5ecbc04d9be5cf27$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($5ecbc04d9be5cf27$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($5ecbc04d9be5cf27$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($5ecbc04d9be5cf27$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($5ecbc04d9be5cf27$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($5ecbc04d9be5cf27$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $5ecbc04d9be5cf27$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($5ecbc04d9be5cf27$export$9fa96a7d116ea3ce(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $5ecbc04d9be5cf27$var$_isFirefox(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $5ecbc04d9be5cf27$var$_isSafari(userAgent = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $5ecbc04d9be5cf27$var$_isChromeIOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $5ecbc04d9be5cf27$var$_isIEMobile(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $5ecbc04d9be5cf27$export$9fa96a7d116ea3ce(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $5ecbc04d9be5cf27$var$_isBlackBerry(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $5ecbc04d9be5cf27$var$_isWebOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $5ecbc04d9be5cf27$export$92108d983e8ee699(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $5ecbc04d9be5cf27$export$9d398bebfec1c039(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $5ecbc04d9be5cf27$var$_isIOSStandalone(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return $5ecbc04d9be5cf27$export$92108d983e8ee699(ua) && !!window.navigator?.standalone;
}
function $5ecbc04d9be5cf27$var$_isIE10() {
    return (0, $029952e65115eee5$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $5ecbc04d9be5cf27$var$_isMobileBrowser(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $5ecbc04d9be5cf27$export$92108d983e8ee699(ua) || $5ecbc04d9be5cf27$export$9fa96a7d116ea3ce(ua) || $5ecbc04d9be5cf27$var$_isWebOS(ua) || $5ecbc04d9be5cf27$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $5ecbc04d9be5cf27$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $5ecbc04d9be5cf27$export$faec65b429be379(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $5ecbc04d9be5cf27$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$5ecbc04d9be5cf27$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $5e587d655f0a08bb$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $5ecbc04d9be5cf27$var$_getPasswordPolicy(auth, request = {}) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $5ecbc04d9be5cf27$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $5ecbc04d9be5cf27$var$PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? $5ecbc04d9be5cf27$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join('') ?? '';
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$export$9f4f30ee63539e24 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $5ecbc04d9be5cf27$var$Subscription(this);
        this.idTokenSubscription = new $5ecbc04d9be5cf27$var$Subscription(this);
        this.beforeStateQueue = new $5ecbc04d9be5cf27$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $5ecbc04d9be5cf27$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $5ecbc04d9be5cf27$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await $5ecbc04d9be5cf27$var$PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $5ecbc04d9be5cf27$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $5ecbc04d9be5cf27$export$91477dc880baac21._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $5ecbc04d9be5cf27$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $5ecbc04d9be5cf27$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $029952e65115eee5$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $5ecbc04d9be5cf27$export$24baa2b76016ce0e(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($5ecbc04d9be5cf27$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $5ecbc04d9be5cf27$var$_getPasswordPolicy(this);
        const passwordPolicy = new $5ecbc04d9be5cf27$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $5ecbc04d9be5cf27$var$revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $5ecbc04d9be5cf27$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $5ecbc04d9be5cf27$var$PersistenceUserManager.create(this, [
                $5ecbc04d9be5cf27$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $5ecbc04d9be5cf27$export$faec65b429be379(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $5ecbc04d9be5cf27$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $5ecbc04d9be5cf27$export$23ebac1979863676(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $5ecbc04d9be5cf27$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $029952e65115eee5$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5ecbc04d9be5cf27$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $5ecbc04d9be5cf27$var$_setExternalJSProvider(p) {
    $5ecbc04d9be5cf27$var$externalJSProvider = p;
}
function $5ecbc04d9be5cf27$var$_loadJS(url) {
    return $5ecbc04d9be5cf27$var$externalJSProvider.loadJS(url);
}
function $5ecbc04d9be5cf27$var$_recaptchaV2ScriptUrl() {
    return $5ecbc04d9be5cf27$var$externalJSProvider.recaptchaV2Script;
}
function $5ecbc04d9be5cf27$var$_recaptchaEnterpriseScriptUrl() {
    return $5ecbc04d9be5cf27$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $5ecbc04d9be5cf27$var$_gapiScriptUrl() {
    return $5ecbc04d9be5cf27$var$externalJSProvider.gapiScript;
}
function $5ecbc04d9be5cf27$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$_SOLVE_TIME_MS = 500;
const $5ecbc04d9be5cf27$var$_EXPIRATION_TIME_MS = 60000;
const $5ecbc04d9be5cf27$var$_WIDGET_ID_START = 1000000000000;
class $5ecbc04d9be5cf27$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $5ecbc04d9be5cf27$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $5ecbc04d9be5cf27$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || $5ecbc04d9be5cf27$var$_WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || $5ecbc04d9be5cf27$var$_WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || '';
    }
    async execute(optWidgetId) {
        const id = optWidgetId || $5ecbc04d9be5cf27$var$_WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return '';
    }
}
class $5ecbc04d9be5cf27$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $5ecbc04d9be5cf27$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $5ecbc04d9be5cf27$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $5ecbc04d9be5cf27$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $5ecbc04d9be5cf27$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $5ecbc04d9be5cf27$var$_EXPIRATION_TIME_MS);
        }, $5ecbc04d9be5cf27$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $5ecbc04d9be5cf27$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $5ecbc04d9be5cf27$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $5ecbc04d9be5cf27$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $5ecbc04d9be5cf27$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $5ecbc04d9be5cf27$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $5ecbc04d9be5cf27$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $5ecbc04d9be5cf27$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $5ecbc04d9be5cf27$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($5ecbc04d9be5cf27$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($5ecbc04d9be5cf27$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $5ecbc04d9be5cf27$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $5ecbc04d9be5cf27$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $5ecbc04d9be5cf27$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $5ecbc04d9be5cf27$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $5ecbc04d9be5cf27$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $5ecbc04d9be5cf27$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $5ecbc04d9be5cf27$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $5ecbc04d9be5cf27$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $5ecbc04d9be5cf27$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $5ecbc04d9be5cf27$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $5ecbc04d9be5cf27$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $5ecbc04d9be5cf27$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $5ecbc04d9be5cf27$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $5ecbc04d9be5cf27$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    const response = await $5ecbc04d9be5cf27$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $5ecbc04d9be5cf27$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $5ecbc04d9be5cf27$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$3466f893ebf79586(app, deps) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(initialOptions, deps ?? {})) return auth;
        else $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $5ecbc04d9be5cf27$var$_initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($5ecbc04d9be5cf27$export$cf2f7c5792f80b46);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$61196ced6d74a310(auth, url, options) {
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = $5ecbc04d9be5cf27$var$extractProtocol(url);
    const { host: host, port: port } = $5ecbc04d9be5cf27$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e((0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulator, authInternal.config.emulator) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $029952e65115eee5$export$5b4d24b45140ad90)(host)) (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`${protocol}//${host}${portStr}`);
    else if (!disableWarnings) $5ecbc04d9be5cf27$var$emitEmulatorWarning();
}
function $5ecbc04d9be5cf27$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $5ecbc04d9be5cf27$var$extractHostAndPort(url) {
    const protocol = $5ecbc04d9be5cf27$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $5ecbc04d9be5cf27$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $5ecbc04d9be5cf27$var$parsePort(port)
        };
    }
}
function $5ecbc04d9be5cf27$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $5ecbc04d9be5cf27$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $5ecbc04d9be5cf27$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $5ecbc04d9be5cf27$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $5ecbc04d9be5cf27$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $5ecbc04d9be5cf27$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$resetPassword(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
async function $5ecbc04d9be5cf27$var$updateEmailPassword(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $5ecbc04d9be5cf27$var$linkEmailPassword(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $5ecbc04d9be5cf27$var$applyActionCode$1(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$signInWithPassword(auth, request) {
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
async function $5ecbc04d9be5cf27$var$sendOobCode(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
async function $5ecbc04d9be5cf27$var$sendEmailVerification$1(auth, request) {
    return $5ecbc04d9be5cf27$var$sendOobCode(auth, request);
}
async function $5ecbc04d9be5cf27$var$sendPasswordResetEmail$1(auth, request) {
    return $5ecbc04d9be5cf27$var$sendOobCode(auth, request);
}
async function $5ecbc04d9be5cf27$var$sendSignInLinkToEmail$1(auth, request) {
    return $5ecbc04d9be5cf27$var$sendOobCode(auth, request);
}
async function $5ecbc04d9be5cf27$var$verifyAndChangeEmail(auth, request) {
    return $5ecbc04d9be5cf27$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$signInWithEmailLink$1(auth, request) {
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
async function $5ecbc04d9be5cf27$var$signInWithEmailLinkForLinking(auth, request) {
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$a07804094c3ecf2d extends $5ecbc04d9be5cf27$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $5ecbc04d9be5cf27$export$a07804094c3ecf2d(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $5ecbc04d9be5cf27$export$a07804094c3ecf2d(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $5ecbc04d9be5cf27$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $5ecbc04d9be5cf27$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $5ecbc04d9be5cf27$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $5ecbc04d9be5cf27$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $5ecbc04d9be5cf27$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $5ecbc04d9be5cf27$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$signInWithIdp(auth, request) {
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$3722cfe417b6ed86 extends $5ecbc04d9be5cf27$export$3a1a48c8f6ef640e {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $5ecbc04d9be5cf27$export$3722cfe417b6ed86(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $5ecbc04d9be5cf27$export$28f7fcd39efa255("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new $5ecbc04d9be5cf27$export$3722cfe417b6ed86(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $5ecbc04d9be5cf27$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $029952e65115eee5$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$sendPhoneVerificationCode(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
async function $5ecbc04d9be5cf27$var$signInWithPhoneNumber$1(auth, request) {
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
async function $5ecbc04d9be5cf27$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $5ecbc04d9be5cf27$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $5ecbc04d9be5cf27$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $5ecbc04d9be5cf27$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: 'REAUTH'
    };
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, apiRequest), $5ecbc04d9be5cf27$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$3a6d5c9ae78a2c08 extends $5ecbc04d9be5cf27$export$3a1a48c8f6ef640e {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $5ecbc04d9be5cf27$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $5ecbc04d9be5cf27$export$3a6d5c9ae78a2c08({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $5ecbc04d9be5cf27$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $5ecbc04d9be5cf27$var$linkWithPhoneNumber$1(auth, {
            idToken: idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $5ecbc04d9be5cf27$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $5ecbc04d9be5cf27$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $5ecbc04d9be5cf27$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $5ecbc04d9be5cf27$var$parseDeepLink(url) {
    const link = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$3b513254972cfc9c {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = $5ecbc04d9be5cf27$var$parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $5ecbc04d9be5cf27$var$parseDeepLink(link);
        try {
            return new $5ecbc04d9be5cf27$export$3b513254972cfc9c(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$21579262ef46735b(link) {
    return $5ecbc04d9be5cf27$export$3b513254972cfc9c.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$71cec2538cb2c617 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $5ecbc04d9be5cf27$export$71cec2538cb2c617.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $5ecbc04d9be5cf27$export$a07804094c3ecf2d._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $5ecbc04d9be5cf27$export$3b513254972cfc9c.parseLink(emailLink);
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $5ecbc04d9be5cf27$export$a07804094c3ecf2d._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $5ecbc04d9be5cf27$export$71cec2538cb2c617.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $5ecbc04d9be5cf27$export$71cec2538cb2c617.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $5ecbc04d9be5cf27$export$71cec2538cb2c617.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $5ecbc04d9be5cf27$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $5ecbc04d9be5cf27$var$BaseOAuthProvider extends $5ecbc04d9be5cf27$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $5ecbc04d9be5cf27$export$71511d61b312f219 extends $5ecbc04d9be5cf27$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $5ecbc04d9be5cf27$export$3722cfe417b6ed86._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $5ecbc04d9be5cf27$export$3722cfe417b6ed86._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $5ecbc04d9be5cf27$export$71511d61b312f219.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $5ecbc04d9be5cf27$export$71511d61b312f219.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $5ecbc04d9be5cf27$export$71511d61b312f219(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$78acf4525d8a74c4 extends $5ecbc04d9be5cf27$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $5ecbc04d9be5cf27$export$3722cfe417b6ed86._fromParams({
            providerId: $5ecbc04d9be5cf27$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $5ecbc04d9be5cf27$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $5ecbc04d9be5cf27$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $5ecbc04d9be5cf27$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $5ecbc04d9be5cf27$export$78acf4525d8a74c4.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $5ecbc04d9be5cf27$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $5ecbc04d9be5cf27$export$78acf4525d8a74c4.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$8743009a87fcb00f extends $5ecbc04d9be5cf27$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $5ecbc04d9be5cf27$export$3722cfe417b6ed86._fromParams({
            providerId: $5ecbc04d9be5cf27$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $5ecbc04d9be5cf27$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $5ecbc04d9be5cf27$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $5ecbc04d9be5cf27$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $5ecbc04d9be5cf27$export$8743009a87fcb00f.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $5ecbc04d9be5cf27$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $5ecbc04d9be5cf27$export$8743009a87fcb00f.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $5ecbc04d9be5cf27$export$dc98b0b04f4c7758 extends $5ecbc04d9be5cf27$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $5ecbc04d9be5cf27$export$3722cfe417b6ed86._fromParams({
            providerId: $5ecbc04d9be5cf27$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $5ecbc04d9be5cf27$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $5ecbc04d9be5cf27$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $5ecbc04d9be5cf27$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $5ecbc04d9be5cf27$export$dc98b0b04f4c7758.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $5ecbc04d9be5cf27$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $5ecbc04d9be5cf27$export$dc98b0b04f4c7758.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $5ecbc04d9be5cf27$export$738ab4df8bf92ae9 extends $5ecbc04d9be5cf27$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $5ecbc04d9be5cf27$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $5ecbc04d9be5cf27$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $5ecbc04d9be5cf27$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$3d8c2f653ac9d0b9 extends $5ecbc04d9be5cf27$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(providerId.startsWith($5ecbc04d9be5cf27$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $5ecbc04d9be5cf27$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $5ecbc04d9be5cf27$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $5ecbc04d9be5cf27$export$738ab4df8bf92ae9.fromJSON(json);
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $5ecbc04d9be5cf27$export$738ab4df8bf92ae9._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$34aec0b863436764 extends $5ecbc04d9be5cf27$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $5ecbc04d9be5cf27$export$3722cfe417b6ed86._fromParams({
            providerId: $5ecbc04d9be5cf27$export$34aec0b863436764.PROVIDER_ID,
            signInMethod: $5ecbc04d9be5cf27$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $5ecbc04d9be5cf27$export$34aec0b863436764.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $5ecbc04d9be5cf27$export$34aec0b863436764.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $5ecbc04d9be5cf27$export$34aec0b863436764.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $5ecbc04d9be5cf27$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $5ecbc04d9be5cf27$export$34aec0b863436764.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$signUp(auth, request) {
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $5ecbc04d9be5cf27$export$91477dc880baac21._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $5ecbc04d9be5cf27$var$providerIdForResponse(idTokenResponse);
        const userCred = new $5ecbc04d9be5cf27$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $5ecbc04d9be5cf27$var$providerIdForResponse(response);
        return new $5ecbc04d9be5cf27$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $5ecbc04d9be5cf27$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$3c2fa207a37baaea(auth) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $5ecbc04d9be5cf27$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $5ecbc04d9be5cf27$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $5ecbc04d9be5cf27$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$MultiFactorError extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $5ecbc04d9be5cf27$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $5ecbc04d9be5cf27$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $5ecbc04d9be5cf27$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $5ecbc04d9be5cf27$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $5ecbc04d9be5cf27$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$8a5498727ef6be21(user, providerId) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $5ecbc04d9be5cf27$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $5ecbc04d9be5cf27$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $5ecbc04d9be5cf27$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $5ecbc04d9be5cf27$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $5ecbc04d9be5cf27$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $5ecbc04d9be5cf27$var$_assertLinkedStatus(expected, user, provider) {
    await $5ecbc04d9be5cf27$var$_reloadWithoutSaving(user);
    const providerIds = $5ecbc04d9be5cf27$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(user, $5ecbc04d9be5cf27$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $5ecbc04d9be5cf27$var$_parseToken(response.idToken);
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $5ecbc04d9be5cf27$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $5ecbc04d9be5cf27$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $5ecbc04d9be5cf27$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$ce26c07117d59d6a(auth, credential) {
    return $5ecbc04d9be5cf27$var$_signInWithCredential($5ecbc04d9be5cf27$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$6559d589eb85fbb6(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $5ecbc04d9be5cf27$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $5ecbc04d9be5cf27$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$efca4cbe5dd06740(user, credential) {
    return $5ecbc04d9be5cf27$var$_reauthenticate((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$signInWithCustomToken$1(auth, request) {
    return $5ecbc04d9be5cf27$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$a8550f7dbe79f93a(auth, customToken) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    const response = await $5ecbc04d9be5cf27$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $5ecbc04d9be5cf27$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $5ecbc04d9be5cf27$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $5ecbc04d9be5cf27$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $5ecbc04d9be5cf27$var$PhoneMultiFactorInfoImpl extends $5ecbc04d9be5cf27$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $5ecbc04d9be5cf27$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $5ecbc04d9be5cf27$var$TotpMultiFactorInfoImpl extends $5ecbc04d9be5cf27$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $5ecbc04d9be5cf27$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $5ecbc04d9be5cf27$var$recachePasswordPolicy(auth) {
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$2e2af4578d910ddf(auth, email, actionCodeSettings) {
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $5ecbc04d9be5cf27$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $5ecbc04d9be5cf27$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $5ecbc04d9be5cf27$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$a93c5207d687da10(auth, oobCode, newPassword) {
    await $5ecbc04d9be5cf27$var$resetPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $5ecbc04d9be5cf27$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$c3950d9923825c02(auth, oobCode) {
    await $5ecbc04d9be5cf27$var$applyActionCode$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$a9c996f45e5784d0(auth, oobCode) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const response = await $5ecbc04d9be5cf27$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $5ecbc04d9be5cf27$var$MultiFactorInfoImpl._fromServerResponse($5ecbc04d9be5cf27$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$7910e0436ed8d1de(auth, code) {
    const { data: data } = await $5ecbc04d9be5cf27$export$a9c996f45e5784d0((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$555508cbc6add439(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $5ecbc04d9be5cf27$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $5ecbc04d9be5cf27$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $5ecbc04d9be5cf27$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $5ecbc04d9be5cf27$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$2219238a014317b0(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $5ecbc04d9be5cf27$export$ce26c07117d59d6a((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), $5ecbc04d9be5cf27$export$71cec2538cb2c617.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $5ecbc04d9be5cf27$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$4c3d22f3d993c33f(auth, email, actionCodeSettings) {
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $5ecbc04d9be5cf27$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $5ecbc04d9be5cf27$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $5ecbc04d9be5cf27$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$f787f51d84a910ad(auth, emailLink) {
    const actionCodeUrl = $5ecbc04d9be5cf27$export$3b513254972cfc9c.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$c9170ad7d4cd7e57(auth, email, emailLink) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const credential = $5ecbc04d9be5cf27$export$71cec2538cb2c617.credentialWithLink(email, emailLink || $5ecbc04d9be5cf27$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $5ecbc04d9be5cf27$export$ce26c07117d59d6a(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$createAuthUri(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $5ecbc04d9be5cf27$export$ee7c8ad385a60b7b(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $5ecbc04d9be5cf27$var$_isHttpOrHttps() ? $5ecbc04d9be5cf27$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $5ecbc04d9be5cf27$var$createAuthUri((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$995eb9fca571757(user, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $5ecbc04d9be5cf27$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $5ecbc04d9be5cf27$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$f38c853ae54ed474(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $5ecbc04d9be5cf27$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $5ecbc04d9be5cf27$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$var$updateProfile$1(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$ab83b03e4111b1d0(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(userInternal, $5ecbc04d9be5cf27$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$1a82df3d29112e01(user, newEmail) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $5ecbc04d9be5cf27$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$306ddfe3a8403e2(user, newPassword) {
    return $5ecbc04d9be5cf27$var$updateEmailOrPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $5ecbc04d9be5cf27$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(user, $5ecbc04d9be5cf27$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $5ecbc04d9be5cf27$var$_fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = $5ecbc04d9be5cf27$var$_parseToken(idTokenResponse.idToken)?.firebase?.['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $5ecbc04d9be5cf27$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $5ecbc04d9be5cf27$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $5ecbc04d9be5cf27$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $5ecbc04d9be5cf27$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $5ecbc04d9be5cf27$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $5ecbc04d9be5cf27$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $5ecbc04d9be5cf27$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $5ecbc04d9be5cf27$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $5ecbc04d9be5cf27$var$FederatedAdditionalUserInfoWithUsername extends $5ecbc04d9be5cf27$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $5ecbc04d9be5cf27$var$FacebookAdditionalUserInfo extends $5ecbc04d9be5cf27$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $5ecbc04d9be5cf27$var$GithubAdditionalUserInfo extends $5ecbc04d9be5cf27$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === 'string' ? profile?.login : null);
    }
}
class $5ecbc04d9be5cf27$var$GoogleAdditionalUserInfo extends $5ecbc04d9be5cf27$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $5ecbc04d9be5cf27$var$TwitterAdditionalUserInfo extends $5ecbc04d9be5cf27$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$d24c54395ce0c509(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $5ecbc04d9be5cf27$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$625550452a3fa3ec(auth, persistence) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$90a7f3efeed30595(auth) {
    return $5ecbc04d9be5cf27$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$efccba1c4a2ef57b(auth, password) {
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $5ecbc04d9be5cf27$export$4a5767248b18ef41(auth, callback, onAbort) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$df995fae86a55f06(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$ef35774e6d314e91(auth) {
    (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$e7094788287c5e9b(auth, user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$96f57966bedc81b4(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$a9c23c6ac3fc3eca(auth, token) {
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$2329c99376c9d0a4(user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $5ecbc04d9be5cf27$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $5ecbc04d9be5cf27$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return $5ecbc04d9be5cf27$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return $5ecbc04d9be5cf27$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $5ecbc04d9be5cf27$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$5ecbc04d9be5cf27$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $5ecbc04d9be5cf27$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $5ecbc04d9be5cf27$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $5ecbc04d9be5cf27$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $5ecbc04d9be5cf27$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$493d36ec626b6698(auth, error) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $5ecbc04d9be5cf27$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$startEnrollPhoneMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
function $5ecbc04d9be5cf27$var$finalizeEnrollPhoneMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
function $5ecbc04d9be5cf27$var$startEnrollTotpMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
function $5ecbc04d9be5cf27$var$finalizeEnrollTotpMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
function $5ecbc04d9be5cf27$var$withdrawMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
class $5ecbc04d9be5cf27$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$5ecbc04d9be5cf27$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $5ecbc04d9be5cf27$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $5ecbc04d9be5cf27$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $5ecbc04d9be5cf27$var$_logoutIfInvalidated(this.user, $5ecbc04d9be5cf27$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $5ecbc04d9be5cf27$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$1fbe638ecf81657e(user) {
    const userModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if (!$5ecbc04d9be5cf27$var$multiFactorUserCache.has(userModular)) $5ecbc04d9be5cf27$var$multiFactorUserCache.set(userModular, $5ecbc04d9be5cf27$var$MultiFactorUserImpl._fromUser(userModular));
    return $5ecbc04d9be5cf27$var$multiFactorUserCache.get(userModular);
}
const $5ecbc04d9be5cf27$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $5ecbc04d9be5cf27$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($5ecbc04d9be5cf27$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($5ecbc04d9be5cf27$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $5ecbc04d9be5cf27$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $5ecbc04d9be5cf27$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $5ecbc04d9be5cf27$var$BrowserLocalPersistence extends $5ecbc04d9be5cf27$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $5ecbc04d9be5cf27$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($5ecbc04d9be5cf27$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $5ecbc04d9be5cf27$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $5ecbc04d9be5cf27$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$5ecbc04d9be5cf27$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$8b22cf2602fb60ce = $5ecbc04d9be5cf27$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $5ecbc04d9be5cf27$var$getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function $5ecbc04d9be5cf27$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class $5ecbc04d9be5cf27$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $5ecbc04d9be5cf27$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return $5ecbc04d9be5cf27$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $5ecbc04d9be5cf27$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $5ecbc04d9be5cf27$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = $5ecbc04d9be5cf27$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $5ecbc04d9be5cf27$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $5ecbc04d9be5cf27$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$5ecbc04d9be5cf27$var$CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $5ecbc04d9be5cf27$export$407448d2b89b1813 = $5ecbc04d9be5cf27$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$BrowserSessionPersistence extends $5ecbc04d9be5cf27$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$5ecbc04d9be5cf27$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$db3b6bfb95261072 = $5ecbc04d9be5cf27$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $5ecbc04d9be5cf27$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $5ecbc04d9be5cf27$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $5ecbc04d9be5cf27$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $5ecbc04d9be5cf27$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$5ecbc04d9be5cf27$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$export$c03999cb2f36933f(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $5ecbc04d9be5cf27$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $5ecbc04d9be5cf27$export$c03999cb2f36933f('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $5ecbc04d9be5cf27$var$_window() {
    return window;
}
function $5ecbc04d9be5cf27$var$_setWindowLocation(url) {
    $5ecbc04d9be5cf27$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$_isWorker() {
    return typeof $5ecbc04d9be5cf27$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $5ecbc04d9be5cf27$var$_window()['importScripts'] === 'function';
}
async function $5ecbc04d9be5cf27$var$_getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function $5ecbc04d9be5cf27$var$_getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function $5ecbc04d9be5cf27$var$_getWorkerGlobalScope() {
    return $5ecbc04d9be5cf27$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$DB_NAME = 'firebaseLocalStorageDb';
const $5ecbc04d9be5cf27$var$DB_VERSION = 1;
const $5ecbc04d9be5cf27$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $5ecbc04d9be5cf27$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $5ecbc04d9be5cf27$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $5ecbc04d9be5cf27$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $5ecbc04d9be5cf27$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($5ecbc04d9be5cf27$var$DB_OBJECTSTORE_NAME);
}
function $5ecbc04d9be5cf27$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($5ecbc04d9be5cf27$var$DB_NAME);
    return new $5ecbc04d9be5cf27$var$DBPromise(request).toPromise();
}
function $5ecbc04d9be5cf27$var$_openDatabase() {
    const request = indexedDB.open($5ecbc04d9be5cf27$var$DB_NAME, $5ecbc04d9be5cf27$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($5ecbc04d9be5cf27$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $5ecbc04d9be5cf27$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($5ecbc04d9be5cf27$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $5ecbc04d9be5cf27$var$_deleteDatabase();
                resolve(await $5ecbc04d9be5cf27$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $5ecbc04d9be5cf27$var$_putObject(db, key, value) {
    const request = $5ecbc04d9be5cf27$var$getObjectStore(db, true).put({
        [$5ecbc04d9be5cf27$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $5ecbc04d9be5cf27$var$DBPromise(request).toPromise();
}
async function $5ecbc04d9be5cf27$var$getObject(db, key) {
    const request = $5ecbc04d9be5cf27$var$getObjectStore(db, false).get(key);
    const data = await new $5ecbc04d9be5cf27$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $5ecbc04d9be5cf27$var$_deleteObject(db, key) {
    const request = $5ecbc04d9be5cf27$var$getObjectStore(db, true).delete(key);
    return new $5ecbc04d9be5cf27$var$DBPromise(request).toPromise();
}
const $5ecbc04d9be5cf27$var$_POLLING_INTERVAL_MS = 800;
const $5ecbc04d9be5cf27$var$_TRANSACTION_RETRY_COUNT = 3;
class $5ecbc04d9be5cf27$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $5ecbc04d9be5cf27$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $5ecbc04d9be5cf27$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $5ecbc04d9be5cf27$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $5ecbc04d9be5cf27$var$Receiver._getInstance($5ecbc04d9be5cf27$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $5ecbc04d9be5cf27$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $5ecbc04d9be5cf27$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $5ecbc04d9be5cf27$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $5ecbc04d9be5cf27$var$_openDatabase();
            await $5ecbc04d9be5cf27$var$_putObject(db, $5ecbc04d9be5cf27$var$STORAGE_AVAILABLE_KEY, '1');
            await $5ecbc04d9be5cf27$var$_deleteObject(db, $5ecbc04d9be5cf27$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$5ecbc04d9be5cf27$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$5ecbc04d9be5cf27$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$5ecbc04d9be5cf27$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $5ecbc04d9be5cf27$var$getObjectStore(db, false).getAll();
            return new $5ecbc04d9be5cf27$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $5ecbc04d9be5cf27$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$5ecbc04d9be5cf27$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$23f2a1d2818174ef = $5ecbc04d9be5cf27$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$startSignInPhoneMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
function $5ecbc04d9be5cf27$var$finalizeSignInPhoneMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
function $5ecbc04d9be5cf27$var$finalizeSignInTotpMfa(auth, request) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $5ecbc04d9be5cf27$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $5ecbc04d9be5cf27$var$_JSLOAD_CALLBACK = $5ecbc04d9be5cf27$var$_generateCallbackName('rcb');
const $5ecbc04d9be5cf27$var$NETWORK_TIMEOUT_DELAY = new $5ecbc04d9be5cf27$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $5ecbc04d9be5cf27$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!$5ecbc04d9be5cf27$var$_window().grecaptcha?.render;
    }
    load(auth, hl = '') {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e($5ecbc04d9be5cf27$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $5ecbc04d9be5cf27$var$isV2($5ecbc04d9be5cf27$var$_window().grecaptcha)) return Promise.resolve($5ecbc04d9be5cf27$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $5ecbc04d9be5cf27$var$_window().setTimeout(()=>{
                reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $5ecbc04d9be5cf27$var$NETWORK_TIMEOUT_DELAY.get());
            $5ecbc04d9be5cf27$var$_window()[$5ecbc04d9be5cf27$var$_JSLOAD_CALLBACK] = ()=>{
                $5ecbc04d9be5cf27$var$_window().clearTimeout(networkTimeout);
                delete $5ecbc04d9be5cf27$var$_window()[$5ecbc04d9be5cf27$var$_JSLOAD_CALLBACK];
                const recaptcha = $5ecbc04d9be5cf27$var$_window().grecaptcha;
                if (!recaptcha || !$5ecbc04d9be5cf27$var$isV2(recaptcha)) {
                    reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$5ecbc04d9be5cf27$var$_recaptchaV2ScriptUrl()}?${(0, $029952e65115eee5$export$ac4103b836844853)({
                onload: $5ecbc04d9be5cf27$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $5ecbc04d9be5cf27$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$5ecbc04d9be5cf27$var$_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $5ecbc04d9be5cf27$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $5ecbc04d9be5cf27$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $5ecbc04d9be5cf27$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $5ecbc04d9be5cf27$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...$5ecbc04d9be5cf27$var$DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $5ecbc04d9be5cf27$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $5ecbc04d9be5cf27$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $5ecbc04d9be5cf27$var$MockReCaptchaLoaderImpl() : new $5ecbc04d9be5cf27$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $5ecbc04d9be5cf27$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e($5ecbc04d9be5cf27$var$_isHttpOrHttps() && !$5ecbc04d9be5cf27$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $5ecbc04d9be5cf27$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $5ecbc04d9be5cf27$var$getRecaptchaParams(this.auth);
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $5ecbc04d9be5cf27$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $5ecbc04d9be5cf27$export$3a6d5c9ae78a2c08._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    const verificationId = await $5ecbc04d9be5cf27$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $5ecbc04d9be5cf27$var$ConfirmationResultImpl(verificationId, (cred)=>$5ecbc04d9be5cf27$export$ce26c07117d59d6a(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $5ecbc04d9be5cf27$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $5ecbc04d9be5cf27$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $5ecbc04d9be5cf27$var$ConfirmationResultImpl(verificationId, (cred)=>$5ecbc04d9be5cf27$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $5ecbc04d9be5cf27$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $5ecbc04d9be5cf27$var$ConfirmationResultImpl(verificationId, (cred)=>$5ecbc04d9be5cf27$export$efca4cbe5dd06740(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $5ecbc04d9be5cf27$var$_verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await $5ecbc04d9be5cf27$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $5ecbc04d9be5cf27$export$24baa2b76016ce0e(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $5ecbc04d9be5cf27$var$FAKE_TOKEN) {
                        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(verifier?.type === $5ecbc04d9be5cf27$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $5ecbc04d9be5cf27$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $5ecbc04d9be5cf27$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $5ecbc04d9be5cf27$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $5ecbc04d9be5cf27$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $5ecbc04d9be5cf27$export$24baa2b76016ce0e(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                $5ecbc04d9be5cf27$export$24baa2b76016ce0e(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $5ecbc04d9be5cf27$var$FAKE_TOKEN) {
                        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(verifier?.type === $5ecbc04d9be5cf27$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $5ecbc04d9be5cf27$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $5ecbc04d9be5cf27$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $5ecbc04d9be5cf27$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $5ecbc04d9be5cf27$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $5ecbc04d9be5cf27$var$FAKE_TOKEN) {
                    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(verifier?.type === $5ecbc04d9be5cf27$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $5ecbc04d9be5cf27$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $5ecbc04d9be5cf27$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $5ecbc04d9be5cf27$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $5ecbc04d9be5cf27$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $5ecbc04d9be5cf27$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $5ecbc04d9be5cf27$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(recaptchaV2Verifier.type === $5ecbc04d9be5cf27$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $5ecbc04d9be5cf27$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $5ecbc04d9be5cf27$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $5ecbc04d9be5cf27$export$3a6d5c9ae78a2c08._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $5ecbc04d9be5cf27$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $5ecbc04d9be5cf27$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $5ecbc04d9be5cf27$export$3a6d5c9ae78a2c08._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $5ecbc04d9be5cf27$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $5ecbc04d9be5cf27$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $5ecbc04d9be5cf27$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $5ecbc04d9be5cf27$export$cf2f7c5792f80b46(resolverOverride);
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$IdpCredential extends $5ecbc04d9be5cf27$export$3a1a48c8f6ef640e {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $5ecbc04d9be5cf27$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $5ecbc04d9be5cf27$var$_signIn(params) {
    return $5ecbc04d9be5cf27$var$_signInWithCredential(params.auth, new $5ecbc04d9be5cf27$var$IdpCredential(params), params.bypassAuthState);
}
function $5ecbc04d9be5cf27$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $5ecbc04d9be5cf27$var$_reauthenticate(user, new $5ecbc04d9be5cf27$var$IdpCredential(params), params.bypassAuthState);
}
async function $5ecbc04d9be5cf27$var$_link(params) {
    const { auth: auth, user: user } = params;
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $5ecbc04d9be5cf27$var$_link$1(user, new $5ecbc04d9be5cf27$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $5ecbc04d9be5cf27$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $5ecbc04d9be5cf27$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $5ecbc04d9be5cf27$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $5ecbc04d9be5cf27$var$_reauth;
            default:
                $5ecbc04d9be5cf27$export$28f7fcd39efa255(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $5ecbc04d9be5cf27$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$4368d992c4eafac0(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    $5ecbc04d9be5cf27$var$_assertInstanceOf(auth, provider, $5ecbc04d9be5cf27$var$FederatedAuthProvider);
    const resolverInternal = $5ecbc04d9be5cf27$var$_withDefaultResolver(authInternal, resolver);
    const action = new $5ecbc04d9be5cf27$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$2d1720544b23b823(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $5ecbc04d9be5cf27$var$_assertInstanceOf(userInternal.auth, provider, $5ecbc04d9be5cf27$var$FederatedAuthProvider);
    const resolverInternal = $5ecbc04d9be5cf27$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $5ecbc04d9be5cf27$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $5ecbc04d9be5cf27$var$_assertInstanceOf(userInternal.auth, provider, $5ecbc04d9be5cf27$var$FederatedAuthProvider);
    const resolverInternal = $5ecbc04d9be5cf27$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $5ecbc04d9be5cf27$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $5ecbc04d9be5cf27$var$PopupOperation extends $5ecbc04d9be5cf27$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($5ecbc04d9be5cf27$var$PopupOperation.currentPopupAction) $5ecbc04d9be5cf27$var$PopupOperation.currentPopupAction.cancel();
        $5ecbc04d9be5cf27$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $5ecbc04d9be5cf27$export$c03999cb2f36933f();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $5ecbc04d9be5cf27$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $5ecbc04d9be5cf27$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$5ecbc04d9be5cf27$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $5ecbc04d9be5cf27$var$redirectOutcomeMap = new Map();
class $5ecbc04d9be5cf27$var$RedirectAction extends $5ecbc04d9be5cf27$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $5ecbc04d9be5cf27$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $5ecbc04d9be5cf27$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $5ecbc04d9be5cf27$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $5ecbc04d9be5cf27$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $5ecbc04d9be5cf27$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $5ecbc04d9be5cf27$var$pendingRedirectKey(auth);
    const persistence = $5ecbc04d9be5cf27$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $5ecbc04d9be5cf27$var$_setPendingRedirectStatus(resolver, auth) {
    return $5ecbc04d9be5cf27$var$resolverPersistence(resolver)._set($5ecbc04d9be5cf27$var$pendingRedirectKey(auth), 'true');
}
function $5ecbc04d9be5cf27$export$a05254e7c3aeba6e() {
    $5ecbc04d9be5cf27$var$redirectOutcomeMap.clear();
}
function $5ecbc04d9be5cf27$export$b9a6b53f9be3734(auth, result) {
    $5ecbc04d9be5cf27$var$redirectOutcomeMap.set(auth._key(), result);
}
function $5ecbc04d9be5cf27$var$resolverPersistence(resolver) {
    return $5ecbc04d9be5cf27$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $5ecbc04d9be5cf27$var$pendingRedirectKey(auth) {
    return $5ecbc04d9be5cf27$export$53a70dd1ebbae346($5ecbc04d9be5cf27$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$39b482c5e57630a8(auth, provider, resolver) {
    return $5ecbc04d9be5cf27$var$_signInWithRedirect(auth, provider, resolver);
}
async function $5ecbc04d9be5cf27$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    $5ecbc04d9be5cf27$var$_assertInstanceOf(auth, provider, $5ecbc04d9be5cf27$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $5ecbc04d9be5cf27$var$_withDefaultResolver(authInternal, resolver);
    await $5ecbc04d9be5cf27$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$35e795649ee09318(user, provider, resolver) {
    return $5ecbc04d9be5cf27$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $5ecbc04d9be5cf27$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $5ecbc04d9be5cf27$var$_assertInstanceOf(userInternal.auth, provider, $5ecbc04d9be5cf27$var$FederatedAuthProvider);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $5ecbc04d9be5cf27$var$_withDefaultResolver(userInternal.auth, resolver);
    await $5ecbc04d9be5cf27$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $5ecbc04d9be5cf27$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $5ecbc04d9be5cf27$var$_linkWithRedirect(user, provider, resolver);
}
async function $5ecbc04d9be5cf27$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $5ecbc04d9be5cf27$var$_assertInstanceOf(userInternal.auth, provider, $5ecbc04d9be5cf27$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $5ecbc04d9be5cf27$var$_withDefaultResolver(userInternal.auth, resolver);
    await $5ecbc04d9be5cf27$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $5ecbc04d9be5cf27$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $5ecbc04d9be5cf27$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $5ecbc04d9be5cf27$export$342063e11d6c3cad(auth, resolver) {
    await $5ecbc04d9be5cf27$export$23ebac1979863676(auth)._initializationPromise;
    return $5ecbc04d9be5cf27$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $5ecbc04d9be5cf27$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($5ecbc04d9be5cf27$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $5ecbc04d9be5cf27$export$23ebac1979863676(auth);
    const resolver = $5ecbc04d9be5cf27$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $5ecbc04d9be5cf27$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $5ecbc04d9be5cf27$var$prepareUserForRedirect(user) {
    const eventId = $5ecbc04d9be5cf27$export$c03999cb2f36933f(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $5ecbc04d9be5cf27$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $5ecbc04d9be5cf27$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$5ecbc04d9be5cf27$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !$5ecbc04d9be5cf27$var$isNullRedirectEvent(event)) {
            const code = event.error.code?.split('auth/')[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($5ecbc04d9be5cf27$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $5ecbc04d9be5cf27$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($5ecbc04d9be5cf27$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($5ecbc04d9be5cf27$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $5ecbc04d9be5cf27$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $5ecbc04d9be5cf27$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $5ecbc04d9be5cf27$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $5ecbc04d9be5cf27$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $5ecbc04d9be5cf27$export$91c6e00c14e7e6fd(auth, request = {}) {
    return $5ecbc04d9be5cf27$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $5ecbc04d9be5cf27$var$HTTP_REGEX = /^https?/;
async function $5ecbc04d9be5cf27$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $5ecbc04d9be5cf27$export$91c6e00c14e7e6fd(auth);
    for (const domain of authorizedDomains)try {
        if ($5ecbc04d9be5cf27$var$matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $5ecbc04d9be5cf27$var$matchDomain(expected) {
    const currentUrl = $5ecbc04d9be5cf27$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$5ecbc04d9be5cf27$var$HTTP_REGEX.test(protocol)) return false;
    if ($5ecbc04d9be5cf27$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$NETWORK_TIMEOUT = new $5ecbc04d9be5cf27$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $5ecbc04d9be5cf27$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $5ecbc04d9be5cf27$var$_window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $5ecbc04d9be5cf27$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $5ecbc04d9be5cf27$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $5ecbc04d9be5cf27$var$resetUnloadedGapiModules();
                    reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $5ecbc04d9be5cf27$var$NETWORK_TIMEOUT.get()
            });
        }
        if ($5ecbc04d9be5cf27$var$_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!$5ecbc04d9be5cf27$var$_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $5ecbc04d9be5cf27$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $5ecbc04d9be5cf27$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $5ecbc04d9be5cf27$var$_loadJS(`${$5ecbc04d9be5cf27$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $5ecbc04d9be5cf27$var$cachedGApiLoader = null;
        throw error;
    });
}
let $5ecbc04d9be5cf27$var$cachedGApiLoader = null;
function $5ecbc04d9be5cf27$var$_loadGapi(auth) {
    $5ecbc04d9be5cf27$var$cachedGApiLoader = $5ecbc04d9be5cf27$var$cachedGApiLoader || $5ecbc04d9be5cf27$var$loadGapi(auth);
    return $5ecbc04d9be5cf27$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$PING_TIMEOUT = new $5ecbc04d9be5cf27$var$Delay(5000, 15000);
const $5ecbc04d9be5cf27$var$IFRAME_PATH = '__/auth/iframe';
const $5ecbc04d9be5cf27$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $5ecbc04d9be5cf27$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $5ecbc04d9be5cf27$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $5ecbc04d9be5cf27$var$getIframeUrl(auth) {
    const config = auth.config;
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $5ecbc04d9be5cf27$var$_emulatorUrl(config, $5ecbc04d9be5cf27$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$5ecbc04d9be5cf27$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c)
    };
    const eid = $5ecbc04d9be5cf27$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $029952e65115eee5$export$ac4103b836844853)(params).slice(1)}`;
}
async function $5ecbc04d9be5cf27$var$_openIframe(auth) {
    const context = await $5ecbc04d9be5cf27$var$_loadGapi(auth);
    const gapi1 = $5ecbc04d9be5cf27$var$_window().gapi;
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $5ecbc04d9be5cf27$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $5ecbc04d9be5cf27$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $5ecbc04d9be5cf27$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $5ecbc04d9be5cf27$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $5ecbc04d9be5cf27$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $5ecbc04d9be5cf27$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $5ecbc04d9be5cf27$var$DEFAULT_WIDTH = 500;
const $5ecbc04d9be5cf27$var$DEFAULT_HEIGHT = 600;
const $5ecbc04d9be5cf27$var$TARGET_BLANK = '_blank';
const $5ecbc04d9be5cf27$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $5ecbc04d9be5cf27$export$2ed0fc6709e59212 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $5ecbc04d9be5cf27$var$_open(auth, url, name, width = $5ecbc04d9be5cf27$var$DEFAULT_WIDTH, height = $5ecbc04d9be5cf27$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = {
        ...$5ecbc04d9be5cf27$var$BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $029952e65115eee5$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $5ecbc04d9be5cf27$var$_isChromeIOS(ua) ? $5ecbc04d9be5cf27$var$TARGET_BLANK : name;
    if ($5ecbc04d9be5cf27$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $5ecbc04d9be5cf27$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($5ecbc04d9be5cf27$var$_isIOSStandalone(ua) && target !== '_self') {
        $5ecbc04d9be5cf27$var$openAsNewWindowIOS(url || '', target);
        return new $5ecbc04d9be5cf27$export$2ed0fc6709e59212(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $5ecbc04d9be5cf27$export$2ed0fc6709e59212(newWin);
}
function $5ecbc04d9be5cf27$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $5ecbc04d9be5cf27$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $5ecbc04d9be5cf27$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $5ecbc04d9be5cf27$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $5ecbc04d9be5cf27$export$3d12bd131bb975d1(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $5ecbc04d9be5cf27$export$24baa2b76016ce0e(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $5ecbc04d9be5cf27$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $029952e65115eee5$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $5ecbc04d9be5cf27$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$5ecbc04d9be5cf27$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$5ecbc04d9be5cf27$var$getHandlerBase(auth)}?${(0, $029952e65115eee5$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $5ecbc04d9be5cf27$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$5ecbc04d9be5cf27$var$WIDGET_PATH}`;
    return $5ecbc04d9be5cf27$var$_emulatorUrl(config, $5ecbc04d9be5cf27$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $5ecbc04d9be5cf27$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $5ecbc04d9be5cf27$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $5ecbc04d9be5cf27$export$db3b6bfb95261072;
        this._completeRedirectFn = $5ecbc04d9be5cf27$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $5ecbc04d9be5cf27$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(this.eventManagers[auth._key()]?.manager, '_initialize() not called before _openPopup()');
        const url = await $5ecbc04d9be5cf27$export$3d12bd131bb975d1(auth, provider, authType, $5ecbc04d9be5cf27$var$_getCurrentUrl(), eventId);
        return $5ecbc04d9be5cf27$var$_open(auth, url, $5ecbc04d9be5cf27$export$c03999cb2f36933f());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $5ecbc04d9be5cf27$export$3d12bd131bb975d1(auth, provider, authType, $5ecbc04d9be5cf27$var$_getCurrentUrl(), eventId);
        $5ecbc04d9be5cf27$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $5ecbc04d9be5cf27$export$d66dc83d8cfc8dd(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $5ecbc04d9be5cf27$var$_openIframe(auth);
        const manager = new $5ecbc04d9be5cf27$export$158acd800e1ef08b(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $5ecbc04d9be5cf27$export$24baa2b76016ce0e(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($5ecbc04d9be5cf27$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $5ecbc04d9be5cf27$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[$5ecbc04d9be5cf27$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $5ecbc04d9be5cf27$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $5ecbc04d9be5cf27$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $5ecbc04d9be5cf27$var$_isMobileBrowser() || $5ecbc04d9be5cf27$var$_isSafari() || $5ecbc04d9be5cf27$export$92108d983e8ee699();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $5ecbc04d9be5cf27$export$953cecd6e717a553 = $5ecbc04d9be5cf27$var$BrowserPopupRedirectResolver;
class $5ecbc04d9be5cf27$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $5ecbc04d9be5cf27$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $5ecbc04d9be5cf27$var$PhoneMultiFactorAssertionImpl extends $5ecbc04d9be5cf27$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $5ecbc04d9be5cf27$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $5ecbc04d9be5cf27$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $5ecbc04d9be5cf27$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$7ccc53e8f1e7dfc5 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $5ecbc04d9be5cf27$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $5ecbc04d9be5cf27$export$7ccc53e8f1e7dfc5.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $5ecbc04d9be5cf27$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $5ecbc04d9be5cf27$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $5ecbc04d9be5cf27$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof mfaSession.user?.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $5ecbc04d9be5cf27$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $5ecbc04d9be5cf27$export$ae1af26003f05816._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $5ecbc04d9be5cf27$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $5ecbc04d9be5cf27$var$TotpMultiFactorAssertionImpl extends $5ecbc04d9be5cf27$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $5ecbc04d9be5cf27$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $5ecbc04d9be5cf27$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $5ecbc04d9be5cf27$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $5ecbc04d9be5cf27$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $5ecbc04d9be5cf27$export$ae1af26003f05816 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $5ecbc04d9be5cf27$export$ae1af26003f05816(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if ($5ecbc04d9be5cf27$var$_isEmptyString(accountName) || $5ecbc04d9be5cf27$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($5ecbc04d9be5cf27$var$_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || 'unknownuser';
            if ($5ecbc04d9be5cf27$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $5ecbc04d9be5cf27$var$_isEmptyString(input) {
    return typeof input === 'undefined' || input?.length === 0;
}
var $5ecbc04d9be5cf27$var$name = "@firebase/auth";
var $5ecbc04d9be5cf27$var$version = "1.13.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5ecbc04d9be5cf27$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ecbc04d9be5cf27$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $5ecbc04d9be5cf27$var$registerAuth(clientPlatform) {
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $5ecbc04d9be5cf27$export$24baa2b76016ce0e(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $5ecbc04d9be5cf27$export$faec65b429be379(clientPlatform)
        };
        const authInstance = new $5ecbc04d9be5cf27$export$9f4f30ee63539e24(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $5ecbc04d9be5cf27$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $5ecbc04d9be5cf27$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $5ecbc04d9be5cf27$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($5ecbc04d9be5cf27$var$name, $5ecbc04d9be5cf27$var$version, $5ecbc04d9be5cf27$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($5ecbc04d9be5cf27$var$name, $5ecbc04d9be5cf27$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5ecbc04d9be5cf27$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $5ecbc04d9be5cf27$var$authIdTokenMaxAge = (0, $029952e65115eee5$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $5ecbc04d9be5cf27$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $5ecbc04d9be5cf27$var$lastPostedIdToken = null;
const $5ecbc04d9be5cf27$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $5ecbc04d9be5cf27$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if ($5ecbc04d9be5cf27$var$lastPostedIdToken === idToken) return;
        $5ecbc04d9be5cf27$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $5ecbc04d9be5cf27$export$ffb5f4729a158638(app = (0, $5e587d655f0a08bb$export$f9962582c9e66d99)()) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $5ecbc04d9be5cf27$export$3466f893ebf79586(app, {
        popupRedirectResolver: $5ecbc04d9be5cf27$export$953cecd6e717a553,
        persistence: [
            $5ecbc04d9be5cf27$export$23f2a1d2818174ef,
            $5ecbc04d9be5cf27$export$8b22cf2602fb60ce,
            $5ecbc04d9be5cf27$export$db3b6bfb95261072
        ]
    });
    const authTokenSyncPath = (0, $029952e65115eee5$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $5ecbc04d9be5cf27$var$mintCookieFactory(authTokenSyncUrl.toString());
            $5ecbc04d9be5cf27$export$4a5767248b18ef41(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $5ecbc04d9be5cf27$export$d141bba7fdc215a3(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $029952e65115eee5$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $5ecbc04d9be5cf27$export$61196ced6d74a310(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $5ecbc04d9be5cf27$var$getScriptParentElement() {
    return document.getElementsByTagName('head')?.[0] ?? document;
}
$5ecbc04d9be5cf27$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $5ecbc04d9be5cf27$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $5ecbc04d9be5cf27$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$5ecbc04d9be5cf27$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );










const $117415e422c8aaf1$var$firebaseConfig = {
    apiKey: "AIzaSyByQclanK_m0OtqpwpB_SeFsAr1Gt_aL4s",
    authDomain: "soulfulcustoms-d880b.firebaseapp.com",
    projectId: "soulfulcustoms-d880b",
    storageBucket: "soulfulcustoms-d880b.firebasestorage.app",
    messagingSenderId: "97375011901",
    appId: "1:97375011901:web:c702fdaed79aec8ca7d654"
};
const $117415e422c8aaf1$var$app = (0, $5e587d655f0a08bb$export$c55cfd413944906d)($117415e422c8aaf1$var$firebaseConfig);
const $117415e422c8aaf1$export$f932f06c7eb6abeb = (0, $31a25a81deadb29c$export$1a8f5705751d8277)($117415e422c8aaf1$var$app);
const $117415e422c8aaf1$export$73693bad9f5880b0 = (0, $5ecbc04d9be5cf27$export$ffb5f4729a158638)($117415e422c8aaf1$var$app);




const $1fac131cb07af2de$export$fc5cbb021d0697ad = "support@soulfulcustoms.shop";
const $1fac131cb07af2de$export$5131fb8971dde985 = "Soulful Customs";
const $1fac131cb07af2de$var$EMAIL_COLLECTION = "soulfulcustoms-mail";
function $1fac131cb07af2de$var$formatCurrency(value = 0) {
    return `$${Number(value || 0).toFixed(2)}`;
}
function $1fac131cb07af2de$var$formatItems(items = []) {
    return items.map((item)=>{
        const option = item.selectedOption?.dimensions || item.selectedOption?.label || "";
        const styles = item.selectedOption?.styles?.length ? `\n   Styles: ${item.selectedOption.styles.map((style)=>style.label).join(", ")}` : "";
        const personalization = item.personalizationText ? `\n   Personalization: ${item.personalizationText}` : "";
        return `- ${item.name} x${item.quantity}${option ? `\n   Option: ${option}` : ""}${personalization}${styles}`;
    }).join("\n");
}
function $1fac131cb07af2de$var$buildCustomerText(order) {
    return `Thank you for ordering from Soulful Customs.

Order Number: ${order.orderNumber}
Order Total: ${$1fac131cb07af2de$var$formatCurrency(order.total)}

Your order has been received. After payment has been received, your order will be confirmed, and production of your custom items will begin.

Order Summary:
${$1fac131cb07af2de$var$formatItems(order.items)}

Sublimation Printing Notice
All products are created using the sublimation printing process. Due to the nature of sublimation printing, slight variations in color and minor printing imperfections may occur. These variations are normal and do not affect the overall quality or functionality of the finished product.

Custom Order & Refund Policy
Because all items are custom-made specifically for your order, all sales are final. Once payment has been submitted, refunds, cancellations, or exchanges cannot be accepted. Customized products cannot be resold, so please review and approve your design carefully before completing your purchase.

Soulful Customs will contact you when your order is ready for pickup.

Thank you,
Soulful Customs`;
}
function $1fac131cb07af2de$var$buildCustomerHtml(order) {
    const itemRows = order.items.map((item)=>{
        const option = item.selectedOption?.dimensions || item.selectedOption?.label || "";
        const styles = item.selectedOption?.styles?.length ? `<br><span style="color:#6e646b;">Styles: ${item.selectedOption.styles.map((style)=>style.label).join(", ")}</span>` : "";
        const personalization = item.personalizationText ? `<br><span style="color:#6e646b;">Personalization: ${item.personalizationText}</span>` : "";
        return `<li style="margin-bottom:12px;"><strong>${item.name}</strong> x${item.quantity}${option ? `<br><span style="color:#6e646b;">Option: ${option}</span>` : ""}${personalization}${styles}</li>`;
    }).join("");
    return `
    <div style="font-family:Arial,sans-serif;color:#171417;line-height:1.6;max-width:640px;margin:0 auto;background:#fffdf9;padding:28px;border-radius:16px;">
      <h1 style="margin:0 0 12px;color:#d64686;">Thank you for ordering from Soulful Customs.</h1>
      <p style="margin:0 0 18px;">Your order has been received.</p>

      <div style="background:#fbf7f2;border:1px solid rgba(30,22,28,0.12);border-radius:12px;padding:16px;margin:18px 0;">
        <p style="margin:0;"><strong>Order Number:</strong> ${order.orderNumber}</p>
        <p style="margin:6px 0 0;"><strong>Order Total:</strong> ${$1fac131cb07af2de$var$formatCurrency(order.total)}</p>
      </div>

      <p>After payment has been received, your order will be confirmed, and production of your custom items will begin.</p>

      <h2 style="font-size:18px;margin-top:24px;">Order Summary</h2>
      <ul style="padding-left:20px;">${itemRows}</ul>

      <h2 style="font-size:18px;margin-top:24px;color:#226674;">Sublimation Printing Notice</h2>
      <p>All products are created using the sublimation printing process. Due to the nature of sublimation printing, slight variations in color and minor printing imperfections may occur. These variations are normal and do not affect the overall quality or functionality of the finished product.</p>

      <h2 style="font-size:18px;margin-top:24px;color:#226674;">Custom Order & Refund Policy</h2>
      <p>Because all items are custom-made specifically for your order, all sales are final. Once payment has been submitted, refunds, cancellations, or exchanges cannot be accepted. Customized products cannot be resold, so please review and approve your design carefully before completing your purchase.</p>

      <p style="margin-top:24px;">Soulful Customs will contact you when your order is ready for pickup.</p>
      <p style="margin-top:24px;">Thank you,<br><strong>Soulful Customs</strong></p>
    </div>
  `;
}
function $1fac131cb07af2de$var$buildSupportText(order) {
    return `New Soulful Customs order submitted.

Order Number: ${order.orderNumber}
Customer: ${order.customer.name}
Email: ${order.customer.email}
Phone: ${order.customer.phone}
Total: ${$1fac131cb07af2de$var$formatCurrency(order.total)}
Payment Status: ${order.paymentStatus}

Items:
${$1fac131cb07af2de$var$formatItems(order.items)}

The customer accepted the user agreement at ${order.agreementAcceptedAt}.`;
}
async function $1fac131cb07af2de$export$afef68ee62425839(order) {
    const mailRef = (0, $31a25a81deadb29c$export$c03999cb2f36933f)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), $1fac131cb07af2de$var$EMAIL_COLLECTION);
    const customerEmail = order.customer?.email?.trim();
    if (!customerEmail) return;
    const emailJobs = [
        {
            to: customerEmail,
            replyTo: $1fac131cb07af2de$export$fc5cbb021d0697ad,
            message: {
                subject: `Soulful Customs Order Confirmation - ${order.orderNumber}`,
                text: $1fac131cb07af2de$var$buildCustomerText(order),
                html: $1fac131cb07af2de$var$buildCustomerHtml(order)
            }
        },
        {
            to: $1fac131cb07af2de$export$fc5cbb021d0697ad,
            replyTo: customerEmail,
            message: {
                subject: `New Order Submitted - ${order.orderNumber}`,
                text: $1fac131cb07af2de$var$buildSupportText(order)
            }
        }
    ];
    const emailDocRefs = await Promise.all(emailJobs.map((email)=>(0, $a33cbddcd7bfa0a9$export$a13890143fb1c2dd)(mailRef, email)));
    return emailDocRefs.map((docRef)=>docRef.id);
}


async function $372ae36bda9b61e1$export$ac29b122ab5923bd(order) {
    const firestoreOrder = JSON.parse(JSON.stringify(order));
    firestoreOrder.createdAt = Date.now();
    const docRef = await (0, $a33cbddcd7bfa0a9$export$a13890143fb1c2dd)((0, $31a25a81deadb29c$export$c03999cb2f36933f)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "orders"), firestoreOrder);
    let emailDocIds = [];
    try {
        emailDocIds = await (0, $1fac131cb07af2de$export$afef68ee62425839)(firestoreOrder);
    } catch (err) {
        console.warn("Order saved, but confirmation email queue failed.", err);
        try {
            await (0, $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2)((0, $31a25a81deadb29c$export$2e2af4578d910ddf)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "orders", docRef.id), {
                emailQueueStatus: "failed",
                emailQueueError: err?.message || "Unknown email queue error",
                emailQueueFailedAt: Date.now()
            });
        } catch (updateErr) {
            console.warn("Could not save email queue failure status.", updateErr);
        }
        return docRef.id;
    }
    try {
        await (0, $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2)((0, $31a25a81deadb29c$export$2e2af4578d910ddf)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "orders", docRef.id), {
            emailQueueStatus: "queued",
            emailQueuedAt: Date.now(),
            emailDocIds: emailDocIds
        });
    } catch (err) {
        console.warn("Confirmation emails queued, but order diagnostics were not saved.", err);
    }
    return docRef.id;
}



function $22ee634b7f4276fc$export$2e2bcd8739ae039() {
    const { cart: cart, setCart: setCart } = (0, $f1950c559c93426d$export$7e0ba394830a1349)();
    const [customer, setCustomer] = (0, $acw62.useState)({
        name: "",
        email: "",
        phone: ""
    });
    const [checkoutError, setCheckoutError] = (0, $acw62.useState)("");
    const [submittedOrder, setSubmittedOrder] = (0, $acw62.useState)(null);
    const [agreementScrolled, setAgreementScrolled] = (0, $acw62.useState)(false);
    const [agreementAccepted, setAgreementAccepted] = (0, $acw62.useState)(false);
    const [isSubmittingOrder, setIsSubmittingOrder] = (0, $acw62.useState)(false);
    const skipsUploads = (item)=>item.skipUploads || item.id === 15;
    if (submittedOrder) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "checkoutPage",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "checkoutContainer",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "successCard",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Thank You!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Your order has been submitted successfully. PayPal has opened so you can complete payment."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        children: [
                            "Order #",
                            submittedOrder.orderNumber
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Soulful Customs will confirm payment and contact you by phone and/or email when your order is ready for pickup."
                    })
                ]
            })
        })
    });
    const subtotal = cart.reduce((total, item)=>total + item.price * item.quantity, 0);
    const TAX_RATE = 0.08375;
    const taxAmount = Number((subtotal * TAX_RATE).toFixed(2));
    const phraseCost = cart.reduce((total, item)=>total + (item.uploads || []).reduce((uploadTotal, upload)=>uploadTotal + (upload.hasPhrase && !item.freeCustomPhrase ? 1 : 0), 0), 0);
    const total = Number((subtotal + phraseCost + taxAmount).toFixed(2));
    const PAYPAL_URL = `https://www.paypal.me/elliadelgado/${total.toFixed(2)}`;
    function generateOrderNumber() {
        const year = new Date().getFullYear();
        const random = Math.floor(1000 + Math.random() * 9000);
        return `SC-${year}-${random}`;
    }
    function validateOrder() {
        if (!customer.name.trim()) {
            setCheckoutError("Please enter your full name.");
            return false;
        }
        if (!customer.email.trim()) {
            setCheckoutError("Please enter your email address.");
            return false;
        }
        if (!customer.phone.trim()) {
            setCheckoutError("Please enter your phone number.");
            return false;
        }
        for (const item of cart){
            if (item.requiresChildName && !item.childName?.trim()) {
                setCheckoutError(`${item.name}: Please enter the child's name.`);
                return false;
            }
            if (item.personalization?.required && !item.personalizationText?.trim()) {
                setCheckoutError(`${item.name}: Please enter ${item.personalization.label.toLowerCase()}.`);
                return false;
            }
            const missingUpload = !skipsUploads(item) && (item.uploads || []).some((upload)=>!upload?.uploadedId);
            if (missingUpload) {
                setCheckoutError(`${item.name}: Please upload all required photos before checkout.`);
                return false;
            }
            if (item.freeCustomPhrase && !item.paragraph?.trim()) {
                setCheckoutError(`${item.name}: Please enter your message or paragraph.`);
                return false;
            }
        }
        setCheckoutError("");
        return true;
    }
    function buildOrder(orderNumber) {
        const orderItems = cart.map((item)=>({
                cartItemId: item.cartItemId,
                id: item.id,
                name: item.name,
                category: item.category,
                selectedOption: {
                    label: item.selectedOption?.label || "",
                    dimensions: item.selectedOption?.dimensions || "",
                    price: item.selectedOption?.price || 0,
                    description: item.selectedOption?.description || "",
                    styles: item.selectedOption?.styles || [],
                    quantityLabel: item.selectedOption?.quantityLabel || ""
                },
                quantity: item.quantity,
                childName: item.childName || "",
                personalizationText: item.personalizationText || "",
                personalizationEnabled: Boolean(item.personalization?.required || item.personalizationEnabled || item.personalizationText),
                paragraph: item.paragraph || "",
                uploads: (item.uploads || []).map((upload)=>({
                        file: upload.file || "",
                        uploadedId: upload.uploadedId || "",
                        note: upload.note || "",
                        hasPhrase: upload.hasPhrase || false,
                        customPhrase: upload.customPhrase || "",
                        uploadedAt: upload.uploadedAt || 0
                    }))
            }));
        return {
            orderNumber: orderNumber,
            customer: customer,
            items: orderItems,
            subtotal: subtotal,
            phraseCost: phraseCost,
            taxAmount: taxAmount,
            total: total,
            status: "pending",
            paymentMethod: "paypal-manual",
            paymentStatus: "pending-verification",
            paymentAmount: total,
            agreementAccepted: true,
            agreementAcceptedAt: new Date().toISOString()
        };
    }
    function handleAgreementScroll(e) {
        const target = e.currentTarget;
        const hasReachedBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 8;
        if (hasReachedBottom) setAgreementScrolled(true);
    }
    async function handlePayNow() {
        setCheckoutError("");
        if (!validateOrder()) return;
        if (!agreementAccepted) {
            setCheckoutError("Please read and accept the user agreement before payment.");
            return;
        }
        setIsSubmittingOrder(true);
        const paypalWindow = window.open("about:blank", "_blank");
        try {
            const orderNumber = generateOrderNumber();
            await (0, $372ae36bda9b61e1$export$ac29b122ab5923bd)(buildOrder(orderNumber));
            if (paypalWindow) paypalWindow.location.href = PAYPAL_URL;
            else window.open(PAYPAL_URL, "_blank");
            setSubmittedOrder({
                orderNumber: orderNumber
            });
            setCart([]);
        } catch (err) {
            console.error(err);
            if (paypalWindow) paypalWindow.close();
            alert("Checkout failed");
        } finally{
            setIsSubmittingOrder(false);
        }
    }
    const updateUpload = async (itemId, optionLabel, slot, file)=>{
        if (!file) return;
        const result = await (0, $69dd0c0f45f96013$export$a5575dbeeffdad98)(file);
        setCart(cart.map((item)=>{
            if (item.cartItemId !== itemId || item.selectedOption?.label !== optionLabel) return item;
            const uploads = [
                ...item.uploads || []
            ];
            uploads[slot] = {
                ...uploads[slot],
                file: file.name,
                uploadedId: result.fileId,
                url: result.url,
                uploadedAt: Date.now()
            };
            return {
                ...item,
                uploads: uploads
            };
        }));
    };
    const updateCartItem = (cartItemId, updates)=>{
        setCart(cart.map((item)=>item.cartItemId === cartItemId ? {
                ...item,
                ...updates
            } : item));
    };
    const updateQuantity = (id, optionLabel, value)=>{
        const qty = Math.max(1, parseInt(value) || 1);
        setCart(cart.map((item)=>{
            if (item.cartItemId !== id || item.selectedOption?.label !== optionLabel) return item;
            let uploadCount;
            if (skipsUploads(item)) uploadCount = 0;
            else if (item.selectedOption?.id === "doubleDifferent") uploadCount = qty * 2;
            else if (item.requiredUploads) uploadCount = qty * item.requiredUploads;
            else uploadCount = qty;
            const uploads = Array.from({
                length: uploadCount
            }).map((_, i)=>item.uploads?.[i] || {
                    file: null,
                    uploadedId: null,
                    note: "",
                    hasPhrase: false,
                    customPhrase: ""
                });
            return {
                ...item,
                quantity: qty,
                uploads: uploads
            };
        }));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "checkoutPage",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "checkoutContainer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "checkoutLeft",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Shopping Cart"
                        }),
                        cart.some((item)=>!skipsUploads(item)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "photoQualityNotice",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    children: "\uD83D\uDCF8 Photo Quality Notice"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "For the best print quality, please upload high-resolution, clear photos."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Low-quality, blurry, dark, cropped, heavily compressed, or screenshot-quality images may result in a printed product that appears pixelated or unclear."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Soulful Customs is not responsible for print quality issues caused by low-resolution photos submitted by the customer."
                                })
                            ]
                        }),
                        cart.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "emptyCart",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Your Cart is Empty"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Browse our collection and create something memorable."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/shop",
                                    className: "primaryBtn",
                                    children: "Shop Now"
                                })
                            ]
                        }),
                        cart.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "checkoutItem",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: item.image,
                                        alt: item.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "checkoutInfo",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "itemSize",
                                                children: [
                                                    "Selection:",
                                                    " ",
                                                    item.selectedOption?.dimensions || item.selectedOption?.label
                                                ]
                                            }),
                                            item.childName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "itemSize",
                                                children: [
                                                    "Child: ",
                                                    item.childName
                                                ]
                                            }),
                                            item.personalizationText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "itemSize",
                                                children: [
                                                    item.personalization?.label || "Personalization",
                                                    ":",
                                                    " ",
                                                    item.personalizationText
                                                ]
                                            }),
                                            item.selectedOption?.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: item.selectedOption.description
                                            }),
                                            item.selectedOption?.styles?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "selectedStylePreviewGrid",
                                                children: item.selectedOption.styles.map((style)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "selectedStylePreview",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: style.image,
                                                                alt: style.label
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    "Holder ",
                                                                    style.badgeNumber,
                                                                    ": ",
                                                                    style.label
                                                                ]
                                                            })
                                                        ]
                                                    }, `${item.cartItemId}-${style.badgeNumber}`))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "quantityControl",
                                                children: [
                                                    !item.isCustomProject && !skipsUploads(item) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "number",
                                                        min: "1",
                                                        value: item.quantity,
                                                        onChange: (e)=>updateQuantity(item.cartItemId, item.selectedOption?.label, e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "removeBtn",
                                                        onClick: ()=>setCart(cart.filter((i)=>i.cartItemId !== item.cartItemId)),
                                                        children: "Remove"
                                                    })
                                                ]
                                            }),
                                            item.personalization?.enabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "uploadCard personalizationCard",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "phraseCheckbox",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: item.personalization.required || item.personalizationEnabled || Boolean(item.personalizationText),
                                                                disabled: item.personalization.required,
                                                                onChange: (e)=>{
                                                                    updateCartItem(item.cartItemId, {
                                                                        personalizationEnabled: e.target.checked,
                                                                        personalizationText: e.target.checked ? item.personalizationText || "" : ""
                                                                    });
                                                                }
                                                            }),
                                                            item.personalization.required ? item.personalization.label : `${item.personalization.label} (included)`
                                                        ]
                                                    }),
                                                    (item.personalization.required || item.personalizationEnabled || item.personalizationText !== "") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "text",
                                                        className: "phraseInput",
                                                        value: item.personalizationText || "",
                                                        placeholder: item.personalization.placeholder,
                                                        onChange: (e)=>updateCartItem(item.cartItemId, {
                                                                personalizationText: e.target.value
                                                            })
                                                    }),
                                                    item.personalization.helperText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: item.personalization.helperText
                                                    })
                                                ]
                                            }),
                                            !skipsUploads(item) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "uploadSection",
                                                children: (item.uploads || []).map((upload, index)=>{
                                                    const isDoubleDifferent = item.selectedOption?.id === "doubleDifferent";
                                                    let uploadLabel = `Photo ${index + 1} of ${item.requiredUploads || item.quantity}`;
                                                    if (isDoubleDifferent) uploadLabel = index % 2 === 0 ? `Front Photo ${Math.floor(index / 2) + 1}` : `Back Photo ${Math.floor(index / 2) + 1}`;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "uploadCard",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                children: uploadLabel
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "file",
                                                                accept: "image/*",
                                                                onChange: (e)=>updateUpload(item.cartItemId, item.selectedOption?.label, index, e.target.files[0])
                                                            }),
                                                            upload.file && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                children: [
                                                                    "\u2713 ",
                                                                    upload.file
                                                                ]
                                                            }),
                                                            item.allowCustomPhrase !== false && !item.freeCustomPhrase && !item.personalization?.enabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                        className: "phraseCheckbox",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                type: "checkbox",
                                                                                checked: upload.hasPhrase || false,
                                                                                onChange: (e)=>{
                                                                                    setCart(cart.map((i)=>{
                                                                                        if (i.cartItemId !== item.cartItemId || i.selectedOption?.label !== item.selectedOption?.label) return i;
                                                                                        const uploads = [
                                                                                            ...i.uploads
                                                                                        ];
                                                                                        uploads[index] = {
                                                                                            ...uploads[index],
                                                                                            hasPhrase: e.target.checked
                                                                                        };
                                                                                        if (!e.target.checked) uploads[index].customPhrase = "";
                                                                                        return {
                                                                                            ...i,
                                                                                            uploads: uploads
                                                                                        };
                                                                                    }));
                                                                                }
                                                                            }),
                                                                            "Add Custom Phrase (+$1)"
                                                                        ]
                                                                    }),
                                                                    upload.hasPhrase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "text",
                                                                        className: "phraseInput",
                                                                        maxLength: "50",
                                                                        placeholder: "Enter custom phrase...",
                                                                        value: upload.customPhrase || "",
                                                                        onChange: (e)=>{
                                                                            setCart(cart.map((i)=>{
                                                                                if (i.cartItemId !== item.cartItemId || i.selectedOption?.label !== item.selectedOption?.label) return i;
                                                                                const uploads = [
                                                                                    ...i.uploads
                                                                                ];
                                                                                uploads[index] = {
                                                                                    ...uploads[index],
                                                                                    customPhrase: e.target.value
                                                                                };
                                                                                return {
                                                                                    ...i,
                                                                                    uploads: uploads
                                                                                };
                                                                            }));
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                                placeholder: "Special instructions",
                                                                value: upload.note || "",
                                                                onChange: (e)=>{
                                                                    setCart(cart.map((i)=>{
                                                                        if (i.cartItemId !== item.cartItemId || i.selectedOption?.label !== item.selectedOption?.label) return i;
                                                                        const uploads = [
                                                                            ...i.uploads
                                                                        ];
                                                                        uploads[index] = {
                                                                            ...uploads[index],
                                                                            note: e.target.value
                                                                        };
                                                                        return {
                                                                            ...i,
                                                                            uploads: uploads
                                                                        };
                                                                    }));
                                                                }
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            }),
                                            item.freeCustomPhrase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "uploadCard",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: "Message / Paragraph"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                        className: "paragraphInput",
                                                        placeholder: "Enter the message or paragraph you'd like added...",
                                                        value: item.paragraph || "",
                                                        onChange: (e)=>{
                                                            setCart(cart.map((i)=>i.cartItemId === item.cartItemId ? {
                                                                    ...i,
                                                                    paragraph: e.target.value
                                                                } : i));
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, item.cartItemId))
                    ]
                }),
                cart.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "checkoutRight",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Summary"
                        }),
                        checkoutError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "checkoutErrorCard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "checkoutErrorIcon",
                                    children: "\u26A0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Missing Required Information"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: checkoutError
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "summaryBreakdown",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Subtotal"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "$",
                                                subtotal.toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                phraseCost > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Custom Phrases"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "$",
                                                phraseCost.toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "summaryRow",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Sales Tax (8.375%)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "$",
                                                taxAmount.toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "summaryRow totalRow",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Total"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "$",
                                                total.toFixed(2)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "customerSection",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Customer Information"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "pickupNotice",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Pickup Only"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Orders are available for local pickup only. Soulful Customs will contact you by phone and/or email when your order is ready and arrange pickup details."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Full Name",
                                    value: customer.name,
                                    onChange: (e)=>setCustomer({
                                            ...customer,
                                            name: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "email",
                                    placeholder: "Email",
                                    value: customer.email,
                                    onChange: (e)=>setCustomer({
                                            ...customer,
                                            email: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "tel",
                                    placeholder: "Phone",
                                    value: customer.phone,
                                    onChange: (e)=>setCustomer({
                                            ...customer,
                                            phone: e.target.value
                                        })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "userAgreementCard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "agreementHeader",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Required"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: "User Agreement"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Please review the order, production, and refund terms before continuing to payment."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "agreementScrollBox",
                                    onScroll: handleAgreementScroll,
                                    tabIndex: "0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Payment & Production"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "After payment has been received, your order will be confirmed, and production of your custom items will begin."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Sublimation Printing Notice"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "All products are created using the sublimation printing process. Due to the nature of sublimation printing, slight variations in color and minor printing imperfections may occur. These variations are normal and do not affect the overall quality or functionality of the finished product."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Custom Order & Refund Policy"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "Because all items are custom-made specifically for your order, all sales are final. Once payment has been submitted, refunds, cancellations, or exchanges cannot be accepted. Customized products cannot be resold, so please review and approve your design carefully before completing your purchase."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Final Review"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "Please confirm all photos, names, phrases, badge holder styles, product options, and contact details are correct before paying. Soulful Customs will use the details provided in this checkout to prepare your order."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !agreementScrolled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "agreementHint",
                                    children: "Scroll to the bottom of the agreement to unlock acceptance."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: `agreementCheckbox ${!agreementScrolled ? "agreementCheckboxDisabled" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: agreementAccepted,
                                            disabled: !agreementScrolled,
                                            onChange: (e)=>setAgreementAccepted(e.target.checked)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "I have read, understand, and agree to the user agreement."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "primaryBtn",
                            onClick: handlePayNow,
                            disabled: !agreementAccepted || isSubmittingOrder,
                            children: isSubmittingOrder ? "Submitting Order..." : "Pay Now"
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


const $c7005eaaffd9833e$var$provider = new (0, $5ecbc04d9be5cf27$export$8743009a87fcb00f)();
async function $c7005eaaffd9833e$export$d25f561707ef4ea2() {
    const result = await (0, $5ecbc04d9be5cf27$export$4368d992c4eafac0)((0, $117415e422c8aaf1$export$73693bad9f5880b0), $c7005eaaffd9833e$var$provider);
    return result.user;
}
async function $c7005eaaffd9833e$export$a0973bcfe11b05c9() {
    await (0, $5ecbc04d9be5cf27$export$96f57966bedc81b4)((0, $117415e422c8aaf1$export$73693bad9f5880b0));
}


const $06d72f7e994bc15f$export$d3d924fda388a731 = [
    "macceez@gmail.com",
    "elliadelgado@gmail.com"
];




async function $0a509bd0bd5c2f21$export$a5be085772e686f9() {
    const ordersRef = (0, $31a25a81deadb29c$export$c03999cb2f36933f)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "orders");
    const q = (0, $a33cbddcd7bfa0a9$export$2fa187e846a241c4)(ordersRef, (0, $a33cbddcd7bfa0a9$export$f18af21d6f4dafd8)("createdAt", "desc"));
    const snapshot = await (0, $a33cbddcd7bfa0a9$export$81d3477bd73c86ef)(q);
    return snapshot.docs.map((docSnapshot)=>({
            firestoreId: docSnapshot.id,
            ...docSnapshot.data()
        }));
}
async function $0a509bd0bd5c2f21$export$3d5e2ef71327aff8(firestoreId, status) {
    const orderRef = (0, $31a25a81deadb29c$export$2e2af4578d910ddf)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "orders", firestoreId);
    await (0, $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2)(orderRef, {
        status: status
    });
}


function $1946771fe7dd4640$export$2e2bcd8739ae039() {
    const [user, setUser] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)("");
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [selectedOrder, setSelectedOrder] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)("");
    async function handleLogin() {
        try {
            const loggedInUser = await (0, $c7005eaaffd9833e$export$d25f561707ef4ea2)();
            if (!(0, $06d72f7e994bc15f$export$d3d924fda388a731).includes(loggedInUser.email)) {
                setError("You are not authorized.");
                return;
            }
            setUser(loggedInUser);
        } catch (err) {
            console.error(err);
        }
    }
    async function handleStatusUpdate() {
        if (!selectedOrder) return;
        try {
            await (0, $0a509bd0bd5c2f21$export$3d5e2ef71327aff8)(selectedOrder.firestoreId, status);
            setSelectedOrder({
                ...selectedOrder,
                status: status
            });
            setOrders(orders.map((order)=>order.firestoreId === selectedOrder.firestoreId ? {
                    ...order,
                    status: status
                } : order));
        } catch (err) {
            console.error(err);
        }
    }
    (0, $acw62.useEffect)(()=>{
        async function loadOrders() {
            try {
                const data = await (0, $0a509bd0bd5c2f21$export$a5be085772e686f9)();
                setOrders(data);
            } catch (err) {
                console.error(err);
            }
        }
        if (user) loadOrders();
    }, [
        user
    ]);
    if (!user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "adminLogin",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Admin Login"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "primaryBtn",
                onClick: handleLogin,
                children: "Sign In With Google"
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: error
            })
        ]
    });
    const activeOrders = orders.filter((order)=>order.status !== "cancelled" && order.status !== "archived");
    const inactiveOrders = orders.filter((order)=>order.status === "cancelled" || order.status === "archived");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "adminPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "adminHeader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: "Soulful Customs Admin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: user.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "adminStats",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "adminStatCard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Total Orders"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: orders.length
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "adminDashboard",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                        className: "adminSidebar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "adminSectionTitle",
                                children: "Active Orders"
                            }),
                            activeOrders.map((order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: `adminOrderListItem ${selectedOrder?.firestoreId === order.firestoreId ? "active" : ""}`,
                                    onClick: ()=>{
                                        setSelectedOrder(order);
                                        setStatus(order.status);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: order.orderNumber
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: order.customer?.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `statusBadge status-${order.status}`,
                                                    children: order.status
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "$",
                                                        order.total?.toFixed(2)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, order.firestoreId)),
                            inactiveOrders.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "adminSectionTitle",
                                        children: "Archived & Cancelled"
                                    }),
                                    inactiveOrders.map((order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: `adminOrderListItem ${selectedOrder?.firestoreId === order.firestoreId ? "active" : ""}`,
                                            onClick: ()=>{
                                                setSelectedOrder(order);
                                                setStatus(order.status);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: order.orderNumber
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: order.customer?.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `statusBadge status-${order.status}`,
                                                            children: order.status
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            children: [
                                                                "$",
                                                                order.total?.toFixed(2)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, order.firestoreId))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "adminContent",
                        children: !selectedOrder ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "adminEmptyState",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Select an Order"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Choose an order from the left to view details."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "adminDetailCard",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "adminStatusControls",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Order Status"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: status,
                                                    onChange: (e)=>setStatus(e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "pending",
                                                            children: "Pending"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "in-progress",
                                                            children: "In Progress"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "ready",
                                                            children: "Ready For Pickup"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "completed",
                                                            children: "Completed"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "cancelled",
                                                            children: "Cancelled"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "archived",
                                                            children: "Archived"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "primaryBtn",
                                                    onClick: handleStatusUpdate,
                                                    children: "Save Status"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            children: selectedOrder.orderNumber
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "adminInfoGrid",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: selectedOrder.customer?.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: selectedOrder.customer?.email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Phone"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: selectedOrder.customer?.phone
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Status"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `statusBadge status-${selectedOrder.status}`,
                                                            children: selectedOrder.status
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                selectedOrder.items?.map((item, itemIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "adminDetailCard",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "adminInfoGrid",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Category"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: item.category
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Quantity"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: item.quantity
                                                            })
                                                        ]
                                                    }),
                                                    item.selectedOption?.label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Option"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: item.selectedOption.label
                                                            })
                                                        ]
                                                    }),
                                                    item.selectedOption?.dimensions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Dimensions"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: item.selectedOption.dimensions
                                                            })
                                                        ]
                                                    }),
                                                    item.childName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Child Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: item.childName
                                                            })
                                                        ]
                                                    }),
                                                    item.personalizationText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                children: "Personalization"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: item.personalizationText
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            item.paragraph && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "adminParagraph",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Paragraph"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: item.paragraph
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                children: "Uploaded Photos"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "adminUploads",
                                                children: item.uploads?.map((upload, uploadIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "adminUploadCard",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: `${"https://soulful-upload.ceaser-r-hernandez.workers.dev"}?file=${upload.uploadedId}`,
                                                                alt: "Customer Upload",
                                                                className: "adminUploadPreview"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: `${"https://soulful-upload.ceaser-r-hernandez.workers.dev"}?file=${upload.uploadedId}`,
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                className: "adminDownloadBtn",
                                                                children: "Download"
                                                            }),
                                                            upload.customPhrase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "Phrase:"
                                                                    }),
                                                                    " ",
                                                                    upload.customPhrase
                                                                ]
                                                            }),
                                                            upload.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "adminUploadNote",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "Special Instructions"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: upload.note
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, uploadIndex))
                                            })
                                        ]
                                    }, item.cartItemId || itemIndex))
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db9ed9a2274fc7a3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b294e964c12237c$export$2e2bcd8739ae039), {
                            isCompact: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/about",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a5d0e60c7a8ff3$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/contact",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $612acbb6453dd4ca$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/shop",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72b2dfd9222704fd$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/checkout",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22ee634b7f4276fc$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/admin",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1946771fe7dd4640$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5686e64eaa3841eb$export$2e2bcd8739ae039), {})
        ]
    });
}




const $35da740d59af89ba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1950c559c93426d$export$9081b9c87ee4e12e), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {})
        })
    })
}));


//# sourceMappingURL=SoulfulCustoms.b6d6464b.js.map
